module.exports = {
    BubblesData: () => {
        return [
            [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[125.722,461.654],[125.722,378.241],[66.0545,463.522],[66.0545,382.116]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[125.722,547.541],[125.722,464.127],[66.0545,547.341],[66.0545,465.935]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[125.722,554.8],[125.722,638.213],[66.0545,554.425],[66.0545,635.832]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[125.722,645.222],[125.722,728.636],[66.0545,642.672],[66.0545,724.078]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[125.722,735.794],[125.722,819.208],[66.0545,731.064],[66.0545,812.47]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,458.448],[187.633,371.587],[106.202,461.037],[106.202,376.959]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,547.883],[187.633,461.022],[106.202,547.607],[106.202,463.529]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,555.442],[187.633,642.303],[106.202,554.923],[106.202,639.001]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,649.601],[187.633,736.462],[106.202,646.065],[106.202,730.143]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,743.917],[187.633,830.778],[106.202,737.358],[106.202,821.436]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[327.68,367.423],[327.68,281.156],[181.204,376.809],[181.204,295.255]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,458.448],[187.633,371.587],[207.813,459.13],[207.813,373.002]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,547.883],[187.633,461.022],[207.813,547.81],[207.813,461.682]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,555.442],[187.633,642.303],[207.813,555.305],[207.813,641.433]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,649.601],[187.633,736.462],[207.813,648.67],[207.813,734.798]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[187.633,743.917],[187.633,830.778],[207.813,742.189],[207.813,828.317]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[271.917,457.124],[271.917,368.841],[207.813,459.13],[207.813,373.002]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[271.917,548.024],[271.917,459.741],[207.813,547.81],[207.813,461.682]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[271.917,555.707],[271.917,643.99],[207.813,555.305],[207.813,641.433]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[271.917,651.408],[271.917,739.691],[207.813,648.67],[207.813,734.798]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[271.917,747.268],[271.917,835.551],[207.813,742.189],[207.813,828.317]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[343.017,457.687],[343.017,366.966],[272.584,459.818],[272.584,371.466]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[343.017,551.097],[343.017,460.376],[272.584,550.787],[272.584,462.436]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[343.017,558.992],[343.017,649.712],[272.584,558.476],[272.584,646.827]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[343.017,657.335],[343.017,748.056],[272.584,654.251],[272.584,742.602]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[343.017,755.841],[343.017,846.562],[272.584,750.184],[272.584,838.535]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,454.008],[420.398,359.194],[323.654,456.981],[323.654,365.474]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,551.631],[420.398,456.818],[323.654,551.199],[323.654,459.693]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,559.882],[420.398,654.695],[323.654,559.163],[323.654,650.669]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,662.662],[420.398,757.475],[323.654,658.358],[323.654,749.865]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,765.612],[420.398,860.425],[323.654,757.718],[323.654,849.224]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[492.414,356.866],[492.414,265.299],[327.939,367.406],[327.939,281.131]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,454.008],[420.398,359.194],[440.266,454.793],[440.266,360.852]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,551.631],[420.398,456.818],[440.266,551.517],[440.266,457.577]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,559.882],[420.398,654.695],[440.266,559.692],[440.266,653.632]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,662.662],[420.398,757.475],[440.266,661.526],[440.266,755.466]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[420.398,765.612],[420.398,860.425],[440.266,763.528],[440.266,857.468]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[519.357,452.402],[519.357,355.802],[440.266,454.793],[440.266,360.852]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[519.357,551.864],[519.357,455.265],[440.266,551.517],[440.266,457.577]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[519.357,560.271],[519.357,656.87],[440.266,559.692],[440.266,653.632]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[519.357,664.987],[519.357,761.587],[440.266,661.526],[440.266,755.466]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[519.357,769.876],[519.357,866.476],[440.266,763.528],[440.266,857.468]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[492.526,356.858],[492.526,265.288],[713.279,376.164],[713.279,294.286]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[600.878,449.888],[600.878,350.492],[516.541,452.439],[516.541,355.88]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[600.878,552.229],[600.878,452.834],[516.541,551.859],[516.541,455.301]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[600.878,560.879],[600.878,660.275],[516.541,560.262],[516.541,656.82]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[600.878,668.626],[600.878,768.022],[516.541,664.933],[516.541,761.492]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[600.878,776.552],[600.878,875.948],[516.541,769.778],[516.541,866.337]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[767.255,339.253],[767.255,238.843],[567.681,352.042],[567.681,258.054]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,445.452],[698.825,341.122],[582.095,449.039],[582.095,348.699]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,552.874],[698.825,448.544],[582.095,552.353],[582.095,452.013]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,561.953],[698.825,666.282],[582.095,561.085],[582.095,661.425]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,675.048],[698.825,779.378],[582.095,669.855],[582.095,770.195]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,788.331],[698.825,892.661],[582.095,778.806],[582.095,879.146]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,445.452],[698.825,341.122],[717.848,446.401],[717.848,343.128]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,552.874],[698.825,448.544],[717.848,552.736],[717.848,449.462]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,561.953],[698.825,666.282],[717.848,561.723],[717.848,664.997]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,675.048],[698.825,779.378],[717.848,673.674],[717.848,776.947]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[698.825,788.331],[698.825,892.661],[717.848,785.81],[717.848,889.083]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[814.584,443.477],[814.584,336.951],[717.848,446.401],[717.848,343.128]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[814.584,553.16],[814.584,446.634],[717.848,552.736],[717.848,449.462]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[814.584,562.431],[814.584,668.957],[717.848,561.723],[717.848,664.996]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[814.584,677.907],[814.584,784.433],[717.848,673.674],[717.848,776.947]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[814.584,793.575],[814.584,900.101],[717.848,785.81],[717.848,889.083]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[767.39,339.244],[767.39,238.83],[975.432,362.224],[975.432,273.347]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[815.051,443.503],[815.051,337.006],[890.577,447.605],[890.577,345.67]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[815.051,553.157],[815.051,446.66],[890.577,552.561],[890.577,450.626]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[815.051,562.424],[815.051,668.921],[890.577,561.432],[890.577,663.366]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[815.051,677.869],[815.051,784.366],[890.577,671.931],[890.577,773.866]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[815.051,793.505],[815.051,900.002],[890.577,782.614],[890.577,884.548]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1089.09,435.121],[1089.09,319.301],[975.12,438.568],[975.12,326.582]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1089.09,554.374],[1089.09,438.554],[975.12,553.873],[975.12,441.887]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1089.09,564.453],[1089.09,680.273],[975.12,563.619],[975.12,675.605]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1089.09,690.005],[1089.09,805.825],[975.12,685.014],[975.12,797]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1089.09,815.764],[1089.09,931.584],[975.12,806.61],[975.12,918.596]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,429.048],[1232.64,306.473],[1072.59,433.966],[1072.59,316.862]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,555.256],[1232.64,432.681],[1072.59,554.542],[1072.59,437.437]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,565.923],[1232.64,688.497],[1072.59,564.732],[1072.59,681.837]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,698.796],[1232.64,821.371],[1072.59,691.676],[1072.59,808.78]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,831.89],[1232.64,954.465],[1072.59,818.83],[1072.59,935.934]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1419.4,297.461],[1419.4,176.07],[1135.22,315.672],[1135.22,203.424]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,429.048],[1232.64,306.473],[1248.62,430.356],[1248.62,309.236]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,555.256],[1232.64,432.681],[1248.62,555.066],[1248.62,433.946]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,565.923],[1232.64,688.497],[1248.62,565.606],[1248.62,686.726]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,698.796],[1232.64,821.371],[1248.62,696.902],[1248.62,818.022]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1232.64,831.89],[1232.64,954.465],[1248.62,828.416],[1248.62,949.536]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1381.18,426.349],[1381.18,300.772],[1248.62,430.356],[1248.62,309.236]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1381.18,555.648],[1381.18,430.071],[1248.62,555.066],[1248.62,433.946]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1381.18,566.576],[1381.18,692.153],[1248.62,565.606],[1248.62,686.726]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1381.18,702.704],[1381.18,828.281],[1248.62,696.902],[1248.62,818.022]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1381.18,839.057],[1381.18,964.634],[1248.62,828.416],[1248.62,949.536]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1522.99,421.051],[1522.99,290.701],[1379.79,425.417],[1379.79,299.882]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1522.99,555.265],[1522.99,424.915],[1379.79,554.673],[1379.79,429.138]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1522.99,566.608],[1522.99,696.958],[1379.79,565.598],[1379.79,691.133]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1522.99,707.911],[1522.99,838.261],[1379.79,701.681],[1379.79,827.216]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1522.99,849.447],[1522.99,979.797],[1379.79,837.989],[1379.79,963.524]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1753.6,276.044],[1753.6,143.9],[1419.47,297.456],[1419.47,176.063]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,413.177],[1714.03,274.144],[1509.34,419.521],[1509.34,287.484]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,556.331],[1714.03,417.298],[1509.34,555.472],[1509.34,423.435]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,568.431],[1714.03,707.464],[1509.34,566.962],[1509.34,698.999]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,719.146],[1714.03,858.179],[1509.34,710.093],[1509.34,842.13]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,870.111],[1714.03,1009.14],[1509.34,853.462],[1509.34,985.499]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,413.177],[1714.03,274.144],[1725.26,414.815],[1725.26,277.588]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,556.331],[1714.03,417.298],[1725.26,556.11],[1725.26,418.883]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,568.431],[1714.03,707.464],[1725.26,568.052],[1725.26,705.279]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,719.146],[1714.03,858.179],[1725.26,716.809],[1725.26,854.036]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1714.03,870.111],[1714.03,1009.14],[1725.26,865.812],[1725.26,1003.04]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,409.554],[1897.72,266.524],[1725.26,414.815],[1725.26,277.588]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,556.822],[1897.72,413.793],[1725.26,556.11],[1725.26,418.883]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,569.269],[1897.72,712.299],[1725.26,568.052],[1725.26,705.279]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,724.316],[1897.72,867.346],[1725.26,716.809],[1725.26,854.036]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,879.62],[1897.72,1022.65],[1725.26,865.812],[1725.26,1003.04]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1753.84,276.029],[1753.84,143.878],[1874.11,314.436],[1874.11,201.567]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,406.195],[1897.72,263.166],[1967.97,419.932],[1967.97,291.669]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,553.464],[1897.72,410.435],[1967.97,551.997],[1967.97,423.734]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,565.911],[1897.72,708.941],[1967.97,563.159],[1967.97,691.422]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,720.958],[1897.72,863.988],[1967.97,702.199],[1967.97,830.462]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:1,
                    verts:[[1897.72,876.262],[1897.72,1019.29],[1967.97,841.47],[1967.97,969.733]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[77.6162,459.661],[77.6162,374.103],[9.94542,461.376],[9.94542,377.664]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[77.6162,547.754],[77.6162,462.196],[9.94542,547.57],[9.94542,463.858]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[77.6162,555.199],[77.6162,640.756],[9.94542,554.855],[9.94542,638.568]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[77.6162,647.945],[77.6162,733.502],[9.94542,645.601],[9.94542,729.314]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[77.6162,740.844],[77.6162,826.401],[9.94542,736.498],[9.94542,820.21]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,456.605],[150.5,367.763],[58.4786,458.973],[58.4786,372.677]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,548.08],[150.5,459.238],[58.4786,547.827],[58.4786,461.531]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,555.811],[150.5,644.653],[58.4786,555.337],[58.4786,641.633]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,652.118],[150.5,740.959],[58.4786,648.884],[58.4786,735.18]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,748.583],[150.5,837.425],[58.4786,742.586],[58.4786,828.882]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[295.469,364.436],[295.469,276.67],[131.931,372.953],[131.931,289.463]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,456.605],[150.5,367.763],[170.047,457.359],[170.047,369.328]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,548.08],[150.5,459.238],[170.047,547.999],[170.047,459.968]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,555.811],[150.5,644.653],[170.047,555.66],[170.047,643.691]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,652.118],[150.5,740.959],[170.047,651.088],[170.047,739.119]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[150.5,748.583],[150.5,837.425],[170.047,746.674],[170.047,834.705]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[241.856,455.539],[241.856,365.551],[170.047,457.359],[170.047,369.328]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[241.856,548.194],[241.856,458.206],[170.047,547.999],[170.047,459.968]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[241.856,556.025],[241.856,646.013],[170.047,555.66],[170.047,643.691]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[241.856,653.573],[241.856,743.561],[170.047,651.088],[170.047,739.119]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[241.856,751.284],[241.856,841.271],[170.047,746.674],[170.047,834.705]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[321.147,456.364],[321.147,364.172],[242.702,458.287],[242.702,368.233]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[321.147,551.289],[321.147,459.097],[242.702,551.01],[242.702,460.956]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[321.147,559.312],[321.147,651.504],[242.702,558.847],[242.702,648.901]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[321.147,659.25],[321.147,751.442],[242.702,656.467],[242.702,746.521]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[321.147,759.354],[321.147,851.546],[242.702,754.249],[242.702,844.303]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[476.984,354.982],[476.984,262.47],[295.757,364.421],[295.757,276.647]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,452.925],[410.022,356.908],[302.78,455.592],[302.78,362.541]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,551.788],[410.022,455.771],[302.78,551.401],[302.78,458.35]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,560.144],[410.022,656.161],[302.78,559.499],[302.78,652.549]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,664.229],[410.022,760.246],[302.78,660.368],[302.78,753.419]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,768.486],[410.022,864.504],[302.78,761.404],[302.78,854.455]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,452.925],[410.022,356.908],[428.576,453.776],[428.576,358.704]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,551.788],[410.022,455.771],[428.576,551.665],[428.576,456.593]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,560.144],[410.022,656.161],[428.576,559.938],[428.576,655.01]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,664.229],[410.022,760.246],[428.576,662.998],[428.576,758.069]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[410.022,768.486],[410.022,864.504],[428.576,766.228],[428.576,861.299]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[515.385,451.649],[515.385,354.213],[428.576,453.776],[428.576,358.704]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[515.385,551.974],[515.385,454.537],[428.576,551.665],[428.576,456.593]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[515.385,560.453],[515.385,657.889],[428.576,559.938],[428.576,655.01]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[515.385,666.076],[515.385,763.513],[428.576,662.998],[428.576,758.069]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[515.385,771.874],[515.385,869.311],[428.576,766.228],[428.576,861.299]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[477.107,354.976],[477.107,262.46],[680.97,375.661],[680.97,293.53]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[604.374,449.423],[604.374,349.511],[512.419,451.677],[512.419,354.271]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[604.374,552.297],[604.374,452.385],[512.419,551.97],[512.419,454.564]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[604.374,560.992],[604.374,660.904],[512.419,560.446],[512.419,657.852]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[604.374,669.299],[604.374,769.211],[512.419,666.036],[512.419,763.442]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[604.374,777.785],[604.374,877.698],[512.419,771.801],[512.419,869.207]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[774.282,339.498],[774.282,239.212],[559.082,350.706],[559.082,256.047]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,445.37],[713.807,340.949],[587.314,448.516],[587.314,347.594]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,552.885],[713.807,448.465],[587.314,552.429],[587.314,451.507]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,561.973],[713.807,666.393],[587.314,561.211],[587.314,662.133]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,675.167],[713.807,779.587],[587.314,670.612],[587.314,771.534]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,788.548],[713.807,892.969],[587.314,780.195],[587.314,881.116]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,445.37],[713.807,340.949],[730.715,446.375],[730.715,343.072]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,552.885],[713.807,448.465],[730.715,552.74],[730.715,449.437]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,561.973],[713.807,666.393],[730.715,561.729],[730.715,665.032]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,675.167],[713.807,779.587],[730.715,673.712],[730.715,777.015]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[713.807,788.548],[713.807,892.969],[730.715,785.88],[730.715,889.183]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.366,443.836],[834.366,337.709],[730.715,446.375],[730.715,343.072]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.366,553.108],[834.366,446.982],[730.715,552.74],[730.715,449.437]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.366,562.344],[834.366,668.47],[730.715,561.729],[730.715,665.032]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.366,677.387],[834.366,783.514],[730.715,673.712],[730.715,777.015]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.366,792.621],[834.366,898.748],[730.715,785.88],[730.715,889.183]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[774.426,339.491],[774.426,239.201],[957.515,363.572],[957.515,275.371]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.771,443.864],[834.771,337.768],[900.427,448.158],[900.427,346.838]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.771,553.104],[834.771,447.008],[900.427,552.481],[900.427,451.161]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.771,562.337],[834.771,668.433],[900.427,561.298],[900.427,662.618]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.771,677.347],[834.771,783.444],[900.427,671.131],[900.427,772.451]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[834.771,792.548],[834.771,898.644],[900.427,781.146],[900.427,882.465]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1124.13,436.686],[1124.13,322.606],[1004.67,439.613],[1004.67,328.79]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1124.13,554.147],[1124.13,440.067],[1004.67,553.721],[1004.67,442.898]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1124.13,564.074],[1124.13,678.154],[1004.67,563.366],[1004.67,674.189]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1124.13,687.739],[1124.13,801.819],[1004.67,683.501],[1004.67,794.324]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1124.13,811.609],[1124.13,925.688],[1004.67,803.835],[1004.67,914.659]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,431.367],[1276.84,311.372],[1110.63,435.501],[1110.63,320.104]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,554.919],[1276.84,434.924],[1110.63,554.319],[1110.63,438.921]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,565.361],[1276.84,685.356],[1110.63,564.361],[1110.63,679.758]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,695.438],[1276.84,815.434],[1110.63,689.454],[1110.63,804.852]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,825.731],[1276.84,945.726],[1110.63,814.755],[1110.63,930.152]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1453.22,304.138],[1453.22,186.099],[1161.83,319.314],[1161.83,208.895]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,431.367],[1276.84,311.372],[1289.32,432.692],[1289.32,314.171]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,554.919],[1276.84,434.924],[1289.32,554.727],[1289.32,436.205]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,565.361],[1276.84,685.356],[1289.32,565.041],[1289.32,683.562]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,695.438],[1276.84,815.434],[1289.32,693.52],[1289.32,812.041]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1276.84,825.731],[1276.84,945.726],[1289.32,822.213],[1289.32,940.734]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1425.07,429.367],[1425.07,307.148],[1289.32,432.692],[1289.32,314.171]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1425.07,555.209],[1425.07,432.99],[1289.32,554.727],[1289.32,436.205]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1425.07,565.845],[1425.07,688.065],[1289.32,565.041],[1289.32,683.562]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1425.07,698.334],[1425.07,820.553],[1289.32,693.52],[1289.32,812.041]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1425.07,831.042],[1425.07,953.261],[1289.32,822.213],[1289.32,940.734]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1568.68,424.872],[1568.68,298.735],[1423.66,428.455],[1423.66,306.269]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1568.68,554.747],[1568.68,428.611],[1423.66,554.262],[1423.66,432.076]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1568.68,565.724],[1568.68,691.861],[1423.66,564.895],[1423.66,687.081]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1568.68,702.459],[1568.68,828.595],[1423.66,697.347],[1423.66,819.532]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1568.68,839.42],[1568.68,965.557],[1423.66,830.018],[1423.66,952.204]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1787.44,286.731],[1787.44,159.953],[1453.29,304.134],[1453.29,186.093]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,418.221],[1763.83,284.75],[1559.08,423.357],[1559.08,295.55]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,555.648],[1763.83,422.177],[1559.08,554.952],[1559.08,427.145]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,567.263],[1763.83,700.734],[1559.08,566.075],[1559.08,693.882]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,711.949],[1763.83,845.42],[1559.08,704.62],[1559.08,832.428]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,856.874],[1763.83,990.345],[1559.08,843.396],[1559.08,971.203]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,418.221],[1763.83,284.75],[1770.81,419.817],[1770.81,288.105]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,555.648],[1763.83,422.177],[1770.81,555.432],[1770.81,423.721]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,567.263],[1763.83,700.734],[1770.81,566.894],[1770.81,698.606]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,711.949],[1763.83,845.42],[1770.81,709.672],[1770.81,841.384]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1763.83,856.874],[1763.83,990.345],[1770.81,852.687],[1770.81,984.398]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1940.48,415.623],[1940.48,279.287],[1770.81,419.817],[1770.81,288.105]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1940.48,556],[1940.48,419.664],[1770.81,555.432],[1770.81,423.721]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1940.48,567.865],[1940.48,704.201],[1770.81,566.894],[1770.81,698.606]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1940.48,715.656],[1940.48,851.993],[1770.81,709.672],[1770.81,841.384]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1940.48,863.693],[1940.48,1000.03],[1770.81,852.687],[1770.81,984.398]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:2,
                    verts:[[1787.67,286.719],[1787.67,159.935],[1862.34,324.016],[1862.34,215.956]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[33.5717,457.51],[33.5717,369.641],[-42.3824,459.047],[-42.3824,372.831]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[33.5717,547.983],[33.5717,460.114],[-42.3824,547.819],[-42.3824,461.603]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[33.5717,555.63],[33.5717,643.499],[-42.3824,555.322],[-42.3824,641.538]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[33.5717,650.882],[33.5717,738.751],[-42.3824,648.782],[-42.3824,734.999]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[33.5717,746.292],[33.5717,834.161],[-42.3824,742.398],[-42.3824,828.614]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,454.641],[117.772,363.688],[14.9487,456.751],[14.9487,368.066]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,548.29],[117.772,457.337],[14.9487,548.064],[14.9487,459.38]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,556.205],[117.772,647.158],[14.9487,555.782],[14.9487,644.467]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,654.8],[117.772,745.753],[14.9487,651.918],[14.9487,740.603]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,753.559],[117.772,844.512],[14.9487,748.214],[14.9487,836.898]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[267.094,361.239],[267.094,271.868],[86.3636,368.77],[86.3636,283.18]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,454.641],[117.772,363.688],[136.531,455.467],[136.531,365.401]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,548.29],[117.772,457.337],[136.531,548.202],[136.531,458.136]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,556.205],[117.772,647.158],[136.531,556.039],[136.531,646.105]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,654.8],[117.772,745.753],[136.531,653.672],[136.531,743.737]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[117.772,753.559],[117.772,844.512],[136.531,751.467],[136.531,841.532]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[216.054,453.858],[216.054,362.063],[136.531,455.467],[136.531,365.401]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[216.054,548.373],[216.054,456.579],[136.531,548.202],[136.531,458.136]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[216.054,556.362],[216.054,648.156],[136.531,556.039],[136.531,646.105]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[216.054,655.869],[216.054,747.664],[136.531,653.672],[136.531,743.737]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[216.054,755.541],[216.054,847.336],[136.531,751.467],[136.531,841.532]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[303.414,454.975],[303.414,361.238],[217.082,456.664],[217.082,364.805]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[303.414,551.491],[303.414,457.754],[217.082,551.245],[217.082,459.387]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[303.414,559.648],[303.414,653.385],[217.082,559.239],[217.082,651.098]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[303.414,661.261],[303.414,754.998],[217.082,658.816],[217.082,750.675]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[303.414,763.042],[303.414,856.779],[217.082,758.558],[217.082,850.416]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[464.874,352.998],[464.874,259.489],[267.409,361.226],[267.409,271.848]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,451.812],[403.575,354.557],[286.209,454.14],[286.209,359.474]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,551.95],[403.575,454.695],[286.209,551.612],[286.209,456.946]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,560.413],[403.575,657.668],[286.209,559.85],[286.209,654.516]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,665.84],[403.575,763.095],[286.209,662.47],[286.209,757.136]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,771.441],[403.575,868.696],[286.209,765.26],[286.209,859.926]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,451.812],[403.575,354.557],[420.639,452.724],[420.639,356.484]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,551.95],[403.575,454.695],[420.639,551.817],[420.639,455.577]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,560.413],[403.575,657.668],[420.639,560.193],[420.639,656.433]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,665.84],[403.575,763.095],[420.639,664.52],[420.639,760.76]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[403.575,771.441],[403.575,868.696],[420.639,769.019],[420.639,865.26]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[514.699,450.885],[514.699,352.599],[420.639,452.724],[420.639,356.484]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[514.699,552.085],[514.699,453.798],[420.639,551.817],[420.639,455.577]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[514.699,560.638],[514.699,658.924],[420.639,560.193],[420.639,656.433]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[514.699,667.182],[514.699,765.468],[420.639,664.52],[420.639,760.76]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[514.699,773.903],[514.699,872.189],[420.639,769.019],[420.639,865.26]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[465.006,352.992],[465.006,259.481],[650.658,374.953],[650.658,292.467]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[610.541,448.968],[610.541,348.549],[511.603,450.903],[511.603,352.636]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[610.541,552.363],[610.541,451.944],[511.603,552.082],[511.603,453.815]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[610.541,561.102],[610.541,661.521],[511.603,560.633],[511.603,658.9]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[610.541,669.958],[610.541,770.377],[511.603,667.157],[511.603,765.423]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[610.541,778.995],[610.541,879.414],[511.603,773.856],[511.603,872.123]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[782.58,339.759],[782.58,239.604],[553.373,349.31],[553.373,253.95]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,445.328],[730.512,340.861],[595.359,448.008],[595.359,346.523]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,552.892],[730.512,448.424],[595.359,552.502],[595.359,451.016]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,561.983],[730.512,666.45],[595.359,561.334],[595.359,662.82]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,675.228],[730.512,779.695],[595.359,671.347],[595.359,772.833]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,788.66],[730.512,893.127],[595.359,781.542],[595.359,883.028]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,445.328],[730.512,340.86],[745.168,446.379],[745.168,343.081]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,552.892],[730.512,448.424],[745.168,552.739],[745.168,449.441]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,561.983],[730.512,666.45],[745.168,561.728],[745.168,665.026]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,675.228],[730.512,779.695],[745.168,673.705],[745.168,777.003]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[730.512,788.66],[730.512,893.127],[745.168,785.868],[745.168,889.166]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[854.683,444.238],[854.683,338.559],[745.168,446.379],[745.168,343.081]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[854.683,553.05],[854.683,447.37],[745.168,552.739],[745.168,449.441]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[854.683,562.246],[854.683,667.926],[745.168,561.728],[745.168,665.026]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[854.683,676.805],[854.683,782.485],[745.168,673.705],[745.168,777.003]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[854.683,791.554],[854.683,897.233],[745.168,785.868],[745.168,889.166]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[782.732,339.753],[782.732,239.595],[940.137,364.738],[940.137,277.123]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[855.023,444.267],[855.023,338.619],[910.455,448.711],[910.455,348.008]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[855.023,553.046],[855.023,447.398],[910.455,552.4],[910.455,451.696]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[855.023,562.24],[855.023,667.887],[910.455,561.164],[910.455,661.868]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[855.023,676.764],[855.023,782.412],[910.455,670.329],[910.455,771.033]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[855.023,791.478],[855.023,897.126],[910.455,779.675],[910.455,880.379]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1156.17,438.294],[1156.17,326.004],[1032.77,440.708],[1032.77,331.103]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1156.17,553.913],[1156.17,441.623],[1032.77,553.562],[1032.77,443.957]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1156.17,563.685],[1156.17,675.975],[1032.77,563.101],[1032.77,672.706]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1156.17,685.41],[1156.17,797.7],[1032.77,681.915],[1032.77,791.521]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1156.17,807.336],[1156.17,919.627],[1032.77,800.927],[1032.77,910.532]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,433.722],[1315.68,316.345],[1145.67,437.094],[1145.67,323.468]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,554.577],[1315.68,437.2],[1145.67,554.087],[1145.67,440.461]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,564.792],[1315.68,682.168],[1145.67,563.975],[1145.67,677.601]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,692.03],[1315.68,809.407],[1145.67,687.148],[1145.67,800.774]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,819.48],[1315.68,936.856],[1145.67,810.525],[1145.67,924.151]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1480.41,310.682],[1480.41,195.928],[1185.51,322.97],[1185.51,214.386]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,433.722],[1315.68,316.345],[1324.78,435.047],[1324.78,319.145]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,554.577],[1315.68,437.2],[1324.78,554.384],[1324.78,438.482]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,564.792],[1315.68,682.168],[1324.78,564.471],[1324.78,680.373]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,692.03],[1315.68,809.407],[1324.78,690.111],[1324.78,806.013]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1315.68,819.48],[1315.68,936.856],[1324.78,815.96],[1324.78,931.862]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1461.79,432.368],[1461.79,313.487],[1324.78,435.047],[1324.78,319.145]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1461.79,554.774],[1461.79,435.892],[1324.78,554.384],[1324.78,438.482]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1461.79,565.119],[1461.79,684.001],[1324.78,564.471],[1324.78,680.373]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1461.79,693.989],[1461.79,812.871],[1324.78,690.111],[1324.78,806.013]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1461.79,823.073],[1461.79,941.955],[1324.78,815.96],[1324.78,931.862]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1605.17,428.62],[1605.17,306.616],[1460.39,431.475],[1460.39,312.62]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1605.17,554.24],[1605.17,432.236],[1460.39,553.853],[1460.39,434.998]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1605.17,564.857],[1605.17,686.86],[1460.39,564.196],[1460.39,683.051]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1605.17,697.111],[1605.17,819.115],[1460.39,693.038],[1460.39,811.893]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1605.17,829.585],[1605.17,951.589],[1460.39,822.093],[1460.39,940.948]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1810.5,296.927],[1810.5,175.268],[1480.49,310.678],[1480.49,195.923]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,423.099],[1801.23,295.006],[1599.35,427.137],[1599.35,303.499]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,554.988],[1801.23,426.895],[1599.35,554.44],[1599.35,430.802]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,566.135],[1801.23,694.227],[1599.35,565.2],[1599.35,688.838]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,704.989],[1801.23,833.082],[1599.35,699.227],[1599.35,822.865]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,844.074],[1801.23,972.166],[1599.35,833.475],[1599.35,957.114]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,423.099],[1801.23,295.006],[1804.38,424.635],[1804.38,298.238]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,554.988],[1801.23,426.895],[1804.38,554.779],[1804.38,428.382]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,566.135],[1801.23,694.227],[1804.38,565.779],[1804.38,692.176]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,704.989],[1801.23,833.082],[1804.38,702.796],[1804.38,829.194]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1801.23,844.074],[1801.23,972.166],[1804.38,840.041],[1804.38,966.438]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1969.1,421.386],[1804.38,424.635],[1969.1,291.404],[1804.38,298.238]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1969.1,555.22],[1969.1,425.238],[1804.38,554.779],[1804.38,428.382]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1969.1,566.531],[1969.1,696.512],[1804.38,565.779],[1804.38,692.176]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1969.1,707.434],[1804.38,702.796],[1969.1,837.415],[1804.38,829.194]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1969.1,848.569],[1804.38,840.041],[1969.1,978.551],[1804.38,966.438]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:3,
                    verts:[[1810.72,296.918],[1810.72,175.254],[1844.63,332.818],[1844.63,229.178]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,452.543],[89.5242,359.336],[-24.2747,454.356],[-24.2747,363.098]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,548.514],[89.5242,455.306],[-24.2747,548.32],[-24.2747,457.061]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,556.625],[89.5242,649.833],[-24.2747,556.262],[-24.2747,647.521]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,657.664],[89.5242,750.872],[-24.2747,655.188],[-24.2747,746.447]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,758.87],[89.5242,852.078],[-24.2747,754.279],[-24.2747,845.538]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[242.564,357.81],[242.564,266.717],[44.5671,364.23],[44.5671,276.36]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,452.543],[89.5242,359.336],[107.33,453.441],[107.33,361.199]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,548.514],[89.5242,455.306],[107.33,548.418],[107.33,456.175]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,556.625],[89.5242,649.833],[107.33,556.445],[107.33,648.687]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,657.664],[89.5242,750.872],[107.33,656.438],[107.33,748.68]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[89.5242,758.87],[89.5242,852.078],[107.33,756.596],[107.33,848.838]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[194.538,452.071],[194.538,358.356],[107.33,453.441],[107.33,361.199]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[194.538,548.564],[194.538,454.849],[107.33,548.418],[107.33,456.175]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[194.538,556.72],[194.538,650.435],[107.33,556.445],[107.33,648.687]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[194.538,658.309],[194.538,752.025],[107.33,656.438],[107.33,748.68]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[194.538,760.067],[194.538,853.782],[107.33,756.596],[107.33,848.838]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[289.796,453.511],[289.796,358.145],[195.752,454.94],[195.752,361.163]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[289.796,551.703],[289.796,456.338],[195.752,551.496],[195.752,457.719]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[289.796,560.002],[289.796,655.368],[195.752,559.656],[195.752,653.433]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[289.796,663.381],[289.796,758.747],[195.752,661.312],[195.752,755.089]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[289.796,766.93],[289.796,862.296],[195.752,763.136],[195.752,856.913]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[456.009,350.889],[456.009,256.322],[242.907,357.799],[242.907,266.701]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,450.659],[400.961,352.121],[273.922,452.615],[273.922,356.253]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,552.117],[400.961,453.58],[273.922,551.833],[273.922,455.471]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,560.693],[400.961,659.23],[273.922,560.219],[273.922,656.581]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,667.51],[400.961,766.047],[273.922,664.678],[273.922,761.04]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,774.503],[400.961,873.041],[273.922,769.31],[273.922,865.672]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,450.659],[400.961,352.121],[416.366,451.629],[416.366,354.169]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,552.117],[400.961,453.58],[416.366,551.977],[416.366,454.517]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,560.693],[400.961,659.23],[416.366,560.458],[416.366,657.917]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,667.51],[400.961,766.047],[416.366,666.106],[416.366,763.566]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[400.961,774.503],[400.961,873.041],[416.366,771.929],[416.366,869.389]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[517.156,450.098],[517.156,350.936],[416.366,451.629],[416.366,354.169]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[517.156,552.199],[517.156,453.037],[416.366,551.977],[416.366,454.517]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[517.156,560.828],[517.156,659.99],[416.366,560.458],[416.366,657.917]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[517.156,668.322],[517.156,767.484],[416.366,666.106],[416.366,763.566]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[517.156,775.994],[517.156,875.156],[416.366,771.929],[416.366,869.389]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[456.15,350.885],[456.15,256.315],[622.308,374.023],[622.308,291.07]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[619.193,448.506],[619.193,347.574],[513.952,450.105],[513.952,350.951]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[619.193,552.43],[619.193,451.498],[513.952,552.198],[513.952,453.044]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[619.193,561.214],[619.193,662.146],[513.952,560.827],[513.952,659.98]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[619.193,670.626],[619.193,771.559],[513.952,668.311],[513.952,767.465]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[619.193,780.22],[619.193,881.153],[513.952,775.974],[513.952,875.128]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[792,339.995],[792,239.958],[550.443,347.827],[550.443,251.723]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,445.305],[748.694,340.813],[606.028,447.502],[606.028,345.453]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,552.895],[748.694,448.402],[606.028,552.576],[606.028,450.527]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,561.988],[748.694,666.48],[606.028,561.457],[606.028,663.506]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,675.26],[748.694,779.752],[606.028,672.08],[606.028,774.13]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,788.72],[748.694,893.212],[606.028,782.887],[606.028,884.937]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,445.305],[748.694,340.813],[760.987,446.395],[760.987,343.114]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,552.895],[748.694,448.402],[760.987,552.737],[760.987,449.456]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,561.988],[748.694,666.48],[760.987,561.724],[760.987,665.005]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,675.26],[748.694,779.752],[760.987,673.683],[760.987,776.964]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[748.694,788.72],[748.694,893.212],[760.987,785.827],[760.987,889.108]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.321,444.658],[875.321,339.446],[760.987,446.395],[760.987,343.114]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.321,552.989],[875.321,447.777],[760.987,552.737],[760.987,449.456]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.321,562.145],[875.321,667.357],[760.987,561.724],[760.987,665.005]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.321,676.197],[875.321,781.409],[760.987,673.683],[760.987,776.964]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.321,790.438],[875.321,895.65],[760.987,785.827],[760.987,889.108]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[792.159,339.99],[792.159,239.951],[923.334,365.699],[923.334,278.567]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.594,444.688],[875.594,339.508],[920.569,449.245],[920.569,349.134]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.594,552.985],[875.594,447.805],[920.569,552.323],[920.569,452.212]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.594,562.138],[875.594,667.317],[920.569,561.035],[920.569,661.146]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.594,676.155],[875.594,781.334],[920.569,669.557],[920.569,769.668]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[875.594,790.36],[875.594,895.54],[920.569,778.259],[920.569,878.37]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1185.21,439.906],[1185.21,329.408],[1059.29,441.819],[1059.29,333.45]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1185.21,553.679],[1185.21,443.181],[1059.29,553.401],[1059.29,445.031]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1185.21,563.295],[1185.21,673.793],[1059.29,562.832],[1059.29,671.201]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1185.21,683.077],[1185.21,793.575],[1059.29,680.307],[1059.29,788.677]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1185.21,803.057],[1185.21,913.555],[1059.29,797.977],[1059.29,906.346]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,436.057],[1349.39,321.278],[1177.65,438.701],[1177.65,326.863]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,554.238],[1349.39,439.459],[1177.65,553.854],[1177.65,442.016]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,564.226],[1349.39,679.005],[1177.65,563.586],[1177.65,675.424]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,688.649],[1349.39,803.428],[1177.65,684.821],[1177.65,796.659]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,813.278],[1349.39,928.057],[1177.65,806.257],[1177.65,918.094]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1501.61,316.987],[1501.61,205.399],[1206.35,326.56],[1206.35,219.778]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,436.057],[1349.39,321.278],[1355.24,437.37],[1355.24,324.051]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,554.238],[1349.39,439.459],[1355.24,554.047],[1355.24,440.729]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,564.226],[1349.39,679.005],[1355.24,563.909],[1355.24,677.227]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,688.649],[1349.39,803.428],[1355.24,686.748],[1355.24,800.067]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1349.39,813.278],[1349.39,928.057],[1355.24,809.792],[1355.24,923.11]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1491.89,435.295],[1491.89,319.668],[1355.24,437.37],[1355.24,324.051]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1491.89,554.349],[1491.89,438.722],[1355.24,554.047],[1355.24,440.729]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1491.89,564.411],[1491.89,680.038],[1355.24,563.909],[1355.24,677.227]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1491.89,689.753],[1491.89,805.38],[1355.24,686.748],[1355.24,800.067]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1491.89,815.302],[1491.89,930.929],[1355.24,809.792],[1355.24,923.11]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1633.38,432.232],[1633.38,314.211],[1490.51,434.42],[1490.51,318.813]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1633.38,553.75],[1633.38,435.73],[1490.51,553.454],[1490.51,437.847]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1633.38,564.021],[1633.38,682.041],[1490.51,563.514],[1490.51,679.121]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1633.38,691.958],[1633.38,809.978],[1490.51,688.835],[1490.51,804.442]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1633.38,820.107],[1490.51,814.363],[1633.38,938.127],[1490.51,929.97]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1824.35,306.522],[1824.35,189.68],[1501.68,316.984],[1501.68,205.395]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.8,427.739],[1631.02,430.794],[1827.8,304.763],[1631.02,311.189]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.8,554.359],[1827.8,431.384],[1631.02,553.945],[1631.02,434.34]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.8,565.061],[1827.8,688.036],[1631.02,564.353],[1631.02,683.959]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.8,698.368],[1631.02,694.008],[1827.8,821.344],[1631.02,813.614]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.8,831.897],[1631.02,823.878],[1827.8,954.872],[1631.02,943.483]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.55,429.206],[1985.83,426.781],[1827.55,307.849],[1985.83,302.749]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.55,554.16],[1827.55,432.803],[1985.83,554.489],[1985.83,430.457]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.55,564.721],[1827.55,686.078],[1985.83,565.282],[1985.83,689.314]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.55,696.274],[1985.83,699.736],[1827.55,817.631],[1985.83,823.767]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:4,
                    verts:[[1827.55,828.046],[1985.83,834.411],[1827.55,949.403],[1985.83,958.443]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,450.3],[65.8341,354.68],[-59.0753,451.772],[-59.0753,357.735]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,548.753],[65.8341,453.134],[-59.0753,548.596],[-59.0753,454.559]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,557.075],[65.8341,652.694],[-59.0753,556.78],[-59.0753,650.816]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,660.728],[65.8341,756.348],[-59.0753,658.717],[-59.0753,752.754]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,764.554],[65.8341,860.174],[-59.0753,760.824],[-59.0753,854.861]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[221.887,354.123],[221.887,261.179],[6.60485,359.298],[6.60485,268.952]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,450.3],[65.8341,354.68],[82.5105,451.27],[82.5105,356.693]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,548.753],[65.8341,453.134],[82.5105,548.65],[82.5105,454.073]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,557.075],[65.8341,652.694],[82.5105,556.88],[82.5105,651.457]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,660.728],[65.8341,756.348],[82.5105,659.403],[82.5105,753.98]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[65.8341,764.554],[65.8341,860.174],[82.5105,762.096],[82.5105,856.673]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[177.333,450.167],[177.333,354.404],[82.5105,451.27],[82.5105,356.693]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[177.333,548.768],[177.333,453.005],[82.5105,548.65],[82.5105,454.073]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[177.333,557.101],[177.333,652.864],[82.5105,556.88],[82.5105,651.457]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[177.333,660.91],[177.333,756.673],[82.5105,659.403],[82.5105,753.98]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[177.333,764.891],[177.333,860.653],[82.5105,762.096],[82.5105,856.673]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[280.269,451.96],[280.269,354.87],[178.737,453.103],[178.737,357.283]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[280.269,551.928],[280.269,454.838],[178.737,551.763],[178.737,455.943]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[280.269,560.378],[280.269,657.468],[178.737,560.101],[178.737,655.921]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[280.269,665.626],[280.269,762.716],[178.737,663.972],[178.737,759.792]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[280.269,771.048],[280.269,868.138],[178.737,768.015],[178.737,863.835]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[450.31,348.632],[450.31,252.932],[222.257,354.114],[222.257,261.166]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,449.454],[402.083,349.577],[265.897,451.006],[265.897,352.854]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,552.292],[402.083,452.415],[265.897,552.067],[265.897,453.915]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,560.984],[402.083,660.862],[265.897,560.609],[265.897,658.76]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,669.254],[402.083,769.131],[265.897,667.007],[265.897,765.159]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,777.702],[402.083,877.58],[265.897,773.582],[265.897,871.734]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,449.454],[402.083,349.577],[415.664,450.477],[415.664,351.737]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,552.292],[402.083,452.415],[415.664,552.144],[415.664,453.404]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,560.984],[402.083,660.862],[415.664,560.737],[415.664,659.477]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,669.254],[402.083,769.131],[415.664,667.773],[415.664,766.514]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[402.083,777.702],[402.083,877.58],[415.664,774.987],[415.664,873.727]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[522.62,449.274],[522.62,349.196],[415.664,450.477],[415.664,351.737]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[522.62,552.318],[522.62,452.241],[415.664,552.144],[415.664,453.404]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[522.62,561.028],[522.62,661.106],[415.664,560.737],[415.664,659.477]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[522.62,669.514],[522.62,769.592],[415.664,667.773],[415.664,766.514]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[522.62,778.181],[522.62,878.258],[415.664,774.987],[415.664,873.727]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[450.46,348.629],[450.46,252.926],[595.868,372.851],[595.868,289.31]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[630.158,448.024],[630.158,346.556],[519.328,449.271],[519.328,349.19]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[630.158,552.5],[630.158,451.032],[519.328,552.319],[519.328,452.237]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[630.158,561.33],[630.158,662.798],[519.328,561.028],[519.328,661.11]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[630.158,671.324],[630.158,772.792],[519.328,669.519],[519.328,769.6]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[630.158,781.5],[630.158,882.968],[519.328,778.189],[519.328,878.271]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[802.411,340.168],[802.411,240.219],[550.184,346.232],[550.184,249.326]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,445.284],[768.14,340.768],[619.131,446.982],[619.131,344.353]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,552.898],[768.14,448.382],[619.131,552.651],[619.131,450.023]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,561.993],[768.14,666.51],[619.131,561.583],[619.131,664.211]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,675.291],[768.14,779.808],[619.131,672.834],[619.131,775.462]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,788.777],[768.14,893.293],[619.131,784.269],[619.131,886.897]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,445.284],[768.14,340.767],[777.985,446.403],[777.985,343.131]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,552.898],[768.14,448.382],[777.985,552.735],[777.985,449.464]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,561.993],[768.14,666.51],[777.985,561.723],[777.985,664.994]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,675.291],[768.14,779.808],[777.985,673.671],[777.985,776.943]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[768.14,788.777],[768.14,893.293],[777.985,785.805],[777.985,889.077]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.11,445.075],[896.11,340.326],[777.985,446.403],[777.985,343.131]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.11,552.928],[896.11,448.179],[777.985,552.735],[777.985,449.464]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.11,562.044],[896.11,666.793],[777.985,561.722],[777.985,664.994]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.11,675.594],[896.11,780.343],[777.985,673.671],[777.985,776.943]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.11,789.332],[896.11,894.081],[777.985,785.805],[777.985,889.077]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[802.575,340.165],[802.575,240.213],[907.12,366.438],[907.12,279.676]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.315,445.104],[896.315,340.389],[930.7,449.739],[930.7,350.179]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.315,552.924],[896.315,448.208],[930.7,552.251],[930.7,452.69]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.315,562.037],[896.315,666.753],[930.7,560.915],[930.7,660.476]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.315,675.551],[896.315,780.267],[930.7,668.841],[930.7,768.402]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[896.315,789.253],[896.315,893.969],[930.7,776.946],[930.7,876.506]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1211.31,441.487],[1211.31,332.748],[1084.15,442.917],[1084.15,335.769]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1211.31,553.449],[1211.31,444.71],[1084.15,553.242],[1084.15,446.093]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1211.31,562.912],[1211.31,671.652],[1084.15,562.566],[1084.15,669.714]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1211.31,680.788],[1211.31,789.528],[1084.15,678.717],[1084.15,785.866]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1211.31,798.859],[1211.31,907.599],[1084.15,795.061],[1084.15,902.209]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,438.333],[1378.25,326.085],[1206.61,440.288],[1206.61,330.216]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,553.907],[1378.25,441.66],[1206.61,553.623],[1206.61,443.551]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,563.676],[1378.25,675.923],[1206.61,563.202],[1206.61,673.275]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,685.355],[1378.25,797.602],[1206.61,682.524],[1206.61,792.596]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,807.235],[1378.25,919.483],[1206.61,802.042],[1206.61,912.115]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1517.42,322.981],[1517.42,214.403],[1224.51,330.022],[1224.51,224.979]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,438.333],[1378.25,326.085],[1381.02,439.622],[1381.02,328.809]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,553.907],[1378.25,441.66],[1381.02,553.72],[1381.02,442.907]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,563.676],[1378.25,675.923],[1381.02,563.363],[1381.02,674.177]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,685.355],[1378.25,797.602],[1381.02,683.487],[1381.02,794.301]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1378.25,807.235],[1378.25,919.483],[1381.02,803.81],[1381.02,914.624]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1515.95,438.105],[1515.95,325.605],[1381.02,439.622],[1381.02,328.809]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1515.95,553.94],[1515.95,441.44],[1381.02,553.72],[1381.02,442.907]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1515.95,563.731],[1515.95,676.231],[1381.02,563.363],[1381.02,674.177]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1515.95,685.684],[1381.02,683.487],[1515.95,798.185],[1381.02,794.301]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1515.95,807.839],[1381.02,803.81],[1515.95,920.34],[1381.02,914.624]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1654.25,435.665],[1514.6,437.249],[1654.25,321.432],[1514.6,324.762]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1654.25,553.285],[1514.6,553.07],[1654.25,439.051],[1514.6,440.583]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1654.25,563.226],[1514.6,562.86],[1654.25,677.46],[1514.6,675.347]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1654.25,687.058],[1514.6,684.798],[1654.25,801.292],[1514.6,797.286]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1654.25,811.095],[1514.6,806.939],[1654.25,925.329],[1514.6,919.426]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1517.49,322.979],[1830.41,315.458],[1517.49,214.4],[1830.41,203.102]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1655.04,434.283],[1655.04,318.524],[1845.06,432.099],[1845.06,313.932]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1655.04,553.472],[1655.04,437.714],[1845.06,553.768],[1845.06,435.601]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1655.04,563.546],[1655.04,679.305],[1845.06,564.052],[1845.06,682.218]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1655.04,689.031],[1655.04,804.79],[1845.06,692.147],[1845.06,810.314]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1655.04,814.724],[1845.06,820.455],[1655.04,930.483],[1845.06,938.621]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1841.81,433.491],[1841.81,316.859],[1992.66,431.779],[1992.66,313.26]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1841.81,690.161],[1841.81,806.792],[1992.66,692.603],[1992.66,811.122]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1841.81,816.801],[1841.81,933.433],[1992.66,821.293],[1992.66,939.812]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1841.81,553.58],[1841.81,436.948],[1992.66,553.811],[1992.66,435.292]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:5,
                    verts:[[1841.81,563.729],[1841.81,680.361],[1992.66,564.125],[1992.66,682.645]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[205.085,350.15],[205.085,255.212],[-27.4378,353.933],[-27.4378,260.894]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,447.894],[46.8015,349.688],[-89.3061,448.978],[-89.3061,351.939]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,549.01],[46.8015,450.805],[-89.3061,548.895],[-89.3061,451.855]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,557.557],[46.8015,655.762],[-89.3061,557.339],[-89.3061,654.379]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,664.014],[46.8015,762.22],[-89.3061,662.533],[-89.3061,759.573]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,770.647],[46.8015,868.853],[-89.3061,767.9],[-89.3061,864.94]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,447.894],[46.8015,349.688],[62.1598,448.936],[62.1598,351.851]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,549.01],[46.8015,450.805],[62.1598,548.899],[62.1598,451.814]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,557.557],[46.8015,655.762],[62.1598,557.348],[62.1598,654.433]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,664.014],[46.8015,762.22],[62.1598,662.59],[62.1598,759.675]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[46.8015,770.647],[46.8015,868.853],[62.1598,768.007],[62.1598,865.092]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[164.485,448.131],[164.485,350.181],[62.1598,448.936],[62.1598,351.851]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[164.485,548.985],[164.485,451.035],[62.1598,548.899],[62.1598,451.814]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[164.485,557.509],[164.485,655.459],[62.1598,557.348],[62.1598,654.433]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[164.485,663.689],[164.485,761.64],[62.1598,662.59],[62.1598,759.675]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[164.485,770.046],[164.485,867.996],[62.1598,768.007],[62.1598,865.092]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[274.823,450.312],[274.823,351.389],[166.079,451.139],[166.079,353.136]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[274.823,552.168],[274.823,453.244],[166.079,552.048],[166.079,454.044]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[274.823,560.776],[274.823,659.7],[166.079,560.576],[166.079,658.58]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[274.823,668.012],[274.823,766.935],[166.079,666.814],[166.079,764.818]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[274.823,775.425],[274.823,874.348],[166.079,773.228],[166.079,871.232]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[447.712,346.203],[447.712,249.283],[205.481,350.144],[205.481,255.202]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,448.187],[406.86,346.9],[262.127,449.302],[262.127,349.255]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,552.476],[406.86,451.189],[262.127,552.315],[262.127,452.267]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,561.291],[406.86,662.578],[262.127,561.021],[262.127,661.068]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,671.088],[406.86,772.375],[262.127,669.474],[262.127,769.522]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,781.067],[406.86,882.354],[262.127,778.107],[262.127,878.155]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,448.187],[406.86,346.9],[418.458,449.259],[418.458,349.164]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,552.476],[406.86,451.189],[418.458,552.321],[418.458,452.226]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,561.291],[406.86,662.578],[418.458,561.031],[418.458,661.127]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,671.088],[406.86,772.375],[418.458,669.537],[418.458,769.632]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[406.86,781.067],[406.86,882.354],[418.458,778.222],[418.458,878.317]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[530.968,448.403],[530.968,347.357],[418.458,449.259],[418.458,349.164]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[530.968,552.445],[530.968,451.398],[418.458,552.321],[418.458,452.226]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[530.968,561.238],[530.968,662.285],[418.458,561.031],[418.458,661.127]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[530.968,670.775],[530.968,771.822],[418.458,669.537],[418.458,769.632]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[530.968,780.493],[530.968,881.54],[418.458,778.222],[418.458,878.317]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[447.87,346.2],[447.87,249.279],[571.28,371.419],[571.28,287.159]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[643.285,447.509],[643.285,345.469],[527.613,448.389],[527.613,347.327]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[643.285,552.575],[643.285,450.534],[527.613,552.447],[527.613,451.385]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[643.285,561.455],[643.285,663.496],[527.613,561.242],[527.613,662.304]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[643.285,672.069],[643.285,774.11],[527.613,670.795],[527.613,771.858]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[643.285,782.867],[643.285,884.908],[527.613,780.531],[527.613,881.593]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[813.705,340.248],[813.705,240.338],[552.501,344.498],[552.501,246.722]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,445.247],[788.672,340.689],[634.503,446.434],[634.503,343.197]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,552.903],[788.672,448.346],[634.503,552.731],[634.503,449.494]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,562.002],[788.672,666.56],[634.503,561.715],[634.503,664.952]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,675.345],[788.672,779.902],[634.503,673.626],[634.503,776.863]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,788.875],[788.672,893.433],[634.503,785.722],[634.503,888.959]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,445.247],[788.672,340.689],[796.004,446.388],[796.004,343.1]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,552.903],[788.672,448.346],[796.004,552.738],[796.004,449.45]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,562.002],[788.672,666.56],[796.004,561.726],[796.004,665.014]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,675.345],[788.672,779.902],[796.004,673.693],[796.004,776.981]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[788.672,788.875],[788.672,893.433],[796.004,785.844],[796.004,889.132]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[916.918,445.469],[916.918,341.158],[796.004,446.388],[796.004,343.1]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[916.918,552.871],[916.918,448.561],[796.004,552.738],[796.004,449.45]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[916.918,561.949],[916.918,666.259],[796.004,561.726],[796.004,665.014]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[916.918,675.023],[916.918,779.334],[796.004,673.693],[796.004,776.981]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[916.918,788.286],[916.918,892.596],[796.004,785.844],[796.004,889.132]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[813.873,340.245],[813.873,240.334],[891.489,366.937],[891.489,280.426]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[917.056,445.499],[917.056,341.222],[940.799,450.18],[940.799,351.11]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[917.056,552.867],[917.056,448.59],[940.799,552.187],[940.799,453.117]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[917.056,561.941],[917.056,666.219],[940.799,560.808],[940.799,659.879]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[917.056,674.98],[917.056,779.257],[940.799,668.203],[940.799,767.273]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[917.056,788.206],[917.056,892.483],[940.799,775.775],[940.799,874.846]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1234.58,443.012],[1234.58,335.968],[1107.35,443.98],[1107.35,338.013]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1234.58,553.228],[1234.58,446.185],[1107.35,553.087],[1107.35,447.12]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1234.58,562.543],[1234.58,669.587],[1107.35,562.309],[1107.35,668.276]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1234.58,678.581],[1234.58,785.624],[1107.35,677.18],[1107.35,783.146]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1234.58,794.81],[1107.35,792.24],[1234.58,901.853],[1107.35,898.207]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.59,440.519],[1232.63,441.828],[1402.59,330.703],[1232.63,333.467]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.59,553.59],[1402.59,443.774],[1232.63,553.4],[1232.63,445.039]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.59,563.147],[1402.59,672.963],[1232.63,562.83],[1232.63,671.19]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.59,682.19],[1232.63,680.295],[1402.59,792.006],[1232.63,788.655]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.59,801.43],[1232.63,797.954],[1402.59,911.246],[1232.63,906.315]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1528.43,328.62],[1240.12,333.31],[1528.43,222.872],[1240.12,229.918]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.47,441.777],[1534.57,440.773],[1402.47,333.36],[1534.57,331.239]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.47,553.407],[1402.47,444.991],[1534.57,553.553],[1534.57,444.019]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.47,562.842],[1402.47,671.259],[1534.57,563.085],[1534.57,672.619]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.47,680.368],[1534.57,681.822],[1402.47,788.785],[1534.57,791.356]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1402.47,798.089],[1534.57,800.756],[1402.47,906.505],[1534.57,910.289]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1528.51,328.618],[1528.51,222.87],[1829.88,323.715],[1829.88,215.505]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1533.26,439.934],[1533.26,330.408],[1668.64,438.896],[1668.64,328.225]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1533.26,552.707],[1533.26,443.181],[1668.64,552.847],[1668.64,442.177]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1533.26,562.238],[1533.26,671.764],[1668.64,562.478],[1668.64,673.149]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1533.26,680.967],[1533.26,790.493],[1668.64,682.448],[1668.64,793.119]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1533.26,799.892],[1668.64,802.617],[1533.26,909.418],[1668.64,913.287]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1672.28,437.573],[1672.28,325.444],[1854.35,436.159],[1854.35,322.47]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1672.28,553.027],[1672.28,440.897],[1854.35,553.218],[1854.35,439.529]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1672.28,562.784],[1672.28,674.914],[1854.35,563.112],[1854.35,676.801]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1672.28,684.336],[1672.28,796.465],[1854.35,686.354],[1854.35,800.043]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1672.28,806.088],[1672.28,918.218],[1854.35,809.799],[1854.35,923.489]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1848.47,437.473],[1848.47,325.233],[1991.29,436.377],[1991.29,322.928]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1848.47,684.479],[1848.47,796.719],[1991.29,686.042],[1991.29,799.491]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1848.47,806.351],[1848.47,918.592],[1991.29,809.227],[1991.29,922.676]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1848.47,553.04],[1848.47,440.8],[1991.29,553.189],[1991.29,439.74]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:6,
                    verts:[[1848.47,562.808],[1848.47,675.048],[1991.29,563.061],[1991.29,676.51]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[192.213,345.862],[192.213,248.771],[-57.4278,348.09],[-57.4278,252.118]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,445.31],[32.5738,344.326],[-114.763,445.953],[-114.763,345.661]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,549.286],[32.5738,448.303],[-114.763,549.218],[-114.763,448.926]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,558.074],[32.5738,659.058],[-114.763,557.945],[-114.763,658.237]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,667.543],[32.5738,768.526],[-114.763,666.664],[-114.763,766.956]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,777.192],[32.5738,878.176],[-114.763,775.563],[-114.763,875.854]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,445.31],[32.5738,344.326],[46.4108,446.425],[46.4108,346.64]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,549.286],[32.5738,448.303],[46.4108,549.167],[46.4108,449.382]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,558.074],[32.5738,659.058],[46.4108,557.851],[46.4108,657.636]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,667.543],[32.5738,768.526],[46.4108,666.02],[46.4108,765.805]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[32.5738,777.192],[32.5738,878.176],[46.4108,774.368],[46.4108,874.153]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[156.073,445.952],[156.073,345.659],[46.4108,446.425],[46.4108,346.64]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[156.073,549.218],[156.073,448.925],[46.4108,549.167],[46.4108,449.382]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[156.073,557.946],[156.073,658.239],[46.4108,557.851],[46.4108,657.636]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[156.073,666.666],[156.073,766.959],[46.4108,666.02],[46.4108,765.805]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[156.073,775.566],[156.073,875.859],[46.4108,774.368],[46.4108,874.153]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[273.482,448.555],[273.482,347.678],[157.86,449.038],[157.86,348.696]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[273.482,552.423],[273.482,451.545],[157.86,552.353],[157.86,452.012]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[273.482,561.202],[273.482,662.079],[157.86,561.085],[157.86,661.426]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[273.482,670.555],[273.482,771.432],[157.86,669.857],[157.86,770.198]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[273.482,780.089],[273.482,880.967],[157.86,778.809],[157.86,879.151]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[448.174,343.578],[448.174,245.34],[192.636,345.859],[192.636,248.766]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,446.848],[415.24,344.071],[262.638,447.492],[262.638,345.431]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,552.671],[415.24,449.894],[262.638,552.577],[262.638,450.517]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,561.615],[415.24,664.392],[262.638,561.459],[262.638,663.519]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,673.027],[415.24,775.804],[262.638,672.095],[262.638,774.155]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,784.624],[415.24,887.401],[262.638,782.914],[262.638,884.974]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,446.848],[415.24,344.071],[424.697,447.964],[424.697,346.428]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,552.671],[415.24,449.894],[424.697,552.509],[424.697,450.973]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,561.615],[415.24,664.392],[424.697,561.345],[424.697,662.88]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,673.027],[415.24,775.804],[424.697,671.411],[424.697,772.947]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[415.24,784.624],[415.24,887.401],[424.697,781.66],[424.697,883.196]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[542.11,447.475],[542.11,345.395],[424.697,447.964],[424.697,346.428]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[542.11,552.58],[542.11,450.5],[424.697,552.509],[424.697,450.973]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[542.11,561.463],[542.11,663.543],[424.697,561.345],[424.697,662.88]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[542.11,672.12],[542.11,774.199],[424.697,671.411],[424.697,772.947]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[542.11,782.96],[542.11,885.039],[424.697,781.66],[424.697,883.196]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[448.34,343.577],[448.34,245.338],[548.49,369.709],[548.49,284.59]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[658.453,446.95],[658.453,344.288],[538.713,447.45],[538.713,345.342]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[658.453,552.656],[658.453,449.993],[538.713,552.583],[538.713,450.476]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[658.453,561.59],[658.453,664.253],[538.713,561.469],[538.713,663.577]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[658.453,672.879],[658.453,775.542],[538.713,672.156],[538.713,774.263]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[658.453,784.352],[658.453,887.015],[538.713,783.026],[538.713,885.134]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[825.794,340.209],[825.794,240.279],[557.322,342.604],[557.322,243.877]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,445.181],[810.146,340.551],[652.01,445.849],[652.01,341.96]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,552.913],[810.146,448.282],[652.01,552.816],[652.01,448.928]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,562.018],[810.146,666.649],[652.01,561.857],[652.01,665.745]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,675.44],[810.146,780.071],[652.01,674.474],[652.01,778.362]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,789.05],[810.146,893.68],[652.01,787.277],[652.01,891.166]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,445.181],[810.146,340.551],[814.918,446.338],[814.918,342.993]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,552.913],[810.146,448.282],[814.918,552.745],[814.918,449.401]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,562.018],[810.146,666.649],[814.918,561.738],[814.918,665.083]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,675.44],[810.146,780.071],[814.918,673.766],[814.918,777.11]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[810.146,789.05],[810.146,893.68],[814.918,785.979],[814.918,889.323]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.649,445.826],[937.649,341.913],[814.918,446.338],[814.918,342.993]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.649,552.819],[937.649,448.906],[814.918,552.745],[814.918,449.401]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.649,561.862],[937.649,665.775],[814.918,561.738],[814.918,665.083]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.649,674.506],[937.649,778.419],[814.918,673.766],[814.918,777.11]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.649,787.337],[937.649,891.25],[814.918,785.979],[814.918,889.323]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[825.965,340.207],[825.965,240.277],[876.426,367.185],[876.426,280.798]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.719,445.856],[937.719,341.976],[950.829,450.556],[950.829,351.903]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.719,552.815],[937.719,448.935],[950.829,552.132],[950.829,453.48]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.719,561.855],[937.719,665.735],[950.829,560.718],[950.829,659.37]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.719,674.463],[937.719,778.343],[950.829,667.659],[950.829,766.312]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[937.719,787.257],[937.719,891.137],[950.829,774.778],[950.829,873.431]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.14,444.462],[1128.88,444.989],[1255.14,339.033],[1128.88,340.145]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.14,553.017],[1128.88,552.941],[1255.14,447.587],[1128.88,448.096]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.14,562.192],[1128.88,562.065],[1255.14,667.622],[1128.88,666.909]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.14,676.48],[1128.88,675.718],[1255.14,781.91],[1128.88,780.563]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.14,790.958],[1128.88,789.56],[1255.14,896.388],[1128.88,894.405]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1253.36,336.393],[1253.36,234.548],[1535.18,333.878],[1535.18,230.77]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.84,443.3],[1255.84,336.577],[1422.76,442.596],[1422.76,335.089]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.84,553.186],[1255.84,446.463],[1422.76,553.288],[1422.76,445.782]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.84,562.473],[1255.84,669.196],[1422.76,562.644],[1422.76,670.15]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.84,678.163],[1255.84,784.886],[1422.76,679.183],[1422.76,786.689]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1255.84,794.045],[1422.76,795.915],[1255.84,900.767],[1422.76,903.422]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1419.92,443.816],[1419.92,337.667],[1548.28,443.281],[1548.28,336.537]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1419.92,677.416],[1419.92,783.565],[1548.28,678.191],[1548.28,784.934]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1419.92,792.674],[1419.92,898.823],[1548.28,794.095],[1548.28,900.839]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1419.92,553.111],[1419.92,446.962],[1548.28,553.189],[1548.28,446.445]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1419.92,562.349],[1419.92,668.497],[1548.28,562.478],[1548.28,669.222]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1535.25,333.878],[1535.25,230.769],[1823.77,331.303],[1823.77,226.902]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1547.02,442.46],[1547.02,335.719],[1677.34,441.912],[1677.34,334.567]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1547.02,552.365],[1547.02,445.624],[1677.34,552.439],[1677.34,445.094]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1547.02,561.654],[1547.02,668.395],[1677.34,561.78],[1677.34,669.126]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1547.02,677.363],[1547.02,784.104],[1677.34,678.145],[1677.34,785.49]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1547.02,793.265],[1547.02,900.006],[1677.34,794.702],[1677.34,902.047]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1683.54,440.653],[1683.54,331.919],[1856.83,439.915],[1856.83,330.368]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1683.54,552.609],[1683.54,443.876],[1856.83,552.709],[1856.83,443.162]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1683.54,562.072],[1683.54,670.806],[1856.83,562.243],[1856.83,671.79]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1683.54,679.942],[1683.54,788.675],[1856.83,680.994],[1856.83,790.541]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1683.54,798.007],[1683.54,906.74],[1856.83,799.942],[1856.83,909.489]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1848.64,441.15],[1848.64,332.965],[1983.1,440.585],[1983.1,331.776]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1848.64,679.232],[1848.64,787.418],[1983.1,680.039],[1983.1,788.848]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1848.64,796.702],[1848.64,904.887],[1983.1,798.186],[1983.1,906.995]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1848.64,552.542],[1848.64,444.357],[1983.1,552.619],[1983.1,443.81]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:7,
                    verts:[[1848.64,561.957],[1848.64,670.142],[1983.1,562.088],[1983.1,670.897]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[183.384,341.23],[183.384,241.813],[-83.1549,341.718],[-83.1549,242.546]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,442.53],[23.3715,338.559],[-135.151,442.672],[-135.151,338.854]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,549.583],[23.3715,445.612],[-135.151,549.568],[-135.151,445.75]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,558.631],[23.3715,662.602],[-135.151,558.603],[-135.151,662.421]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,671.338],[23.3715,775.309],[-135.151,671.144],[-135.151,774.963]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,784.232],[23.3715,888.203],[-135.151,783.872],[-135.151,887.69]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,442.53],[23.3715,338.559],[35.4673,443.718],[35.4673,341.024]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,549.583],[23.3715,445.612],[35.4673,549.456],[35.4673,446.762]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,558.631],[23.3715,662.602],[35.4673,558.393],[35.4673,661.088]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,671.338],[23.3715,775.309],[35.4673,669.716],[35.4673,772.411]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[23.3715,784.232],[23.3715,888.203],[35.4673,781.224],[35.4673,883.918]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[152.24,443.615],[152.24,340.809],[35.4673,443.718],[35.4673,341.024]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[152.24,549.467],[152.24,446.662],[35.4673,549.456],[35.4673,446.762]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[152.24,558.414],[152.24,661.219],[35.4673,558.393],[35.4673,661.088]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[152.24,669.857],[152.24,772.663],[35.4673,669.716],[35.4673,772.411]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[152.24,781.485],[152.24,884.291],[35.4673,781.224],[35.4673,883.918]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[276.318,446.679],[276.318,343.715],[154.22,446.784],[154.22,343.936]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[276.318,552.695],[276.318,449.731],[154.22,552.68],[154.22,449.832]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[276.318,561.656],[276.318,664.62],[154.22,561.63],[154.22,664.478]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[276.318,673.271],[276.318,776.235],[154.22,673.12],[154.22,775.968]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[276.318,785.071],[276.318,888.035],[154.22,784.794],[154.22,887.642]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[451.692,340.738],[451.692,241.075],[183.831,341.229],[183.831,241.812]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,445.427],[427.212,341.07],[267.507,445.565],[267.507,341.362]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,552.877],[427.212,448.52],[267.507,552.857],[267.507,448.654]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,561.959],[427.212,666.316],[267.507,561.925],[267.507,666.128]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,675.084],[427.212,779.441],[267.507,674.884],[267.507,779.087]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,788.396],[427.212,892.753],[267.507,788.029],[267.507,892.232]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,445.427],[427.212,341.07],[434.375,446.583],[434.375,343.513]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,552.877],[427.212,448.52],[434.375,552.709],[434.375,449.638]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,561.959],[427.212,666.316],[434.375,561.679],[434.375,664.75]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,675.084],[427.212,779.441],[434.375,673.41],[434.375,776.481]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[427.212,788.396],[427.212,892.753],[434.375,785.326],[434.375,888.397]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[555.987,446.479],[555.987,343.293],[434.375,446.583],[434.375,343.513]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[555.987,552.724],[555.987,449.538],[434.375,552.709],[434.375,449.638]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[555.987,561.704],[555.987,664.891],[434.375,561.679],[434.375,664.75]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[555.987,673.56],[555.987,776.747],[434.375,673.41],[434.375,776.481]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[555.987,785.602],[555.987,888.789],[434.375,785.326],[434.375,888.397]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[451.864,340.738],[451.864,241.074],[527.464,367.7],[527.464,281.572]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[675.573,446.338],[675.573,342.994],[552.573,446.443],[552.573,343.216]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[675.573,552.745],[675.573,449.401],[552.573,552.73],[552.573,449.503]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[675.573,561.738],[675.573,665.082],[552.573,561.713],[552.573,664.94]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[675.573,673.765],[675.573,777.109],[552.573,673.613],[552.573,776.84]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[675.573,785.978],[675.573,889.322],[552.573,785.699],[552.573,888.925]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[838.616,340.03],[838.616,240.01],[564.606,340.532],[564.606,240.764]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,445.076],[832.452,340.329],[671.552,445.216],[671.552,340.624]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,552.928],[832.452,448.181],[671.552,552.908],[671.552,448.316]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,562.044],[832.452,666.791],[671.552,562.01],[671.552,666.602]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,675.592],[832.452,780.339],[671.552,675.39],[671.552,779.982]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,789.328],[832.452,894.075],[671.552,788.958],[671.552,893.55]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,445.076],[832.452,340.329],[834.63,446.241],[834.63,342.79]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,552.928],[832.452,448.181],[834.63,552.759],[834.63,449.307]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,562.044],[832.452,666.791],[834.63,561.762],[834.63,665.213]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,675.592],[832.452,780.339],[834.63,673.905],[834.63,777.357]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[832.452,789.328],[832.452,894.075],[834.63,786.235],[834.63,889.686]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.231,446.136],[834.63,446.241],[958.231,342.566],[834.63,342.79]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.231,552.774],[958.231,449.205],[834.63,552.759],[834.63,449.307]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.231,561.787],[958.231,665.356],[834.63,561.762],[834.63,665.213]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.231,674.058],[834.63,673.905],[958.231,777.627],[834.63,777.357]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.231,786.515],[834.63,786.235],[958.231,890.085],[834.63,889.686]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[838.789,340.029],[838.789,240.01],[861.909,367.171],[861.909,280.777]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.233,446.165],[958.233,342.63],[960.767,450.857],[960.767,352.54]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.233,552.77],[958.233,449.234],[960.767,552.089],[960.767,453.771]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.233,561.78],[958.233,665.316],[960.767,560.645],[960.767,658.962]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.233,674.015],[958.233,777.551],[960.767,667.223],[960.767,765.54]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[958.233,786.436],[958.233,889.972],[960.767,773.978],[960.767,872.295]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1148.78,445.933],[1148.78,342.139],[1273.13,445.827],[1273.13,341.914]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1148.78,552.804],[1148.78,449.01],[1273.13,552.819],[1273.13,448.907]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1148.78,561.836],[1148.78,665.63],[1273.13,561.862],[1273.13,665.774]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1148.78,674.351],[1148.78,778.145],[1273.13,674.505],[1273.13,778.418]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1148.78,787.053],[1273.13,787.335],[1148.78,890.847],[1273.13,891.248]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1264.37,339.25],[1264.37,238.839],[1538.08,338.749],[1538.08,238.086]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1276.35,444.692],[1276.35,339.517],[1439.05,444.551],[1439.05,339.22]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1276.35,552.984],[1276.35,447.809],[1439.05,553.004],[1439.05,447.673]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1276.35,562.137],[1276.35,667.311],[1439.05,562.171],[1439.05,667.502]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1276.35,676.148],[1276.35,781.323],[1439.05,676.352],[1439.05,781.683]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1276.35,790.348],[1276.35,895.523],[1439.05,790.722],[1439.05,896.054]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1433.69,445.729],[1433.69,341.708],[1557.56,445.623],[1557.56,341.484]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1433.69,674.647],[1433.69,778.668],[1557.56,674.8],[1557.56,778.939]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1433.69,787.595],[1433.69,891.616],[1557.56,787.876],[1557.56,892.015]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1433.69,552.833],[1433.69,448.812],[1557.56,552.849],[1557.56,448.71]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1433.69,561.886],[1433.69,665.907],[1557.56,561.911],[1557.56,666.05]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1538.15,338.749],[1538.15,238.086],[1812.9,338.245],[1812.9,237.33]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1556.35,444.818],[1556.35,340.677],[1681.01,444.71],[1681.01,340.451]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1556.35,552.045],[1556.35,447.904],[1681.01,552.06],[1681.01,447.8]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1556.35,561.108],[1556.35,665.249],[1681.01,561.133],[1681.01,665.392]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1556.35,673.999],[1556.35,778.14],[1681.01,674.152],[1681.01,778.412]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1556.35,787.077],[1556.35,891.218],[1681.01,787.359],[1681.01,891.619]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1689.5,443.517],[1689.5,337.941],[1853.44,443.374],[1853.44,337.64]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1689.5,552.221],[1689.5,446.646],[1853.44,552.241],[1853.44,446.508]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1689.5,561.409],[1689.5,666.985],[1853.44,561.442],[1853.44,667.176]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1689.5,675.855],[1689.5,781.431],[1853.44,676.06],[1853.44,781.793]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1689.5,790.491],[1689.5,896.067],[1853.44,790.867],[1853.44,896.6]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1843.24,674.409],[1843.24,778.867],[1969.19,674.564],[1969.19,779.142]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1843.24,787.831],[1843.24,892.289],[1969.19,788.117],[1969.19,892.694]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1843.24,444.53],[1843.24,340.072],[1969.19,444.421],[1969.19,339.844]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1843.24,552.084],[1843.24,447.626],[1969.19,552.099],[1969.19,447.521]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:8,
                    verts:[[1843.24,561.174],[1843.24,665.632],[1969.19,561.2],[1969.19,665.777]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[178.779,336.225],[178.779,234.295],[-104.302,334.764],[-104.302,232.101]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[19.5125,439.54],[19.5125,332.354],[-150.052,439.112],[-150.052,331.466]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[19.5125,549.903],[19.5125,442.717],[-150.052,549.948],[-150.052,442.302]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[19.5125,559.23],[19.5125,666.416],[-150.052,559.316],[-150.052,666.962]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[19.5125,675.422],[19.5125,782.608],[-150.052,676.007],[-150.052,783.653]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[19.5125,791.806],[19.5125,898.992],[-150.052,792.89],[-150.052,900.536]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[153.206,441.108],[153.206,335.607],[29.6277,440.8],[29.6277,334.968]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[153.206,549.735],[153.206,444.235],[29.6277,549.768],[29.6277,443.936]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[153.206,558.916],[153.206,664.417],[29.6277,558.978],[29.6277,664.81]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[153.206,673.281],[153.206,778.781],[29.6277,673.702],[29.6277,779.533]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[153.206,787.835],[153.206,893.336],[29.6277,788.615],[29.6277,894.447]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[283.465,444.676],[283.465,339.483],[155.377,444.367],[155.377,338.831]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[283.465,552.986],[283.465,447.794],[155.377,553.031],[155.377,447.495]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[283.465,562.141],[283.465,667.333],[155.377,562.215],[155.377,667.751]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[283.465,676.172],[283.465,781.364],[155.377,676.619],[155.377,782.155]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[283.465,790.392],[283.465,895.585],[155.377,791.212],[155.377,896.748]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[458.307,337.667],[458.307,236.462],[179.249,336.227],[179.249,234.299]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[442.813,443.919],[442.813,337.885],[276.876,443.515],[276.876,337.03]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[442.813,553.096],[442.813,447.062],[276.876,553.155],[276.876,446.671]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[442.813,562.324],[442.813,668.358],[276.876,562.422],[276.876,668.906]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[442.813,677.267],[442.813,783.301],[276.876,677.853],[276.876,784.337]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[442.813,792.4],[442.813,898.434],[276.876,793.475],[276.876,899.959]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[572.579,445.412],[572.579,341.039],[447.53,445.111],[447.53,340.402]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[572.579,552.879],[572.579,448.506],[447.53,552.923],[447.53,448.214]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[572.579,561.962],[572.579,666.336],[447.53,562.035],[447.53,666.744]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[572.579,675.105],[572.579,779.479],[447.53,675.542],[447.53,780.25]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[572.579,788.436],[572.579,892.81],[447.53,789.236],[447.53,893.945]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[694.587,445.667],[694.587,341.576],[569.173,445.364],[569.173,340.938]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[694.587,552.842],[694.587,448.752],[569.173,552.886],[569.173,448.46]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[694.587,561.901],[694.587,665.991],[569.173,561.974],[569.173,666.401]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[694.587,674.737],[694.587,778.828],[569.173,675.175],[569.173,779.602]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[694.587,787.76],[569.173,788.563],[694.587,891.851],[569.173,892.99]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[852.124,339.7],[852.124,239.515],[574.351,338.266],[574.351,237.361]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.505,444.926],[693.061,444.53],[855.505,340.012],[693.061,339.175]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.505,552.95],[855.505,448.036],[693.061,553.007],[693.061,447.652]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.505,562.08],[693.061,562.176],[855.505,666.994],[693.061,667.531]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.505,675.809],[693.061,676.383],[855.505,780.723],[693.061,781.738]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.505,789.727],[693.061,790.779],[855.505,894.641],[693.061,896.134]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.068,446.093],[978.61,446.391],[855.068,342.476],[978.61,343.105]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.068,552.781],[855.068,449.164],[978.61,552.737],[978.61,449.452]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.068,561.798],[855.068,665.414],[978.61,561.726],[978.61,665.011]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.068,674.12],[978.61,673.689],[855.068,777.737],[978.61,776.975]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[855.068,786.629],[978.61,785.838],[855.068,890.245],[978.61,889.124]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1167.96,784.625],[1167.96,887.403],[1150.18,772.08],[1150.18,869.602]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1167.07,446.806],[1167.07,343.982],[1288.67,447.099],[1288.67,344.601]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1167.96,446.847],[1167.96,344.07],[1150.18,451.572],[1150.18,354.049]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1167.07,552.677],[1167.07,449.853],[1288.67,552.634],[1288.67,450.137]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1167.07,561.625],[1167.07,664.449],[1288.67,561.554],[1288.67,664.052]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1167.07,673.088],[1167.07,775.912],[1288.67,672.664],[1288.67,775.162]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1167.07,784.736],[1167.07,887.56],[1288.67,783.958],[1288.67,886.456]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1273.15,341.872],[1273.15,242.778],[1212.02,368.511],[1212.02,282.791]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1273.26,341.873],[1273.26,242.779],[1537.52,343.237],[1537.52,244.827]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,445.997],[1294.28,342.273],[1288.67,447.099],[1288.67,344.601]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,552.794],[1294.28,449.071],[1288.67,552.634],[1288.67,450.137]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,561.821],[1294.28,665.544],[1288.67,561.554],[1288.67,664.052]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,674.26],[1294.28,777.983],[1288.67,672.664],[1288.67,775.162]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,786.884],[1294.28,890.608],[1288.67,783.958],[1288.67,886.456]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,445.997],[1294.28,342.273],[1451.74,446.381],[1451.74,343.084]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,552.794],[1294.28,449.071],[1451.74,552.739],[1451.74,449.442]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,561.821],[1294.28,665.544],[1451.74,561.728],[1451.74,665.024]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,674.26],[1294.28,777.983],[1451.74,673.703],[1451.74,777]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1294.28,786.884],[1294.28,890.608],[1451.74,785.864],[1451.74,889.161]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1444.05,447.512],[1444.05,345.474],[1562.81,447.798],[1562.81,346.078]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1444.05,561.454],[1444.05,663.492],[1562.81,561.385],[1562.81,663.105]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1444.05,672.066],[1444.05,774.104],[1562.81,671.651],[1562.81,773.371]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1444.05,782.861],[1444.05,884.899],[1562.81,782.101],[1562.81,883.821]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1444.05,552.574],[1444.05,450.536],[1562.81,552.533],[1562.81,450.813]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1537.58,343.237],[1537.58,244.828],[1797.89,344.58],[1797.89,246.846]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1561.66,447.008],[1561.66,345.282],[1680.18,447.296],[1680.18,345.887]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1561.66,551.749],[1561.66,450.023],[1680.18,551.71],[1680.18,450.301]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1561.66,560.601],[1561.66,662.327],[1680.18,560.534],[1680.18,661.943]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1561.66,670.874],[1561.66,772.6],[1680.18,670.463],[1680.18,771.872]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1561.66,781.33],[1561.66,883.056],[1680.18,780.574],[1680.18,881.982]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,446.169],[1690.72,343.518],[1680.18,447.296],[1680.18,345.887]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,551.862],[1690.72,449.211],[1680.18,551.71],[1680.18,450.301]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,560.795],[1690.72,663.446],[1680.18,560.534],[1680.18,661.943]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,672.071],[1690.72,774.722],[1680.18,670.463],[1680.18,771.872]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,783.531],[1690.72,886.182],[1680.18,780.574],[1680.18,881.982]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,446.169],[1690.72,343.518],[1844.94,446.548],[1844.94,344.316]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,551.862],[1690.72,449.211],[1844.94,551.811],[1844.94,449.578]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,560.795],[1690.72,663.446],[1844.94,560.707],[1844.94,662.94]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,672.071],[1690.72,774.722],[1844.94,671.53],[1844.94,773.762]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1690.72,783.531],[1690.72,886.182],[1844.94,782.535],[1844.94,884.768]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1833,669.989],[1833,771.03],[1950.43,669.581],[1950.43,770.308]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1833,779.701],[1833,880.742],[1950.43,778.952],[1950.43,879.679]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1833,447.628],[1833,346.587],[1950.43,447.914],[1950.43,347.187]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1833,551.664],[1833,450.623],[1950.43,551.626],[1950.43,450.899]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:9,
                    verts:[[1833,560.457],[1833,661.499],[1950.43,560.391],[1950.43,661.118]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[178.668,330.824],[178.668,226.182],[-120.413,327.175],[-120.413,220.702]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[21.4321,436.324],[21.4321,325.681],[-158.893,435.247],[-158.893,323.448]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[21.4321,550.246],[21.4321,439.603],[-158.893,550.361],[-158.893,438.561]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[21.4321,559.875],[21.4321,670.518],[-158.893,560.09],[-158.893,671.89]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[21.4321,679.814],[21.4321,790.457],[-158.893,681.284],[-158.893,793.084]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[21.4321,799.952],[21.4321,910.594],[-158.893,802.678],[-158.893,914.478]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[159.281,438.421],[159.281,330.033],[29.3054,437.655],[29.3054,328.443]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[159.281,550.022],[159.281,441.634],[29.3054,550.104],[29.3054,440.892]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[159.281,559.454],[159.281,667.843],[29.3054,559.608],[29.3054,668.82]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[159.281,676.95],[159.281,785.338],[29.3054,677.996],[29.3054,787.208]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[159.281,794.64],[159.281,903.028],[29.3054,796.581],[29.3054,905.793]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[295.129,442.538],[295.129,334.968],[161.641,441.777],[161.641,333.361]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[295.129,553.297],[295.129,445.727],[161.641,553.407],[161.641,444.991]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[295.129,562.658],[295.129,670.228],[161.641,562.842],[161.641,671.258]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[295.129,679.266],[295.129,786.836],[161.641,680.368],[161.641,788.784]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[295.129,796.068],[295.129,903.638],[161.641,798.088],[161.641,906.505]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[468.106,334.355],[468.106,231.486],[179.159,330.83],[179.159,226.191]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[462.128,442.321],[462.128,334.51],[290.954,441.334],[290.954,332.424]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[462.128,553.328],[462.128,445.517],[290.954,553.472],[290.954,444.562]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[462.128,562.71],[462.128,670.522],[290.954,562.949],[290.954,671.859]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[462.128,679.58],[462.128,787.392],[290.954,681.01],[290.954,789.92]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[462.128,796.644],[462.128,904.456],[290.954,799.266],[290.954,908.176]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[591.904,444.27],[464.248,443.543],[591.904,338.626],[464.248,337.09]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[591.904,553.045],[591.904,447.401],[464.248,553.151],[464.248,446.698]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[591.904,562.239],[591.904,667.882],[464.248,562.415],[464.248,668.867]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[591.904,676.759],[464.248,677.812],[591.904,782.403],[464.248,784.264]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[591.904,791.469],[464.248,793.4],[591.904,897.112],[464.248,899.852]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[586.587,335.8],[586.587,233.657],[866.289,339.213],[866.289,238.783]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[588.533,444.211],[715.464,444.934],[588.533,338.5],[715.464,340.029]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[588.533,553.054],[715.464,552.949],[588.533,447.344],[715.464,448.043]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[588.533,562.253],[715.464,562.078],[588.533,667.963],[715.464,666.983]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[588.533,676.845],[715.464,675.798],[588.533,782.555],[715.464,780.703]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[588.533,791.627],[715.464,789.706],[588.533,897.337],[715.464,894.611]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,443.789],[716.499,337.609],[715.464,444.934],[715.464,340.029]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,553.115],[716.499,446.936],[715.464,552.949],[715.464,448.043]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,562.355],[716.499,668.534],[715.464,562.078],[715.464,666.983]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,677.456],[716.499,783.635],[715.464,675.798],[715.464,780.703]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,792.747],[716.499,898.926],[715.464,789.706],[715.464,894.611]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,443.789],[716.499,337.61],[879.237,444.728],[879.237,339.593]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,553.115],[716.499,446.936],[879.237,552.979],[879.237,447.844]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,562.355],[716.499,668.534],[879.237,562.128],[879.237,667.263]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,677.456],[716.499,783.635],[879.237,676.097],[879.237,781.231]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[716.499,792.747],[879.237,790.254],[716.499,898.926],[879.237,895.389]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[876.177,445.89],[876.177,342.048],[998.743,446.588],[998.743,343.523]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[876.177,674.414],[876.177,778.256],[998.743,673.403],[998.743,776.469]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[876.177,787.168],[876.177,891.01],[998.743,785.314],[998.743,888.379]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[876.177,552.81],[876.177,448.968],[998.743,552.709],[998.743,449.643]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[876.177,561.847],[876.177,665.689],[998.743,561.678],[998.743,664.743]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1184.56,782.501],[1184.56,884.388],[1156.67,770.262],[1156.67,867.023]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1183.79,447.603],[1183.79,345.667],[1301.85,448.276],[1301.85,347.088]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1183.79,552.561],[1183.79,450.625],[1301.85,552.463],[1301.85,451.276]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1183.79,561.432],[1183.79,663.368],[1301.85,561.269],[1301.85,662.457]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1183.79,671.933],[1183.79,773.87],[1301.85,670.959],[1301.85,772.147]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1183.79,782.617],[1183.79,884.554],[1301.85,780.831],[1301.85,882.019]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1280.04,344.26],[1280.04,246.365],[1193.88,370.117],[1193.88,285.202]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1280.14,344.262],[1280.14,246.367],[1533.75,347.356],[1533.75,251.014]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,447.211],[1309.71,344.839],[1301.85,448.276],[1301.85,347.088]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,552.618],[1309.71,450.246],[1301.85,552.463],[1301.85,451.276]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,561.527],[1309.71,663.9],[1301.85,561.269],[1301.85,662.457]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,672.501],[1309.71,774.874],[1301.85,670.959],[1301.85,772.147]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,783.659],[1309.71,886.031],[1301.85,780.831],[1301.85,882.019]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,447.211],[1309.71,344.839],[1461.04,448.084],[1461.04,346.683]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,552.618],[1309.71,450.246],[1461.04,552.491],[1461.04,451.09]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,561.527],[1309.71,663.9],[1461.04,561.316],[1461.04,662.717]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,672.501],[1309.71,774.874],[1461.04,671.237],[1461.04,772.639]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1309.71,783.659],[1309.71,886.031],[1461.04,781.341],[1461.04,882.742]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1451.19,449.166],[1451.19,348.967],[1564.34,449.811],[1564.34,350.329]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1451.19,669.671],[1451.19,769.87],[1564.34,668.738],[1564.34,768.219]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1451.19,778.468],[1451.19,878.667],[1564.34,776.757],[1564.34,876.238]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1451.19,552.334],[1451.19,452.136],[1564.34,552.241],[1564.34,452.759]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1451.19,561.054],[1451.19,661.252],[1564.34,560.898],[1564.34,660.379]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1533.81,347.356],[1533.81,251.015],[1779.19,350.35],[1779.19,255.512]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1563.26,449.034],[1563.26,349.543],[1675.27,449.678],[1675.27,350.896]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1563.26,551.474],[1563.26,451.983],[1675.27,551.387],[1675.27,452.606]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1563.26,560.132],[1563.26,659.623],[1675.27,559.983],[1675.27,658.765]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1563.26,667.983],[1563.26,767.474],[1675.27,667.064],[1675.27,765.846]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1563.26,776.012],[1563.26,875.503],[1675.27,774.323],[1675.27,873.104]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,448.618],[1687.64,348.667],[1675.27,449.678],[1675.27,350.896]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,551.531],[1687.64,451.58],[1675.27,551.387],[1675.27,452.606]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,560.229],[1687.64,660.179],[1675.27,559.983],[1675.27,658.765]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,668.577],[1687.64,768.527],[1675.27,667.064],[1675.27,765.846]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,777.105],[1687.64,877.055],[1675.27,774.323],[1675.27,873.104]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,448.618],[1687.64,348.667],[1831.92,449.457],[1831.92,350.433]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,551.531],[1687.64,451.58],[1831.92,551.417],[1831.92,452.392]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,560.229],[1687.64,660.179],[1831.92,560.034],[1831.92,659.059]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,668.577],[1687.64,768.527],[1831.92,667.379],[1831.92,766.403]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1687.64,777.105],[1687.64,877.055],[1831.92,774.901],[1831.92,873.926]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1818.46,665.944],[1818.46,763.86],[1927.42,665.05],[1927.42,762.275]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1818.46,772.263],[1818.46,870.178],[1927.42,770.619],[1927.42,867.844]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1818.46,450.463],[1818.46,352.547],[1927.42,451.089],[1927.42,353.864]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1818.46,551.281],[1818.46,453.365],[1927.42,551.196],[1927.42,453.971]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:10,
                    verts:[[1818.46,559.801],[1818.46,657.717],[1927.42,559.656],[1927.42,656.881]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[183.421,325.008],[183.421,217.448],[-130.861,318.899],[-130.861,208.271]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[29.7037,432.872],[29.7037,318.519],[-160.909,431.058],[-160.909,314.754]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[29.7037,550.615],[29.7037,436.261],[-160.909,550.809],[-160.909,434.505]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[29.7037,560.566],[29.7037,674.92],[-160.909,560.93],[-160.909,677.234]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[29.7037,684.528],[29.7037,798.881],[-160.909,687.006],[-160.909,803.31]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[29.7037,808.695],[29.7037,923.048],[-160.909,813.291],[-160.909,929.594]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[170.879,435.549],[170.879,324.073],[35.0494,434.272],[35.0494,321.424]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[170.879,550.329],[170.879,438.853],[35.0494,550.465],[35.0494,437.617]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[170.879,560.03],[170.879,671.506],[35.0494,560.286],[35.0494,673.134]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[170.879,680.872],[170.879,792.348],[35.0494,682.616],[35.0494,795.464]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[170.879,801.915],[170.879,913.391],[35.0494,805.148],[35.0494,917.996]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[311.59,440.265],[311.59,330.166],[173.424,439.009],[173.424,327.514]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[311.59,553.627],[311.59,443.528],[173.424,553.809],[173.424,442.314]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[311.59,563.208],[311.59,673.307],[173.424,563.512],[173.424,675.007]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[311.59,682.557],[311.59,792.656],[173.424,684.375],[173.424,795.87]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[311.59,802.104],[173.424,805.438],[311.59,912.203],[173.424,916.933]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[481.231,330.797],[481.231,226.143],[183.932,325.018],[183.932,217.463]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[485.291,440.634],[310.03,439.022],[485.291,330.946],[310.03,327.54]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[485.291,553.573],[485.291,443.885],[310.03,553.807],[310.03,442.326]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[485.291,563.119],[310.03,563.509],[485.291,672.807],[310.03,674.991]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[485.291,682.023],[310.03,684.357],[485.291,791.712],[310.03,795.839]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[485.291,801.125],[310.03,805.406],[485.291,910.813],[310.03,916.888]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[484.666,441.88],[614.013,443.055],[484.666,333.577],[614.013,336.059]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[484.666,680.22],[614.013,678.519],[484.666,788.522],[614.013,785.515]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[484.666,797.816],[614.013,794.697],[484.666,906.119],[614.013,901.693]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[484.666,553.392],[484.666,445.09],[614.013,553.222],[614.013,446.226]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[484.666,562.817],[484.666,671.12],[614.013,562.533],[614.013,669.529]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[601.268,333.131],[601.268,229.648],[578.545,361.439],[578.545,272.169]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[601.384,333.133],[601.384,229.651],[881.09,338.57],[881.09,237.818]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[610.705,442.983],[610.705,335.907],[738.198,444.141],[738.198,338.354]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[610.705,553.232],[610.705,446.156],[738.198,553.064],[738.198,447.277]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[610.705,562.55],[610.705,669.626],[738.198,562.27],[738.198,668.057]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[610.705,678.623],[610.705,785.698],[738.198,676.945],[738.198,782.733]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[610.705,794.887],[738.198,791.811],[610.705,901.963],[738.198,897.598]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,442.994],[741.845,335.931],[738.198,444.141],[738.198,338.354]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,553.231],[741.845,446.167],[738.198,553.064],[738.198,447.277]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,562.548],[741.845,669.611],[738.198,562.27],[738.198,668.057]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,678.606],[741.845,785.669],[738.198,676.945],[738.198,782.733]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,794.857],[741.845,901.921],[738.198,791.811],[738.198,897.598]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,442.994],[741.845,335.931],[903.592,444.482],[903.592,339.074]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,553.231],[741.845,446.167],[903.592,553.014],[903.592,447.606]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,562.548],[741.845,669.611],[903.592,562.187],[903.592,667.596]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,678.606],[741.845,785.67],[903.592,676.452],[903.592,781.86]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[741.845,794.857],[741.845,901.921],[903.592,790.906],[903.592,896.314]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[897.911,445.633],[897.911,341.505],[1018.58,446.729],[1018.58,343.82]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[897.911,674.786],[897.911,778.914],[1018.58,673.199],[1018.58,776.108]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[897.911,787.85],[897.911,891.977],[1018.58,784.939],[1018.58,887.848]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[897.911,552.847],[897.911,448.719],[1018.58,552.688],[1018.58,449.779]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[897.911,561.909],[897.911,666.037],[1018.58,561.644],[1018.58,664.552]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1199.59,780.572],[1199.59,881.652],[1161.98,768.691],[1161.98,864.794]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1284.96,346.421],[1284.96,249.61],[1174.89,371.418],[1174.89,287.157]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1198.92,448.328],[1198.92,347.197],[1312.73,449.362],[1312.73,349.381]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1198.92,552.456],[1198.92,451.325],[1312.73,552.306],[1312.73,452.325]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1198.92,561.257],[1198.92,662.387],[1312.73,561.006],[1312.73,660.987]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1198.92,670.885],[1198.92,772.015],[1312.73,669.388],[1312.73,769.368]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1198.92,780.694],[1198.92,881.825],[1312.73,777.948],[1312.73,877.929]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1285.07,346.422],[1285.07,249.613],[1526.98,351.125],[1526.98,256.676]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,448.338],[1322.72,347.218],[1312.73,449.362],[1312.73,349.381]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,552.455],[1322.72,451.335],[1312.73,552.306],[1312.73,452.325]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,561.254],[1322.72,662.374],[1312.73,561.006],[1312.73,660.987]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,670.87],[1322.72,771.99],[1312.73,669.388],[1312.73,769.368]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,780.668],[1322.72,881.787],[1312.73,777.948],[1312.73,877.929]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,448.338],[1322.72,347.218],[1467.13,449.666],[1467.13,350.024]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,552.455],[1322.72,451.335],[1467.13,552.262],[1467.13,452.62]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,561.254],[1322.72,662.374],[1467.13,560.933],[1467.13,660.575]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,670.87],[1322.72,771.99],[1467.13,668.947],[1467.13,768.589]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1322.72,780.668],[1322.72,881.787],[1467.13,777.14],[1467.13,876.782]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1455.28,450.696],[1455.28,352.198],[1562.38,451.668],[1562.38,354.253]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1455.28,560.684],[1455.28,659.181],[1562.38,560.448],[1562.38,657.863]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1455.28,667.457],[1455.28,765.954],[1562.38,666.048],[1562.38,763.464]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1455.28,774.407],[1455.28,872.904],[1562.38,771.823],[1562.38,869.239]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1455.28,552.112],[1455.28,453.615],[1562.38,551.971],[1562.38,454.556]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1527.04,351.126],[1527.04,256.677],[1757.15,355.599],[1757.15,263.396]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1561.37,450.905],[1561.37,353.476],[1666.6,451.869],[1666.6,355.503]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1561.37,551.221],[1561.37,453.792],[1666.6,551.09],[1666.6,454.725]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1561.37,559.699],[1561.37,657.128],[1666.6,559.476],[1666.6,655.841]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1561.37,665.314],[1561.37,762.742],[1666.6,663.938],[1666.6,760.303]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1561.37,771.103],[1561.37,868.531],[1666.6,768.573],[1666.6,864.938]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,450.875],[1680.59,353.414],[1666.6,451.869],[1666.6,355.503]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,551.225],[1680.59,453.764],[1666.6,551.09],[1666.6,454.725]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,559.706],[1680.59,657.167],[1666.6,559.476],[1666.6,655.841]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,665.356],[1680.59,762.816],[1666.6,663.938],[1666.6,760.303]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,771.18],[1680.59,868.641],[1666.6,768.573],[1666.6,864.938]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,450.875],[1680.59,353.414],[1814.8,452.121],[1814.8,356.033]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,551.225],[1680.59,453.764],[1814.8,551.056],[1814.8,454.969]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,559.706],[1680.59,657.167],[1814.8,559.418],[1814.8,655.505]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,665.356],[1680.59,762.816],[1814.8,663.579],[1814.8,759.666]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1680.59,771.18],[1680.59,868.641],[1814.8,767.912],[1814.8,863.999]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1800.04,453.054],[1800.04,357.995],[1900.65,453.976],[1900.65,359.934]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1800.04,662.247],[1800.04,757.305],[1900.65,660.931],[1900.65,754.973]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1800.04,550.93],[1800.04,455.871],[1900.65,550.805],[1900.65,456.763]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1800.04,559.202],[1800.04,654.26],[1900.65,558.988],[1900.65,653.03]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:11,
                    verts:[[1800.04,765.463],[1800.04,860.521],[1900.65,763.043],[1900.65,857.084]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[193.521,318.772],[193.521,208.08],[-134.811,309.894],[-134.811,194.745]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[45.0519,429.18],[45.0519,310.858],[-155.114,426.526],[-155.114,305.351]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[45.0519,551.009],[45.0519,432.687],[-155.114,551.293],[-155.114,430.118]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[45.0519,561.306],[45.0519,679.628],[-155.114,561.838],[-155.114,683.013]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[45.0519,689.57],[45.0519,807.892],[-155.114,693.194],[-155.114,814.369]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[45.0519,818.046],[45.0519,936.369],[-155.114,824.768],[-155.114,945.943]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[188.525,432.491],[47.5604,430.646],[188.525,317.728],[47.5604,313.9]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[188.525,550.656],[188.525,435.892],[47.5604,550.853],[47.5604,434.107]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[188.525,560.643],[188.525,675.406],[47.5604,561.012],[47.5604,677.758]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[188.525,685.048],[47.5604,687.567],[188.525,799.811],[47.5604,804.313]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[188.525,809.66],[47.5604,814.332],[188.525,924.423],[47.5604,931.078]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[191.248,436.063],[333.204,437.859],[191.248,321.291],[333.204,325.084]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[191.248,554.237],[333.204,553.976],[191.248,439.465],[333.204,441.201]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[191.248,564.225],[333.204,563.79],[191.248,678.997],[333.204,676.565]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[191.248,688.641],[333.204,686.04],[191.248,803.413],[333.204,798.815]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[191.248,813.262],[333.204,808.493],[191.248,928.034],[333.204,921.268]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[194.049,318.786],[194.049,208.102],[497.871,327.002],[497.871,220.442]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,436.583],[334.461,322.389],[333.204,437.859],[333.204,325.084]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,554.162],[334.461,439.967],[333.204,553.976],[333.204,441.201]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,564.099],[334.461,678.293],[333.204,563.79],[333.204,676.565]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,687.888],[334.461,802.082],[333.204,686.04],[333.204,798.815]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,811.882],[334.461,926.076],[333.204,808.493],[333.204,921.268]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,436.583],[334.461,322.389],[512.475,438.864],[512.475,327.206]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,554.162],[334.461,439.967],[512.475,553.83],[512.475,442.173]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,564.099],[334.461,678.293],[512.475,563.547],[512.475,675.204]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,687.888],[334.461,802.082],[512.475,684.586],[512.475,796.243]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[334.461,811.882],[512.475,805.825],[334.461,926.076],[512.475,917.482]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[508.963,440.127],[508.963,329.874],[638.984,441.771],[638.984,333.347]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[508.963,682.757],[508.963,793.01],[638.984,680.377],[638.984,788.801]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[508.963,802.471],[508.963,912.724],[638.984,798.105],[638.984,906.529]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[508.963,553.647],[508.963,443.394],[638.984,553.408],[638.984,444.985]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[508.963,563.241],[508.963,673.494],[638.984,562.843],[638.984,671.267]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[618.728,330.27],[618.728,225.35],[566.17,358.77],[566.17,268.159]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[618.845,330.273],[618.845,225.355],[896.513,337.781],[896.513,236.633]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[635.769,441.687],[635.769,333.17],[762.793,443.294],[762.793,336.565]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[635.769,553.42],[635.769,444.903],[762.793,553.187],[762.793,446.457]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[635.769,562.864],[635.769,671.381],[762.793,562.475],[762.793,669.204]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[635.769,680.499],[635.769,789.016],[762.793,678.172],[762.793,784.902]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[635.769,798.328],[635.769,906.845],[762.793,794.061],[762.793,900.79]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,442.152],[769.096,334.152],[762.793,443.294],[762.793,336.565]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,553.353],[769.096,445.353],[762.793,553.187],[762.793,446.457]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,562.751],[769.096,670.751],[762.793,562.475],[762.793,669.204]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,679.826],[769.096,787.826],[762.793,678.172],[762.793,784.902]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,797.094],[769.096,905.094],[762.793,794.061],[762.793,900.79]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,442.152],[769.096,334.152],[928.514,444.194],[928.514,338.466]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,553.353],[769.096,445.353],[928.514,553.056],[928.514,447.328]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,562.751],[769.096,670.751],[928.514,562.257],[928.514,667.985]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,679.826],[769.096,787.826],[928.514,676.869],[928.514,782.597]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[769.096,797.094],[769.096,905.094],[928.514,791.67],[928.514,897.398]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[920.227,445.328],[920.227,340.86],[1038.08,446.818],[1038.08,344.008]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[920.227,675.228],[920.227,779.696],[1038.08,673.07],[1038.08,775.88]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[920.227,788.661],[920.227,893.128],[1038.08,784.703],[1038.08,887.513]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[920.227,552.892],[920.227,448.424],[1038.08,552.675],[1038.08,449.865]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[920.227,561.983],[920.227,666.45],[1038.08,561.622],[1038.08,664.432]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1287.97,348.366],[1287.97,252.532],[1155.03,372.428],[1155.03,288.674]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1213.01,778.827],[1213.01,879.176],[1166.1,767.355],[1166.1,862.899]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1212.46,448.983],[1212.46,348.581],[1321.33,450.361],[1321.33,351.491]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1212.46,552.361],[1212.46,451.959],[1321.33,552.161],[1321.33,453.291]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1212.46,561.098],[1212.46,661.5],[1321.33,560.765],[1321.33,659.634]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1212.46,669.936],[1212.46,770.338],[1321.33,667.942],[1321.33,766.811]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1212.46,778.954],[1212.46,879.355],[1321.33,775.296],[1321.33,874.166]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1288.06,348.369],[1288.06,252.536],[1517.35,354.568],[1517.35,261.848]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,449.381],[1333.32,349.422],[1321.33,450.361],[1321.33,351.491]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,552.303],[1333.32,452.344],[1321.33,552.161],[1321.33,453.291]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,561.002],[1333.32,660.961],[1321.33,560.765],[1321.33,659.634]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,669.359],[1333.32,769.319],[1321.33,667.942],[1321.33,766.811]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,777.897],[1333.32,877.856],[1321.33,775.296],[1321.33,874.166]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,449.381],[1333.32,349.422],[1470.1,451.134],[1470.1,353.124]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,552.303],[1333.32,452.344],[1470.1,552.049],[1470.1,454.039]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,561.002],[1333.32,660.961],[1470.1,560.578],[1470.1,658.587]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,669.359],[1333.32,769.319],[1470.1,666.822],[1470.1,764.832]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1333.32,777.897],[1333.32,877.856],[1470.1,773.243],[1470.1,871.253]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1456.42,452.108],[1456.42,355.183],[1557.11,453.382],[1557.11,357.872]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1456.42,665.411],[1456.42,762.337],[1557.11,663.568],[1557.11,759.077]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1456.42,770.655],[1456.42,867.581],[1557.11,767.274],[1557.11,862.783]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1456.42,551.907],[1456.42,454.981],[1557.11,551.722],[1557.11,456.213]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1456.42,560.342],[1456.42,657.267],[1557.11,560.034],[1557.11,655.543]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1517.4,354.57],[1517.4,261.85],[1732,360.373],[1732,270.566]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1556.17,452.63],[1556.17,357.104],[1654.38,453.883],[1654.38,359.739]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1556.17,550.987],[1556.17,455.461],[1654.38,550.817],[1654.38,456.673]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1556.17,559.3],[1556.17,654.826],[1654.38,559.01],[1654.38,653.154]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1556.17,662.852],[1556.17,758.377],[1654.38,661.064],[1654.38,755.208]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1556.17,766.575],[1556.17,862.101],[1654.38,763.288],[1654.38,857.432]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,452.956],[1669.82,357.789],[1654.38,453.883],[1654.38,359.739]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,550.943],[1669.82,455.776],[1654.38,550.817],[1654.38,456.673]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,559.225],[1669.82,654.391],[1654.38,559.01],[1654.38,653.154]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,662.387],[1669.82,757.554],[1654.38,661.064],[1654.38,755.208]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,765.721],[1669.82,860.887],[1654.38,763.288],[1654.38,857.432]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,452.956],[1669.82,357.789],[1793.9,454.559],[1793.9,361.161]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,550.943],[1669.82,455.776],[1793.9,550.726],[1793.9,457.328]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,559.225],[1669.82,654.391],[1793.9,558.853],[1793.9,652.251]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,662.387],[1669.82,757.554],[1793.9,660.099],[1793.9,753.497]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1669.82,765.721],[1669.82,860.887],[1793.9,761.512],[1793.9,854.91]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1778,558.654],[1778,651.1],[1870.41,558.381],[1870.41,649.527]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1778,658.867],[1778,751.314],[1870.41,657.185],[1870.41,748.331]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1778,759.247],[1778,851.694],[1870.41,756.153],[1870.41,847.299]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1778,455.422],[1778,362.976],[1870.41,456.601],[1870.41,365.456]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:12,
                    verts:[[1778,550.609],[1778,458.162],[1870.41,550.449],[1870.41,459.303]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[-131.194,300.127],[209.56,312.12],[-131.194,180.075],[209.56,198.089]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[68.3571,425.252],[-140.274,421.645],[68.3571,302.708],[-140.274,295.224]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[68.3571,551.429],[68.3571,428.884],[-140.274,551.814],[-140.274,425.393]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[68.3571,562.093],[-140.274,562.816],[68.3571,684.637],[-140.274,689.237]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[68.3571,694.934],[-140.274,699.859],[68.3571,817.478],[-140.274,826.281]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[68.3571,827.995],[-140.274,837.13],[68.3571,950.539],[-140.274,963.551]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[67.6954,426.779],[212.851,429.255],[67.6954,305.877],[212.851,311.013]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[67.6954,551.266],[67.6954,430.363],[212.851,551.001],[212.851,432.759]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[67.6954,561.787],[67.6954,682.69],[212.851,561.291],[212.851,679.533]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[67.6954,692.848],[212.851,689.468],[67.6954,813.751],[212.851,807.71]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[67.6954,824.127],[212.851,817.857],[67.6954,945.029],[212.851,936.099]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[210.102,312.139],[210.102,198.118],[518.257,322.985],[518.257,214.409]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[215.74,432.946],[215.74,314.706],[360.394,435.331],[360.394,319.744]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[215.74,554.69],[215.74,436.45],[360.394,554.343],[360.394,438.757]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[215.74,564.979],[215.74,683.219],[360.394,564.402],[360.394,679.989]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[215.74,693.153],[215.74,811.393],[360.394,689.701],[360.394,805.287]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[215.74,821.54],[360.394,815.206],[215.74,939.779],[360.394,930.793]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,434.029],[364.671,316.995],[360.394,435.331],[360.394,319.744]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,554.532],[364.671,437.498],[360.394,554.343],[360.394,438.757]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,564.717],[364.671,681.751],[360.394,564.402],[360.394,679.989]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,691.585],[364.671,808.619],[360.394,689.701],[360.394,805.287]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,818.663],[364.671,935.697],[360.394,815.206],[360.394,930.793]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,434.029],[364.671,316.995],[543.884,437.023],[543.884,323.319]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,554.532],[364.671,437.498],[543.884,554.098],[543.884,440.393]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,564.717],[364.671,681.751],[543.884,563.992],[543.884,677.697]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,691.585],[364.671,808.619],[543.884,687.25],[543.884,800.955]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[364.671,818.663],[364.671,935.697],[543.884,810.712],[543.884,924.417]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[537.352,438.295],[537.352,326.006],[666.908,440.43],[666.908,330.516]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[537.352,563.685],[537.352,675.974],[666.908,563.168],[666.908,673.083]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[537.352,685.409],[537.352,797.698],[666.908,682.318],[666.908,792.232]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[537.352,807.335],[537.352,919.624],[666.908,801.665],[666.908,911.579]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[537.352,553.913],[537.352,441.623],[666.908,553.603],[666.908,443.688]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[638.98,327.234],[638.98,220.791],[555.515,355.775],[555.515,263.661]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[639.096,327.238],[639.096,220.797],[912.542,336.862],[912.542,235.253]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[663.818,440.334],[663.818,330.312],[789.26,442.402],[789.26,334.681]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[663.818,553.617],[663.818,443.595],[789.26,553.316],[789.26,445.595]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[663.818,563.191],[663.818,673.213],[789.26,562.691],[789.26,670.412]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[663.818,682.457],[663.818,792.479],[789.26,679.463],[789.26,787.184]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[663.818,801.921],[663.818,911.943],[789.26,796.429],[789.26,904.15]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,441.273],[798.244,332.295],[789.26,442.402],[789.26,334.681]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,553.48],[798.244,444.503],[789.26,553.316],[789.26,445.595]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,562.964],[798.244,671.942],[789.26,562.691],[789.26,670.412]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,681.098],[798.244,790.076],[789.26,679.463],[789.26,787.184]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,799.428],[798.244,908.406],[789.26,796.429],[789.26,904.15]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,441.273],[798.244,332.295],[953.937,443.874],[953.937,337.789]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,553.48],[798.244,444.503],[953.937,553.103],[953.937,447.018]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,562.964],[798.244,671.942],[953.937,562.335],[953.937,668.419]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,681.098],[798.244,790.076],[953.937,677.333],[953.937,783.417]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[798.244,799.428],[798.244,908.406],[953.937,792.521],[953.937,898.606]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[943.075,444.982],[943.075,340.13],[1057.18,446.863],[1057.18,344.102]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[943.075,675.728],[943.075,780.58],[1057.18,673.006],[1057.18,775.766]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[943.075,789.578],[943.075,894.431],[1057.18,784.585],[1057.18,887.345]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[943.075,552.942],[943.075,448.09],[1057.18,552.669],[1057.18,449.908]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[943.075,562.066],[943.075,666.918],[1057.18,561.611],[1057.18,664.372]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.8,777.247],[1224.8,876.934],[1169.01,766.236],[1169.01,861.311]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1289.05,350.114],[1289.05,255.157],[1134.27,373.162],[1134.27,289.777]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.8,449.626],[1224.8,349.939],[1169.01,453.773],[1169.01,358.698]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.8,552.267],[1224.8,452.58],[1169.01,551.665],[1169.01,456.591]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.8,560.943],[1224.8,660.63],[1169.01,559.939],[1169.01,655.014]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.8,669.005],[1224.8,768.692],[1169.01,663.002],[1169.01,758.077]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.37,449.577],[1224.37,349.835],[1327.67,451.28],[1327.67,353.433]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.37,552.275],[1224.37,452.533],[1327.67,552.027],[1327.67,454.18]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.37,560.954],[1224.37,660.696],[1327.67,560.542],[1327.67,658.389]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.37,669.076],[1224.37,768.818],[1327.67,666.611],[1327.67,764.458]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1224.37,777.377],[1224.37,877.119],[1327.67,772.855],[1327.67,870.702]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1289.14,350.117],[1289.14,255.162],[1504.93,357.712],[1504.93,266.57]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,450.349],[1341.52,351.466],[1327.67,451.28],[1327.67,353.433]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,552.162],[1341.52,453.28],[1327.67,552.027],[1327.67,454.18]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,560.768],[1341.52,659.65],[1327.67,560.542],[1327.67,658.389]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,667.958],[1341.52,766.841],[1327.67,666.611],[1327.67,764.458]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,775.327],[1341.52,874.209],[1327.67,772.855],[1327.67,870.702]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,450.349],[1341.52,351.467],[1470.02,452.496],[1470.02,356.001]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,552.162],[1341.52,453.28],[1470.02,551.851],[1470.02,455.356]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,560.768],[1341.52,659.65],[1470.02,560.248],[1470.02,656.743]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,667.958],[1341.52,766.841],[1470.02,664.85],[1470.02,761.345]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1341.52,775.327],[1341.52,874.209],[1470.02,769.626],[1470.02,866.121]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1454.67,453.414],[1454.67,357.94],[1548.62,454.962],[1548.62,361.211]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1454.67,663.522],[1454.67,758.996],[1548.62,661.28],[1548.62,755.032]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1454.67,767.189],[1454.67,862.663],[1548.62,763.077],[1548.62,856.829]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1454.67,551.717],[1454.67,456.243],[1548.62,551.492],[1548.62,457.741]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1454.67,560.026],[1454.67,655.5],[1548.62,559.651],[1548.62,653.403]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1504.98,357.714],[1504.98,266.573],[1703.86,364.714],[1703.86,277.087]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1547.75,454.221],[1547.75,360.451],[1638.78,455.735],[1638.78,363.633]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1547.75,550.771],[1547.75,457.001],[1638.78,550.566],[1638.78,458.464]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1547.75,558.932],[1547.75,652.702],[1638.78,558.581],[1638.78,650.683]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1547.75,660.581],[1547.75,754.351],[1638.78,658.422],[1638.78,750.524]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1547.75,762.399],[1547.75,856.169],[1638.78,758.428],[1638.78,850.529]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,454.874],[1655.48,361.822],[1638.78,455.735],[1638.78,363.633]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,550.683],[1655.48,457.632],[1638.78,550.566],[1638.78,458.464]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,558.781],[1655.48,651.832],[1638.78,558.581],[1638.78,650.683]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,659.651],[1655.48,752.702],[1638.78,658.422],[1638.78,750.524]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,760.687],[1655.48,853.739],[1638.78,758.428],[1638.78,850.529]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,454.873],[1655.48,361.822],[1769.43,456.794],[1769.43,365.86]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,550.683],[1655.48,457.632],[1769.43,550.423],[1769.43,459.489]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,558.781],[1655.48,651.832],[1769.43,558.336],[1769.43,649.27]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,659.651],[1655.48,752.702],[1769.43,656.911],[1769.43,747.845]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1655.48,760.687],[1655.48,853.739],[1769.43,755.648],[1769.43,846.582]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1752.56,655.777],[1752.56,745.834],[1836.92,653.775],[1836.92,742.285]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1752.56,457.588],[1752.56,367.531],[1836.92,458.991],[1836.92,370.481]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1752.56,550.315],[1752.56,460.258],[1836.92,550.125],[1836.92,461.615]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1752.56,558.152],[1752.56,648.21],[1836.92,557.828],[1836.92,646.338]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:13,
                    verts:[[1752.56,753.563],[1752.56,843.62],[1836.92,749.881],[1836.92,838.391]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[-118.678,289.591],[-118.678,164.249],[232.242,305.08],[232.242,187.514]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[-114.898,416.422],[-114.898,284.387],[100.645,421.106],[100.645,294.105]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[-114.898,552.372],[-114.898,420.336],[100.645,551.872],[100.645,424.87]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[-114.898,563.862],[-114.898,695.898],[100.645,562.924],[100.645,689.925]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[-114.898,706.992],[-114.898,839.028],[100.645,700.596],[100.645,827.597]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[-114.898,850.359],[100.645,838.496],[-114.898,982.394],[100.645,965.497]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[96.4626,562.607],[96.4626,687.91],[244.582,561.971],[244.582,683.864]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[96.4626,422.686],[96.4626,297.383],[244.582,425.859],[244.582,303.967]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[96.4626,551.703],[96.4626,426.4],[244.582,551.364],[244.582,429.472]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[96.4626,698.438],[96.4626,823.741],[244.582,694.105],[244.582,815.997]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[96.4626,834.495],[96.4626,959.798],[244.582,826.458],[244.582,948.35]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[232.793,305.104],[232.793,187.55],[542.653,318.78],[542.653,208.093]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[247.621,429.675],[247.621,307.798],[393.632,432.7],[393.632,314.187]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[247.621,555.165],[247.621,433.288],[393.632,554.725],[393.632,436.212]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[247.621,565.771],[247.621,687.648],[393.632,565.039],[393.632,683.552]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[247.621,697.888],[247.621,819.765],[393.632,693.51],[393.632,812.023]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[247.621,830.224],[247.621,952.101],[393.632,822.193],[393.632,940.706]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,431.382],[401.123,311.403],[393.632,432.7],[393.632,314.187]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,554.917],[401.123,434.938],[393.632,554.725],[393.632,436.212]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,565.358],[401.123,685.336],[393.632,565.039],[393.632,683.552]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,695.417],[401.123,815.396],[393.632,693.51],[393.632,812.023]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,825.692],[401.123,945.671],[393.632,822.193],[393.632,940.706]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,431.382],[401.123,311.403],[579.725,435.133],[579.725,319.326]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,554.917],[401.123,434.938],[579.725,554.372],[579.725,438.565]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,565.358],[401.123,685.336],[579.725,564.45],[579.725,680.257]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,695.417],[401.123,815.396],[579.725,689.987],[579.725,805.794]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[401.123,825.692],[401.123,945.671],[579.725,815.733],[579.725,931.54]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[662.162,324.055],[662.162,216.015],[546.767,352.459],[546.767,258.68]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[570.059,436.404],[570.059,322.01],[697.877,439.05],[697.877,327.6]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[570.059,688.147],[570.059,802.541],[697.877,684.316],[697.877,795.766]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[570.059,812.357],[570.059,926.751],[697.877,805.331],[697.877,916.781]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[570.059,554.188],[570.059,439.794],[697.877,553.803],[697.877,442.353]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[570.059,564.142],[570.059,678.536],[697.877,563.502],[697.877,674.952]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[662.276,324.06],[662.276,216.023],[929.151,335.839],[929.151,233.716]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[694.947,438.941],[694.947,327.37],[817.596,441.481],[817.596,332.736]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[694.947,553.819],[694.947,442.248],[817.596,553.45],[817.596,444.704]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[694.947,563.528],[694.947,675.1],[817.596,562.914],[817.596,671.659]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[694.947,684.474],[694.947,796.045],[817.596,680.796],[817.596,789.542]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[694.947,805.62],[694.947,917.191],[817.596,798.874],[817.596,907.62]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,440.373],[829.269,330.395],[817.596,441.481],[817.596,332.736]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,553.611],[829.269,443.633],[817.596,553.45],[817.596,444.704]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,563.182],[829.269,673.16],[817.596,562.914],[817.596,671.659]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,682.401],[829.269,792.379],[817.596,680.796],[817.596,789.542]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,801.817],[829.269,911.796],[817.596,798.874],[817.596,907.62]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,440.373],[829.269,330.395],[979.775,443.534],[979.775,337.071]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,553.611],[829.269,443.633],[979.775,553.152],[979.775,446.689]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,563.182],[829.269,673.16],[979.775,562.417],[979.775,668.88]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,682.401],[829.269,792.379],[979.775,677.825],[979.775,784.288]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[829.269,801.817],[829.269,911.796],[979.775,793.424],[979.775,899.888]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[966.386,444.609],[966.386,339.342],[1075.79,446.874],[1075.79,344.126]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[966.386,676.269],[966.386,781.536],[1075.79,672.99],[1075.79,775.737]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[966.386,790.569],[966.386,895.836],[1075.79,784.555],[1075.79,887.303]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[966.386,552.996],[966.386,447.729],[1075.79,552.667],[1075.79,449.919]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[966.386,562.157],[966.386,667.424],[1075.79,561.609],[1075.79,664.357]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1288.17,351.685],[1288.17,257.517],[1112.6,373.636],[1112.6,290.488]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.89,775.806],[1234.89,874.89],[1170.68,765.309],[1170.68,859.995]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.89,450.168],[1234.89,351.085],[1170.68,454.122],[1170.68,359.435]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.89,552.189],[1234.89,453.105],[1170.68,551.615],[1170.68,456.928]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.89,560.811],[1234.89,659.895],[1170.68,559.855],[1170.68,654.541]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.89,668.22],[1234.89,767.303],[1170.68,662.497],[1170.68,757.183]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.58,450.118],[1234.58,350.979],[1331.69,452.13],[1331.69,355.228]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.58,552.196],[1234.58,453.057],[1331.69,551.904],[1331.69,455.002]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.58,560.823],[1234.58,659.962],[1331.69,560.337],[1331.69,657.238]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.58,668.292],[1234.58,767.431],[1331.69,665.38],[1331.69,762.282]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1234.58,775.939],[1234.58,875.078],[1331.69,770.598],[1331.69,867.5]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1288.26,351.689],[1288.26,257.523],[1489.76,360.582],[1489.76,270.882]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,451.251],[1347.27,353.371],[1331.69,452.13],[1331.69,355.228]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,552.031],[1347.27,454.152],[1331.69,551.904],[1331.69,455.002]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,560.549],[1347.27,658.429],[1331.69,560.337],[1331.69,657.238]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,666.653],[1347.27,764.532],[1331.69,665.38],[1331.69,762.282]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,772.932],[1347.27,870.811],[1331.69,770.598],[1331.69,867.5]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,451.251],[1347.27,353.372],[1466.9,453.763],[1466.9,358.678]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,552.031],[1347.27,454.152],[1466.9,551.667],[1466.9,456.581]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,560.549],[1347.27,658.429],[1466.9,559.941],[1466.9,655.026]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,666.653],[1347.27,764.532],[1466.9,663.016],[1466.9,758.101]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1347.27,772.932],[1347.27,870.811],[1466.9,766.261],[1466.9,861.346]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1450.04,559.733],[1450.04,653.864],[1536.98,559.298],[1536.98,651.426]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1450.04,661.772],[1450.04,755.903],[1536.98,659.167],[1536.98,751.295]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1450.04,763.98],[1450.04,858.11],[1536.98,759.201],[1536.98,851.329]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1450.04,454.622],[1450.04,360.492],[1536.98,456.422],[1536.98,364.294]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1450.04,551.542],[1450.04,457.412],[1536.98,551.281],[1536.98,459.153]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1489.8,360.585],[1489.8,270.885],[1672.83,368.663],[1672.83,283.019]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1536.18,455.691],[1536.18,363.542],[1619.87,457.439],[1619.87,367.217]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1536.18,550.572],[1536.18,458.423],[1619.87,550.335],[1619.87,460.113]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1536.18,558.591],[1536.18,650.741],[1619.87,558.187],[1619.87,648.409]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1536.18,658.483],[1536.18,750.633],[1619.87,655.99],[1619.87,746.212]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1536.18,758.541],[1536.18,850.69],[1619.87,753.955],[1619.87,844.177]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,456.644],[1637.68,365.544],[1619.87,457.439],[1619.87,367.217]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,550.443],[1637.68,459.344],[1619.87,550.335],[1619.87,460.113]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,558.371],[1637.68,649.47],[1619.87,558.187],[1619.87,648.409]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,657.125],[1637.68,748.224],[1619.87,655.99],[1619.87,746.212]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,756.042],[1637.68,847.141],[1619.87,753.955],[1619.87,844.177]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,456.644],[1637.68,365.544],[1741.52,458.843],[1741.52,370.169]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,550.443],[1637.68,459.344],[1741.52,550.145],[1741.52,461.471]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,558.371],[1637.68,649.47],[1741.52,557.862],[1741.52,646.536]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,657.125],[1637.68,748.224],[1741.52,653.986],[1741.52,742.66]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1637.68,756.042],[1637.68,847.141],[1741.52,750.27],[1741.52,838.944]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1723.82,459.571],[1723.82,371.7],[1800.31,461.169],[1800.31,375.061]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1723.82,557.693],[1723.82,645.564],[1800.31,557.324],[1800.31,643.432]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1723.82,652.947],[1723.82,740.818],[1800.31,650.667],[1800.31,736.776]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1723.82,550.047],[1723.82,462.176],[1800.31,549.83],[1800.31,463.721]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:14,
                    verts:[[1723.82,748.359],[1723.82,836.23],[1800.31,744.166],[1800.31,830.274]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[-95.6684,278.311],[-95.6684,147.305],[262.357,297.701],[262.357,176.431]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[-77.2513,410.884],[-77.2513,272.894],[143.053,416.776],[143.053,285.12]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[-77.2513,552.963],[-77.2513,414.974],[143.053,552.334],[143.053,420.678]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[-77.2513,564.972],[-77.2513,702.961],[143.053,563.791],[143.053,695.447]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[-77.2513,714.555],[-77.2513,852.545],[143.053,706.509],[143.053,838.165]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[-77.2513,864.387],[-77.2513,1002.38],[143.053,849.463],[143.053,981.119]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[134.995,563.467],[134.995,693.38],[284.504,562.677],[284.504,688.357]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[134.995,418.397],[134.995,288.483],[284.504,422.336],[284.504,296.656]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[134.995,552.161],[134.995,422.247],[284.504,551.74],[284.504,426.061]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[134.995,704.296],[134.995,834.209],[284.504,698.917],[284.504,824.596]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[134.995,845.358],[134.995,975.272],[284.504,835.382],[284.504,961.061]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[262.911,297.731],[262.911,176.476],[571.333,314.435],[571.333,201.566]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[287.669,426.283],[287.669,300.634],[433.406,429.996],[433.406,308.475]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[287.669,555.657],[287.669,430.007],[433.406,555.118],[433.406,433.598]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[287.669,566.592],[287.669,692.241],[433.406,565.693],[433.406,687.214]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[287.669,702.799],[287.669,828.448],[433.406,697.424],[433.406,818.944]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[287.669,839.231],[287.669,964.881],[433.406,829.373],[433.406,950.893]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,428.674],[444.288,305.683],[433.407,429.996],[433.407,308.475]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,555.31],[444.288,432.319],[433.407,555.118],[433.407,433.598]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,566.013],[444.288,689.004],[433.407,565.693],[433.407,687.214]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,699.338],[444.288,822.328],[433.407,697.424],[433.407,818.944]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,832.883],[444.288,955.874],[433.407,829.373],[433.407,950.893]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,428.674],[444.288,305.683],[620.187,433.221],[620.187,315.287]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,555.31],[444.288,432.319],[620.187,554.65],[620.187,436.716]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,566.013],[444.288,689.004],[620.187,564.913],[620.187,682.846]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,699.338],[444.288,822.328],[620.187,692.755],[620.187,810.689]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[444.288,832.883],[444.288,955.874],[620.187,820.81],[620.187,938.744]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[688.412,320.776],[688.412,211.091],[540.173,348.833],[540.173,253.233]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[607.296,434.479],[607.296,317.945],[731.957,437.653],[731.957,324.649]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[607.296,564.608],[607.296,681.142],[731.957,563.84],[731.957,676.844]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[607.296,690.934],[607.296,807.468],[731.957,686.339],[731.957,799.342]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[607.296,554.467],[607.296,437.933],[731.957,554.006],[731.957,441.002]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[607.296,817.468],[607.296,934.002],[731.957,809.04],[731.957,922.044]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[688.523,320.782],[688.523,211.1],[946.301,334.744],[946.301,232.07]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[729.224,437.532],[729.224,324.393],[847.772,440.551],[847.772,330.771]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[729.224,554.024],[729.224,440.885],[847.772,553.585],[847.772,443.805]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[729.224,563.869],[729.224,677.008],[847.772,563.139],[847.772,672.919]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[729.224,686.514],[729.224,799.653],[847.772,682.143],[847.772,791.922]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[729.224,809.362],[729.224,922.501],[847.772,801.343],[847.772,911.123]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,439.474],[862.115,328.495],[847.773,440.551],[847.773,330.771]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,553.742],[862.115,442.763],[847.773,553.585],[847.773,443.805]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,563.399],[862.115,674.378],[847.773,563.139],[847.773,672.919]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,683.702],[862.115,794.681],[847.773,682.143],[847.773,791.922]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,804.205],[862.115,915.183],[847.773,801.343],[847.773,911.123]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,439.474],[862.115,328.496],[1005.91,443.191],[1005.91,336.346]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,553.742],[862.115,442.763],[1005.91,553.202],[1005.91,446.358]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,563.399],[862.115,674.378],[1005.91,562.5],[1005.91,669.344]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,683.703],[862.115,794.681],[1005.91,678.322],[1005.91,785.166]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[862.115,804.205],[862.115,915.183],[1005.91,794.335],[1005.91,901.18]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[990.066,444.225],[990.066,338.53],[1093.79,446.866],[1093.79,344.109]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[990.066,676.825],[990.066,782.519],[1093.79,673.001],[1093.79,775.758]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[990.066,791.589],[990.066,897.284],[1093.79,784.576],[1093.79,887.333]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[990.066,553.052],[990.066,447.357],[1093.79,552.668],[1093.79,449.911]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[990.066,562.25],[990.066,667.944],[1093.79,561.611],[1093.79,664.367]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1285.3,353.104],[1285.3,259.648],[1089.97,373.866],[1089.97,290.834]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243.19,774.474],[1243.19,872.999],[1171.05,764.545],[1171.05,858.912]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243.19,450.67],[1243.19,352.145],[1171.05,454.409],[1171.05,360.043]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243.19,552.116],[1243.19,453.59],[1171.05,551.573],[1171.05,457.206]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243.19,560.69],[1243.19,659.215],[1171.05,559.785],[1171.05,654.151]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243.19,667.493],[1243.19,766.019],[1171.05,662.08],[1171.05,756.447]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243,450.619],[1243,352.038],[1333.35,452.921],[1333.35,356.899]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243,552.123],[1243,453.541],[1333.35,551.789],[1333.35,455.767]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243,560.702],[1243,659.284],[1333.35,560.145],[1333.35,656.167]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243,667.567],[1243,766.149],[1333.35,664.235],[1333.35,760.257]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1243,774.609],[1243,873.191],[1333.35,768.497],[1333.35,864.519]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1285.38,353.108],[1285.38,259.655],[1471.84,363.207],[1471.84,274.823]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,452.098],[1350.5,355.16],[1333.35,452.921],[1333.35,356.899]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,551.909],[1350.5,454.971],[1333.35,551.789],[1333.35,455.767]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,560.344],[1350.5,657.282],[1333.35,560.145],[1333.35,656.167]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,665.427],[1350.5,762.364],[1333.35,664.235],[1333.35,760.257]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,770.683],[1350.5,867.621],[1333.35,768.497],[1333.35,864.519]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,452.098],[1350.5,355.16],[1460.74,454.947],[1460.74,361.178]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,551.909],[1350.5,454.971],[1460.74,551.495],[1460.74,457.726]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,560.344],[1350.5,657.282],[1460.74,559.655],[1460.74,653.423]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,665.427],[1350.5,762.364],[1460.74,661.302],[1460.74,755.07]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1350.5,770.683],[1350.5,867.621],[1460.74,763.117],[1460.74,856.886]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1442.51,455.744],[1442.51,362.863],[1522.19,457.773],[1522.19,367.148]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1442.51,660.147],[1442.51,753.029],[1522.19,657.21],[1522.19,747.835]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1442.51,761],[1442.51,853.881],[1522.19,755.612],[1522.19,846.237]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1442.51,551.379],[1442.51,458.497],[1522.19,551.084],[1522.19,460.459]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1442.51,559.462],[1442.51,652.343],[1522.19,558.971],[1522.19,649.596]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1471.88,363.209],[1471.88,274.827],[1638.95,372.257],[1638.95,288.417]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1521.47,457.052],[1521.47,366.404],[1597.71,459.01],[1597.71,370.521]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1521.47,550.388],[1521.47,459.739],[1597.71,550.123],[1597.71,461.633]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1521.47,558.276],[1521.47,648.925],[1597.71,557.823],[1597.71,646.313]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1521.47,656.542],[1521.47,747.19],[1597.71,653.748],[1597.71,742.237]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1521.47,754.969],[1521.47,845.618],[1597.71,749.831],[1597.71,838.32]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,458.281],[1616.48,368.986],[1597.71,459.01],[1597.71,370.521]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,550.221],[1616.48,460.927],[1597.71,550.123],[1597.71,461.633]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,557.992],[1616.48,647.286],[1597.71,557.823],[1597.71,646.313]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,654.789],[1616.48,744.083],[1597.71,653.748],[1597.71,742.237]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,751.746],[1616.48,841.04],[1597.71,749.831],[1597.71,838.32]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,458.281],[1616.48,368.986],[1710.25,460.725],[1710.25,374.127]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,550.221],[1616.48,460.927],[1710.25,549.89],[1710.25,463.292]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,557.992],[1616.48,647.286],[1710.25,557.426],[1710.25,644.025]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,654.789],[1616.48,744.083],[1710.25,651.301],[1710.25,737.899]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1616.48,751.746],[1616.48,841.04],[1710.25,745.331],[1710.25,831.929]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1691.87,650.354],[1691.87,736.221],[1760.64,647.833],[1760.64,731.751]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1691.87,461.389],[1691.87,375.522],[1760.64,463.156],[1760.64,379.238]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1691.87,549.8],[1691.87,463.934],[1760.64,549.561],[1760.64,465.643]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1691.87,557.273],[1691.87,643.14],[1760.64,556.864],[1760.64,640.782]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:15,
                    verts:[[1691.87,743.59],[1691.87,829.456],[1760.64,738.953],[1760.64,822.871]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[-60.3239,266.36],[-60.3239,129.355],[300.743,290.069],[300.743,164.967]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[-25.414,405.085],[-25.414,260.862],[196.77,412.319],[196.77,275.871]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[-25.414,553.583],[-25.414,409.36],[196.77,552.81],[196.77,416.363]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[-25.414,566.134],[-25.414,710.357],[196.77,564.684],[196.77,701.132]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[-25.414,722.475],[-25.414,866.698],[196.77,712.596],[196.77,849.044]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[-25.414,879.075],[-25.414,1023.3],[196.77,860.753],[196.77,997.2]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[184.493,564.355],[184.493,699.034],[333.411,563.399],[333.411,692.95]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[184.493,413.963],[184.493,279.284],[333.411,418.734],[333.411,289.182]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[184.493,552.635],[184.493,417.955],[333.411,552.125],[333.411,422.574]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[184.493,710.35],[184.493,845.03],[333.411,703.835],[333.411,833.387]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[184.493,856.587],[184.493,991.267],[333.411,844.505],[333.411,974.056]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[301.295,290.105],[301.295,165.021],[604.553,310.018],[604.553,194.932]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[336.673,422.817],[336.673,293.312],[480.179,427.262],[480.179,302.701]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[336.673,556.161],[336.673,426.655],[480.179,555.515],[480.179,430.954]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[336.673,567.43],[336.673,696.935],[480.179,566.355],[480.179,690.916]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[336.673,707.817],[336.673,837.322],[480.179,701.381],[480.179,825.942]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[336.673,848.436],[336.673,977.941],[480.179,836.632],[480.179,961.193]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,425.951],[494.593,299.931],[480.179,427.262],[480.179,302.701]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,555.705],[494.593,429.686],[480.179,555.515],[480.179,430.954]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,566.672],[494.593,692.692],[480.179,566.355],[480.179,690.916]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,703.28],[494.593,829.299],[480.179,701.381],[480.179,825.942]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,840.114],[494.593,966.134],[480.179,836.632],[480.179,961.193]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,425.951],[494.593,299.931],[665.398,431.325],[665.398,311.283]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,555.705],[494.593,429.686],[665.398,554.925],[665.398,434.883]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,566.672],[494.593,692.692],[665.398,565.372],[665.398,685.414]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,703.28],[494.593,829.299],[665.398,695.5],[665.398,815.542]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[494.593,840.114],[494.593,966.134],[665.398,825.843],[665.398,945.885]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[717.844,317.457],[717.844,206.106],[536.036,344.915],[536.036,247.348]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[649.23,432.557],[649.23,313.886],[769.167,436.27],[769.167,321.729]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[649.23,693.716],[649.23,812.387],[769.167,688.34],[769.167,802.882]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[649.23,554.746],[649.23,436.075],[769.167,554.207],[769.167,439.665]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[649.23,565.073],[649.23,683.745],[769.167,564.175],[769.167,678.716]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[649.23,822.571],[649.23,941.243],[769.167,812.712],[769.167,927.253]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[717.951,317.464],[717.951,206.116],[963.929,333.616],[963.929,230.377]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[766.672,436.137],[766.672,321.446],[879.717,439.638],[879.717,328.843]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[766.672,554.226],[766.672,439.536],[879.717,553.718],[879.717,442.922]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[766.672,564.207],[766.672,678.897],[879.717,563.36],[879.717,674.155]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[766.672,688.534],[766.672,803.224],[879.717,683.465],[879.717,794.26]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[766.672,813.067],[766.672,927.757],[879.717,803.768],[879.717,914.564]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,438.602],[896.678,326.654],[879.717,439.638],[879.717,328.843]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,553.868],[896.678,441.92],[879.717,553.718],[879.717,442.922]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,563.61],[896.678,675.559],[879.717,563.36],[879.717,674.155]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,684.965],[896.678,796.913],[879.717,683.465],[879.717,794.26]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,806.52],[896.678,918.468],[879.717,803.768],[879.717,914.564]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,438.602],[896.678,326.654],[1032.19,442.866],[1032.19,335.66]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,553.868],[896.678,441.92],[1032.19,553.249],[1032.19,446.043]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,563.61],[896.678,675.559],[1032.19,562.579],[1032.19,669.785]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,684.965],[896.678,796.913],[1032.19,678.792],[1032.19,785.998]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[896.678,806.52],[896.678,918.468],[1032.19,795.198],[1032.19,902.404]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1013.99,443.85],[1013.99,337.738],[1111.06,446.855],[1111.06,344.086]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1013.99,677.368],[1013.99,783.479],[1111.06,673.017],[1111.06,775.786]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1013.99,553.106],[1013.99,446.995],[1111.06,552.67],[1111.06,449.901]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1013.99,562.34],[1013.99,668.452],[1111.06,561.613],[1111.06,664.382]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1013.99,792.586],[1013.99,898.697],[1111.06,784.605],[1111.06,887.374]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1280.36,354.394],[1280.36,261.587],[1066.38,373.87],[1066.38,290.84]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.58,773.216],[1249.58,871.214],[1170.05,763.913],[1170.05,858.015]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.58,451.144],[1249.58,353.146],[1170.05,454.647],[1170.05,360.545]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.58,552.047],[1249.58,454.049],[1170.05,551.538],[1170.05,457.436]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.58,560.575],[1249.58,658.573],[1170.05,559.727],[1170.05,653.829]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.58,666.807],[1249.58,764.806],[1170.05,661.736],[1170.05,755.838]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.51,451.093],[1249.51,353.038],[1332.55,453.665],[1332.55,358.471]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.51,552.054],[1249.51,453.999],[1332.55,551.681],[1332.55,456.487]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.51,560.588],[1249.51,658.643],[1332.55,559.965],[1332.55,655.159]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.51,666.882],[1249.51,764.937],[1332.55,663.158],[1332.55,758.352]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1249.51,773.352],[1249.51,871.407],[1332.55,766.521],[1332.55,861.716]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1280.44,354.399],[1280.44,261.594],[1451.16,365.61],[1451.16,278.433]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,452.901],[1351.14,356.857],[1332.55,453.665],[1332.55,358.471]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,551.792],[1351.14,455.748],[1332.55,551.681],[1332.55,456.487]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,560.15],[1351.14,656.194],[1332.55,559.965],[1332.55,655.159]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,664.264],[1351.14,760.307],[1332.55,663.158],[1332.55,758.352]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,768.55],[1351.14,864.593],[1332.55,766.521],[1332.55,861.716]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,452.901],[1351.14,356.857],[1451.49,456.059],[1451.49,363.526]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,551.792],[1351.14,455.748],[1451.49,551.333],[1451.49,458.801]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,560.15],[1351.14,656.194],[1451.49,559.386],[1451.49,651.918]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,664.264],[1351.14,760.307],[1451.49,659.693],[1451.49,752.225]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1351.14,768.55],[1351.14,864.593],[1451.49,760.166],[1451.49,852.698]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1432.05,456.793],[1432.05,365.077],[1504.26,459.028],[1504.26,369.799]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1432.05,658.63],[1432.05,750.346],[1504.26,655.394],[1504.26,744.623]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1451.2,365.612],[1451.2,278.437],[1602.22,375.529],[1602.22,293.332]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1432.05,551.227],[1432.05,459.511],[1504.26,550.902],[1504.26,461.673]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1432.05,559.208],[1432.05,650.924],[1504.26,558.667],[1504.26,647.896]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1432.05,758.217],[1432.05,849.932],[1504.26,752.28],[1504.26,841.51]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1503.62,458.316],[1503.62,369.061],[1572.33,460.462],[1572.33,373.573]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1503.62,550.217],[1503.62,460.962],[1572.33,549.926],[1572.33,463.037]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1503.62,557.984],[1503.62,647.239],[1572.33,557.487],[1572.33,644.376]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1503.62,654.738],[1503.62,743.993],[1572.33,651.677],[1572.33,738.566]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1503.62,751.653],[1503.62,840.908],[1572.33,746.023],[1572.33,832.911]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,459.797],[1591.91,372.176],[1572.33,460.462],[1572.33,373.573]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,550.016],[1591.91,462.395],[1572.33,549.926],[1572.33,463.037]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,557.641],[1591.91,645.263],[1572.33,557.487],[1572.33,644.376]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,652.625],[1591.91,740.246],[1572.33,651.677],[1572.33,738.566]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,747.766],[1591.91,835.387],[1572.33,746.023],[1572.33,832.911]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,459.797],[1591.91,372.176],[1675.69,462.456],[1675.69,377.767]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,550.016],[1591.91,462.395],[1675.69,549.656],[1675.69,464.966]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,557.641],[1591.91,645.263],[1675.69,557.026],[1675.69,641.715]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,652.625],[1591.91,740.246],[1675.69,648.831],[1675.69,733.52]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1591.91,747.766],[1591.91,835.387],[1675.69,740.788],[1675.69,825.477]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1656.74,647.975],[1656.74,732.003],[1717.98,645.245],[1717.98,727.164]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1656.74,463.056],[1656.74,379.028],[1717.98,464.969],[1717.98,383.051]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1656.74,549.575],[1656.74,465.547],[1717.98,549.315],[1717.98,467.397]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1656.74,556.887],[1656.74,640.915],[1717.98,556.444],[1717.98,638.362]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:16,
                    verts:[[1656.74,739.214],[1656.74,823.242],[1717.98,734.194],[1717.98,816.112]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[-10.6328,253.879],[-10.6328,110.607],[348.229,282.305],[348.229,153.306]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[-162.081,393.541],[-162.081,236.908],[28.1525,400.925],[28.1525,252.229]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[-162.081,554.816],[-162.081,398.183],[28.1525,554.027],[28.1525,405.332]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[-162.081,568.447],[-162.081,725.079],[28.1525,566.967],[28.1525,715.662]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[-162.081,738.24],[-162.081,894.872],[28.1525,728.156],[28.1525,876.851]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[-162.081,908.314],[-162.081,1064.95],[28.1525,889.612],[28.1525,1038.31]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,399.117],[42.6028,248.48],[28.1525,400.925],[28.1525,252.229]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,554.22],[42.6028,403.582],[28.1525,554.027],[28.1525,405.332]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,567.329],[42.6028,717.967],[28.1525,566.967],[28.1525,715.662]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,730.624],[42.6028,881.262],[28.1525,728.156],[28.1525,876.851]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,894.189],[42.6028,1044.83],[28.1525,889.612],[28.1525,1038.31]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,399.117],[42.6028,248.48],[262.927,407.816],[262.927,266.529]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,554.22],[42.6028,403.582],[262.927,553.291],[262.927,412.004]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,567.329],[42.6028,717.967],[262.927,565.586],[262.927,706.873]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,730.624],[42.6028,881.262],[262.927,718.745],[262.927,860.032]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[42.6028,894.189],[42.6028,1044.83],[262.927,872.156],[262.927,1013.44]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[246.129,409.463],[246.129,269.946],[392.024,415.122],[392.024,281.689]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[246.129,553.115],[246.129,413.598],[392.024,552.511],[392.024,419.077]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[246.129,565.256],[246.129,704.773],[392.024,564.122],[392.024,697.556]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[246.129,716.496],[246.129,856.013],[392.024,708.767],[392.024,842.201]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[246.129,867.986],[246.129,1007.5],[392.024,853.651],[392.024,987.085]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[348.769,282.348],[348.769,153.37],[642.519,305.618],[642.519,188.322]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[395.342,419.343],[395.342,285.974],[534.316,424.556],[534.316,296.985]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[395.342,556.665],[395.342,423.296],[534.316,555.908],[534.316,428.337]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[395.342,568.271],[395.342,701.64],[534.316,567.01],[534.316,694.58]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[395.342,712.846],[395.342,846.215],[534.316,705.299],[534.316,832.87]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[395.342,857.661],[395.342,991.029],[534.316,843.817],[534.316,971.388]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,423.273],[552.354,294.275],[534.316,424.556],[534.316,296.985]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,556.094],[552.354,427.096],[534.316,555.908],[534.316,428.337]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,567.32],[552.354,696.318],[534.316,567.01],[534.316,694.58]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,707.157],[552.354,836.155],[534.316,705.299],[534.316,832.87]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,847.225],[552.354,976.223],[534.316,843.817],[534.316,971.388]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,423.273],[552.354,294.275],[715.384,429.494],[715.384,307.415]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,556.094],[552.354,427.096],[715.384,555.191],[715.384,433.112]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,567.32],[552.354,696.318],[715.384,565.815],[715.384,687.894]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,707.157],[552.354,836.155],[715.384,698.151],[715.384,820.23]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[552.354,847.225],[552.354,976.223],[715.384,830.706],[715.384,952.785]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[750.52,314.173],[750.52,201.172],[534.714,340.739],[534.714,241.075]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[695.939,430.684],[695.939,309.928],[809.45,434.939],[809.45,318.917]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[695.939,565.527],[695.939,686.282],[809.45,564.497],[809.45,680.519]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[695.939,696.428],[695.939,817.183],[809.45,690.267],[809.45,806.29]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[695.939,555.018],[695.939,434.263],[809.45,554.4],[809.45,438.378]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[695.939,827.546],[695.939,948.302],[809.45,816.246],[809.45,932.269]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[750.622,314.181],[750.622,201.184],[981.941,332.505],[981.941,228.707]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[807.231,434.794],[807.231,318.61],[913.292,438.772],[913.292,327.013]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[807.231,554.421],[807.231,438.237],[913.292,553.844],[913.292,442.085]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[807.231,564.532],[807.231,680.716],[913.292,563.569],[913.292,675.328]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[807.231,690.478],[807.231,806.662],[913.292,684.718],[913.292,796.477]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[807.231,816.633],[807.231,932.817],[913.292,806.068],[913.292,917.827]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,437.789],[932.781,324.936],[913.292,438.772],[913.292,327.013]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,553.986],[932.781,441.134],[913.292,553.844],[913.292,442.085]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,563.807],[932.781,676.66],[913.292,563.569],[913.292,675.328]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,686.142],[932.781,798.995],[913.292,684.718],[913.292,796.477]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,808.679],[932.781,921.532],[913.292,806.068],[913.292,917.827]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,437.789],[932.781,324.936],[1058.4,442.582],[1058.4,335.06]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,553.986],[932.781,441.134],[1058.4,553.29],[1058.4,445.769]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,563.807],[932.781,676.66],[1058.4,562.647],[1058.4,670.169]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,686.142],[932.781,798.995],[1058.4,679.203],[1058.4,786.725]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[932.781,808.679],[932.781,921.532],[1058.4,795.952],[1058.4,903.473]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1037.97,443.506],[1037.97,337.013],[1127.42,446.86],[1127.42,344.096]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1037.97,562.424],[1037.97,668.917],[1127.42,561.612],[1127.42,664.375]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1037.97,677.865],[1037.97,784.358],[1127.42,673.01],[1127.42,775.773]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1037.97,553.156],[1037.97,446.663],[1127.42,552.669],[1127.42,449.906]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1037.97,793.497],[1037.97,899.99],[1127.42,784.592],[1127.42,887.356]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.94,771.995],[1253.94,869.482],[1167.62,763.379],[1167.62,857.256]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1273.29,355.583],[1273.29,263.373],[1041.81,373.666],[1041.81,290.534]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.94,451.604],[1253.94,354.117],[1167.62,454.849],[1167.62,360.971]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.94,551.98],[1253.94,454.493],[1167.62,551.509],[1167.62,457.631]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.94,560.464],[1253.94,657.951],[1167.62,559.679],[1167.62,653.557]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.94,666.142],[1253.94,763.629],[1167.62,661.444],[1167.62,755.322]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.99,451.552],[1253.99,354.009],[1329.21,454.374],[1329.21,359.968]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.99,551.988],[1253.99,454.444],[1329.21,551.578],[1329.21,457.172]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.99,560.476],[1253.99,658.02],[1329.21,559.793],[1329.21,654.199]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.99,666.216],[1253.99,763.76],[1329.21,662.131],[1329.21,756.537]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1253.99,772.131],[1253.99,869.675],[1329.21,764.639],[1329.21,859.044]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1273.36,355.589],[1273.36,263.381],[1427.72,367.816],[1427.72,281.747]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,453.673],[1349.08,358.488],[1329.21,454.374],[1329.21,359.968]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,551.68],[1349.08,456.495],[1329.21,551.578],[1329.21,457.172]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,559.963],[1349.08,655.148],[1329.21,559.793],[1329.21,654.199]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,663.146],[1349.08,758.331],[1329.21,662.131],[1329.21,756.537]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,766.499],[1349.08,861.684],[1329.21,764.639],[1329.21,859.044]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,453.673],[1349.08,358.488],[1439.11,457.109],[1439.11,365.744]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,551.68],[1349.08,456.495],[1439.11,551.181],[1439.11,459.817]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,559.963],[1349.08,655.148],[1439.11,559.132],[1439.11,650.496]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,663.146],[1349.08,758.331],[1439.11,658.172],[1439.11,749.537]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1349.08,766.499],[1349.08,861.684],[1439.11,757.377],[1439.11,848.741]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1427.75,367.819],[1427.75,281.752],[1562.68,378.508],[1562.68,297.806]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1418.63,457.777],[1418.63,367.156],[1483.19,460.197],[1483.19,372.268]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1418.63,657.205],[1418.63,747.826],[1483.19,653.701],[1483.19,741.63]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1418.63,551.084],[1418.63,460.463],[1483.19,550.732],[1483.19,462.803]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1418.63,558.97],[1418.63,649.591],[1483.19,558.384],[1483.19,646.313]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1418.63,755.602],[1418.63,846.223],[1483.19,749.176],[1483.19,837.104]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1482.62,459.494],[1482.62,371.538],[1543.73,461.805],[1543.73,376.397]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1482.62,550.057],[1482.62,462.101],[1543.73,549.744],[1543.73,464.336]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1482.62,557.711],[1482.62,645.668],[1543.73,557.177],[1543.73,642.585]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1482.62,653.058],[1482.62,741.014],[1543.73,649.761],[1543.73,735.169]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1482.62,748.562],[1482.62,836.518],[1543.73,742.498],[1543.73,827.906]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,461.206],[1563.99,375.138],[1543.73,461.805],[1543.73,376.397]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,549.825],[1563.99,463.757],[1543.73,549.744],[1543.73,464.336]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,557.315],[1563.99,643.383],[1543.73,557.177],[1543.73,642.585]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,650.615],[1563.99,736.683],[1543.73,649.761],[1543.73,735.169]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,744.069],[1563.99,830.137],[1543.73,742.498],[1543.73,827.906]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,461.206],[1563.99,375.138],[1637.88,464.05],[1637.88,381.118]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,549.825],[1563.99,463.757],[1637.88,549.44],[1637.88,466.508]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,557.315],[1563.99,643.383],[1637.88,556.657],[1637.88,639.589]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,650.615],[1563.99,736.683],[1637.88,646.557],[1637.88,729.489]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1563.99,744.069],[1563.99,830.137],[1637.88,736.606],[1637.88,819.538]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1618.49,464.587],[1618.49,382.247],[1672.35,466.625],[1672.35,386.533]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1618.49,549.367],[1618.49,467.027],[1672.35,549.091],[1672.35,468.999]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1618.49,556.533],[1618.49,638.872],[1672.35,556.061],[1672.35,636.153]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1618.49,645.791],[1618.49,728.13],[1672.35,642.883],[1672.35,722.975]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:17,
                    verts:[[1618.49,735.197],[1618.49,817.536],[1672.35,729.848],[1672.35,809.94]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[55.4548,241.09],[55.4548,91.3984],[-157.643,282.907],[-157.643,154.209]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[-79.2431,386.062],[-79.2431,221.391],[108.94,394.928],[108.94,239.786]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[-79.2431,555.615],[-79.2431,390.943],[108.94,554.668],[108.94,399.526]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[-79.2431,569.945],[-79.2431,734.617],[108.94,568.169],[108.94,723.31]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[-79.2431,748.453],[-79.2431,913.124],[108.94,736.346],[108.94,891.487]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[-79.2431,927.256],[-79.2431,1091.93],[108.94,904.801],[108.94,1059.94]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[55.4548,241.09],[55.4548,91.3984],[405.535,274.578],[405.535,141.698]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,393.118],[128.659,236.032],[108.94,394.928],[108.94,239.786]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,554.861],[128.659,397.774],[108.94,554.668],[108.94,399.526]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,568.531],[128.659,725.618],[108.94,568.169],[108.94,723.31]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,738.817],[128.659,895.903],[108.94,736.346],[108.94,891.487]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,909.384],[128.659,1066.47],[108.94,904.801],[108.94,1059.94]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,393.118],[128.659,236.032],[342.449,403.382],[342.449,257.329]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,554.861],[128.659,397.774],[342.449,553.765],[342.449,407.711]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,568.531],[128.659,725.618],[342.449,566.475],[342.449,712.528]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,738.817],[128.659,895.903],[342.449,724.8],[342.449,870.853]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[128.659,909.384],[128.659,1066.47],[342.449,883.387],[342.449,1029.44]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[320.909,405.002],[320.909,260.691],[460.882,411.592],[460.882,274.364]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[320.909,553.592],[320.909,409.28],[460.882,552.888],[460.882,415.66]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[320.909,566.15],[320.909,710.462],[460.882,564.83],[460.882,702.058]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[320.909,722.587],[320.909,866.899],[460.882,713.588],[460.882,850.816]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[320.909,879.283],[320.909,1023.6],[460.882,862.593],[460.882,999.82]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[406.055,274.627],[406.055,141.773],[685.338,301.343],[685.338,181.9]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[464.207,415.949],[464.207,278.805],[596.014,421.95],[596.014,291.48]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[464.207,557.158],[464.207,420.014],[596.014,556.286],[596.014,425.817]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[464.207,569.093],[464.207,706.237],[596.014,567.64],[596.014,698.11]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[464.207,717.76],[464.207,854.904],[596.014,709.072],[596.014,839.542]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[464.207,866.673],[464.207,1003.82],[596.014,850.738],[596.014,981.208]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,420.716],[617.689,288.873],[596.014,421.95],[596.014,291.48]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,556.466],[617.689,424.623],[596.014,556.286],[596.014,425.817]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,567.939],[617.689,699.781],[596.014,567.64],[596.014,698.11]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,710.859],[617.689,842.701],[596.014,709.072],[596.014,839.542]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,854.016],[617.689,985.858],[596.014,850.738],[596.014,981.208]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,420.716],[617.689,288.873],[770.013,427.783],[770.013,303.802]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,556.466],[617.689,424.623],[770.013,555.439],[770.013,431.458]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,567.939],[617.689,699.781],[770.013,566.229],[770.013,690.21]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,710.859],[617.689,842.701],[770.013,700.627],[770.013,824.609]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[617.689,854.016],[617.689,985.858],[770.013,835.249],[770.013,959.23]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[786.425,311.012],[786.425,196.425],[536.609,336.349],[536.609,234.482]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[747.36,428.913],[747.36,306.189],[852.636,433.703],[852.636,316.307]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[747.36,698.991],[747.36,821.715],[852.636,692.057],[852.636,809.453]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[747.36,565.955],[747.36,688.679],[852.636,564.796],[852.636,682.193]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[747.36,555.275],[747.36,432.551],[852.636,554.58],[852.636,437.183]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[747.36,832.247],[747.36,954.971],[852.636,819.528],[852.636,936.925]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[786.52,311.021],[786.52,196.438],[1000.21,331.462],[1000.21,227.141]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[850.735,433.547],[850.735,315.976],[948.281,437.988],[948.281,325.357]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[850.735,554.602],[850.735,437.032],[948.281,553.957],[948.281,441.326]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[850.735,564.834],[850.735,682.404],[948.281,563.759],[948.281,676.39]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[850.735,692.283],[850.735,809.854],[948.281,685.853],[948.281,798.485]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[850.735,819.943],[850.735,937.514],[948.281,808.15],[948.281,920.781]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,437.07],[970.161,323.417],[948.281,437.988],[948.281,325.357]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,554.091],[970.161,440.438],[948.281,553.957],[948.281,441.326]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,563.981],[970.161,677.634],[948.281,563.759],[948.281,676.39]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,687.183],[970.161,800.836],[948.281,685.853],[948.281,798.484]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,810.589],[970.161,924.242],[948.281,808.15],[948.281,920.781]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,437.07],[970.161,323.417],[1084.29,442.365],[1084.29,334.602]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,554.091],[970.161,440.438],[1084.29,553.322],[1084.29,445.559]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,563.981],[970.161,677.634],[1084.29,562.7],[1084.29,670.462]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,687.183],[970.161,800.836],[1084.29,679.517],[1084.29,787.28]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[970.161,810.589],[970.161,924.242],[1084.29,796.528],[1084.29,904.29]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1061.8,443.22],[1061.8,336.408],[1142.68,446.9],[1142.68,344.182]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1061.8,562.493],[1061.8,669.304],[1142.68,561.602],[1142.68,664.321]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1061.8,678.279],[1061.8,785.091],[1142.68,672.951],[1142.68,775.67]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1061.8,553.198],[1061.8,446.386],[1142.68,552.663],[1142.68,449.945]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1061.8,794.257],[1061.8,901.069],[1142.68,784.485],[1142.68,887.204]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1264.02,356.697],[1264.02,265.045],[1016.29,373.274],[1016.29,289.945]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.14,770.775],[1256.14,867.751],[1163.68,762.905],[1163.68,856.584]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.14,452.063],[1256.14,355.087],[1163.68,455.027],[1163.68,361.348]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.14,551.914],[1256.14,454.938],[1163.68,551.483],[1163.68,457.804]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.14,560.353],[1256.14,657.329],[1163.68,559.635],[1163.68,653.315]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.14,665.477],[1256.14,762.453],[1163.68,661.186],[1163.68,754.865]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.31,452.012],[1256.31,354.98],[1323.24,455.06],[1323.24,361.416]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.31,551.921],[1256.31,454.888],[1323.24,551.478],[1323.24,457.835]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.31,560.365],[1256.31,657.398],[1323.24,559.628],[1323.24,653.271]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.31,665.551],[1256.31,762.583],[1323.24,661.139],[1323.24,754.782]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1256.31,770.91],[1256.31,867.943],[1323.24,762.818],[1323.24,856.461]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1264.08,356.703],[1264.08,265.054],[1401.5,369.848],[1401.5,284.799]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,454.426],[1344.23,360.077],[1323.24,455.06],[1323.24,361.417]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,551.57],[1344.23,457.222],[1323.24,551.478],[1323.24,457.835]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,559.781],[1344.23,654.129],[1323.24,559.628],[1323.24,653.271]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,662.057],[1344.23,756.405],[1323.24,661.139],[1323.24,754.782]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,764.501],[1344.23,858.85],[1323.24,762.818],[1323.24,856.461]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,454.426],[1344.23,360.078],[1423.58,458.108],[1423.58,367.854]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,551.57],[1344.23,457.222],[1423.58,551.036],[1423.58,460.783]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,559.781],[1344.23,654.129],[1423.58,558.89],[1423.58,649.143]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,662.057],[1344.23,756.405],[1423.58,656.726],[1423.58,746.98]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1344.23,764.501],[1344.23,858.85],[1423.58,754.725],[1423.58,844.978]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1401.53,369.851],[1401.53,284.803],[1520.35,381.217],[1520.35,301.875]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1402.21,458.708],[1402.21,369.123],[1458.97,461.291],[1458.97,374.578]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1402.21,558.745],[1402.21,648.33],[1458.97,558.12],[1458.97,644.832]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1402.21,655.857],[1402.21,745.442],[1458.97,652.118],[1458.97,738.831]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1402.21,550.949],[1402.21,461.363],[1458.97,550.574],[1458.97,463.861]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1402.21,753.13],[1402.21,842.715],[1458.97,746.272],[1458.97,832.985]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1458.48,460.595],[1458.48,373.854],[1511.96,463.05],[1511.96,379.015]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1458.48,549.908],[1458.48,463.166],[1511.96,549.575],[1511.96,465.54]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1458.48,557.456],[1458.48,644.198],[1511.96,556.888],[1511.96,640.923]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1458.48,651.486],[1458.48,738.228],[1511.96,647.984],[1511.96,732.019]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1458.48,745.672],[1458.48,832.413],[1511.96,739.231],[1511.96,823.266]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,462.517],[1532.77,377.894],[1511.96,463.05],[1511.96,379.015]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,549.648],[1532.77,465.025],[1511.96,549.575],[1511.96,465.54]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,557.012],[1532.77,641.634],[1511.96,556.888],[1511.96,640.923]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,648.745],[1532.77,733.367],[1511.96,647.984],[1511.96,732.019]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,740.629],[1532.77,825.252],[1511.96,739.231],[1511.96,823.266]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,462.517],[1532.77,377.894],[1596.89,465.517],[1596.89,384.204]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,549.648],[1532.77,465.025],[1596.89,549.241],[1596.89,467.928]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,557.012],[1532.77,641.634],[1596.89,556.317],[1596.89,637.631]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,648.745],[1532.77,733.367],[1596.89,644.463],[1596.89,725.776]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1532.77,740.629],[1532.77,825.252],[1596.89,732.754],[1596.89,814.068]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1577.15,465.993],[1577.15,385.204],[1623.82,468.136],[1623.82,389.71]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1577.15,549.177],[1577.15,468.388],[1623.82,548.886],[1623.82,470.461]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1577.15,556.207],[1577.15,636.996],[1623.82,555.711],[1623.82,634.137]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1577.15,643.785],[1577.15,724.574],[1623.82,640.726],[1623.82,719.152]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:18,
                    verts:[[1577.15,731.507],[1577.15,812.296],[1623.82,725.883],[1623.82,804.308]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[139.796,228.321],[139.796,72.2185],[-136.764,269.779],[-136.764,134.49]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,378.597],[27.7691,205.901],[-160.242,393.991],[-160.242,237.842]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,556.412],[27.7691,383.716],[-160.242,554.768],[-160.242,398.619]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,571.441],[27.7691,744.137],[-160.242,568.356],[-160.242,724.505]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,758.647],[27.7691,931.344],[-160.242,737.625],[-160.242,893.774]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,946.164],[27.7691,1118.86],[-160.242,907.174],[-160.242,1063.32]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,378.597],[27.7691,205.901],[208.915,389.047],[208.915,227.584]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,556.412],[27.7691,383.716],[208.915,555.296],[208.915,393.833]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,571.441],[27.7691,744.137],[208.915,569.347],[208.915,730.81]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,758.647],[27.7691,931.344],[208.915,744.377],[208.915,905.84]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[27.7691,946.164],[27.7691,1118.86],[208.915,919.696],[208.915,1081.16]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[139.796,228.321],[139.796,72.2185],[473.155,267.1],[473.155,130.467]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,387.276],[234.187,223.909],[208.915,389.047],[208.915,227.584]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,555.485],[234.187,392.118],[208.915,555.296],[208.915,393.833]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,569.702],[234.187,733.069],[208.915,569.347],[208.915,730.81]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,746.795],[234.187,910.162],[208.915,744.377],[208.915,905.84]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,924.182],[234.187,1087.55],[208.915,919.696],[208.915,1081.16]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,387.276],[234.187,223.909],[435.849,399.162],[435.849,248.572]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,555.485],[234.187,392.118],[435.849,554.215],[435.849,403.625]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,569.702],[234.187,733.069],[435.849,567.32],[435.849,717.91]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,746.795],[234.187,910.162],[435.849,730.563],[435.849,881.154]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[234.187,924.182],[234.187,1087.55],[435.849,894.077],[435.849,1044.67]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[409.474,567.008],[409.474,715.922],[540.199,565.498],[540.199,706.312]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[409.474,400.721],[409.474,251.806],[540.199,408.256],[540.199,267.442]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[409.474,554.049],[409.474,405.134],[540.199,553.244],[540.199,412.43]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[409.474,728.435],[409.474,877.349],[540.199,718.144],[540.199,858.958]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[409.474,890.128],[409.474,1039.04],[540.199,871.042],[540.199,1011.86]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[473.643,267.157],[473.643,130.552],[732.968,297.324],[732.968,175.864]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[543.469,412.743],[543.469,272.034],[665.199,419.53],[665.199,286.368]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[543.469,557.623],[543.469,416.914],[665.199,556.638],[665.199,423.477]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[543.469,569.868],[543.469,710.578],[665.199,568.226],[665.199,701.387]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[543.469,722.401],[543.469,863.11],[665.199,712.576],[665.199,845.737]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[543.469,875.186],[543.469,1015.9],[665.199,857.165],[665.199,990.326]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,418.368],[690.426,283.914],[665.199,419.53],[665.199,286.368]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,556.807],[690.426,422.353],[665.199,556.638],[665.199,423.477]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,568.507],[690.426,702.961],[665.199,568.226],[665.199,701.387]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,714.258],[690.426,848.711],[665.199,712.576],[665.199,845.737]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,860.25],[690.426,994.703],[665.199,857.165],[665.199,990.326]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,418.368],[690.426,283.914],[828.948,426.258],[828.948,300.581]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,556.807],[690.426,422.353],[828.948,555.661],[828.948,429.983]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,568.507],[690.426,702.961],[828.948,566.598],[828.948,692.275]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,714.258],[690.426,848.711],[828.948,702.835],[828.948,828.513]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[690.426,860.25],[690.426,994.703],[828.948,839.298],[828.948,964.976]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[825.426,308.079],[825.426,192.019],[542.151,331.808],[542.151,227.66]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[825.513,308.089],[825.513,192.035],[1018.56,330.547],[1018.56,225.766]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[803.238,427.309],[803.238,302.801],[898.418,432.612],[898.418,314.001]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[803.238,701.313],[803.238,825.821],[898.418,693.637],[898.418,812.248]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[803.238,555.508],[803.238,431],[898.418,554.738],[898.418,436.127]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[803.238,566.343],[803.238,690.852],[898.418,565.06],[898.418,683.671]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[803.238,836.506],[803.238,961.015],[898.418,822.426],[898.418,941.037]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[896.872,432.446],[896.872,313.65],[984.369,437.324],[984.369,323.954]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[896.872,554.762],[896.872,435.967],[984.369,554.054],[984.369,440.684]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[896.872,565.1],[896.872,683.896],[984.369,563.92],[984.369,677.29]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[896.872,693.877],[896.872,812.673],[984.369,686.815],[984.369,800.185]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[896.872,822.868],[896.872,941.663],[984.369,809.915],[984.369,923.285]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,436.483],[1008.45,322.177],[984.369,437.324],[984.369,323.954]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,554.176],[1008.45,439.871],[984.369,554.054],[984.369,440.684]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,564.123],[1008.45,678.429],[984.369,563.92],[984.369,677.29]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,688.033],[1008.45,802.338],[984.369,686.815],[984.369,800.185]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,812.148],[1008.45,926.453],[984.369,809.915],[984.369,923.285]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,436.483],[1008.45,322.177],[1109.55,442.242],[1109.55,334.342]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,554.176],[1008.45,439.871],[1109.55,553.34],[1109.55,445.44]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,564.123],[1008.45,678.429],[1109.55,562.73],[1109.55,670.629]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,688.033],[1008.45,802.338],[1109.55,679.695],[1109.55,787.595]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1008.45,812.148],[1008.45,926.453],[1109.55,796.855],[1109.55,904.755]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1085.21,443.018],[1085.21,335.981],[1156.62,446.996],[1156.62,344.384]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1085.21,562.542],[1085.21,669.579],[1156.62,561.579],[1156.62,664.191]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1085.21,678.572],[1085.21,785.609],[1156.62,672.812],[1156.62,775.424]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1085.21,553.227],[1085.21,446.19],[1156.62,552.649],[1156.62,450.038]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1085.21,794.794],[1085.21,901.831],[1156.62,784.23],[1156.62,886.842]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1252.5,357.76],[1252.5,266.642],[989.891,372.715],[989.891,289.106]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.05,769.52],[1256.05,865.97],[1158.16,762.455],[1158.16,855.945]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1252.55,357.766],[1252.55,266.651],[1372.53,371.723],[1372.53,287.616]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.05,452.536],[1256.05,356.086],[1158.16,455.197],[1158.16,361.706]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.05,551.845],[1256.05,455.395],[1158.16,551.458],[1158.16,457.968]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.05,560.238],[1256.05,656.688],[1158.16,559.594],[1158.16,653.085]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.05,664.792],[1256.05,761.243],[1158.16,660.941],[1158.16,754.431]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.33,452.486],[1256.33,355.98],[1314.57,455.733],[1314.57,362.838]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.33,551.852],[1256.33,455.346],[1314.57,551.381],[1314.57,458.486]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.33,560.25],[1256.33,656.756],[1314.57,559.465],[1314.57,652.359]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.33,664.865],[1256.33,761.371],[1314.57,660.164],[1314.57,753.059]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1256.33,769.653],[1256.33,866.159],[1314.57,761.031],[1314.57,853.925]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,455.169],[1336.51,361.648],[1314.58,455.733],[1314.58,362.838]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,551.463],[1336.51,457.941],[1314.58,551.381],[1314.58,458.486]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,559.601],[1336.51,653.123],[1314.58,559.465],[1314.58,652.359]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,660.98],[1336.51,754.502],[1314.58,660.164],[1314.58,753.059]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,762.528],[1336.51,856.049],[1314.58,761.031],[1314.58,853.925]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,455.169],[1336.51,361.648],[1404.88,459.064],[1404.88,369.874]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,551.463],[1336.51,457.941],[1404.88,550.897],[1404.88,461.707]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,559.601],[1336.51,653.123],[1404.88,558.659],[1404.88,647.848]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,660.98],[1336.51,754.502],[1404.88,655.342],[1404.88,744.531]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1336.51,762.528],[1336.51,856.049],[1404.88,752.185],[1404.88,841.375]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1372.56,371.727],[1372.56,287.62],[1475.28,383.676],[1475.28,305.569]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1382.77,459.595],[1382.77,370.996],[1431.64,462.317],[1431.64,376.745]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1382.77,558.53],[1382.77,647.129],[1431.64,557.871],[1431.64,643.443]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1382.77,654.573],[1382.77,743.172],[1431.64,650.633],[1431.64,736.204]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1382.77,550.82],[1382.77,462.221],[1431.64,550.424],[1431.64,464.853]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1382.77,750.776],[1382.77,839.375],[1431.64,743.547],[1431.64,829.119]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1431.22,461.629],[1431.22,376.028],[1477.07,464.205],[1477.07,381.444]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1431.22,549.768],[1431.22,464.166],[1477.07,549.419],[1477.07,466.658]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1431.22,557.217],[1431.22,642.819],[1477.07,556.621],[1477.07,639.382]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1431.22,650.011],[1431.22,735.612],[1477.07,646.335],[1477.07,729.096]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1431.22,742.959],[1431.22,828.56],[1477.07,736.198],[1477.07,818.959]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,463.738],[1498.3,380.462],[1477.07,464.205],[1477.07,381.444]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,549.482],[1498.3,466.206],[1477.07,549.419],[1477.07,466.658]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,556.729],[1498.3,640.005],[1477.07,556.621],[1477.07,639.382]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,647.002],[1498.3,730.278],[1477.07,646.335],[1477.07,729.096]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,737.424],[1498.3,820.7],[1477.07,736.198],[1477.07,818.959]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,463.738],[1498.3,380.462],[1552.79,466.869],[1552.79,387.045]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,549.482],[1498.3,466.206],[1552.79,549.058],[1552.79,469.235]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,556.729],[1498.3,640.005],[1552.79,556.005],[1552.79,635.828]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,647.002],[1498.3,730.278],[1552.79,642.535],[1552.79,722.358]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1498.3,737.424],[1498.3,820.7],[1552.79,729.208],[1552.79,809.032]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1532.81,467.283],[1532.81,387.917],[1572.46,469.513],[1572.46,392.606]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1532.81,555.909],[1532.81,635.275],[1572.46,555.393],[1572.46,632.3]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1532.81,549.002],[1532.81,469.636],[1572.46,548.7],[1572.46,471.793]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1532.81,641.943],[1532.81,721.309],[1572.46,638.762],[1572.46,715.669]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:19,
                    verts:[[1532.81,728.12],[1532.81,807.487],[1572.46,722.269],[1572.46,799.176]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,371.434],[160.83,191.038],[-79.2779,386.407],[-79.2779,222.106]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,557.177],[160.83,376.781],[-79.2779,555.578],[-79.2779,391.277]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,572.876],[160.83,753.272],[-79.2779,569.876],[-79.2779,734.177]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,768.429],[160.83,948.825],[-79.2779,747.981],[-79.2779,912.282]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,964.306],[160.83,1144.7],[-79.2779,926.382],[-79.2779,1090.68]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[243.743,216.007],[243.743,53.7218],[-100.213,256.086],[-100.213,113.923]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,371.434],[160.83,191.038],[328.912,383.513],[328.912,216.101]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,557.177],[160.83,376.781],[328.912,555.887],[328.912,388.475]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,572.876],[160.83,753.272],[328.912,570.456],[328.912,737.868]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,768.429],[160.83,948.825],[328.912,751.934],[328.912,919.346]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[160.83,964.306],[160.83,1144.7],[328.912,933.713],[328.912,1101.12]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[243.743,216.007],[243.743,53.7218],[551.214,260.132],[551.214,120.001]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,381.83],[359.816,212.608],[328.912,383.513],[328.912,216.101]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,556.067],[359.816,386.845],[328.912,555.887],[328.912,388.475]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,570.793],[359.816,740.014],[328.912,570.456],[328.912,737.868]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,754.233],[359.816,923.454],[328.912,751.934],[328.912,919.346]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,937.976],[328.912,933.713],[359.816,1107.2],[328.912,1101.12]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,381.83],[359.816,212.608],[543.005,395.328],[543.005,240.618]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,556.067],[359.816,386.845],[543.005,554.625],[543.005,399.914]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,570.793],[359.816,740.014],[543.005,568.088],[543.005,722.799]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,754.233],[359.816,923.454],[543.005,735.798],[543.005,890.509]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[359.816,937.976],[359.816,1107.2],[543.005,903.786],[543.005,1058.5]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[511.881,567.796],[511.881,720.94],[629.718,566.101],[629.718,710.151]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[511.881,396.786],[511.881,243.642],[629.718,405.246],[629.718,261.197]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[511.881,554.469],[511.881,401.325],[629.718,553.565],[629.718,409.516]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[511.881,733.808],[511.881,886.952],[629.718,722.254],[629.718,866.304]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[511.881,900.094],[511.881,1053.24],[629.718,878.666],[629.718,1022.72]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[551.658,260.196],[551.658,120.096],[785.167,293.707],[785.167,170.432]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[632.864,409.853],[632.864,265.929],[741.438,417.393],[741.438,281.856]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[632.864,558.043],[632.864,414.119],[741.438,556.948],[741.438,421.411]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[632.864,570.568],[632.864,714.492],[741.438,568.743],[741.438,704.281]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[632.864,726.585],[632.864,870.509],[741.438,715.669],[741.438,851.206]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[632.864,882.86],[632.864,1026.78],[741.438,862.838],[741.438,998.375]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,416.329],[770.01,279.608],[741.439,417.393],[741.439,281.856]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,557.103],[770.01,420.382],[741.439,556.948],[741.439,421.411]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,569.001],[770.01,705.722],[741.439,568.743],[741.439,704.281]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,717.209],[770.01,853.93],[741.439,715.669],[741.439,851.206]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,865.663],[741.439,862.838],[770.01,1002.38],[741.439,998.375]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,416.329],[770.01,279.608],[891.599,424.988],[891.599,297.898]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,557.103],[770.01,420.382],[891.599,555.845],[891.599,428.755]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,569.001],[770.01,705.722],[891.599,566.905],[891.599,693.995]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,717.209],[770.01,853.93],[891.599,704.674],[891.599,831.764]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[770.01,865.663],[770.01,1002.38],[891.599,842.671],[891.599,969.761]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[867.255,305.488],[867.255,188.127],[551.777,327.194],[551.777,220.73]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[867.331,305.499],[867.331,188.143],[1036.79,329.818],[1036.79,224.672]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[863.081,425.94],[863.081,299.909],[946.325,431.716],[946.325,312.109]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[863.081,566.675],[863.081,692.706],[946.325,565.277],[946.325,684.884]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[863.081,555.707],[863.081,429.676],[946.325,554.868],[946.325,435.261]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[863.081,703.295],[863.081,829.326],[946.325,694.933],[946.325,814.54]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[863.081,840.142],[863.081,966.173],[946.325,824.804],[946.325,944.411]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[945.17,431.542],[945.17,311.741],[1021.14,436.818],[1021.14,322.885]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[945.17,554.894],[945.17,435.093],[1021.14,554.127],[1021.14,440.195]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[945.17,565.319],[945.17,685.12],[1021.14,564.042],[1021.14,677.975]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[945.17,695.186],[945.17,814.986],[1021.14,687.548],[1021.14,801.48]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[945.17,825.267],[945.17,945.068],[1021.14,811.258],[1021.14,925.19]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,436.067],[1047.17,321.299],[1021.14,436.818],[1021.14,322.885]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,554.236],[1047.17,439.469],[1021.14,554.127],[1021.14,440.195]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,564.224],[1047.17,678.992],[1021.14,564.042],[1021.14,677.975]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,688.635],[1047.17,803.403],[1021.14,687.548],[1021.14,801.48]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,813.252],[1021.14,811.258],[1047.17,928.019],[1021.14,925.19]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,436.067],[1047.17,321.299],[1133.83,442.238],[1133.83,334.334]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,554.236],[1047.17,439.469],[1133.83,553.34],[1133.83,445.436]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,564.224],[1047.17,678.992],[1133.83,562.73],[1133.83,670.634]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,688.635],[1047.17,803.403],[1133.83,679.701],[1133.83,787.605]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1047.17,813.252],[1047.17,928.019],[1133.83,796.865],[1133.83,904.769]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1107.87,442.925],[1107.87,335.786],[1169.01,447.167],[1169.01,344.746]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1107.87,562.564],[1107.87,669.704],[1169.01,561.538],[1169.01,663.959]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1107.87,553.24],[1107.87,446.101],[1169.01,552.624],[1169.01,450.203]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1107.87,678.706],[1107.87,785.845],[1169.01,672.565],[1169.01,774.986]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1107.87,795.04],[1107.87,902.179],[1169.01,783.775],[1169.01,886.197]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1238.71,358.795],[1238.71,268.197],[962.699,372.01],[962.699,288.046]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.55,768.196],[1253.55,864.092],[1151.02,761.993],[1151.02,855.29]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1238.75,358.802],[1238.75,268.207],[1340.88,373.458],[1340.88,290.222]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.55,453.034],[1253.55,357.139],[1151.02,455.371],[1151.02,362.073]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.55,551.772],[1253.55,455.877],[1151.02,551.433],[1151.02,458.136]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.55,560.118],[1253.55,656.013],[1151.02,559.552],[1151.02,652.85]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.55,664.071],[1253.55,759.966],[1151.02,660.689],[1151.02,753.986]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.95,452.985],[1253.95,357.035],[1303.16,456.403],[1303.16,364.254]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.95,551.78],[1253.95,455.829],[1303.16,551.283],[1303.16,459.134]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.95,560.13],[1253.95,656.08],[1303.16,559.302],[1303.16,651.451]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.95,664.142],[1253.95,760.092],[1303.16,659.194],[1303.16,751.343]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1253.95,768.326],[1253.95,864.276],[1303.16,759.251],[1303.16,851.4]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.86,455.913],[1325.86,363.218],[1303.16,456.403],[1303.16,364.254]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.86,551.355],[1325.86,458.66],[1303.16,551.283],[1303.16,459.134]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.86,559.421],[1325.86,652.116],[1303.16,559.302],[1303.16,651.451]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.86,659.904],[1325.86,752.599],[1303.16,659.194],[1303.16,751.343]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.86,760.553],[1303.16,759.251],[1325.86,853.248],[1303.16,851.4]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.85,455.913],[1325.85,363.218],[1383.04,459.985],[1383.04,371.82]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.85,551.355],[1325.85,458.66],[1383.04,550.763],[1383.04,462.598]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.85,559.421],[1325.85,652.116],[1383.04,558.436],[1383.04,646.601]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.85,659.904],[1325.85,752.599],[1383.04,654.008],[1383.04,742.173]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1325.85,760.553],[1325.85,853.248],[1383.04,749.739],[1383.04,837.904]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1340.9,373.462],[1340.9,290.227],[1427.59,385.902],[1427.59,308.912]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1360.36,460.444],[1360.36,372.79],[1401.26,463.282],[1401.26,378.785]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1360.36,550.696],[1360.36,463.043],[1401.26,550.284],[1401.26,465.787]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1360.36,558.324],[1360.36,645.978],[1401.26,557.638],[1401.26,642.135]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1360.36,653.343],[1360.36,740.997],[1401.26,649.235],[1401.26,733.732]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1360.36,748.519],[1360.36,836.173],[1401.26,740.983],[1401.26,825.481]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1400.92,462.602],[1400.92,378.074],[1439.16,465.278],[1439.16,383.7]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1400.92,549.636],[1400.92,465.108],[1439.16,549.273],[1439.16,467.696]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1400.92,556.992],[1400.92,641.521],[1439.16,556.373],[1439.16,637.95]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1400.92,648.623],[1400.92,733.151],[1439.16,644.805],[1439.16,726.382]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1400.92,740.405],[1400.92,824.934],[1439.16,733.383],[1439.16,814.961]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,464.877],[1460.69,382.857],[1439.16,465.278],[1439.16,383.7]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,549.328],[1460.69,467.308],[1439.16,549.273],[1439.16,467.696]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,556.466],[1460.69,638.486],[1439.16,556.373],[1439.16,637.95]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,645.377],[1460.69,727.397],[1439.16,644.805],[1439.16,726.382]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,734.436],[1460.69,816.456],[1439.16,733.383],[1439.16,814.961]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,464.877],[1460.69,382.857],[1505.71,468.111],[1505.71,389.657]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,549.328],[1460.69,467.308],[1505.71,548.89],[1505.71,470.436]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,556.466],[1460.69,638.486],[1505.71,555.717],[1505.71,634.171]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,645.377],[1460.69,727.397],[1505.71,640.763],[1505.71,719.216]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1460.69,734.436],[1460.69,816.456],[1505.71,725.949],[1505.71,804.402]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1485.59,468.466],[1485.59,390.403],[1518.4,470.764],[1518.4,395.236]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1485.59,548.842],[1485.59,470.779],[1518.4,548.53],[1518.4,473.003]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1485.59,555.635],[1485.59,633.697],[1518.4,555.103],[1518.4,630.631]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1485.59,640.256],[1485.59,718.319],[1518.4,636.977],[1518.4,712.504]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:20,
                    verts:[[1485.59,725.018],[1485.59,803.081],[1518.4,718.986],[1518.4,794.514]]
                },
                ],
                [
                {
                    num:"603",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[367.728,204.687],[367.728,36.7194],[-45.3716,242.128],[-45.3716,92.9577]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,364.937],[320.382,177.556],[27.1041,378.966],[27.1041,206.666]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,557.871],[320.382,370.491],[27.1041,556.372],[27.1041,384.073]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,574.178],[320.382,761.558],[27.1041,571.367],[27.1041,743.666]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,777.302],[320.382,964.682],[27.1041,758.143],[27.1041,930.443]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,980.763],[320.382,1168.14],[27.1041,945.229],[27.1041,1117.53]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,364.937],[320.382,177.556],[468.609,378.6],[468.609,205.907]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,557.871],[320.382,370.491],[468.609,556.412],[468.609,383.718]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,574.178],[320.382,761.558],[468.609,571.44],[468.609,744.133]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,777.302],[320.382,964.682],[468.609,758.643],[468.609,931.336]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[320.382,980.763],[320.382,1168.14],[468.609,946.156],[468.609,1118.85]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[367.728,204.687],[367.728,36.7194],[639.307,253.968],[639.307,110.741]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,377.061],[504.934,202.714],[468.609,378.6],[468.609,205.907]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,556.576],[504.934,382.229],[468.609,556.412],[468.609,383.718]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,571.748],[504.934,746.096],[468.609,571.44],[468.609,744.133]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,760.745],[504.934,935.092],[468.609,758.643],[468.609,931.336]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,950.054],[468.609,946.156],[504.934,1124.4],[468.609,1118.85]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,377.061],[504.934,202.714],[662.914,392.076],[662.914,233.868]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,556.576],[504.934,382.229],[662.914,554.972],[662.914,396.765]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,571.748],[504.934,746.096],[662.914,568.74],[662.914,726.948]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,760.745],[504.934,935.092],[662.914,740.24],[662.914,898.448]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[504.934,950.054],[504.934,1124.4],[662.914,912.025],[662.914,1070.23]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[639.694,254.038],[639.694,110.847],[841.446,290.648],[841.446,165.837]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[627.359,568.477],[627.359,725.273],[728.557,566.61],[728.557,713.39]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[627.359,393.388],[627.359,236.592],[728.557,402.707],[728.557,255.927]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[627.359,554.832],[627.359,398.036],[728.557,553.837],[728.557,407.057]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[627.359,738.448],[627.359,895.244],[728.557,725.723],[728.557,872.502]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[627.359,908.7],[627.359,1065.5],[728.557,885.099],[728.557,1031.88]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[731.502,407.417],[731.502,260.784],[823.854,415.644],[823.854,278.161]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[731.502,558.397],[731.502,411.763],[823.854,557.202],[823.854,419.719]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[731.502,571.157],[731.502,717.791],[823.854,569.166],[823.854,706.65]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[731.502,730.111],[731.502,876.744],[823.854,718.201],[823.854,855.685]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[731.502,889.328],[731.502,1035.96],[823.854,867.483],[823.854,1004.97]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,414.703],[855.42,276.174],[823.854,415.644],[823.854,278.161]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,557.339],[855.42,418.809],[823.854,557.202],[823.854,419.719]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,569.394],[855.42,707.924],[823.854,569.166],[823.854,706.65]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,719.563],[855.42,858.093],[823.854,718.201],[823.854,855.685]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,869.981],[823.854,867.483],[855.42,1008.51],[823.854,1004.97]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[911.471,303.355],[911.471,184.923],[565.89,322.604],[565.89,213.836]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,414.703],[855.42,276.174],[957.099,424.042],[957.099,295.9]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,557.339],[855.42,418.809],[957.099,555.983],[957.099,427.84]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,569.394],[855.42,707.924],[957.099,567.134],[957.099,695.276]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,719.563],[855.42,858.093],[957.099,706.043],[957.099,834.186]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[855.42,869.981],[855.42,1008.51],[957.099,845.183],[957.099,973.325]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[911.536,303.367],[911.536,184.941],[1054.65,329.335],[1054.65,223.947]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[926.123,424.876],[926.123,297.66],[995.71,431.068],[995.71,310.74]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[926.123,566.932],[926.123,694.148],[995.71,565.434],[995.71,685.762]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[926.123,555.862],[926.123,428.646],[995.71,554.962],[995.71,434.634]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[926.123,704.836],[926.123,832.052],[995.71,695.872],[995.71,816.2]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[926.123,842.969],[926.123,970.184],[995.71,826.526],[995.71,946.854]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[994.975,430.887],[994.975,310.359],[1058.07,436.508],[1058.07,322.231]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[994.975,554.989],[994.975,434.46],[1058.07,554.172],[1058.07,439.895]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[994.975,565.477],[994.975,686.006],[1058.07,564.117],[1058.07,678.394]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[994.975,696.133],[994.975,816.662],[1058.07,687.996],[1058.07,802.273]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[994.975,827.005],[994.975,947.534],[1058.07,812.08],[1058.07,926.357]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,435.859],[1085.76,320.86],[1058.07,436.508],[1058.07,322.231]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,554.267],[1085.76,439.267],[1058.07,554.172],[1058.07,439.895]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,564.274],[1085.76,679.273],[1058.07,564.117],[1058.07,678.394]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,688.936],[1085.76,803.935],[1058.07,687.996],[1058.07,802.273]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,813.804],[1058.07,812.08],[1085.76,928.803],[1058.07,926.357]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,435.859],[1085.76,320.86],[1156.73,442.378],[1156.73,334.629]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,554.267],[1085.76,439.267],[1156.73,553.32],[1156.73,445.571]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,564.274],[1085.76,679.273],[1156.73,562.697],[1156.73,670.445]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,688.936],[1085.76,803.935],[1156.73,679.499],[1156.73,787.247]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1085.76,813.804],[1085.76,928.803],[1156.73,796.494],[1156.73,904.243]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1129.44,442.968],[1129.44,335.875],[1179.6,447.431],[1179.6,345.304]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1129.44,562.554],[1129.44,669.646],[1179.6,561.474],[1179.6,663.601]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1222.66,359.823],[1222.66,269.74],[934.866,371.181],[934.866,286.801]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1129.44,553.234],[1129.44,446.142],[1179.6,552.586],[1179.6,450.458]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1129.44,678.644],[1129.44,785.737],[1179.6,672.182],[1179.6,774.31]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1129.44,794.927],[1129.44,902.019],[1179.6,783.074],[1179.6,885.202]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1248.56,766.776],[1248.56,862.077],[1142.24,761.485],[1142.24,854.57]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1222.7,359.83],[1222.7,269.751],[1306.66,375.066],[1306.66,292.636]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1248.56,453.569],[1248.56,358.268],[1142.24,455.562],[1142.24,362.477]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1248.56,551.695],[1248.56,456.394],[1142.24,551.405],[1142.24,458.321]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1248.56,559.988],[1248.56,655.289],[1142.24,559.506],[1142.24,652.591]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1248.56,663.296],[1248.56,758.597],[1142.24,660.412],[1142.24,753.497]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1249.07,453.522],[1249.07,358.168],[1288.99,457.078],[1288.99,365.68]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1249.07,551.702],[1249.07,456.348],[1288.99,551.185],[1288.99,459.787]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1249.07,560],[1249.07,655.353],[1288.99,559.139],[1288.99,650.537]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1249.07,663.365],[1249.07,758.719],[1288.99,658.217],[1288.99,749.615]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1249.07,766.902],[1249.07,862.255],[1288.99,757.458],[1288.99,848.856]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,456.663],[1312.27,364.804],[1288.99,457.078],[1288.99,365.68]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,551.245],[1312.27,459.386],[1288.99,551.185],[1288.99,459.787]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,559.239],[1312.27,651.099],[1288.99,559.139],[1288.99,650.537]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,658.817],[1312.27,750.676],[1288.99,658.216],[1288.99,749.615]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,758.559],[1288.99,757.458],[1312.27,850.419],[1288.99,848.856]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1306.68,375.069],[1306.68,292.641],[1377.42,387.905],[1377.42,311.921]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,456.664],[1312.27,364.804],[1358.14,460.876],[1358.14,373.703]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,551.245],[1312.27,459.386],[1358.14,550.634],[1358.14,463.46]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,559.239],[1312.27,651.099],[1358.14,558.22],[1358.14,645.394]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,658.817],[1312.27,750.676],[1358.14,652.718],[1358.14,739.892]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1312.27,758.559],[1312.27,850.419],[1358.14,747.373],[1358.14,834.546]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1335.04,461.263],[1335.04,374.519],[1367.96,464.192],[1367.96,380.707]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1335.04,558.126],[1335.04,644.87],[1367.96,557.417],[1367.96,640.903]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1335.04,550.578],[1335.04,463.834],[1367.96,550.152],[1367.96,466.667]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1335.04,652.158],[1335.04,738.902],[1367.96,647.917],[1367.96,731.402]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1335.04,746.346],[1335.04,833.089],[1367.96,738.567],[1367.96,822.052]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1367.7,463.519],[1367.7,380.002],[1398.38,466.273],[1398.38,385.792]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1367.7,549.512],[1367.7,465.995],[1398.38,549.139],[1398.38,468.658]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1367.7,556.78],[1367.7,640.297],[1398.38,556.142],[1398.38,636.623]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1367.7,647.314],[1367.7,730.831],[1398.38,643.385],[1398.38,723.865]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1367.7,737.998],[1367.7,821.515],[1398.38,730.772],[1398.38,811.253]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,465.937],[1420.09,385.087],[1398.38,466.273],[1398.38,385.792]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,549.184],[1420.09,468.334],[1398.38,549.139],[1398.38,468.658]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,556.22],[1420.09,637.071],[1398.38,556.142],[1398.38,636.623]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,643.864],[1420.09,724.714],[1398.38,643.385],[1398.38,723.865]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,731.653],[1398.38,730.772],[1420.09,812.503],[1398.38,811.253]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,465.937],[1420.09,385.087],[1455.84,469.249],[1455.84,392.051]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,549.184],[1420.09,468.334],[1455.84,548.736],[1455.84,471.537]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,556.22],[1420.09,637.071],[1455.84,555.454],[1455.84,632.652]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,643.864],[1420.09,724.714],[1455.84,639.138],[1455.84,716.337]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1420.09,731.653],[1420.09,812.503],[1455.84,722.962],[1455.84,800.16]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1435.66,469.545],[1435.66,392.672],[1461.81,471.895],[1461.81,397.614]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1435.66,548.695],[1435.66,471.823],[1461.81,548.377],[1461.81,474.096]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1435.66,555.385],[1435.66,632.258],[1461.81,554.841],[1461.81,629.122]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1435.66,638.717],[1435.66,715.589],[1461.81,635.363],[1461.81,709.644]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:21,
                    verts:[[1435.66,722.186],[1435.66,799.058],[1461.81,716.018],[1461.81,790.299]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[66.0393,375.425],[66.0393,199.32],[-221.813,385.862],[-221.813,220.976]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[66.0393,556.751],[66.0393,380.645],[-221.813,555.636],[-221.813,390.749]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[66.0393,572.076],[66.0393,748.182],[-221.813,569.985],[-221.813,734.871]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[66.0393,762.979],[66.0393,939.084],[-221.813,748.725],[-221.813,913.612]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[66.0393,954.197],[66.0393,1130.3],[-221.813,927.762],[-221.813,1092.65]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[510.85,194.978],[510.85,22.1361],[30.0835,228.327],[30.0835,72.228]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,359.518],[504.771,166.312],[160.434,372.003],[160.434,192.218]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,558.45],[504.771,365.244],[160.434,557.116],[160.434,377.331]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,575.263],[504.771,768.469],[160.434,572.762],[160.434,752.547]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,784.703],[504.771,977.908],[160.434,767.653],[160.434,947.437]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,994.489],[504.771,1187.69],[160.434,962.866],[160.434,1142.65]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,359.518],[504.771,166.312],[626.133,374.607],[626.133,197.623]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,558.45],[504.771,365.244],[626.133,556.838],[626.133,379.853]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,575.263],[504.771,768.469],[626.133,572.24],[626.133,749.225]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,784.703],[504.771,977.908],[626.133,764.095],[626.133,941.08]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[504.771,994.489],[504.771,1187.69],[626.133,956.269],[626.133,1133.25]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[510.85,194.978],[510.85,22.1361],[736.375,248.917],[736.375,103.154]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,373.272],[667.311,194.853],[626.133,374.607],[626.133,197.623]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,556.981],[667.311,378.561],[626.133,556.838],[626.133,379.853]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,572.507],[667.311,750.927],[626.133,572.24],[626.133,749.225]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,765.919],[667.311,944.339],[626.133,764.095],[626.133,941.08]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,959.65],[626.133,956.269],[667.311,1138.07],[626.133,1133.25]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,373.272],[667.311,194.853],[793.531,389.601],[793.531,228.734]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,556.981],[667.311,378.561],[793.531,555.237],[793.531,394.369]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,572.507],[667.311,750.927],[793.531,569.236],[793.531,730.103]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,765.919],[667.311,944.339],[793.531,743.619],[793.531,904.486]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[667.311,959.65],[667.311,1138.07],[793.531,918.292],[793.531,1079.16]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[736.693,248.993],[736.693,103.269],[901.041,288.3],[901.041,162.31]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[754.124,390.726],[754.124,231.067],[835.116,400.782],[835.116,251.934]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[754.124,555.117],[754.124,395.458],[835.116,554.042],[835.116,405.194]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[754.124,569.011],[754.124,728.669],[835.116,566.996],[835.116,715.844]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[754.124,742.084],[754.124,901.743],[835.116,728.351],[835.116,877.199]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[754.124,915.444],[754.124,1075.1],[835.116,889.973],[835.116,1038.82]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[837.782,405.575],[837.782,256.893],[911.08,414.382],[911.08,275.496]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[837.782,558.664],[837.782,409.982],[911.08,557.385],[911.08,418.499]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[837.782,571.603],[837.782,720.286],[911.08,569.472],[911.08,708.358]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[837.782,732.778],[837.782,881.461],[911.08,720.028],[911.08,858.915]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[837.782,894.22],[837.782,1042.9],[911.08,870.833],[911.08,1009.72]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[957.464,301.795],[957.464,182.579],[584.823,318.151],[584.823,207.148]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,413.589],[945.147,273.82],[911.08,414.382],[911.08,275.496]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,557.501],[945.147,417.732],[911.08,557.385],[911.08,418.499]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,569.664],[945.147,709.433],[911.08,569.472],[911.08,708.358]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,721.176],[945.147,860.945],[911.08,720.028],[911.08,858.915]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,872.94],[911.08,870.833],[945.147,1012.71],[911.08,1009.72]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,413.589],[945.147,273.82],[1024.3,423.485],[1024.3,294.722]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,557.501],[945.147,417.732],[1024.3,556.064],[1024.3,427.301]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,569.664],[945.147,709.433],[1024.3,567.269],[1024.3,696.032]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,721.176],[945.147,860.945],[1024.3,706.85],[1024.3,835.613]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[945.147,872.94],[945.147,1012.71],[1024.3,846.663],[1024.3,975.426]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[957.516,301.807],[957.516,182.598],[1071.85,329.151],[1071.85,223.671]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[991.32,424.182],[991.32,296.194],[1045.76,430.714],[1045.76,309.992]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[991.32,567.1],[991.32,695.087],[1045.76,565.519],[1045.76,686.241]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[991.32,555.962],[991.32,427.975],[1045.76,555.014],[1045.76,434.292]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[991.32,705.841],[991.32,833.828],[1045.76,696.384],[1045.76,817.106]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[991.32,844.812],[991.32,972.799],[1045.76,827.466],[1045.76,948.187]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1045.47,430.53],[1045.47,309.603],[1094.55,436.428],[1094.55,322.062]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1045.47,555.041],[1045.47,434.114],[1094.55,554.184],[1094.55,439.818]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1045.47,565.564],[1045.47,686.491],[1094.55,564.137],[1094.55,678.503]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1045.47,696.651],[1045.47,817.578],[1094.55,688.112],[1094.55,802.478]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1045.47,827.956],[1045.47,948.882],[1094.55,812.293],[1094.55,926.659]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,435.891],[1123.53,320.927],[1094.56,436.428],[1094.56,322.062]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,554.262],[1123.53,439.298],[1094.56,554.184],[1094.56,439.818]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,564.267],[1123.53,679.23],[1094.56,564.137],[1094.56,678.503]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,688.89],[1123.53,803.853],[1094.56,688.112],[1094.56,802.478]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,813.719],[1094.56,812.293],[1123.53,928.683],[1094.56,926.659]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,435.891],[1123.53,320.927],[1177.84,442.681],[1177.84,335.269]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,554.262],[1123.53,439.298],[1177.84,553.276],[1177.84,445.864]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,564.267],[1123.53,679.23],[1177.84,562.623],[1177.84,670.035]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,688.89],[1123.53,803.853],[1177.84,679.06],[1177.84,786.472]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1123.53,813.719],[1123.53,928.683],[1177.84,795.69],[1177.84,903.102]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1204.42,360.859],[1204.42,271.297],[906.586,370.252],[906.586,285.405]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1149.53,443.166],[1149.53,336.294],[1188.18,447.803],[1188.18,346.088]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1149.53,562.506],[1149.53,669.378],[1188.18,561.384],[1188.18,663.098]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1149.53,553.206],[1149.53,446.334],[1188.18,552.532],[1188.18,450.818]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1149.53,678.357],[1149.53,785.229],[1188.18,671.645],[1188.18,773.359]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1149.53,794.401],[1149.53,901.272],[1188.18,782.088],[1188.18,883.803]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.05,765.238],[1241.05,859.894],[1131.82,760.902],[1131.82,853.743]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1204.45,360.866],[1204.45,271.308],[1270.05,376.555],[1270.05,294.873]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.05,454.149],[1241.05,359.492],[1131.82,455.781],[1131.82,362.941]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.05,551.611],[1241.05,456.954],[1131.82,551.374],[1131.82,458.533]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.05,559.848],[1241.05,654.505],[1131.82,559.453],[1131.82,652.294]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.05,662.458],[1241.05,757.114],[1131.82,660.094],[1131.82,752.935]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.65,454.103],[1241.65,359.396],[1272.12,457.764],[1272.12,367.129]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.65,551.617],[1241.65,456.91],[1272.12,551.086],[1272.12,460.45]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.65,559.859],[1241.65,654.566],[1272.12,558.973],[1272.12,649.608]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.65,662.524],[1241.65,757.231],[1272.12,657.224],[1272.12,747.859]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1241.65,765.358],[1241.65,860.066],[1272.12,755.637],[1272.12,846.272]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1270.06,376.558],[1270.06,294.878],[1324.99,389.695],[1324.99,314.609]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,457.427],[1295.8,366.417],[1272.12,457.764],[1272.12,367.129]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,551.135],[1295.8,460.124],[1272.12,551.086],[1272.12,460.45]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,559.055],[1295.8,650.065],[1272.12,558.973],[1272.12,649.608]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,657.712],[1295.8,748.722],[1272.12,657.224],[1272.12,747.859]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,756.532],[1272.12,755.637],[1295.8,847.542],[1272.12,846.272]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,457.427],[1295.8,366.417],[1330.31,461.741],[1330.31,375.529]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,551.135],[1295.8,460.124],[1330.31,550.508],[1330.31,464.296]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,559.055],[1295.8,650.065],[1330.31,558.011],[1330.31,644.222]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,657.712],[1295.8,748.722],[1330.31,651.466],[1330.31,737.678]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1295.8,756.532],[1295.8,847.542],[1330.31,745.076],[1330.31,831.288]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1306.95,462.054],[1306.95,376.191],[1331.91,465.05],[1331.91,382.519]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1306.95,557.935],[1306.95,643.798],[1331.91,557.21],[1331.91,639.741]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1306.95,550.463],[1306.95,464.599],[1331.91,550.028],[1331.91,467.496]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1306.95,651.013],[1306.95,736.876],[1331.91,646.675],[1331.91,729.207]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1306.95,744.245],[1306.95,830.108],[1331.91,736.289],[1331.91,818.82]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1331.73,464.384],[1331.73,381.821],[1354.94,467.193],[1354.94,387.728]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1331.73,549.395],[1331.73,466.831],[1354.94,549.014],[1354.94,469.548]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1331.73,556.58],[1331.73,639.143],[1354.94,555.93],[1354.94,635.395]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1331.73,646.08],[1331.73,728.644],[1354.94,642.072],[1354.94,721.537]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1331.73,735.729],[1331.73,818.292],[1354.94,728.357],[1354.94,807.823]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,466.923],[1376.73,387.159],[1354.94,467.193],[1354.94,387.728]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,549.051],[1376.73,469.287],[1354.94,549.014],[1354.94,469.548]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,555.992],[1376.73,635.756],[1354.94,555.93],[1354.94,635.395]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,642.458],[1376.73,722.222],[1354.94,642.072],[1354.94,721.537]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,729.067],[1354.94,728.357],[1376.73,808.83],[1354.94,807.823]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,466.923],[1376.73,387.159],[1403.41,470.287],[1403.41,394.233]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,549.051],[1376.73,469.287],[1403.41,548.595],[1403.41,472.541]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,555.992],[1376.73,635.756],[1403.41,555.213],[1403.41,631.267]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,642.458],[1376.73,722.222],[1403.41,637.658],[1403.41,713.711]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:22,
                    verts:[[1376.73,729.067],[1376.73,808.83],[1403.41,720.238],[1403.41,796.292]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[211.781,368.793],[211.781,185.559],[-124.924,377.717],[-124.924,204.076]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[211.781,557.459],[211.781,374.224],[-124.924,556.506],[-124.924,382.864]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[211.781,573.405],[211.781,756.64],[-124.924,571.617],[-124.924,745.258]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[211.781,772.035],[211.781,955.27],[-124.924,759.848],[-124.924,933.49]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[211.781,970.995],[211.781,1154.23],[-124.924,948.391],[-124.924,1122.03]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[670.528,187.515],[670.528,10.9257],[127.754,215.224],[127.754,52.5454]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,355.595],[709.732,158.173],[320.446,365.913],[320.446,179.582]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,558.869],[709.732,361.447],[320.446,557.767],[320.446,371.436]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,576.049],[709.732,773.471],[320.446,573.982],[320.446,760.313]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,790.059],[709.732,987.481],[320.446,775.969],[320.446,962.299]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,1004.42],[709.732,1201.84],[320.446,978.29],[320.446,1164.62]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[670.528,187.515],[670.528,10.9257],[840.627,245.277],[840.627,97.6873]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,355.595],[709.732,158.173],[797.81,371.827],[797.81,191.853]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,558.869],[709.732,361.447],[797.81,557.135],[797.81,377.161]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,576.049],[709.732,773.471],[797.81,572.797],[797.81,752.771]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,790.059],[709.732,987.481],[797.81,767.893],[797.81,947.867]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[709.732,1004.42],[709.732,1201.84],[797.81,963.312],[797.81,1143.29]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,370.751],[797.81,371.827],[842.886,189.621],[797.81,191.853]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,557.25],[842.886,376.12],[797.81,557.135],[797.81,377.161]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,573.013],[842.886,754.143],[797.81,572.797],[797.81,752.771]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,769.362],[797.81,767.893],[842.886,950.492],[797.81,947.867]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,966.036],[797.81,963.312],[842.886,1147.17],[797.81,1143.29]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[840.865,245.358],[840.865,97.8086],[962.915,286.804],[962.915,160.062]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,370.751],[842.886,189.621],[931.711,388.085],[931.711,225.589]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,557.25],[842.886,376.12],[931.711,555.398],[931.711,392.902]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,573.013],[842.886,754.143],[931.711,569.54],[931.711,732.036]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,769.362],[842.886,950.492],[931.711,745.69],[931.711,908.186]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[842.886,966.036],[842.886,1147.17],[931.711,922.131],[931.711,1084.63]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[889.298,388.982],[889.298,227.449],[947.052,399.604],[947.052,249.49]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[889.298,555.303],[889.298,393.77],[947.052,554.168],[947.052,404.053]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[889.298,569.36],[889.298,730.893],[947.052,567.232],[947.052,717.346]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[889.298,744.465],[889.298,905.998],[947.052,729.959],[947.052,880.074]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[889.298,919.861],[889.298,1081.39],[947.052,892.956],[947.052,1043.07]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[949.365,404.452],[949.365,254.521],[1001.28,413.696],[1001.28,274.047]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[949.365,558.827],[949.365,408.896],[1001.28,557.485],[1001.28,417.836]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[949.365,571.875],[949.365,721.806],[1001.28,569.638],[1001.28,709.287]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[949.365,734.404],[949.365,884.335],[1001.28,721.021],[1001.28,860.67]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[949.365,897.202],[949.365,1047.13],[1001.28,872.655],[1001.28,1012.3]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1004.45,300.909],[1004.45,181.249],[608.785,313.963],[608.785,200.857]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,413.071],[1001.28,413.696],[1037.21,272.727],[1001.28,274.047]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,557.576],[1037.21,417.231],[1001.28,557.485],[1001.28,417.836]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,569.789],[1037.21,710.133],[1001.28,569.638],[1001.28,709.287]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,721.925],[1001.28,721.021],[1037.21,862.27],[1001.28,860.67]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,874.314],[1001.28,872.655],[1037.21,1014.66],[1001.28,1012.3]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1004.49,300.922],[1004.49,181.268],[1088.09,329.312],[1088.09,223.912]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,413.072],[1037.21,272.727],[1091.81,423.368],[1091.81,294.475]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,557.576],[1037.21,417.231],[1091.81,556.081],[1091.81,427.188]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,569.789],[1037.21,710.133],[1091.81,567.297],[1091.81,696.19]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,721.925],[1037.21,862.27],[1091.81,707.02],[1091.81,835.912]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1037.21,874.314],[1037.21,1014.66],[1091.81,846.973],[1091.81,975.866]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1057.38,423.914],[1057.38,295.628],[1095.52,430.693],[1095.52,309.948]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1057.38,567.165],[1057.38,695.451],[1095.52,565.524],[1095.52,686.27]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1057.38,556.001],[1057.38,427.716],[1095.52,555.017],[1095.52,434.272]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1057.38,706.229],[1057.38,834.515],[1095.52,696.415],[1095.52,817.16]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1057.38,845.524],[1057.38,973.809],[1095.52,827.522],[1095.52,948.267]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1095.68,430.507],[1095.68,309.556],[1129.91,436.604],[1129.91,322.434]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1095.68,555.044],[1095.68,434.092],[1129.91,554.158],[1129.91,439.988]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1095.68,565.569],[1095.68,686.521],[1129.91,564.094],[1129.91,678.264]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1095.68,696.684],[1095.68,817.635],[1129.91,687.857],[1129.91,802.028]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1095.68,828.015],[1095.68,948.966],[1129.91,811.825],[1129.91,925.996]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,436.187],[1129.91,436.604],[1159.79,321.552],[1129.91,322.434]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,554.219],[1159.79,439.584],[1129.91,554.158],[1129.91,439.988]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,564.195],[1159.79,678.829],[1129.91,564.094],[1129.91,678.264]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,688.461],[1129.91,687.857],[1159.79,803.096],[1129.91,802.028]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,812.934],[1129.91,811.825],[1159.79,927.568],[1129.91,925.996]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,436.187],[1159.79,321.552],[1196.77,443.16],[1196.77,336.282]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,554.219],[1159.79,439.584],[1196.77,553.206],[1196.77,446.328]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,564.195],[1159.79,678.829],[1196.77,562.507],[1196.77,669.385]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,688.461],[1159.79,803.096],[1196.77,678.366],[1196.77,785.244]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1159.79,812.934],[1159.79,927.568],[1196.77,794.416],[1196.77,901.294]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1184.11,361.916],[1184.11,272.885],[878.106,369.246],[878.106,283.894]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1184.13,361.923],[1184.13,272.896],[1231.27,377.931],[1231.27,296.94]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1167.78,443.536],[1167.78,337.076],[1194.54,448.292],[1194.54,347.121]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1167.78,562.416],[1167.78,668.877],[1194.54,561.265],[1194.54,662.436]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.02,763.568],[1231.02,857.525],[1119.82,760.22],[1119.82,852.775]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.02,454.777],[1231.02,360.82],[1119.82,456.038],[1119.82,363.483]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.02,551.519],[1231.02,457.562],[1119.82,551.336],[1119.82,458.781]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.02,559.696],[1231.02,653.653],[1119.82,559.391],[1119.82,651.946]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.02,661.547],[1231.02,755.505],[1119.82,659.722],[1119.82,752.277]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.28,377.935],[1231.28,296.945],[1270.57,391.276],[1270.57,316.984]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.72,454.734],[1231.72,360.729],[1252.66,458.464],[1252.66,368.607]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.72,551.526],[1231.72,457.521],[1252.66,550.984],[1252.66,461.127]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.72,559.706],[1231.72,653.711],[1252.66,558.804],[1252.66,648.661]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.72,661.61],[1231.72,755.615],[1252.66,656.211],[1252.66,746.068]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1231.72,763.682],[1231.72,857.687],[1252.66,753.779],[1252.66,843.636]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,458.205],[1252.66,458.464],[1276.55,368.061],[1252.66,368.607]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,551.022],[1276.55,460.877],[1252.66,550.984],[1252.66,461.127]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,558.866],[1276.55,649.011],[1252.66,558.804],[1252.66,648.661]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,656.585],[1252.66,656.211],[1276.55,746.729],[1252.66,746.068]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,754.465],[1252.66,753.779],[1276.55,844.609],[1252.66,843.636]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,458.205],[1276.55,368.061],[1299.75,462.581],[1299.75,377.303]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,551.022],[1276.55,460.877],[1299.75,550.386],[1299.75,465.109]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,558.866],[1276.55,649.011],[1299.75,557.807],[1299.75,643.085]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,656.585],[1276.55,746.729],[1299.75,650.25],[1299.75,735.528]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.55,754.465],[1276.55,844.609],[1299.75,742.846],[1299.75,828.124]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.28,462.82],[1276.28,377.809],[1293.37,465.858],[1293.37,384.224]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.28,557.749],[1276.28,642.761],[1293.37,557.014],[1293.37,638.648]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1276.28,649.904],[1276.28,734.915],[1293.37,645.507],[1293.37,727.14]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1293.27,465.198],[1293.27,383.532],[1309.12,468.041],[1309.12,389.509]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1293.27,556.391],[1293.27,638.057],[1309.12,555.733],[1309.12,634.264]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1293.27,549.284],[1293.27,467.619],[1309.12,548.899],[1309.12,470.368]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1293.27,644.919],[1293.27,726.584],[1309.12,640.863],[1309.12,719.394]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1293.27,733.593],[1293.27,815.259],[1309.12,726.133],[1309.12,804.664]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,467.835],[1309.12,468.041],[1330.89,389.077],[1309.12,389.509]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,548.927],[1330.89,470.169],[1309.12,548.899],[1309.12,470.368]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,555.781],[1330.89,634.539],[1309.12,555.733],[1309.12,634.264]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,641.157],[1309.12,640.863],[1330.89,719.915],[1309.12,719.394]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,726.674],[1309.12,726.133],[1330.89,805.432],[1309.12,804.664]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,467.835],[1330.89,389.076],[1348.72,471.226],[1348.72,396.209]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,548.927],[1330.89,470.169],[1348.72,548.468],[1348.72,473.45]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,555.781],[1330.89,634.539],[1348.72,554.996],[1348.72,630.014]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,641.157],[1330.89,719.915],[1348.72,636.317],[1348.72,711.335]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:23,
                    verts:[[1330.89,726.674],[1330.89,805.432],[1348.72,717.773],[1348.72,792.79]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[383.684,363.278],[383.684,174.115],[2.35069,370.103],[2.35069,188.276]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[383.684,558.048],[383.684,368.885],[2.35069,557.319],[2.35069,375.492]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[383.684,574.51],[383.684,763.673],[2.35069,573.142],[2.35069,754.969]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[383.684,779.567],[383.684,968.73],[2.35069,770.247],[2.35069,952.074]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[383.684,984.963],[383.684,1174.13],[2.35069,967.678],[2.35069,1149.5]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[842.378,182.872],[842.378,3.95111],[248.027,203.454],[248.027,34.8663]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,353.531],[928.3,153.891],[504.464,361.117],[504.464,169.63]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,559.089],[928.3,359.448],[504.464,558.279],[504.464,366.792]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,576.463],[928.3,776.103],[504.464,574.943],[504.464,766.43]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,792.878],[928.3,992.518],[504.464,782.519],[504.464,974.006]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,1009.65],[928.3,1209.29],[504.464,990.438],[504.464,1181.93]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[842.378,182.872],[842.378,3.95111],[949.57,243.302],[949.57,94.72]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,353.531],[928.3,153.891],[978.207,370.5],[978.207,189.099]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,559.089],[928.3,359.448],[978.207,557.277],[978.207,375.876]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,576.463],[928.3,776.103],[978.207,573.063],[978.207,754.463]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,792.878],[928.3,992.518],[978.207,769.705],[978.207,951.106]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[928.3,1009.65],[928.3,1209.29],[978.207,966.673],[978.207,1148.07]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,369.728],[978.207,370.5],[1025.88,187.498],[978.207,189.099]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,557.359],[1025.88,375.13],[978.207,557.277],[978.207,375.876]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,573.218],[978.207,573.063],[1025.88,755.447],[978.207,754.463]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,770.759],[978.207,769.705],[1025.88,952.988],[978.207,951.106]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,968.627],[978.207,966.673],[1025.88,1150.86],[978.207,1148.07]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,369.728],[1025.88,187.498],[1073.35,387.665],[1073.35,224.716]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,557.359],[1025.88,375.13],[1073.35,555.443],[1073.35,392.495]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,573.218],[1025.88,755.447],[1073.35,569.624],[1073.35,732.572]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,770.759],[1025.88,952.988],[1073.35,746.264],[1073.35,909.212]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1025.88,968.627],[1025.88,1150.86],[1073.35,923.196],[1073.35,1086.14]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1063.27,404.145],[1063.27,253.873],[1092.21,413.652],[1092.21,273.953]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1063.27,558.872],[1063.27,408.599],[1092.21,557.491],[1092.21,417.792]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1063.27,571.949],[1063.27,722.222],[1092.21,569.649],[1092.21,709.348]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1063.27,734.848],[1063.27,885.12],[1092.21,721.085],[1092.21,860.785]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1063.27,898.016],[1063.27,1048.29],[1092.21,872.773],[1092.21,1012.47]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,413.21],[1092.21,413.652],[1129.29,273.02],[1092.21,273.953]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,557.556],[1129.29,417.365],[1092.21,557.491],[1092.21,417.792]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,569.755],[1092.21,569.649],[1129.29,709.946],[1092.21,709.348]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,721.725],[1092.21,721.085],[1129.29,861.915],[1092.21,860.784]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,873.946],[1092.21,872.773],[1129.29,1014.14],[1092.21,1012.47]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,413.21],[1129.29,273.02],[1158.09,423.726],[1158.09,295.233]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,557.556],[1129.29,417.365],[1158.09,556.029],[1158.09,427.535]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,569.755],[1129.29,709.946],[1158.09,567.21],[1158.09,695.704]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,721.725],[1129.29,861.915],[1158.09,706.5],[1158.09,834.994]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1129.29,873.946],[1129.29,1014.14],[1158.09,846.021],[1158.09,974.515]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1144.55,430.846],[1144.55,310.272],[1163.44,437.053],[1163.44,323.382]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1144.55,565.487],[1144.55,686.062],[1163.44,563.985],[1163.44,677.656]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1144.55,554.995],[1144.55,434.42],[1163.44,554.093],[1163.44,440.422]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1144.55,696.193],[1144.55,816.767],[1163.44,687.207],[1163.44,800.879]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1144.55,827.114],[1144.55,947.689],[1163.44,810.633],[1163.44,924.305]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,436.761],[1163.44,437.053],[1193.79,322.764],[1163.44,323.382]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,554.136],[1193.79,440.139],[1163.44,554.093],[1163.44,440.422]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,564.056],[1163.44,563.985],[1193.79,678.052],[1163.44,677.657]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,687.63],[1163.44,687.207],[1193.79,801.627],[1163.44,800.879]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,811.41],[1163.44,810.633],[1193.79,925.406],[1163.44,924.305]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,436.761],[1193.79,322.764],[1213.14,443.824],[1213.14,337.685]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,554.136],[1193.79,440.139],[1213.14,553.11],[1213.14,446.97]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,564.056],[1193.79,678.052],[1213.14,562.347],[1213.14,668.486]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,687.63],[1193.79,801.627],[1213.14,677.404],[1213.14,783.544]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1193.79,811.41],[1193.79,925.406],[1213.14,792.653],[1213.14,898.793]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1218.55,761.761],[1218.55,854.961],[1106.33,759.42],[1106.33,851.64]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1218.55,455.458],[1218.55,362.258],[1106.33,456.339],[1106.33,364.12]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1218.55,551.421],[1218.55,458.22],[1106.33,551.293],[1106.33,459.073]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1218.55,559.531],[1218.55,652.732],[1106.33,559.318],[1106.33,651.538]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1218.55,660.562],[1218.55,753.763],[1106.33,659.286],[1106.33,751.506]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1219.34,455.417],[1219.34,362.172],[1230.79,459.178],[1230.79,370.116]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1219.34,551.426],[1219.34,458.181],[1230.79,550.88],[1230.79,461.818]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1219.34,559.541],[1219.34,652.786],[1230.79,558.631],[1230.79,647.693]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1219.34,660.621],[1219.34,753.866],[1230.79,655.176],[1230.79,744.239]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1219.34,761.868],[1219.34,855.113],[1230.79,751.882],[1230.79,840.944]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,458.999],[1230.79,459.178],[1254.71,369.737],[1230.79,370.116]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,550.906],[1254.71,461.644],[1230.79,550.88],[1230.79,461.818]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,558.674],[1230.79,558.631],[1254.71,647.936],[1230.79,647.693]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,655.436],[1230.79,655.176],[1254.71,744.698],[1230.79,744.239]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,752.358],[1230.79,751.882],[1254.71,841.62],[1230.79,840.944]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,458.999],[1254.71,369.737],[1266.75,463.396],[1266.75,379.024]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,550.906],[1254.71,461.644],[1266.75,550.268],[1266.75,465.896]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,558.674],[1254.71,647.936],[1266.75,557.61],[1266.75,641.982]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,655.436],[1254.71,744.698],[1266.75,649.071],[1266.75,733.443]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1254.71,752.358],[1254.71,841.62],[1266.75,740.683],[1266.75,825.055]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1252.61,643.829],[1252.61,724.653],[1261.25,639.757],[1261.25,717.433]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1252.61,731.589],[1252.61,812.413],[1261.25,724.099],[1261.25,801.776]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,468.673],[1261.25,468.816],[1282.9,390.84],[1261.25,391.139]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,555.587],[1261.25,555.554],[1282.9,633.42],[1261.25,633.23]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,639.96],[1261.25,639.757],[1282.9,717.794],[1261.25,717.433]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,548.814],[1282.9,470.98],[1261.25,548.794],[1261.25,471.118]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,724.473],[1261.25,724.099],[1282.9,802.306],[1261.25,801.776]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,468.673],[1282.9,390.84],[1292.12,472.069],[1292.12,397.98]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,548.814],[1282.9,470.98],[1292.12,548.354],[1292.12,474.265]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,555.587],[1282.9,633.42],[1292.12,554.801],[1292.12,628.89]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,639.96],[1282.9,717.794],[1292.12,635.115],[1292.12,709.204]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:24,
                    verts:[[1282.9,724.473],[1282.9,802.306],[1292.12,715.562],[1292.12,789.651]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[577.609,359.291],[577.609,165.841],[160.056,363.462],[160.056,174.496]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[577.609,558.474],[577.609,365.025],[160.056,558.029],[160.056,369.062]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[577.609,575.309],[577.609,768.758],[160.056,574.473],[160.056,763.439]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[577.609,785.012],[577.609,978.462],[160.056,779.316],[160.056,968.282]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[577.609,995.063],[577.609,1188.51],[160.056,984.499],[160.056,1173.47]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1020.43,181.469],[1020.43,1.84461],[389.606,193.696],[389.606,20.2102]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,353.56],[1151.33,153.95],[707.092,357.997],[707.092,163.157]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,559.086],[1151.33,359.476],[707.092,558.612],[707.092,363.772]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,576.457],[1151.33,776.067],[707.092,575.568],[707.092,770.408]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,792.839],[1151.33,992.449],[707.092,786.779],[707.092,981.619]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,1009.58],[1151.33,1209.19],[707.092,998.339],[707.092,1193.18]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1020.43,181.469],[1020.43,1.84461],[1060.15,243.163],[1060.15,94.5116]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,353.56],[1151.33,153.95],[1160.55,370.776],[1160.55,189.673]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,559.086],[1151.33,359.476],[1160.55,557.247],[1160.55,376.144]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,576.457],[1151.33,776.067],[1160.55,573.008],[1160.55,754.111]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,792.839],[1151.33,992.449],[1160.55,769.327],[1160.55,950.431]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1151.33,1009.58],[1151.33,1209.19],[1160.55,965.973],[1160.55,1147.08]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,370.335],[1160.55,370.776],[1209.27,188.757],[1160.55,189.673]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,557.294],[1160.55,557.247],[1209.27,375.717],[1160.55,376.144]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,573.096],[1160.55,573.008],[1209.27,754.674],[1160.55,754.111]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,769.93],[1160.55,769.327],[1209.27,951.508],[1160.55,950.431]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,967.09],[1160.55,965.973],[1209.27,1148.67],[1160.55,1147.08]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,370.335],[1209.27,188.757],[1213.71,388.412],[1213.71,226.266]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,557.294],[1209.27,375.717],[1213.71,555.364],[1213.71,393.218]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,569.557],[1181.43,569.496],[1218.85,708.835],[1181.43,708.495]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,573.096],[1209.27,754.674],[1213.71,569.474],[1213.71,731.62]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,720.537],[1181.43,720.174],[1218.85,859.815],[1181.43,859.173]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,769.93],[1209.27,951.508],[1213.71,745.244],[1213.71,907.39]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,871.768],[1181.43,871.101],[1218.85,1011.05],[1181.43,1010.1]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1209.27,967.09],[1209.27,1148.67],[1213.71,921.305],[1213.71,1083.45]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,414.03],[1181.43,414.281],[1218.85,274.752],[1181.43,275.283]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,557.436],[1181.43,557.4],[1218.85,418.158],[1181.43,418.401]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,414.03],[1218.85,274.752],[1221.53,424.572],[1221.53,297.019]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,557.436],[1218.85,418.158],[1221.53,555.906],[1221.53,428.353]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,569.557],[1218.85,708.835],[1221.53,567.006],[1221.53,694.559]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,720.537],[1218.85,859.816],[1221.53,705.276],[1221.53,832.829]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1218.85,871.768],[1218.85,1011.05],[1221.53,843.775],[1221.53,971.328]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1224.86,437.614],[1194.47,437.78],[1224.86,324.567],[1194.47,324.917]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1224.86,554.012],[1194.47,553.988],[1224.86,440.965],[1194.47,441.125]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1224.86,563.85],[1194.47,563.809],[1224.86,676.897],[1194.47,676.672]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1224.86,686.395],[1194.47,686.155],[1224.86,799.442],[1194.47,799.018]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1224.86,437.614],[1224.86,324.567],[1226.66,444.671],[1226.66,339.473]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1224.86,554.012],[1224.86,440.965],[1226.66,552.987],[1226.66,447.789]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1224.86,563.85],[1224.86,676.897],[1226.66,562.142],[1226.66,667.34]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1230.51,459.804],[1206.74,459.906],[1230.51,371.439],[1206.74,371.652]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1230.51,550.789],[1206.74,550.775],[1230.51,462.424],[1206.74,462.521]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1230.51,558.479],[1206.74,558.455],[1230.51,646.845],[1206.74,646.708]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1230.51,459.805],[1230.51,371.439],[1231.63,464.183],[1231.63,380.686]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1230.51,550.789],[1230.51,462.424],[1231.63,550.154],[1231.63,466.657]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1230.51,558.479],[1230.51,646.845],[1231.63,557.42],[1231.63,640.916]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1233.17,469.438],[1211.72,469.518],[1233.17,392.447],[1211.72,392.616]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1233.17,548.71],[1211.72,548.699],[1233.17,471.72],[1211.72,471.797]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1233.17,555.41],[1211.72,555.391],[1233.17,632.401],[1211.72,632.294]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1233.17,469.438],[1233.17,392.447],[1234.02,472.814],[1234.02,399.546]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1233.17,548.71],[1233.17,471.72],[1234.02,548.253],[1234.02,474.985]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:25,
                    verts:[[1233.17,555.41],[1233.17,632.401],[1234.02,554.629],[1234.02,627.896]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[786.72,357.165],[786.72,161.431],[345.453,358.248],[345.453,163.679]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[786.72,558.701],[786.72,362.967],[345.453,558.585],[345.453,364.015]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[786.72,575.735],[786.72,771.469],[345.453,575.518],[345.453,770.087]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[786.72,787.915],[786.72,983.65],[345.453,786.436],[345.453,981.006]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[786.72,1000.45],[786.72,1196.18],[345.453,997.703],[345.453,1192.27]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[1197.72,183.497],[1197.72,4.89094],[549.238,186.591],[549.238,9.53723]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[920.467,356.837],[1368.66,355.736],[920.467,160.749],[1368.66,158.466]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[920.467,558.736],[920.467,362.649],[1368.66,558.854],[1368.66,361.583]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[920.467,575.8],[920.467,771.888],[1368.66,576.021],[1368.66,773.291]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[920.467,788.363],[1368.66,789.866],[920.467,984.451],[1368.66,987.136]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[920.467,1001.28],[1368.66,1004.07],[920.467,1197.37],[1368.66,1201.34]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[1337.52,372.683],[1385.67,372.576],[1337.52,193.63],[1385.67,193.407]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[1337.52,572.625],[1385.67,572.647],[1337.52,751.679],[1385.67,751.816]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[1337.52,766.724],[1385.67,766.87],[1337.52,945.777],[1385.67,946.039]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[1337.52,961.143],[1385.67,961.415],[1337.52,1140.2],[1385.67,1140.58]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:26,
                    verts:[[1337.52,557.044],[1337.52,377.99],[1385.67,557.055],[1385.67,377.886]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[576.849,371.94],[528.27,371.721],[576.849,192.088],[528.27,191.633]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[576.849,557.123],[528.27,557.146],[576.849,377.271],[528.27,377.059]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[576.849,572.774],[528.27,572.818],[576.849,752.627],[528.27,752.906]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[576.849,767.738],[528.27,768.037],[576.849,947.59],[528.27,948.125]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[576.849,963.025],[528.27,963.58],[576.849,1142.88],[528.27,1143.67]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1002.1,357.096],[552.737,354.863],[1002.1,161.287],[552.737,156.653]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1002.1,558.709],[552.737,558.947],[1002.1,362.9],[552.737,360.737]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1002.1,575.748],[552.737,576.196],[1002.1,771.557],[552.737,774.405]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1002.1,788.009],[552.737,791.059],[1002.1,983.818],[552.737,989.269]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1002.1,1000.62],[552.737,1006.28],[1002.1,1196.43],[552.737,1204.49]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[721.758,182.64],[721.758,3.60352],[1367.17,188.873],[1367.17,12.9651]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1135.13,357.757],[1135.13,162.659],[1570.58,359.922],[1570.58,167.15]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1135.13,558.638],[1135.13,363.54],[1570.58,558.407],[1570.58,365.635]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1135.13,575.616],[1135.13,770.714],[1570.58,575.182],[1570.58,767.954]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1135.13,787.106],[1135.13,982.204],[1570.58,784.151],[1570.58,976.922]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:27,
                    verts:[[1135.13,998.947],[1135.13,1194.05],[1570.58,993.465],[1570.58,1186.24]]
                },
                ],
                [
                {
                    num:"408",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[641.621,546.926],[641.621,469.701],[639.252,546.555],[639.252,473.06]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[641.621,553.646],[641.621,630.87],[639.252,552.951],[639.252,626.446]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[641.621,637.359],[641.621,714.583],[639.252,632.622],[639.252,706.117]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[641.621,546.926],[663.172,546.914],[641.621,469.701],[663.172,469.801]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[641.621,553.646],[663.172,553.625],[641.621,630.87],[663.172,630.738]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[641.621,637.359],[663.172,637.217],[641.621,714.583],[663.172,714.33]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,548.066],[648.911,459.363],[645.808,547.581],[645.808,463.763]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,555.785],[648.911,644.488],[645.808,554.875],[645.808,638.693]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,651.941],[648.911,740.644],[645.808,645.735],[645.808,729.553]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,748.256],[648.911,836.959],[645.808,736.746],[645.808,820.564]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,456.734],[672.806,456.866],[648.911,368.032],[672.806,368.305]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,548.066],[672.806,548.052],[648.911,459.363],[672.806,459.491]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,555.785],[672.806,555.759],[648.911,644.488],[672.806,644.32]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,651.941],[672.806,651.761],[648.911,740.644],[672.806,740.322]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[648.911,748.256],[672.806,747.922],[648.911,836.959],[672.806,836.482]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,433.835],[664.544,320.517],[659.557,441.14],[659.557,335.674]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,550.512],[664.544,437.194],[659.557,549.732],[659.557,444.266]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,560.373],[664.544,673.691],[659.557,558.91],[659.557,664.376]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,683.212],[664.544,796.53],[659.557,673.237],[659.557,778.703]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,806.255],[664.544,919.573],[659.557,787.754],[659.557,893.22]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,433.835],[695.025,434.051],[664.544,320.517],[695.025,320.964]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,550.512],[695.025,550.489],[664.544,437.194],[695.025,437.402]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,560.373],[695.025,560.33],[664.544,673.691],[695.025,673.417]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,683.212],[695.025,682.918],[664.544,796.53],[695.025,796.005]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[664.544,806.255],[695.025,805.71],[664.544,919.573],[695.025,918.796]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,553.118],[681.201,413.575],[673.757,551.953],[673.757,424.129]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,565.261],[681.201,704.804],[673.757,563.077],[673.757,690.901]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,716.529],[681.201,856.072],[673.757,701.641],[673.757,829.465]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,868.047],[681.201,1007.59],[673.757,840.434],[673.757,968.258]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,409.439],[681.201,269.896],[673.757,420.341],[673.757,292.517]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,409.439],[718.676,409.765],[681.201,269.896],[718.676,270.573]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,553.118],[718.676,553.083],[681.201,413.575],[718.676,413.891]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,565.261],[718.676,565.196],[681.201,704.804],[718.676,704.388]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,716.529],[718.676,716.083],[681.201,856.072],[718.676,855.276]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[681.201,868.047],[718.676,867.221],[681.201,1007.59],[718.676,1006.41]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,370.163],[708.015,188.4],[695.7,388.202],[695.7,225.83]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,557.313],[708.015,375.55],[695.7,555.386],[695.7,393.014]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,573.13],[708.015,754.893],[695.7,569.516],[695.7,731.888]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,770.165],[708.015,951.928],[695.7,745.531],[695.7,907.903]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,967.526],[708.015,1149.29],[695.7,921.837],[695.7,1084.21]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,370.163],[756.704,370.716],[708.015,188.4],[756.704,189.549]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,557.313],[756.704,557.254],[708.015,375.55],[756.704,376.086]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,573.13],[756.704,573.02],[708.015,754.893],[756.704,754.187]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,770.165],[756.704,769.409],[708.015,951.928],[756.704,950.577]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[708.015,967.526],[756.704,966.124],[708.015,1149.29],[756.704,1147.29]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,353.573],[773.399,153.976],[756.704,370.716],[756.704,189.549]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,559.085],[773.399,359.488],[756.704,557.254],[756.704,376.086]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,576.454],[773.399,776.051],[756.704,573.02],[756.704,754.187]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,792.821],[773.399,992.417],[756.704,769.409],[756.704,950.577]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,1009.55],[773.399,1209.14],[756.704,966.124],[756.704,1147.29]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,353.573],[773.399,153.976],[1213.95,359.095],[1213.95,165.435]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,559.085],[773.399,359.488],[1213.95,558.495],[1213.95,364.835]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,576.454],[773.399,776.051],[1213.95,575.348],[1213.95,769.008]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,792.821],[773.399,992.417],[1213.95,785.279],[1213.95,978.939]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[773.399,1009.55],[773.399,1209.14],[1213.95,995.559],[1213.95,1189.22]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[900.718,182.075],[900.718,2.75482],[847.711,243.516],[847.711,95.0424]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[900.559,182.124],[900.559,2.82802],[1522.51,197.249],[1522.51,25.5471]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[1341.36,360.692],[1341.36,168.75],[1749.23,365.805],[1749.23,179.359]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[1341.36,558.324],[1341.36,366.382],[1749.23,557.778],[1749.23,371.332]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[1341.36,575.028],[1341.36,766.971],[1749.23,574.003],[1749.23,760.45]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[1341.36,783.098],[1341.36,975.041],[1749.23,776.116],[1749.23,962.562]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:28,
                    verts:[[1341.36,991.513],[1341.36,1183.46],[1749.23,978.563],[1749.23,1165.01]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,466.633],[592.821,388.571],[581.98,470.111],[581.98,395.788]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,547.009],[592.821,468.947],[581.98,546.637],[581.98,472.314]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,553.802],[592.821,631.864],[581.98,553.105],[581.98,627.428]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,638.423],[592.821,716.485],[581.98,633.673],[581.98,707.996]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,723.184],[592.821,801.246],[581.98,714.375],[581.98,788.698]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,466.633],[614.564,466.801],[592.821,388.571],[614.564,388.919]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,547.009],[592.821,468.947],[614.564,546.991],[614.564,469.109]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,553.802],[592.821,631.864],[614.564,553.768],[614.564,631.65]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,638.423],[614.564,638.194],[592.821,716.485],[614.564,716.076]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[592.821,723.184],[614.564,722.759],[592.821,801.246],[614.564,800.641]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,455.945],[626.137,366.393],[611.969,460.49],[611.969,375.825]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,548.15],[626.137,458.599],[611.969,547.665],[611.969,463]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,555.944],[626.137,645.495],[611.969,555.033],[611.969,639.698]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,653.019],[626.137,742.57],[611.969,646.812],[611.969,731.477]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,750.255],[626.137,839.807],[611.969,738.743],[611.969,823.408]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,455.945],[650.137,456.158],[626.137,366.393],[650.137,366.836]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,548.15],[626.137,458.599],[650.137,548.128],[650.137,458.805]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,555.944],[626.137,645.495],[650.137,555.901],[650.137,645.223]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,653.019],[650.137,652.728],[626.137,742.57],[650.137,742.05]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[626.137,750.255],[650.137,749.716],[626.137,839.807],[650.137,839.038]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[663.394,452.274],[663.394,358.778],[650.137,456.158],[650.137,366.836]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[663.394,548.542],[663.394,455.046],[650.137,548.128],[650.137,458.805]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[663.394,556.679],[663.394,650.176],[650.137,555.901],[650.137,645.223]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[663.394,658.031],[663.394,751.528],[650.137,652.728],[650.137,742.05]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[663.394,759.552],[663.394,853.049],[650.137,749.716],[650.137,839.038]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[664.173,452.317],[664.173,358.866],[717.202,452.811],[717.202,359.89]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[664.173,548.538],[664.173,455.087],[717.202,548.485],[717.202,455.565]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[664.173,556.67],[664.173,650.121],[717.202,556.571],[717.202,649.492]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[664.173,657.973],[664.173,751.424],[717.202,657.299],[717.202,750.22]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[664.173,759.444],[717.202,758.194],[664.173,852.894],[717.202,851.114]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,433.115],[697.298,319.022],[674.64,440.384],[674.64,334.106]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,550.589],[697.298,436.496],[674.64,549.812],[674.64,443.534]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,560.518],[697.298,674.61],[674.64,559.061],[674.64,665.34]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,684.196],[697.298,798.289],[674.64,674.269],[674.64,780.548]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,808.08],[697.298,922.172],[674.64,789.668],[674.64,895.947]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,433.115],[727.622,433.461],[697.298,319.022],[727.622,319.74]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,550.589],[697.298,436.496],[727.622,550.552],[727.622,436.831]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,560.518],[697.298,674.61],[727.622,560.448],[727.622,674.169]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,684.196],[727.622,683.724],[697.298,798.289],[727.622,797.445]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[697.298,808.08],[727.622,807.204],[697.298,922.172],[727.622,920.925]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[749.389,427.084],[749.389,306.51],[727.622,433.461],[727.622,319.74]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[749.389,551.233],[749.389,430.658],[727.622,550.552],[727.622,436.831]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[749.389,561.726],[749.389,682.301],[727.622,560.448],[727.622,674.169]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[749.389,692.432],[749.389,813.007],[727.622,683.724],[727.622,797.445]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[749.389,823.354],[749.389,943.929],[727.622,807.204],[727.622,920.925]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,408.927],[772.691,268.835],[739.054,419.719],[739.054,291.226]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,553.172],[772.691,413.08],[739.054,552.02],[739.054,423.527]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,565.364],[772.691,705.456],[739.054,563.202],[739.054,691.694]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,717.227],[772.691,857.32],[739.054,702.49],[739.054,830.983]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,869.342],[772.691,1009.44],[739.054,842.01],[739.054,970.502]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,408.927],[809.596,409.448],[772.691,268.835],[809.596,269.915]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,553.172],[772.691,413.08],[809.596,553.117],[809.596,413.584]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,565.364],[772.691,705.456],[809.596,565.259],[809.596,704.792]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,717.227],[809.596,716.516],[772.691,857.32],[809.596,856.049]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[772.691,869.342],[809.596,868.023],[772.691,1009.44],[809.596,1007.56]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[842.821,399.716],[842.821,249.721],[809.596,409.448],[809.596,269.915]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[842.821,554.156],[842.821,404.162],[809.596,553.117],[809.596,413.584]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[842.821,567.209],[842.821,717.204],[809.596,565.259],[809.596,704.792]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[842.821,729.807],[842.821,879.801],[809.596,716.516],[809.596,856.049]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[842.821,892.673],[842.821,1042.67],[809.596,868.023],[809.596,1007.56]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,370.279],[893.157,188.642],[837.967,387.985],[837.967,225.381]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,557.3],[893.157,375.663],[837.967,555.409],[837.967,392.805]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,573.107],[893.157,754.745],[837.967,569.56],[837.967,732.164]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,770.006],[893.157,951.644],[837.967,745.826],[837.967,908.431]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,967.231],[893.157,1148.87],[837.967,922.385],[837.967,1084.99]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[881.967,388.711],[881.967,226.887],[843.699,399.886],[843.699,250.075]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[881.967,569.414],[881.967,731.238],[843.699,567.175],[843.699,716.986]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,370.279],[940.327,371.154],[893.157,188.642],[940.327,190.456]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,557.3],[893.157,375.663],[940.327,557.207],[940.327,376.51]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,573.107],[893.157,754.745],[940.327,572.932],[940.327,753.629]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,770.006],[940.327,768.812],[893.157,951.644],[940.327,949.509]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[893.157,967.231],[940.327,965.016],[893.157,1148.87],[940.327,1145.71]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,354.463],[997.307,155.823],[940.327,371.154],[940.327,190.456]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,558.99],[997.307,360.35],[940.327,557.207],[940.327,376.51]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,576.276],[997.307,774.915],[940.327,572.932],[940.327,753.629]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,791.606],[997.307,990.245],[940.327,768.812],[940.327,949.509]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,1007.29],[997.307,1205.93],[940.327,965.016],[940.327,1145.71]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,354.463],[997.307,155.823],[1413.01,362.989],[1413.01,173.515]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,558.99],[997.307,360.35],[1413.01,558.079],[1413.01,368.605]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,576.276],[997.307,774.915],[1413.01,574.568],[1413.01,764.042]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,791.605],[997.307,990.245],[1413.01,779.961],[1413.01,969.435]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[997.307,1007.29],[997.307,1205.93],[1413.01,985.695],[1413.01,1175.17]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[1078.61,185.001],[1078.61,7.14894],[958.878,244.56],[958.878,96.6097]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[1078.4,185.046],[1078.4,7.21707],[1659,208.08],[1659,41.8154]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[1530.63,365.402],[1530.63,178.521],[1899.58,372.969],[1899.58,194.224]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[1530.63,557.821],[1530.63,370.941],[1899.58,557.013],[1899.58,378.267]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[1530.63,574.084],[1530.63,760.965],[1899.58,572.568],[1899.58,751.314]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[1530.63,776.667],[1530.63,963.547],[1899.58,766.332],[1899.58,945.078]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:29,
                    verts:[[1530.63,979.585],[1530.63,1166.47],[1899.58,960.417],[1899.58,1139.16]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,465.788],[546.219,386.817],[526.651,469.25],[526.651,394.002]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,547.099],[546.219,468.129],[526.651,546.729],[526.651,471.481]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,553.971],[546.219,632.942],[526.651,553.278],[526.651,628.526]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,639.577],[546.219,718.548],[526.651,634.849],[526.651,710.097]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,725.325],[546.219,804.295],[526.651,716.555],[526.651,791.803]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,465.788],[568.057,466.021],[546.219,386.817],[568.057,387.301]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,547.099],[546.219,468.129],[568.057,547.074],[568.057,468.354]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,553.971],[546.219,632.942],[568.057,553.925],[568.057,632.645]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,639.577],[568.057,639.259],[546.219,718.548],[568.057,717.979]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[546.219,725.325],[568.057,724.735],[546.219,804.295],[568.057,803.455]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[585.216,463.146],[585.216,381.335],[568.057,466.021],[568.057,387.301]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[585.216,547.381],[585.216,465.57],[568.057,547.074],[568.057,468.354]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[585.216,554.501],[585.216,636.312],[568.057,553.925],[568.057,632.645]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[585.216,643.186],[585.216,724.997],[568.057,639.259],[568.057,717.979]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[585.216,732.017],[585.216,813.828],[568.057,724.735],[568.057,803.455]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,455.182],[606.157,364.811],[580.704,459.686],[580.704,374.156]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,548.232],[606.157,457.861],[580.704,547.751],[580.704,462.221]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,556.096],[606.157,646.467],[580.704,555.194],[580.704,640.724]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,654.06],[606.157,744.431],[580.704,647.91],[580.704,733.44]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,752.187],[606.157,842.558],[580.704,740.779],[580.704,826.309]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[649.338,377.786],[649.338,296.723],[606.777,391.045],[606.777,316.638]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,455.182],[630.077,455.477],[606.157,364.811],[630.077,365.422]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,548.232],[606.157,457.861],[630.077,548.2],[630.077,458.146]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,556.096],[606.157,646.467],[630.077,556.037],[630.077,646.092]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,654.06],[630.077,653.658],[606.157,744.431],[630.077,743.713]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[606.157,752.187],[630.077,751.441],[606.157,842.558],[630.077,841.495]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[652.91,451.644],[652.91,357.469],[630.077,455.477],[630.077,365.422]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[652.91,548.61],[652.91,454.435],[630.077,548.2],[630.077,458.146]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[652.91,556.805],[652.91,650.98],[630.077,556.037],[630.077,646.092]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[652.91,658.893],[652.91,753.068],[630.077,653.658],[630.077,743.713]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[652.91,761.149],[652.91,855.324],[630.077,751.441],[630.077,841.495]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[700.217,361.936],[700.217,272.915],[649.392,377.77],[649.392,296.697]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[653.598,451.689],[653.598,357.563],[706.136,452.368],[706.136,358.971]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[653.598,548.605],[653.598,454.479],[706.136,548.533],[706.136,455.136]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[653.598,556.796],[653.598,650.922],[706.136,556.66],[706.136,650.057]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[653.598,658.831],[653.598,752.957],[706.136,657.904],[706.136,751.301]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[653.598,761.034],[653.598,855.16],[706.136,759.316],[706.136,852.713]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,432.703],[733.202,318.167],[692.894,439.835],[692.894,332.966]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[721.785,440.261],[721.785,333.85],[692.742,445.128],[692.742,343.948]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,550.633],[733.202,436.097],[692.894,549.871],[692.894,443.002]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[721.785,559.086],[721.785,665.497],[692.742,558.111],[692.742,659.29]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,560.6],[733.202,675.136],[692.894,559.171],[692.894,666.04]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,684.759],[733.202,799.295],[692.894,675.019],[692.894,781.888]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,809.124],[733.202,923.659],[692.894,791.059],[692.894,897.928]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,432.703],[762.926,433.175],[733.202,318.167],[762.926,319.148]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,550.633],[733.202,436.097],[762.926,550.582],[762.926,436.555]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,560.6],[733.202,675.136],[762.926,560.505],[762.926,674.533]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,684.759],[762.926,684.114],[733.202,799.295],[762.926,798.141]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[733.202,809.124],[762.926,807.927],[733.202,923.659],[762.926,921.955]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[799.986,426.954],[799.986,306.239],[762.926,433.175],[762.926,319.148]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[799.986,551.247],[799.986,430.532],[762.926,550.582],[762.926,436.555]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[799.986,561.752],[799.986,682.467],[762.926,560.505],[762.926,674.533]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[799.986,692.61],[799.986,813.325],[762.926,684.114],[762.926,798.141]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[799.986,823.685],[799.986,944.4],[762.926,807.927],[762.926,921.954]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[841.279,420.237],[841.279,292.302],[800.057,427.145],[800.057,306.635]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[841.279,551.964],[841.279,424.029],[800.057,551.227],[800.057,430.717]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[841.279,563.098],[841.279,691.033],[800.057,561.714],[800.057,682.224]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[841.279,701.782],[841.279,829.717],[800.057,692.349],[800.057,812.859]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[841.279,840.696],[841.279,968.631],[800.057,823.2],[800.057,943.71]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[893.215,301.813],[893.215,182.606],[803.434,329.782],[803.434,224.617]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,409.141],[866.362,269.278],[807.133,419.621],[807.133,291.023]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,553.15],[866.362,413.286],[807.133,552.03],[807.133,423.433]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,565.321],[866.362,705.184],[807.133,563.221],[807.133,691.819]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,716.936],[866.362,856.799],[807.133,702.624],[807.133,831.221]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,868.802],[866.362,1008.66],[807.133,842.257],[807.133,970.855]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,409.141],[901.903,409.845],[866.362,269.278],[901.903,270.738]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,553.15],[866.362,413.286],[901.903,553.074],[901.903,413.968]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,565.321],[866.362,705.184],[901.903,565.18],[901.903,704.286]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,716.936],[901.903,715.974],[866.362,856.799],[901.903,855.081]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[866.362,868.802],[901.903,867.018],[866.362,1008.66],[901.903,1006.12]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[893.27,301.77],[893.27,182.542],[1282.85,315.913],[1282.85,203.786]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[957.778,400.465],[957.778,251.276],[901.903,409.845],[901.903,270.738]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[957.778,554.076],[957.778,404.887],[901.903,553.074],[901.903,413.968]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[957.778,567.059],[957.778,716.249],[901.903,565.18],[901.903,704.286]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[957.778,728.784],[957.778,877.973],[901.903,715.974],[901.903,855.081]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[957.778,890.776],[957.778,1039.97],[901.903,867.018],[901.903,1006.12]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1068.02,247.357],[1068.02,100.811],[937.485,288.021],[937.485,161.891]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1022.2,389.921],[1022.2,229.397],[958.248,400.637],[958.248,251.633]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1022.2,555.202],[1022.2,394.678],[958.248,554.058],[958.248,405.054]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1022.2,569.172],[1022.2,729.696],[958.248,567.025],[958.248,716.029]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1022.2,743.183],[1022.2,903.707],[958.248,728.549],[958.248,877.553]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1022.2,917.483],[1022.2,1078.01],[958.248,890.34],[958.248,1039.34]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,372.026],[1076.12,192.266],[980.477,388.949],[980.477,227.381]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,557.114],[1076.12,377.354],[980.477,555.306],[980.477,393.738]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,572.757],[1076.12,752.517],[980.477,569.367],[980.477,730.935]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,767.621],[1076.12,947.381],[980.477,744.51],[980.477,906.079]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,962.807],[1076.12,1142.57],[980.477,919.944],[980.477,1081.51]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1248.61,191.096],[1248.61,16.3048],[1067.77,247.434],[1067.77,100.927]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,372.026],[1120.27,373.187],[1076.12,192.266],[1120.27,194.675]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,557.114],[1076.12,377.354],[1120.27,556.99],[1120.27,378.478]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,572.757],[1076.12,752.517],[1120.27,572.525],[1120.27,751.036]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,767.621],[1120.27,766.035],[1076.12,947.381],[1120.27,944.547]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1076.12,962.807],[1120.27,959.866],[1076.12,1142.57],[1120.27,1138.38]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,357.417],[1214.21,161.952],[1120.27,373.187],[1120.27,194.675]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,558.674],[1214.21,363.21],[1120.27,556.99],[1120.27,378.478]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,575.684],[1214.21,771.148],[1120.27,572.525],[1120.27,751.036]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,787.572],[1214.21,983.036],[1120.27,766.035],[1120.27,944.547]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,999.81],[1214.21,1195.27],[1120.27,959.866],[1120.27,1138.38]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,357.417],[1214.21,161.952],[1591.9,368.457],[1591.9,184.86]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,558.674],[1214.21,363.21],[1591.9,557.495],[1591.9,373.899]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,575.684],[1214.21,771.148],[1591.9,573.472],[1591.9,757.069]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,787.572],[1214.21,983.036],[1591.9,772.495],[1591.9,956.091]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1214.21,999.81],[1214.21,1195.27],[1591.9,971.847],[1591.9,1155.44]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1248.36,191.137],[1248.36,16.3663],[1773.85,220.707],[1773.85,60.7816]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1696.68,371.52],[1696.68,191.216],[2019.57,380.958],[2019.57,210.8]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1696.68,557.168],[1696.68,376.864],[2019.57,556.16],[2019.57,386.002]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1696.68,572.859],[1696.68,753.163],[2019.57,570.968],[2019.57,741.125]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1696.68,768.312],[1696.68,948.616],[2019.57,755.423],[2019.57,925.58]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:30,
                    verts:[[1696.68,964.089],[1696.68,1144.39],[2019.57,940.183],[2019.57,1110.34]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[493.924,468.565],[493.924,392.579],[472.916,470.991],[472.916,397.614]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[493.924,546.802],[493.924,470.817],[472.916,546.543],[472.916,473.166]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[493.924,553.415],[493.924,629.401],[472.916,552.929],[472.916,626.306]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[493.924,635.785],[493.924,711.771],[472.916,632.471],[472.916,705.848]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[493.924,718.292],[493.924,794.277],[472.916,712.145],[472.916,785.522]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,464.881],[502.23,384.936],[473.697,468.302],[473.697,392.034]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,547.196],[502.23,467.251],[473.697,546.831],[473.697,470.563]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,554.153],[502.23,634.098],[473.697,553.468],[473.697,629.736]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,640.816],[502.23,720.761],[473.697,636.144],[473.697,712.412]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,727.622],[502.23,807.567],[473.697,718.957],[473.697,795.225]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,464.881],[502.23,384.936],[524.06,465.18],[524.06,385.555]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,547.196],[502.23,467.251],[524.06,547.164],[524.06,467.54]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,554.153],[502.23,634.098],[524.06,554.093],[524.06,633.718]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,640.816],[502.23,720.761],[524.06,640.408],[524.06,720.032]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[502.23,727.622],[524.06,726.865],[502.23,807.567],[524.06,806.49]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[548.591,462.35],[548.591,379.684],[524.06,465.18],[524.06,385.555]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[548.591,547.466],[548.591,464.8],[524.06,547.164],[524.06,467.54]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[548.591,554.66],[548.591,637.326],[524.06,554.093],[524.06,633.718]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[548.591,644.272],[548.591,726.938],[524.06,640.408],[524.06,720.032]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[548.591,734.032],[548.591,816.699],[524.06,726.865],[524.06,806.49]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[575.717,459.221],[575.717,373.191],[549.099,462.291],[549.099,379.562]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[575.717,547.801],[575.717,461.771],[549.099,547.473],[549.099,464.743]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[575.717,555.287],[575.717,641.317],[549.099,554.672],[549.099,637.401]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[575.717,648.545],[575.717,734.575],[549.099,644.352],[549.099,727.081]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[575.717,741.958],[575.717,827.988],[549.099,734.181],[549.099,816.91]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,454.453],[589.206,363.298],[552.348,458.872],[552.348,372.467]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,548.31],[589.206,457.155],[552.348,547.838],[552.348,461.433]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,556.242],[589.206,647.398],[552.348,555.357],[552.348,641.762]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,655.057],[589.206,746.212],[552.348,649.022],[552.348,735.427]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,754.035],[589.206,845.19],[552.348,742.841],[552.348,829.246]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[612.324,376.504],[612.324,294.796],[553.971,389.506],[553.971,314.326]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,454.453],[589.206,363.297],[612.854,454.828],[612.854,364.076]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,548.31],[589.206,457.155],[612.854,548.27],[612.854,457.518]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,556.242],[589.206,647.398],[612.854,556.167],[612.854,646.919]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,655.057],[589.206,746.212],[612.854,654.545],[612.854,745.297]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[589.206,754.035],[612.854,753.085],[589.206,845.19],[612.854,843.837]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[681.712,361.042],[681.712,271.572],[612.398,376.487],[612.398,294.771]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.262,451.084],[645.262,356.308],[612.854,454.828],[612.854,364.076]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.262,548.67],[645.262,453.893],[612.854,548.27],[612.854,457.518]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.262,556.917],[645.262,651.693],[612.854,556.167],[612.854,646.919]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.262,659.657],[645.262,754.433],[612.854,654.545],[612.854,745.297]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.262,762.566],[645.262,857.342],[612.854,753.085],[612.854,843.837]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.851,451.132],[645.851,356.407],[697.425,451.991],[697.425,358.189]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.851,548.664],[645.851,453.94],[697.425,548.573],[697.425,454.771]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.851,556.908],[645.851,651.633],[697.425,556.736],[697.425,650.537]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.851,659.592],[645.851,754.317],[697.425,658.419],[697.425,752.22]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[645.851,762.446],[645.851,857.17],[697.425,760.27],[697.425,854.072]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[681.754,361.018],[681.754,271.536],[977.05,371.033],[977.05,286.578]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[742.064,440.032],[742.064,333.374],[701.181,444.748],[701.181,343.16]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[742.064,549.85],[742.064,443.193],[701.181,549.346],[701.181,447.759]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[742.064,559.132],[742.064,665.789],[701.181,558.187],[701.181,659.775]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[742.064,674.751],[742.064,781.408],[701.181,668.31],[701.181,769.898]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[742.064,790.561],[742.064,897.218],[701.181,778.616],[701.181,880.204]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,432.597],[771.495,317.947],[713.962,439.495],[713.962,332.261]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,550.644],[771.495,435.995],[713.962,549.907],[713.962,442.673]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,560.621],[771.495,675.271],[713.962,559.239],[713.962,666.474]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,684.904],[771.495,799.553],[713.962,675.484],[713.962,782.718]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,809.392],[771.495,924.042],[713.962,791.92],[713.962,899.155]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,432.597],[771.495,317.947],[800.191,433.189],[800.191,319.177]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,550.644],[771.495,435.995],[800.191,550.581],[800.191,436.568]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,560.621],[771.495,675.271],[800.191,560.503],[800.191,674.515]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,684.904],[771.495,799.553],[800.191,684.095],[800.191,798.107]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[771.495,809.392],[800.191,807.892],[771.495,924.042],[800.191,921.904]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[851.93,427.213],[851.93,306.776],[800.191,433.189],[800.191,319.177]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[851.93,551.219],[851.93,430.783],[800.191,550.581],[800.191,436.568]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[851.93,561.7],[851.93,682.137],[800.191,560.503],[800.191,674.515]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[851.93,692.256],[851.93,812.693],[800.191,684.095],[800.191,798.107]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[851.93,823.028],[851.93,943.465],[800.191,807.892],[800.191,921.904]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[941.325,303.193],[941.325,184.68],[821.257,329.948],[821.257,224.867]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[908.809,420.796],[908.809,293.462],[851.551,427.402],[851.551,307.168]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[908.809,551.905],[908.809,424.57],[851.551,551.199],[851.551,430.965]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[908.809,562.986],[908.809,690.32],[851.551,561.662],[851.551,681.896]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[908.809,701.019],[908.809,828.353],[851.551,691.999],[851.551,812.233]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[908.809,839.28],[908.809,966.614],[851.551,822.551],[851.551,942.784]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,410.043],[959.601,271.15],[876.302,420.031],[876.302,291.873]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,553.053],[959.601,414.16],[876.302,551.986],[876.302,423.829]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,565.14],[959.601,704.033],[876.302,563.139],[876.302,691.296]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,715.703],[959.601,854.597],[876.302,702.064],[876.302,830.222]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,866.516],[959.601,1005.41],[876.302,841.22],[876.302,969.377]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[941.427,303.152],[941.427,184.618],[1306.61,320.409],[1306.61,210.539]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,410.043],[959.601,271.15],[993.06,410.912],[993.06,272.952]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,553.053],[959.601,414.16],[993.06,552.96],[993.06,415.001]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,565.14],[959.601,704.033],[993.06,564.966],[993.06,702.926]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,715.703],[959.601,854.597],[993.06,714.517],[993.06,852.477]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[959.601,866.516],[993.06,864.316],[959.601,1005.41],[993.06,1002.28]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1069.72,402.057],[1069.72,254.578],[993.06,410.912],[993.06,272.952]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1069.72,553.906],[1069.72,406.428],[993.06,552.96],[993.06,415.001]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1069.72,566.74],[1069.72,714.219],[993.06,564.966],[993.06,702.926]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1069.72,726.61],[1069.72,874.088],[993.06,714.518],[993.06,852.477]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1069.72,886.745],[1069.72,1034.22],[993.06,864.316],[993.06,1002.28]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1171.67,251.866],[1171.67,107.584],[1000.09,290.099],[1000.09,165.013]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1156.88,392.18],[1156.88,234.085],[1069.79,402.227],[1069.79,254.931]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1156.88,554.961],[1156.88,396.866],[1069.79,553.888],[1069.79,406.592]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1156.88,568.719],[1156.88,726.814],[1069.79,566.706],[1069.79,714.002]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1156.88,740.098],[1156.88,898.193],[1069.79,726.378],[1069.79,873.673]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1156.88,911.76],[1156.88,1069.86],[1069.79,886.314],[1069.79,1033.61]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,375.232],[1249.94,198.919],[1118.45,390.998],[1118.45,231.632]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,556.771],[1249.94,380.458],[1118.45,555.087],[1118.45,395.721]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,572.115],[1249.94,748.428],[1118.45,568.956],[1118.45,728.322]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,763.242],[1249.94,939.555],[1118.45,741.712],[1118.45,901.078]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,954.686],[1249.94,1131],[1118.45,914.755],[1118.45,1074.12]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1405.01,199.872],[1405.01,29.4874],[1171.35,251.938],[1171.35,107.693]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,375.232],[1249.94,198.919],[1289.86,376.629],[1289.86,201.818]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,556.771],[1249.94,380.458],[1289.86,556.622],[1289.86,381.811]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,572.115],[1249.94,748.428],[1289.86,571.835],[1289.86,746.646]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,763.242],[1249.94,939.555],[1289.86,761.334],[1289.86,936.146]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1249.94,954.686],[1289.86,951.148],[1249.94,1131],[1289.86,1125.96]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,362.145],[1415.26,171.763],[1289.86,376.629],[1289.86,201.818]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,558.169],[1415.26,367.788],[1289.86,556.622],[1289.86,381.811]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,574.737],[1415.26,765.118],[1289.86,571.835],[1289.86,746.646]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,781.115],[1415.26,971.496],[1289.86,761.334],[1289.86,936.146]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,987.834],[1415.26,1178.22],[1289.86,951.148],[1289.86,1125.96]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1404.72,199.908],[1404.72,29.5413],[1866.17,234.454],[1866.17,81.4311]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,362.145],[1415.26,171.763],[1745.82,375.091],[1745.82,198.625]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,558.169],[1415.26,367.788],[1745.82,556.786],[1745.82,380.321]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,574.737],[1415.26,765.118],[1745.82,572.143],[1745.82,748.609]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,781.115],[1415.26,971.496],[1745.82,763.436],[1745.82,939.901]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1415.26,987.834],[1415.26,1178.22],[1745.82,955.045],[1745.82,1131.51]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1835.98,378.622],[1835.98,205.952],[2109.76,389.344],[2109.76,228.2]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1835.98,556.409],[1835.98,383.74],[2109.76,555.264],[2109.76,394.12]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1835.98,571.436],[1835.98,744.105],[2109.76,569.287],[2109.76,730.432]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1835.98,758.613],[1835.98,931.283],[2109.76,743.971],[2109.76,905.115]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:31,
                    verts:[[1835.98,946.101],[1835.98,1118.77],[2109.76,918.944],[2109.76,1080.09]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[443.715,467.59],[443.715,390.557],[416.143,469.972],[416.143,395.498]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[443.715,546.906],[443.715,469.874],[416.143,546.652],[416.143,472.179]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[443.715,553.61],[443.715,630.643],[416.143,553.133],[416.143,627.607]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[443.715,637.116],[443.715,714.149],[416.143,633.864],[416.143,708.337]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[443.715,720.759],[443.715,797.792],[416.143,714.728],[416.143,789.202]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.213,463.916],[461.213,382.932],[423.503,467.269],[423.503,389.89]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.213,547.299],[461.213,466.316],[423.503,546.941],[423.503,469.562]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.213,554.347],[461.213,635.33],[423.503,553.675],[423.503,631.054]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.213,642.134],[461.213,723.117],[423.503,637.555],[423.503,714.934]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.213,730.067],[461.213,811.05],[423.503,721.574],[423.503,798.953]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.214,463.916],[461.214,382.932],[482.924,464.28],[482.924,383.689]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.214,547.299],[461.214,466.316],[482.924,547.26],[482.924,466.669]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.214,554.347],[461.214,635.33],[482.924,554.273],[482.924,634.865]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.214,642.134],[461.214,723.117],[482.924,641.636],[482.924,722.227]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[461.214,730.067],[482.924,729.143],[461.214,811.05],[482.924,809.734]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[514.926,461.519],[514.926,377.961],[482.924,464.28],[482.924,383.689]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[514.926,547.555],[514.926,463.996],[482.924,547.26],[482.924,466.669]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[514.926,554.827],[514.926,638.386],[482.924,554.273],[482.924,634.865]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[514.926,645.406],[514.926,728.965],[482.924,641.636],[482.924,722.227]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[514.926,736.136],[514.926,819.695],[482.924,729.143],[482.924,809.734]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[577.898,375.142],[577.898,292.75],[503.609,387.789],[503.609,311.747]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[550.215,458.475],[550.215,371.643],[515.588,461.462],[515.588,377.842]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[550.215,547.88],[550.215,461.049],[515.588,547.561],[515.588,463.941]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[550.215,555.437],[550.215,642.268],[515.588,554.838],[515.588,638.458]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[550.215,649.564],[550.215,736.396],[515.588,645.484],[515.588,729.105]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[550.215,743.847],[550.215,830.679],[515.588,736.281],[515.588,819.901]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,453.759],[575.442,361.858],[527.167,458.051],[527.167,370.764]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,548.384],[575.442,456.483],[527.167,547.925],[527.167,460.638]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,556.381],[575.442,648.282],[527.167,555.521],[527.167,642.808]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,656.004],[575.442,747.905],[527.167,650.142],[527.167,737.429]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,755.792],[575.442,847.693],[527.167,744.92],[527.167,832.207]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,453.759],[575.442,361.858],[598.622,454.212],[598.622,362.799]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,548.384],[575.442,456.483],[598.622,548.335],[598.622,456.922]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,556.381],[575.442,648.282],[598.622,556.291],[598.622,647.704]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,656.004],[575.442,747.905],[598.622,655.385],[598.622,746.798]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[575.442,755.792],[598.622,754.643],[575.442,847.693],[598.622,846.057]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[665.646,360.203],[665.646,270.312],[577.992,375.126],[577.992,292.726]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.491,450.597],[640.491,355.296],[598.622,454.212],[598.622,362.799]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.491,548.722],[640.491,453.421],[598.622,548.335],[598.622,456.922]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.491,557.015],[640.491,652.315],[598.622,556.291],[598.622,647.704]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.491,660.323],[640.491,755.623],[598.622,655.385],[598.622,746.798]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.491,763.801],[640.491,859.102],[598.622,754.643],[598.622,846.057]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.974,450.646],[640.974,355.399],[691.119,451.678],[691.119,357.541]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.974,548.716],[640.974,453.469],[691.119,548.606],[691.119,454.468]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.974,557.005],[640.974,652.252],[691.119,556.798],[691.119,650.936]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.974,660.255],[640.974,755.502],[691.119,658.846],[691.119,752.983]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[640.974,763.676],[640.974,858.923],[691.119,761.062],[691.119,855.2]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[665.715,360.18],[665.715,270.277],[950.305,372.087],[950.305,288.162]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[764.382,439.998],[764.382,333.305],[712.101,444.508],[712.101,342.664]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[764.382,549.854],[764.382,443.16],[712.101,549.372],[712.101,447.527]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[764.382,559.139],[764.382,665.832],[712.101,558.235],[712.101,660.08]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[764.382,674.797],[764.382,781.49],[712.101,668.637],[712.101,770.482]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[764.382,790.646],[764.382,897.339],[712.101,779.222],[712.101,881.067]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,432.782],[811.37,318.331],[737.41,439.358],[737.41,331.976]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,550.625],[811.37,436.174],[737.41,549.922],[737.41,442.54]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,560.584],[811.37,675.035],[737.41,559.267],[737.41,666.648]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,684.651],[811.37,799.102],[737.41,675.671],[737.41,783.053]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,808.924],[811.37,923.375],[737.41,792.268],[737.41,899.649]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,432.782],[811.37,318.331],[838.644,433.484],[838.644,319.788]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,550.625],[811.37,436.174],[838.644,550.549],[838.644,436.854]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,560.584],[811.37,675.035],[838.644,560.444],[838.644,674.139]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,684.651],[811.37,799.102],[838.644,683.692],[838.644,797.388]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[811.37,808.924],[838.644,807.145],[811.37,923.375],[838.644,920.841]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[904.09,427.832],[904.09,308.061],[838.644,433.484],[838.644,319.788]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[904.09,551.153],[904.09,431.382],[838.644,550.549],[838.644,436.854]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[904.09,561.576],[904.09,681.347],[838.644,560.444],[838.644,674.139]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[904.09,691.411],[904.09,811.182],[838.644,683.692],[838.644,797.388]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[904.09,821.46],[904.09,941.232],[838.644,807.145],[838.644,920.841]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[988.376,305.261],[988.376,187.786],[840.198,330.487],[840.198,225.677]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[975.27,421.804],[975.27,295.553],[903.275,428.015],[903.275,308.441]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[975.27,551.797],[975.27,425.546],[903.275,551.134],[903.275,431.559]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[975.27,562.784],[975.27,689.035],[903.275,561.539],[903.275,681.114]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[975.27,699.643],[975.27,825.894],[903.275,691.16],[903.275,810.735]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[975.27,836.728],[975.27,962.979],[903.275,820.996],[903.275,940.57]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,411.563],[1050.01,274.303],[944.927,420.906],[944.927,293.691]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,552.891],[1050.01,415.631],[944.927,551.893],[944.927,424.677]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,564.836],[1050.01,702.095],[944.927,562.964],[944.927,690.18]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,713.628],[1050.01,850.888],[944.927,700.868],[944.927,828.084]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,862.667],[1050.01,999.927],[944.927,839.002],[944.927,966.218]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[988.521,305.221],[988.521,187.726],[1325.53,325.152],[1325.53,217.663]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,411.563],[1050.01,274.303],[1080.79,412.572],[1080.79,276.397]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,552.891],[1050.01,415.631],[1080.79,552.783],[1080.79,416.608]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,564.836],[1050.01,702.095],[1080.79,564.634],[1080.79,700.809]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,713.628],[1050.01,850.888],[1080.79,712.25],[1080.79,848.425]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1050.01,862.667],[1080.79,860.112],[1050.01,999.927],[1080.79,996.287]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1267.57,257.731],[1267.57,116.393],[1060.23,293.029],[1060.23,169.412]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1175.68,404.377],[1175.68,259.394],[1080.79,412.572],[1080.79,276.397]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1175.68,553.658],[1175.68,408.675],[1080.79,552.783],[1080.79,416.608]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1175.68,566.275],[1175.68,711.259],[1080.79,564.634],[1080.79,700.809]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1175.68,723.441],[1175.68,868.425],[1080.79,712.25],[1080.79,848.425]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1175.68,880.867],[1175.68,1025.85],[1080.79,860.112],[1080.79,996.287]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1282.2,395.324],[1282.2,240.609],[1175.35,404.542],[1175.35,259.735]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1282.2,554.625],[1282.2,399.91],[1175.35,553.641],[1175.35,408.834]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1282.2,568.089],[1282.2,722.805],[1175.35,566.242],[1175.35,711.049]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1282.2,735.804],[1282.2,890.52],[1175.35,723.216],[1175.35,868.023]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1282.2,903.797],[1282.2,1058.51],[1175.35,880.45],[1175.35,1025.26]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,379.636],[1409.08,208.057],[1247.83,393.974],[1247.83,237.807]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,556.301],[1409.08,384.722],[1247.83,554.77],[1247.83,398.603]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,571.232],[1409.08,742.811],[1247.83,568.36],[1247.83,724.527]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,757.228],[1409.08,928.807],[1247.83,737.648],[1247.83,893.815]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,943.531],[1409.08,1115.11],[1247.83,907.217],[1247.83,1063.38]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1543.77,210.709],[1543.77,45.7643],[1267.18,257.797],[1267.18,116.492]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,379.636],[1409.08,208.057],[1443.94,381.21],[1443.94,211.322]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,556.301],[1409.08,384.722],[1443.94,556.133],[1443.94,386.245]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,571.232],[1409.08,742.811],[1443.94,570.917],[1443.94,740.805]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,757.228],[1409.08,928.807],[1443.94,755.079],[1443.94,924.967]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1409.08,943.531],[1443.94,939.546],[1409.08,1115.11],[1443.94,1109.43]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,368.248],[1594.03,184.427],[1443.94,381.21],[1443.94,211.322]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,557.517],[1594.03,373.696],[1443.94,556.133],[1443.94,386.245]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,573.514],[1594.03,757.335],[1443.94,570.917],[1443.94,740.805]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,772.78],[1594.03,956.601],[1443.94,755.079],[1443.94,924.967]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,972.376],[1594.03,1156.2],[1443.94,939.546],[1443.94,1109.43]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1543.47,210.74],[1543.47,45.8102],[1936.67,248.706],[1936.67,102.837]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,368.248],[1594.03,184.427],[1872.69,382.465],[1872.69,213.927]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,557.517],[1594.03,373.696],[1872.69,555.999],[1872.69,387.461]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,573.514],[1594.03,757.335],[1872.69,570.666],[1872.69,739.204]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,772.78],[1594.03,956.601],[1872.69,753.364],[1872.69,921.902]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:32,
                    verts:[[1594.03,972.376],[1594.03,1156.2],[1872.69,936.366],[1872.69,1104.9]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[396.497,466.533],[396.497,388.363],[362.193,468.851],[362.193,393.172]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[396.497,547.019],[396.497,468.85],[362.193,546.772],[362.193,471.094]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[396.497,553.822],[396.497,631.992],[362.193,553.358],[362.193,629.036]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[396.497,638.56],[396.497,716.73],[362.193,635.395],[362.193,711.073]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[396.497,723.438],[396.497,801.608],[362.193,717.568],[362.193,793.246]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,462.893],[423.459,380.811],[376.388,466.151],[376.388,387.572]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,547.408],[423.459,465.326],[376.388,547.06],[376.388,468.48]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,554.551],[423.459,636.633],[376.388,553.899],[376.388,632.478]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,643.53],[423.459,725.612],[376.388,639.081],[376.388,717.661]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,732.656],[423.459,814.738],[376.388,724.404],[376.388,802.984]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,462.893],[423.459,380.811],[444.931,463.324],[444.931,381.705]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,547.408],[423.459,465.326],[444.931,547.362],[444.931,465.743]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,554.551],[423.459,636.633],[444.931,554.465],[444.931,636.084]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,643.53],[423.459,725.612],[444.931,642.942],[444.931,724.561]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[423.459,732.656],[423.459,814.738],[444.931,731.566],[444.931,813.185]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[484.463,460.655],[484.463,376.167],[444.931,463.324],[444.931,381.705]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[484.463,547.647],[484.463,463.159],[444.931,547.362],[444.931,465.743]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[484.463,555],[484.463,639.488],[444.931,554.465],[444.931,636.084]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[484.463,646.587],[484.463,731.075],[444.931,642.942],[444.931,724.561]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[484.463,738.325],[484.463,822.813],[444.931,731.566],[444.931,813.185]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[546.29,373.701],[546.29,290.586],[455.982,385.895],[455.982,308.902]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[527.909,457.722],[527.909,370.081],[485.279,460.6],[485.279,376.053]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[527.909,547.961],[527.909,460.32],[485.279,547.653],[485.279,463.106]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[527.909,555.587],[527.909,643.228],[485.279,555.011],[485.279,639.558]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[527.909,650.592],[527.909,738.233],[485.279,646.662],[485.279,731.209]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[527.909,745.754],[527.909,833.395],[485.279,738.465],[485.279,823.012]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,453.101],[564.94,360.492],[505.348,457.225],[505.348,369.051]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,548.454],[564.94,455.846],[505.348,548.014],[505.348,459.839]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,556.513],[564.94,649.122],[505.348,555.687],[505.348,643.862]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,656.903],[564.94,749.512],[505.348,651.27],[505.348,739.445]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,757.459],[564.94,850.068],[505.348,747.012],[505.348,835.187]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[652.108,359.412],[652.108,269.124],[546.404,373.685],[546.404,290.563]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,453.101],[564.94,360.492],[587.458,453.63],[587.458,361.59]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,548.454],[564.94,455.846],[587.458,548.398],[587.458,456.358]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,556.513],[564.94,649.122],[587.458,556.407],[587.458,648.447]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,656.903],[564.94,749.512],[587.458,656.18],[587.458,748.22]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[564.94,757.459],[564.94,850.068],[587.458,756.119],[587.458,848.159]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.562,450.177],[638.562,354.425],[587.458,453.63],[587.458,361.59]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.562,548.767],[638.562,453.015],[587.458,548.398],[587.458,456.358]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.562,557.099],[638.562,652.851],[587.458,556.407],[587.458,648.447]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.562,660.896],[638.562,756.648],[587.458,656.181],[587.458,748.22]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.562,764.865],[638.562,860.616],[587.458,756.119],[587.458,848.159]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.935,450.228],[638.935,354.531],[687.202,451.424],[687.202,357.012]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.935,548.761],[638.935,453.064],[687.202,548.633],[687.202,454.222]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.935,557.089],[638.935,652.786],[687.202,556.849],[687.202,651.261]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.935,660.827],[638.935,756.524],[687.202,659.193],[687.202,753.605]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[638.935,764.736],[638.935,860.433],[687.202,761.707],[687.202,856.118]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[652.203,359.389],[652.203,269.09],[924.311,373.063],[924.311,289.629]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[788.294,440.143],[788.294,333.606],[725.245,444.4],[725.245,342.438]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[788.294,549.838],[788.294,443.301],[725.245,549.384],[725.245,447.422]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[788.294,559.109],[788.294,665.647],[725.245,558.257],[725.245,660.218]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[788.294,674.598],[788.294,781.136],[725.245,668.786],[725.245,770.747]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[788.294,790.278],[788.294,896.816],[725.245,779.497],[725.245,881.459]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,433.23],[852.03,319.261],[762.764,439.408],[762.764,332.081]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,550.577],[852.03,436.608],[762.764,549.917],[762.764,442.589]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,560.495],[852.03,674.464],[762.764,559.257],[762.764,666.584]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,684.039],[852.03,798.009],[762.764,675.602],[762.764,782.929]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,807.789],[852.03,921.758],[762.764,792.14],[762.764,899.467]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,433.23],[852.03,319.261],[877.537,434.03],[877.537,320.921]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,550.577],[852.03,436.608],[877.537,550.491],[877.537,437.382]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,560.495],[852.03,674.464],[877.537,560.334],[877.537,673.443]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,684.039],[852.03,798.009],[877.537,682.947],[877.537,796.056]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[852.03,807.789],[852.03,921.758],[877.537,805.762],[877.537,918.871]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1033.55,307.906],[1033.55,191.76],[859.908,331.353],[859.908,226.977]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[955.434,428.766],[955.434,310],[877.537,434.03],[877.537,320.921]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[955.434,551.053],[955.434,432.287],[877.537,550.491],[877.537,437.382]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[955.434,561.389],[955.434,680.156],[877.537,560.334],[877.537,673.443]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[955.434,690.135],[955.434,808.901],[877.537,682.947],[877.537,796.056]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[955.434,819.093],[955.434,937.86],[877.537,805.762],[877.537,918.871]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1039.31,423.197],[1039.31,298.442],[954.208,428.942],[954.208,310.364]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1039.31,551.648],[1039.31,426.894],[954.208,551.035],[954.208,432.457]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1039.31,562.505],[1039.31,687.259],[954.208,561.354],[954.208,679.932]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1039.31,697.741],[1039.31,822.495],[954.208,689.895],[954.208,808.473]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1039.31,833.201],[1039.31,957.955],[954.208,818.648],[954.208,937.226]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,413.602],[1135.6,278.535],[1011.56,422.188],[1011.56,296.349]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,552.673],[1135.6,417.606],[1011.56,551.756],[1011.56,425.917]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,564.427],[1135.6,699.495],[1011.56,562.707],[1011.56,688.546]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,710.843],[1135.6,845.911],[1011.56,699.119],[1011.56,824.957]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,857.502],[1135.6,992.569],[1011.56,835.757],[1011.56,961.595]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1033.73,307.869],[1033.73,191.704],[1339.8,330.016],[1339.8,224.97]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1354.02,264.633],[1354.02,126.762],[1116.85,296.658],[1116.85,174.864]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,413.602],[1135.6,278.535],[1163.25,414.725],[1163.25,280.864]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,552.673],[1135.6,417.606],[1163.25,552.553],[1163.25,418.692]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,564.427],[1135.6,699.495],[1163.25,564.202],[1163.25,698.063]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,710.843],[1135.6,845.911],[1163.25,709.31],[1163.25,843.171]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1135.6,857.502],[1135.6,992.569],[1163.25,854.659],[1163.25,988.52]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1273.37,407.284],[1273.37,265.426],[1163.25,414.725],[1163.25,280.864]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1273.37,553.348],[1273.37,411.489],[1163.25,552.553],[1163.25,418.692]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1273.37,565.693],[1273.37,707.552],[1163.25,564.202],[1163.25,698.063]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1273.37,719.471],[1273.37,861.33],[1163.25,709.31],[1163.25,843.171]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1273.37,873.504],[1273.37,1015.36],[1163.25,854.659],[1163.25,988.52]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1395.45,399.153],[1395.45,248.554],[1272.69,407.441],[1272.69,265.751]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1395.45,554.216],[1395.45,403.617],[1272.69,553.331],[1272.69,411.641]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1395.45,567.322],[1395.45,717.921],[1272.69,565.662],[1272.69,707.352]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1395.45,730.575],[1395.45,881.174],[1272.69,719.257],[1272.69,860.947]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1395.45,894.098],[1395.45,1044.7],[1272.69,873.107],[1272.69,1014.8]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1662.74,222.946],[1662.74,64.1455],[1353.58,264.693],[1353.58,126.85]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,384.928],[1549.87,219.038],[1365.63,397.68],[1365.63,245.498]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,555.736],[1549.87,389.845],[1365.63,554.374],[1365.63,402.191]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,570.172],[1549.87,736.062],[1365.63,567.617],[1365.63,719.8]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,750.001],[1549.87,915.891],[1365.63,732.586],[1365.63,884.769]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,930.127],[1549.87,1096.02],[1365.63,897.829],[1365.63,1050.01]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,384.928],[1549.87,219.038],[1579.23,386.618],[1579.23,222.544]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,555.736],[1549.87,389.845],[1579.23,555.555],[1579.23,391.481]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,570.172],[1549.87,736.062],[1579.23,569.834],[1579.23,733.908]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,750.001],[1549.87,915.891],[1579.23,747.693],[1579.23,911.768]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1549.87,930.127],[1549.87,1096.02],[1579.23,925.848],[1579.23,1089.92]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,375.288],[1746.92,199.034],[1579.23,386.618],[1579.23,222.544]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,556.765],[1746.92,380.512],[1579.23,555.555],[1579.23,391.481]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,572.104],[1746.92,748.358],[1579.23,569.834],[1579.23,733.908]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,763.167],[1746.92,939.421],[1579.23,747.693],[1579.23,911.768]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,954.546],[1746.92,1130.8],[1579.23,925.848],[1579.23,1089.92]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1662.43,222.972],[1662.43,64.1835],[1987.14,262.949],[1987.14,124.231]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,375.288],[1746.92,199.034],[1972.77,390.193],[1972.77,229.961]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,556.765],[1746.92,380.512],[1972.77,555.173],[1972.77,394.942]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,572.104],[1746.92,748.358],[1972.77,569.117],[1972.77,729.349]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,763.167],[1746.92,939.421],[1972.77,742.812],[1972.77,903.044]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:33,
                    verts:[[1746.92,954.546],[1746.92,1130.8],[1972.77,916.794],[1972.77,1077.03]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[352.517,465.391],[352.517,385.994],[311.324,467.628],[311.324,390.634]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[352.517,547.141],[352.517,467.744],[311.324,546.903],[311.324,469.91]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[352.517,554.051],[352.517,633.448],[311.324,553.603],[311.324,630.596]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[352.517,640.119],[352.517,719.516],[311.324,637.065],[311.324,714.058]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[352.517,726.33],[352.517,805.727],[311.324,720.665],[311.324,797.658]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,461.814],[389.184,378.572],[332.609,464.95],[332.609,385.079]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,547.524],[389.184,464.282],[332.609,547.189],[332.609,467.317]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,554.768],[389.184,638.009],[332.609,554.139],[332.609,634.011]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,645.004],[389.184,728.246],[332.609,640.721],[332.609,720.593]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,735.389],[389.184,818.631],[332.609,727.447],[332.609,807.318]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,461.814],[389.184,378.572],[410.293,462.31],[410.293,379.601]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,547.524],[389.184,464.282],[410.293,547.47],[410.293,464.762]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,554.768],[389.184,638.009],[410.293,554.668],[410.293,637.377]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,645.004],[389.184,728.246],[410.293,644.326],[410.293,727.035]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[389.184,735.389],[389.184,818.631],[410.293,734.133],[410.293,816.842]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[457.372,459.756],[457.372,374.302],[410.293,462.31],[410.293,379.601]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[457.372,547.743],[457.372,462.289],[410.293,547.47],[410.293,464.762]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[457.372,555.18],[457.372,640.634],[410.293,554.668],[410.293,637.377]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[457.372,647.814],[457.372,733.269],[410.293,644.326],[410.293,727.035]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[457.372,740.602],[457.372,826.057],[410.293,734.133],[410.293,816.842]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[517.662,372.176],[517.662,288.295],[411.318,383.822],[411.318,305.788]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[508.907,456.96],[508.907,368.501],[458.342,459.703],[458.342,374.192]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[508.907,548.042],[508.907,459.582],[458.342,547.749],[458.342,462.238]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[508.907,555.74],[508.907,644.2],[458.342,555.19],[458.342,640.701]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[508.907,651.632],[508.907,740.092],[458.342,647.886],[458.342,733.397]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[508.907,747.683],[508.907,836.143],[458.342,740.736],[458.342,826.247]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,452.474],[557.701,359.192],[487.001,456.393],[487.001,367.323]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,548.521],[557.701,455.239],[487.001,548.103],[487.001,459.033]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,556.639],[557.701,649.921],[487.001,555.854],[487.001,644.924]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,657.759],[557.701,751.041],[487.001,652.407],[487.001,741.477]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,759.046],[557.701,852.328],[487.001,749.121],[487.001,838.191]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[641.126,358.655],[641.126,267.986],[517.796,372.161],[517.796,288.273]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,452.474],[557.701,359.192],[579.369,453.075],[579.369,360.44]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,548.521],[557.701,455.239],[579.369,548.457],[579.369,455.821]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,556.639],[557.701,649.921],[579.369,556.518],[579.369,649.154]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,657.759],[557.701,751.041],[579.369,656.938],[579.369,749.574]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[557.701,759.046],[557.701,852.328],[579.369,757.523],[579.369,850.159]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.381,449.817],[639.381,353.679],[579.369,453.075],[579.369,360.44]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.381,548.805],[639.381,452.667],[579.369,548.457],[579.369,455.821]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.381,557.171],[639.381,653.309],[579.369,556.518],[579.369,649.154]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.381,661.387],[639.381,757.525],[579.369,656.938],[579.369,749.574]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.381,765.775],[639.381,861.913],[579.369,757.523],[579.369,850.159]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.638,449.869],[639.638,353.786],[685.607,451.218],[685.607,356.586]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.638,548.799],[639.638,452.717],[685.607,548.655],[685.607,454.023]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.638,557.161],[639.638,653.243],[685.607,556.891],[685.607,651.523]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.638,661.316],[639.638,757.399],[685.607,659.474],[685.607,754.107]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[639.638,765.645],[639.638,861.727],[685.607,762.228],[685.607,856.86]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[641.248,358.633],[641.248,267.953],[899.245,373.94],[899.245,290.946]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[813.356,440.444],[813.356,334.229],[740.324,444.406],[740.324,342.45]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[813.356,549.806],[813.356,443.592],[740.324,549.383],[740.324,447.428]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[813.356,559.049],[813.356,665.263],[740.324,558.255],[740.324,660.211]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[813.356,674.188],[813.356,780.402],[740.324,668.777],[740.324,770.732]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[813.356,789.517],[813.356,895.731],[740.324,779.482],[740.324,881.437]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,433.905],[892.74,320.661],[789.541,439.624],[789.541,332.529]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,550.505],[892.74,437.261],[789.541,549.894],[789.541,442.799]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,560.359],[892.74,673.603],[789.541,559.213],[789.541,666.308]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,683.118],[892.74,796.361],[789.541,675.307],[789.541,782.402]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,806.079],[892.74,919.323],[789.541,791.592],[789.541,898.687]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1076.2,311.009],[1076.2,196.42],[880.053,332.489],[880.053,228.684]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,433.905],[892.74,320.661],[916.193,434.789],[916.193,322.497]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,550.505],[892.74,437.261],[916.193,550.41],[916.193,438.117]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,560.359],[892.74,673.603],[916.193,560.182],[916.193,672.475]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,683.118],[892.74,796.361],[916.193,681.91],[916.193,794.202]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[892.74,806.079],[892.74,919.323],[916.193,803.839],[916.193,916.131]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1005.09,429.963],[1005.09,312.483],[916.193,434.789],[916.193,322.497]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1005.09,550.926],[1005.09,433.445],[916.193,550.41],[916.193,438.117]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1005.09,561.149],[1005.09,678.629],[916.193,560.182],[916.193,672.475]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1005.09,688.5],[1005.09,805.981],[916.193,681.91],[916.193,794.202]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1005.09,816.063],[1005.09,933.543],[916.193,803.839],[916.193,916.131]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1099.87,424.9],[1099.87,301.977],[1003.48,430.129],[1003.48,312.827]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1099.87,551.466],[1099.87,428.544],[1003.48,550.908],[1003.48,433.606]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1099.87,562.164],[1099.87,685.086],[1003.48,561.116],[1003.48,678.418]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1099.87,695.414],[1099.87,818.337],[1003.48,688.273],[1003.48,805.575]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1099.87,828.886],[1099.87,951.809],[1003.48,815.642],[1003.48,932.944]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,416.05],[1214.88,283.613],[1075.02,423.801],[1075.02,299.698]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,552.412],[1214.88,419.975],[1075.02,551.584],[1075.02,427.48]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,563.937],[1214.88,696.373],[1075.02,562.384],[1075.02,686.487]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,707.501],[1214.88,839.937],[1075.02,696.915],[1075.02,821.019]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,851.303],[1214.88,983.739],[1075.02,831.669],[1075.02,955.773]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1076.42,310.974],[1076.42,196.367],[1349.77,334.891],[1349.77,232.291]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1430.1,272.252],[1430.1,138.206],[1169.19,300.825],[1169.19,181.123]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,416.05],[1214.88,283.613],[1239.11,417.258],[1239.11,286.12]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,552.412],[1214.88,419.975],[1239.11,552.283],[1239.11,421.145]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,563.937],[1214.88,696.373],[1239.11,563.695],[1239.11,694.832]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,707.501],[1214.88,839.937],[1239.11,705.851],[1239.11,836.989]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1214.88,851.303],[1214.88,983.739],[1239.11,848.242],[1239.11,979.38]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1361.29,410.625],[1361.29,272.356],[1239.11,417.258],[1239.11,286.12]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1361.29,552.991],[1361.29,414.723],[1239.11,552.283],[1239.11,421.145]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1361.29,565.024],[1361.29,703.292],[1239.11,563.695],[1239.11,694.832]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1361.29,714.909],[1361.29,853.178],[1239.11,705.851],[1239.11,836.989]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1361.29,865.043],[1361.29,1003.31],[1239.11,848.242],[1239.11,979.38]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1495.06,403.461],[1495.06,257.491],[1360.3,410.772],[1360.3,272.661]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1495.06,553.756],[1495.06,407.787],[1360.3,552.975],[1360.3,414.865]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1495.06,566.459],[1495.06,712.428],[1360.3,564.994],[1360.3,703.105]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1495.06,724.693],[1495.06,870.662],[1360.3,714.709],[1360.3,852.819]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1495.06,883.189],[1495.06,1029.16],[1360.3,864.671],[1360.3,1002.78]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1761.44,235.967],[1761.44,83.7027],[1429.62,272.305],[1429.62,138.284]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,390.797],[1670.51,231.214],[1470.03,401.908],[1470.03,254.271]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,555.109],[1670.51,395.527],[1470.03,553.922],[1470.03,406.284]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,568.996],[1670.51,728.579],[1470.03,566.77],[1470.03,714.408]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,741.987],[1670.51,901.569],[1470.03,726.813],[1470.03,874.45]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,915.264],[1670.51,1074.85],[1470.03,887.12],[1470.03,1034.76]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,390.797],[1670.51,231.214],[1694.27,392.547],[1694.27,234.847]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,555.109],[1670.51,395.527],[1694.27,554.922],[1694.27,397.222]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,568.996],[1670.51,728.579],[1694.27,568.646],[1694.27,726.346]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,741.987],[1670.51,901.569],[1694.27,739.596],[1694.27,897.297]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1670.51,915.264],[1670.51,1074.85],[1694.27,910.83],[1694.27,1068.53]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,382.848],[1872.93,214.721],[1694.27,392.547],[1694.27,234.847]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,555.958],[1872.93,387.831],[1694.27,554.922],[1694.27,397.222]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,570.589],[1872.93,738.716],[1694.27,568.646],[1694.27,726.346]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,752.842],[1872.93,920.969],[1694.27,739.596],[1694.27,897.297]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,935.397],[1872.93,1103.52],[1694.27,910.83],[1694.27,1068.53]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1761.12,235.987],[1761.12,83.7332],[2020.05,276.793],[2020.05,145.025]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,382.848],[1872.93,214.721],[2047.97,397.952],[2047.97,246.061]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,555.958],[1872.93,387.831],[2047.97,554.345],[2047.97,402.454]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,570.589],[1872.93,738.716],[2047.97,567.563],[2047.97,719.453]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,752.842],[1872.93,920.969],[2047.97,732.215],[2047.97,884.106]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:34,
                    verts:[[1872.93,935.397],[1872.93,1103.52],[2047.97,897.141],[2047.97,1049.03]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[311.954,464.163],[311.954,383.447],[263.732,466.3],[263.732,387.879]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[311.954,547.273],[311.954,466.556],[263.732,547.044],[263.732,468.624]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[311.954,554.297],[311.954,635.014],[263.732,553.869],[263.732,632.289]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[311.954,641.795],[311.954,722.512],[263.732,638.878],[263.732,717.299]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[311.954,729.439],[311.954,810.156],[263.732,724.029],[263.732,802.449]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,460.676],[358.536,376.211],[292.352,463.662],[292.352,382.407]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,547.645],[358.536,463.18],[292.352,547.326],[292.352,466.071]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,554.995],[358.536,639.461],[292.352,554.397],[292.352,635.653]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,646.558],[358.536,731.023],[292.352,642.48],[292.352,723.735]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,738.272],[358.536,822.737],[292.352,730.709],[292.352,811.964]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,460.676],[358.536,376.211],[379.15,461.237],[379.15,377.374]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,547.645],[358.536,463.18],[379.15,547.585],[379.15,463.722]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,554.995],[358.536,639.461],[379.15,554.883],[379.15,638.746]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,646.558],[358.536,731.023],[379.15,645.792],[379.15,729.655]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[358.536,738.272],[358.536,822.737],[379.15,736.852],[379.15,820.715]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[492.108,370.558],[492.108,285.866],[369.777,381.563],[369.777,302.396]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[433.749,458.819],[433.749,372.358],[379.15,461.237],[379.15,377.374]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[433.749,547.843],[433.749,461.382],[379.15,547.585],[379.15,463.722]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[433.749,555.367],[433.749,641.829],[379.15,554.883],[379.15,638.746]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[433.749,649.093],[433.749,735.555],[379.15,645.792],[379.15,729.655]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[433.749,742.975],[433.749,829.436],[379.15,736.852],[379.15,820.715]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[493.248,456.185],[493.248,366.893],[434.872,458.77],[434.872,372.255]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[493.248,548.125],[493.248,458.832],[434.872,547.849],[434.872,461.334]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[493.248,555.895],[493.248,645.188],[434.872,555.378],[434.872,641.892]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[493.248,652.691],[493.248,741.983],[434.872,649.161],[434.872,735.676]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[493.248,749.646],[493.248,838.939],[434.872,743.1],[434.872,829.615]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,451.873],[553.661,357.944],[472.162,455.55],[472.162,365.574]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,548.585],[553.661,454.657],[472.162,548.193],[472.162,458.217]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,556.759],[553.661,650.688],[472.162,556.023],[472.162,645.999]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,658.58],[553.661,752.509],[472.162,653.559],[472.162,743.535]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,760.569],[553.661,854.498],[472.162,751.256],[472.162,841.232]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[632.674,357.913],[632.674,266.872],[492.261,370.545],[492.261,285.845]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,451.873],[553.661,357.944],[574.297,452.542],[574.297,359.332]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,548.585],[553.661,454.657],[574.297,548.514],[574.297,455.304]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,556.759],[553.661,650.688],[574.297,556.625],[574.297,649.835]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,658.58],[553.661,752.509],[574.297,657.666],[574.297,750.876]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[553.661,760.569],[553.661,854.498],[574.297,758.875],[574.297,852.084]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.8,449.507],[642.8,353.036],[574.297,452.542],[574.297,359.332]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.8,548.838],[642.8,452.366],[574.297,548.514],[574.297,455.304]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.8,557.233],[642.8,653.705],[574.297,556.625],[574.297,649.835]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.8,661.811],[642.8,758.282],[574.297,657.666],[574.297,750.876]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.8,766.561],[642.8,863.033],[574.297,758.875],[574.297,852.084]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[632.821,357.892],[632.821,266.84],[875.234,374.697],[875.234,292.083]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.939,449.559],[642.939,353.144],[686.222,451.049],[686.222,356.235]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.939,548.832],[642.939,452.417],[686.222,548.673],[686.222,453.859]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.939,557.223],[642.939,653.638],[686.222,556.924],[686.222,651.739]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.939,661.74],[642.939,758.155],[686.222,659.705],[686.222,754.519]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[642.939,766.429],[642.939,862.845],[686.222,762.656],[686.222,857.47]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[839.147,440.872],[839.147,335.118],[757.034,444.507],[757.034,342.661]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[839.147,549.76],[839.147,444.006],[757.034,549.372],[757.034,447.526]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[839.147,558.963],[839.147,664.717],[757.034,558.235],[757.034,660.081]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[839.147,673.603],[839.147,779.357],[757.034,668.639],[757.034,770.485]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[839.147,788.432],[839.147,894.186],[757.034,779.225],[757.034,881.071]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,434.764],[932.863,322.445],[817.278,439.979],[817.278,333.266]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,550.413],[932.863,438.093],[817.278,549.856],[817.278,443.142]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,560.187],[932.863,672.507],[817.278,559.142],[817.278,665.856]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,681.944],[932.863,794.263],[817.278,674.822],[817.278,781.536]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,803.902],[932.863,916.221],[817.278,790.694],[817.278,897.407]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1115.88,314.443],[1115.88,201.578],[900.335,333.834],[900.335,230.703]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,434.764],[932.863,322.445],[954.036,435.719],[954.036,324.427]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,550.413],[932.863,438.093],[954.036,550.311],[954.036,439.018]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,560.187],[932.863,672.507],[954.036,559.996],[954.036,671.288]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,681.944],[932.863,794.263],[954.036,680.639],[954.036,791.932]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[932.863,803.902],[932.863,916.221],[954.036,801.483],[954.036,912.775]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1052.36,431.364],[1052.36,315.389],[954.036,435.719],[954.036,324.427]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1052.36,550.776],[1052.36,434.801],[954.036,550.311],[954.036,439.018]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1052.36,560.869],[1052.36,676.843],[954.036,559.996],[954.036,671.288]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1052.36,686.588],[1052.36,802.563],[954.036,680.639],[954.036,791.932]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1052.36,812.516],[1052.36,928.49],[954.036,801.483],[954.036,912.775]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1156.17,823.98],[1156.17,944.821],[1050.42,812.122],[1050.42,927.931]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1156.17,426.837],[1156.17,305.996],[1050.42,431.519],[1050.42,315.711]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1156.17,551.259],[1156.17,430.419],[1050.42,550.759],[1050.42,434.951]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1156.17,561.775],[1156.17,682.616],[1050.42,560.837],[1050.42,676.646]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1156.17,692.77],[1156.17,813.61],[1050.42,686.376],[1050.42,802.184]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1116.13,314.411],[1116.13,201.53],[1355.81,339.679],[1355.81,239.484]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,418.791],[1286.9,289.301],[1134.44,425.67],[1134.44,303.574]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,552.119],[1286.9,422.629],[1134.44,551.384],[1134.44,429.289]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,563.388],[1286.9,692.877],[1134.44,562.009],[1134.44,684.105]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,703.757],[1286.9,833.247],[1134.44,694.364],[1134.44,816.459]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,844.359],[1286.9,973.849],[1134.44,826.937],[1134.44,949.032]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1495.54,280.288],[1495.54,150.275],[1216.78,305.366],[1216.78,187.944]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,418.791],[1286.9,289.301],[1307.55,420.059],[1307.55,291.932]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,552.119],[1286.9,422.629],[1307.55,551.983],[1307.55,423.857]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,563.388],[1286.9,692.877],[1307.55,563.133],[1307.55,691.26]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,703.757],[1286.9,833.247],[1307.55,702.026],[1307.55,830.153]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1286.9,844.359],[1286.9,973.849],[1307.55,841.148],[1307.55,969.275]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1438.71,414.249],[1438.71,279.876],[1307.55,420.059],[1307.55,291.932]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1438.71,552.604],[1438.71,418.231],[1307.55,551.983],[1307.55,423.857]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1438.71,564.298],[1438.71,698.67],[1307.55,563.133],[1307.55,691.26]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1438.71,709.961],[1438.71,844.333],[1307.55,702.026],[1307.55,830.153]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1438.71,855.865],[1438.71,990.237],[1307.55,841.148],[1307.55,969.275]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1580.5,408.051],[1580.5,267.017],[1437.45,414.384],[1437.45,280.158]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1580.5,553.266],[1580.5,412.231],[1437.45,552.589],[1437.45,418.363]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1580.5,565.539],[1580.5,706.574],[1437.45,564.27],[1437.45,698.497]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1580.5,718.424],[1580.5,859.458],[1437.45,709.775],[1437.45,844.002]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1580.5,871.562],[1580.5,1012.6],[1437.45,855.521],[1437.45,989.748]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1840.63,249.243],[1840.63,103.644],[1495.04,280.333],[1495.04,150.343]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,396.959],[1770.8,244.001],[1560.25,406.459],[1560.25,263.712]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,554.451],[1770.8,401.492],[1560.25,553.436],[1560.25,410.689]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,567.762],[1770.8,720.72],[1560.25,565.858],[1560.25,708.605]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,733.572],[1770.8,886.53],[1560.25,720.599],[1560.25,863.346]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,899.656],[1770.8,1052.61],[1560.25,875.596],[1560.25,1018.34]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,396.959],[1770.8,244.001],[1789.14,398.724],[1789.14,247.664]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,554.451],[1770.8,401.492],[1789.14,554.262],[1789.14,403.202]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,567.762],[1770.8,720.72],[1789.14,567.408],[1789.14,718.468]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,733.572],[1770.8,886.53],[1789.14,731.161],[1789.14,882.221]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1770.8,899.656],[1770.8,1052.61],[1789.14,895.185],[1789.14,1046.24]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1973.06,390.577],[1973.06,230.758],[1789.14,398.724],[1789.14,247.664]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1973.06,555.132],[1973.06,395.314],[1789.14,554.262],[1789.14,403.202]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1973.06,569.04],[1973.06,728.859],[1789.14,567.408],[1789.14,718.468]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1973.06,742.287],[1973.06,902.106],[1789.14,731.161],[1789.14,882.221]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1973.06,915.821],[1973.06,1075.64],[1789.14,895.185],[1789.14,1046.24]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:35,
                    verts:[[1840.33,249.258],[1840.33,103.667],[2038.06,289.966],[2038.06,164.813]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[274.925,462.845],[274.925,380.711],[219.551,464.862],[219.551,384.897]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[274.925,547.413],[274.925,465.28],[219.551,547.198],[219.551,467.232]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[274.925,554.561],[274.925,636.695],[219.551,554.157],[219.551,634.122]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[274.925,643.596],[274.925,725.73],[219.551,640.841],[219.551,720.807]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[274.925,732.778],[274.925,814.912],[219.551,727.669],[219.551,807.635]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,459.475],[331.596,373.718],[255.738,462.284],[255.738,379.547]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,547.773],[331.596,462.017],[255.738,547.473],[255.738,464.736]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,555.236],[331.596,640.993],[255.738,554.673],[255.738,637.41]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,648.198],[331.596,733.955],[255.738,644.362],[255.738,727.099]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,741.314],[331.596,827.071],[255.738,734.2],[255.738,816.937]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[469.664,368.836],[469.664,283.279],[331.461,379.11],[331.461,298.711]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,459.475],[331.596,373.718],[351.581,460.099],[351.581,375.013]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,547.773],[331.596,462.017],[351.581,547.707],[351.581,462.621]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,555.236],[331.596,640.993],[351.581,555.111],[351.581,640.197]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,648.198],[331.596,733.955],[351.581,647.346],[351.581,732.432]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[331.596,741.314],[331.596,827.071],[351.581,739.734],[351.581,824.82]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[413.63,457.84],[413.63,370.326],[351.581,460.099],[351.581,375.013]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[413.63,547.948],[413.63,460.434],[351.581,547.707],[351.581,462.621]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[413.63,555.564],[413.63,643.078],[351.581,555.111],[351.581,640.197]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[413.63,650.431],[413.63,737.945],[351.581,647.346],[351.581,732.432]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[413.63,745.455],[413.63,832.97],[351.581,739.734],[351.581,824.82]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[480.912,455.391],[480.912,365.244],[414.902,457.794],[414.902,370.23]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[480.912,548.21],[480.912,458.063],[414.902,547.953],[414.902,460.389]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[480.912,556.055],[480.912,646.202],[414.902,555.573],[414.902,643.137]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[480.912,653.776],[480.912,743.923],[414.902,650.494],[414.902,738.058]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[480.912,751.659],[480.912,841.806],[414.902,745.573],[414.902,833.137]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,451.287],[552.705,356.729],[460.809,454.69],[460.809,363.79]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,548.648],[552.705,454.09],[460.809,548.284],[460.809,457.384]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,556.877],[552.705,651.435],[460.809,556.195],[460.809,647.095]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,659.38],[552.705,753.938],[460.809,654.733],[460.809,745.633]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,762.053],[552.705,856.611],[460.809,753.434],[460.809,844.334]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[626.681,357.164],[626.681,265.747],[469.836,368.824],[469.836,283.26]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,451.287],[552.705,356.729],[572.137,452.019],[572.137,358.248]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,548.648],[552.705,454.09],[572.137,548.57],[572.137,454.799]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,556.877],[552.705,651.435],[572.137,556.73],[572.137,650.501]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,659.38],[552.705,753.938],[572.137,658.38],[572.137,752.151]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[552.705,762.053],[552.705,856.611],[572.137,760.198],[572.137,853.969]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.64,449.233],[648.64,352.466],[572.137,452.019],[572.137,358.248]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.64,548.867],[648.64,452.101],[572.137,548.57],[572.137,454.799]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.64,557.288],[648.64,654.055],[572.137,556.73],[572.137,650.501]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.64,662.185],[648.64,758.952],[572.137,658.38],[572.137,752.151]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.64,767.256],[648.64,864.023],[572.137,760.198],[572.137,853.969]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[626.852,357.144],[626.852,265.717],[852.357,375.314],[852.357,293.009]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.66,449.285],[648.66,352.574],[688.908,450.902],[688.908,355.931]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.66,548.862],[648.66,452.151],[688.908,548.689],[688.908,453.717]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.66,557.278],[648.66,653.988],[688.908,556.954],[688.908,651.925]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.66,662.114],[648.66,758.825],[688.908,659.905],[688.908,754.877]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[648.66,767.124],[648.66,863.835],[688.908,763.027],[688.908,857.999]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[865.293,441.398],[865.293,336.209],[775.076,444.682],[775.076,343.024]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[865.293,549.704],[865.293,444.515],[775.076,549.353],[775.076,447.695]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[865.293,558.858],[865.293,664.047],[775.076,558.2],[775.076,659.858]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[865.293,672.885],[865.293,778.074],[775.076,668.4],[775.076,770.058]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[865.293,787.101],[865.293,892.289],[775.076,778.782],[775.076,880.441]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.883,435.764],[971.883,324.52],[845.556,440.442],[845.556,334.227]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.883,550.306],[971.883,439.062],[845.556,549.806],[845.556,443.591]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.883,559.987],[971.883,671.231],[845.556,559.049],[845.556,665.265]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.883,680.578],[971.883,791.822],[845.556,674.19],[845.556,780.405]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.883,801.369],[971.883,912.613],[845.556,789.52],[845.556,895.736]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1152.32,318.088],[1152.32,207.053],[920.503,335.321],[920.503,232.938]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.882,435.764],[971.882,324.52],[990.611,436.776],[990.611,326.62]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.882,550.306],[971.882,439.062],[990.611,550.198],[990.611,440.041]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.882,559.987],[971.882,671.231],[990.611,559.784],[990.611,669.94]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.882,680.578],[971.882,791.822],[990.611,679.196],[990.611,789.352]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[971.882,801.369],[971.882,912.613],[990.611,798.806],[990.611,908.962]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1096.78,432.909],[1096.78,318.596],[990.611,436.776],[990.611,326.62]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1096.78,550.611],[1096.78,436.298],[990.611,550.198],[990.611,440.041]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1096.78,560.559],[1096.78,674.872],[990.611,559.784],[990.611,669.94]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1096.78,684.477],[1096.78,798.79],[990.611,679.196],[990.611,789.352]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1096.78,808.6],[1096.78,922.914],[990.611,798.806],[990.611,908.962]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1207.74,818.676],[1207.74,937.266],[1094.53,808.238],[1094.53,922.397]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1207.74,428.931],[1207.74,310.342],[1094.53,433.053],[1094.53,318.893]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1207.74,551.036],[1207.74,432.446],[1094.53,550.596],[1094.53,436.436]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1207.74,561.356],[1207.74,679.945],[1094.53,560.53],[1094.53,674.689]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1207.74,689.91],[1207.74,808.499],[1094.53,684.281],[1094.53,798.441]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1152.6,318.059],[1152.6,207.01],[1358.38,344.303],[1358.38,246.429]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,421.718],[1351.19,295.375],[1189.24,427.716],[1189.24,307.819]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,551.806],[1351.19,425.463],[1189.24,551.166],[1189.24,431.269]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,562.801],[1351.19,689.144],[1189.24,561.599],[1189.24,681.496]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,699.76],[1351.19,826.103],[1189.24,691.57],[1189.24,811.466]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,836.945],[1351.19,963.289],[1189.24,821.755],[1189.24,941.652]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1550.62,288.479],[1550.62,162.579],[1259.4,310.128],[1259.4,195.096]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,421.718],[1351.19,295.375],[1368.23,423.022],[1368.23,298.08]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,551.806],[1351.19,425.463],[1368.23,551.667],[1368.23,426.725]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,562.801],[1351.19,689.144],[1368.23,562.54],[1368.23,687.482]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,699.76],[1351.19,826.103],[1368.23,697.979],[1368.23,822.921]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1351.19,836.945],[1351.19,963.289],[1368.23,833.643],[1368.23,958.585]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1505.5,418.022],[1505.5,287.705],[1368.23,423.022],[1368.23,298.08]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1505.5,552.201],[1505.5,421.884],[1368.23,551.667],[1368.23,426.725]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1505.5,563.542],[1505.5,693.858],[1368.23,562.54],[1368.23,687.482]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1505.5,704.808],[1505.5,835.125],[1368.23,697.979],[1368.23,822.921]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1505.5,846.308],[1505.5,976.625],[1368.23,833.643],[1368.23,958.585]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1652.05,412.757],[1652.05,276.781],[1504.02,418.146],[1504.02,287.962]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1652.05,552.763],[1652.05,416.787],[1504.02,552.188],[1504.02,422.004]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1652.05,564.596],[1652.05,700.573],[1504.02,563.517],[1504.02,693.7]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1652.05,711.998],[1652.05,847.974],[1504.02,704.638],[1504.02,834.822]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1652.05,859.643],[1652.05,995.619],[1504.02,845.994],[1504.02,976.177]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1901.97,262.36],[1901.97,123.347],[1550.1,288.518],[1550.1,162.637]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,403.182],[1851.75,256.913],[1636.42,411.156],[1636.42,273.459]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,553.786],[1851.75,407.517],[1636.42,552.934],[1636.42,415.237]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,566.515],[1851.75,712.784],[1636.42,564.917],[1636.42,702.614]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,725.073],[1851.75,871.342],[1636.42,714.184],[1636.42,851.881]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,883.894],[1851.75,1030.16],[1636.42,863.698],[1636.42,1001.4]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,403.182],[1851.75,256.913],[1865.02,404.926],[1865.02,260.533]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,553.786],[1851.75,407.517],[1865.02,553.6],[1865.02,409.206]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,566.515],[1851.75,712.784],[1865.02,566.165],[1865.02,710.559]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,725.073],[1851.75,871.342],[1865.02,722.691],[1865.02,867.085]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1851.75,883.894],[1851.75,1030.16],[1865.02,879.477],[1865.02,1023.87]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[2049.6,398.203],[2049.6,246.582],[1865.02,404.926],[1865.02,260.533]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[2049.6,554.318],[2049.6,402.697],[1865.02,553.6],[1865.02,409.206]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[2049.6,567.512],[2049.6,719.133],[1865.02,566.165],[1865.02,710.559]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[2049.6,731.873],[2049.6,883.494],[1865.02,722.691],[1865.02,867.085]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[2049.6,896.506],[2049.6,1048.13],[1865.02,879.477],[1865.02,1023.87]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:36,
                    verts:[[1901.67,262.372],[1901.67,123.364],[2043.77,302.3],[2043.77,183.339]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[241.492,461.43],[241.492,377.774],[178.861,463.308],[178.861,381.671]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[241.492,547.565],[241.492,463.909],[178.861,547.364],[178.861,465.727]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[241.492,554.845],[241.492,638.5],[178.861,554.468],[178.861,636.105]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[241.492,645.529],[241.492,729.184],[178.861,642.964],[178.861,724.601]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[241.492,736.364],[241.492,820.019],[178.861,731.607],[178.861,813.243]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,458.204],[308.39,371.081],[222.839,460.808],[222.839,376.485]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,547.909],[308.39,460.786],[222.839,547.631],[222.839,463.308]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,555.491],[308.39,642.614],[222.839,554.969],[222.839,639.292]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,649.934],[308.39,737.057],[222.839,646.377],[222.839,730.701]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,744.534],[308.39,831.657],[222.839,737.937],[222.839,822.26]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[450.316,366.993],[450.316,280.511],[296.416,376.448],[296.416,294.712]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,458.204],[308.39,371.081],[327.608,458.89],[327.608,372.505]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,547.909],[308.39,460.786],[327.608,547.836],[327.608,461.45]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,555.491],[308.39,642.614],[327.608,555.353],[327.608,641.739]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,649.934],[308.39,737.057],[327.608,648.997],[327.608,735.383]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[308.39,744.534],[308.39,831.657],[327.608,742.796],[327.608,829.181]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[396.997,456.81],[396.997,368.189],[327.608,458.89],[327.608,372.505]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[396.997,548.058],[396.997,459.437],[327.608,547.836],[327.608,461.45]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[396.997,555.77],[396.997,644.391],[327.608,555.353],[327.608,641.739]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[396.997,651.837],[396.997,740.458],[327.608,648.997],[327.608,735.383]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[396.997,748.063],[396.997,836.684],[327.608,742.796],[327.608,829.181]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[471.833,454.567],[471.833,363.535],[398.416,456.768],[398.416,368.101]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[471.833,548.298],[471.833,457.266],[398.416,548.063],[398.416,459.396]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[471.833,556.219],[471.833,647.252],[398.416,555.779],[398.416,644.445]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[471.833,654.9],[471.833,745.932],[398.416,651.895],[398.416,740.562]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[471.833,753.744],[471.833,844.776],[398.416,748.171],[398.416,836.838]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[623.045,356.382],[623.045,264.573],[450.506,366.982],[450.506,280.494]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.682,450.705],[554.682,355.522],[452.871,453.805],[452.871,361.953]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.682,548.71],[554.682,453.526],[452.871,548.379],[452.871,456.527]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.682,556.993],[554.682,652.177],[452.871,556.372],[452.871,648.224]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.682,660.174],[554.682,755.358],[452.871,655.941],[452.871,747.793]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.682,763.526],[554.682,858.71],[452.871,755.675],[452.871,847.527]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.681,450.705],[554.681,355.522],[572.752,451.496],[572.752,357.163]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.681,548.71],[554.681,453.526],[572.752,548.626],[572.752,454.292]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.681,556.993],[554.681,652.177],[572.752,556.835],[572.752,651.168]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.681,660.174],[554.681,755.358],[572.752,659.094],[572.752,753.428]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[554.681,763.526],[554.681,858.71],[572.752,761.523],[572.752,855.857]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.703,448.979],[656.703,351.939],[572.752,451.496],[572.752,357.163]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.703,548.894],[656.703,451.855],[572.752,548.626],[572.752,454.292]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.703,557.339],[656.703,654.379],[572.752,556.835],[572.752,651.168]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.703,662.532],[656.703,759.572],[572.752,659.094],[572.752,753.428]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.703,767.899],[656.703,864.939],[572.752,761.523],[572.752,855.857]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[623.239,356.364],[623.239,264.545],[830.655,375.769],[830.655,293.693]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.604,449.03],[656.604,352.046],[693.507,450.763],[693.507,355.642]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.604,548.889],[656.604,451.905],[693.507,548.704],[693.507,453.582]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.604,557.329],[656.604,654.313],[693.507,556.982],[693.507,652.103]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.604,662.462],[656.604,759.446],[693.507,660.095],[693.507,755.217]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[656.604,767.769],[656.604,864.753],[693.507,763.38],[693.507,858.501]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[891.474,441.99],[891.474,337.439],[794.171,444.907],[794.171,343.49]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[891.474,549.641],[891.474,445.089],[794.171,549.329],[794.171,447.913]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[891.474,558.739],[891.474,663.291],[794.171,558.155],[794.171,659.572]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[891.474,672.076],[891.474,776.627],[794.171,668.093],[794.171,769.51]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[891.474,785.6],[891.474,890.151],[794.171,778.213],[794.171,879.63]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,436.861],[1009.41,326.796],[874.011,440.983],[874.011,335.349]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,550.189],[1009.41,440.124],[874.011,549.748],[874.011,444.114]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,559.767],[1009.41,669.832],[874.011,558.941],[874.011,664.575]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,679.08],[1009.41,789.145],[874.011,673.451],[874.011,779.085]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,798.591],[1009.41,908.656],[874.011,788.15],[874.011,893.785]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1185.41,321.835],[1185.41,212.681],[940.353,336.889],[940.353,235.293]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,436.861],[1009.41,326.796],[1025.58,437.917],[1025.58,328.987]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,550.189],[1009.41,440.124],[1025.58,550.076],[1025.58,441.146]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,559.767],[1009.41,669.832],[1025.58,559.555],[1025.58,668.486]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,679.08],[1009.41,789.145],[1025.58,677.638],[1025.58,786.568]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1009.41,798.591],[1009.41,908.656],[1025.58,795.916],[1025.58,904.847]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1138.02,434.545],[1138.02,321.991],[1025.58,437.917],[1025.58,328.987]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1138.02,550.436],[1138.02,437.881],[1025.58,550.076],[1025.58,441.146]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1138.02,560.231],[1138.02,672.786],[1025.58,559.555],[1025.58,668.486]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1138.02,682.243],[1138.02,794.797],[1025.58,677.638],[1025.58,786.568]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1138.02,804.456],[1138.02,917.011],[1025.58,795.916],[1025.58,904.847]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1254.38,813.148],[1254.38,929.392],[1135.52,804.126],[1135.52,916.54]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1254.38,431.114],[1254.38,314.87],[1135.52,434.676],[1135.52,322.262]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1254.38,550.803],[1254.38,434.559],[1135.52,550.422],[1135.52,438.008]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1254.38,560.919],[1254.38,677.162],[1135.52,560.205],[1135.52,672.619]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1254.38,686.929],[1254.38,803.173],[1135.52,682.064],[1135.52,794.479]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1185.71,321.809],[1185.71,212.642],[1357.9,348.701],[1357.9,253.035]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,424.736],[1407.68,301.636],[1239.13,429.867],[1239.13,312.284]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,551.484],[1407.68,428.384],[1239.13,550.936],[1239.13,433.352]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,562.196],[1407.68,685.296],[1239.13,561.168],[1239.13,678.752]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,695.639],[1407.68,818.739],[1239.13,688.631],[1239.13,806.214]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,829.303],[1407.68,952.403],[1239.13,816.305],[1239.13,933.888]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1595.94,296.615],[1595.94,174.8],[1297.07,314.976],[1297.07,202.378]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,424.736],[1407.68,301.636],[1421.16,426.055],[1421.16,304.373]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,551.484],[1407.68,428.384],[1421.16,551.343],[1421.16,429.661]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,562.196],[1407.68,685.296],[1421.16,561.932],[1421.16,683.614]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,695.639],[1407.68,818.739],[1421.16,693.838],[1421.16,815.519]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1407.68,829.303],[1407.68,952.403],[1421.16,825.961],[1421.16,947.643]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1562.02,421.831],[1562.02,295.609],[1421.16,426.055],[1421.16,304.373]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1562.02,551.794],[1562.02,425.572],[1421.16,551.343],[1421.16,429.661]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1562.02,562.778],[1562.02,689],[1421.16,561.932],[1421.16,683.614]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1562.02,699.606],[1562.02,825.828],[1421.16,693.838],[1421.16,815.519]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1562.02,836.66],[1562.02,962.881],[1421.16,825.961],[1421.16,947.643]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1710.55,417.442],[1710.55,286.502],[1560.36,421.943],[1560.36,295.842]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1710.55,705.6],[1710.55,836.54],[1560.36,699.453],[1560.36,825.554]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1710.55,552.263],[1710.55,421.323],[1560.36,551.782],[1560.36,425.681]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1710.55,563.658],[1710.55,694.598],[1560.36,562.756],[1560.36,688.857]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1710.55,847.777],[1710.55,978.717],[1560.36,836.376],[1560.36,962.477]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1947.49,275.019],[1947.49,142.361],[1595.41,296.648],[1595.41,174.848]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,409.288],[1915.06,269.584],[1699.27,415.858],[1699.27,283.216]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,553.134],[1915.06,413.429],[1699.27,552.432],[1699.27,419.79]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,565.291],[1915.06,704.996],[1699.27,563.975],[1699.27,696.617]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,716.734],[1915.06,856.439],[1699.27,707.762],[1699.27,840.405]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,868.428],[1915.06,1008.13],[1699.27,851.788],[1699.27,984.43]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,409.288],[1915.06,269.584],[1923.72,410.985],[1923.72,273.104]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,553.134],[1915.06,413.429],[1923.72,552.953],[1923.72,415.072]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,565.291],[1915.06,704.996],[1923.72,564.952],[1923.72,702.833]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,716.734],[1915.06,856.439],[1923.72,714.418],[1923.72,852.299]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:37,
                    verts:[[1915.06,868.428],[1915.06,1008.13],[1923.72,864.131],[1923.72,1002.01]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[211.68,459.908],[211.68,374.616],[141.703,461.626],[141.703,378.183]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[211.68,547.727],[211.68,462.436],[141.703,547.544],[141.703,464.1]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[211.68,555.15],[211.68,640.441],[141.703,554.805],[141.703,638.249]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[211.68,647.607],[211.68,732.899],[141.703,645.26],[141.703,728.704]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[211.68,740.218],[211.68,825.51],[141.703,735.865],[141.703,819.309]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,456.854],[288.908,368.28],[193.682,459.226],[193.682,373.202]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,548.053],[288.908,459.479],[193.682,547.8],[193.682,461.776]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,555.761],[288.908,644.335],[193.682,555.286],[193.682,641.31]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,651.778],[288.908,740.352],[193.682,648.538],[193.682,734.562]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,747.953],[288.908,836.527],[193.682,741.944],[193.682,827.968]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[434.017,365.01],[434.017,277.532],[264.649,373.557],[264.649,290.37]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,456.854],[288.908,368.28],[307.219,457.601],[307.219,369.831]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,548.053],[288.908,459.479],[307.219,547.974],[307.219,460.203]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,555.761],[288.908,644.335],[307.219,555.612],[307.219,643.382]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,651.778],[288.908,740.352],[307.219,650.757],[307.219,738.527]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[288.908,747.953],[288.908,836.527],[307.219,746.06],[307.219,833.83]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[383.799,455.721],[383.799,365.93],[307.219,457.601],[307.219,369.831]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[383.799,548.174],[383.799,458.383],[307.219,547.974],[307.219,460.203]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[383.799,555.988],[383.799,645.78],[307.219,555.612],[307.219,643.382]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[383.799,653.324],[383.799,743.116],[307.219,650.757],[307.219,738.527]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[383.799,750.821],[383.799,840.613],[307.219,746.06],[307.219,833.83]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[465.916,453.705],[465.916,361.747],[385.361,455.683],[385.361,365.85]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[465.916,548.39],[465.916,456.431],[385.361,548.178],[385.361,458.346]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[465.916,556.392],[465.916,648.351],[385.361,555.996],[385.361,645.829]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[465.916,656.077],[465.916,748.036],[385.361,653.377],[385.361,743.209]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[465.916,755.928],[465.916,847.886],[385.361,750.919],[385.361,840.751]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[621.649,355.541],[621.649,263.309],[434.224,364.999],[434.224,277.516]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,450.115],[559.424,354.297],[448.246,452.885],[448.246,360.043]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,548.773],[559.424,452.955],[448.246,548.477],[448.246,455.636]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,557.112],[559.424,652.93],[448.246,556.557],[448.246,649.398]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,660.981],[559.424,756.799],[448.246,657.198],[448.246,750.039]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,765.022],[559.424,860.84],[448.246,758.007],[448.246,850.848]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,450.115],[559.424,354.296],[575.986,450.959],[575.986,356.049]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,548.773],[559.424,452.955],[575.986,548.683],[575.986,453.772]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,557.112],[559.424,652.93],[575.986,556.942],[575.986,651.853]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,660.981],[559.424,756.799],[575.986,659.827],[575.986,754.738]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[559.424,765.022],[559.424,860.84],[575.986,762.883],[575.986,857.793]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.792,448.729],[666.792,351.421],[575.986,450.959],[575.986,356.049]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.792,548.921],[666.792,451.613],[575.986,548.683],[575.986,453.772]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.792,557.389],[666.792,654.697],[575.986,556.942],[575.986,651.853]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.792,662.873],[666.792,760.181],[575.986,659.827],[575.986,754.738]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.792,768.532],[666.792,865.84],[575.986,762.883],[575.986,857.793]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[621.865,355.524],[621.865,263.283],[810.133,376.044],[810.133,294.106]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.574,448.78],[666.574,351.526],[699.859,450.615],[699.859,355.334]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.574,548.916],[666.574,451.662],[699.859,548.72],[699.859,453.439]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.574,557.379],[666.574,654.633],[699.859,557.011],[699.859,652.292]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.574,662.804],[666.574,760.057],[699.859,660.298],[699.859,755.578]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[666.574,768.403],[666.574,865.657],[699.859,763.755],[699.859,859.036]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[917.437,442.62],[917.437,338.746],[814.072,445.158],[814.072,344.011]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[917.437,549.574],[917.437,445.699],[814.072,549.303],[814.072,448.156]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[917.437,558.613],[917.437,662.488],[814.072,558.105],[814.072,659.251]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[917.437,671.215],[917.437,775.09],[814.072,667.75],[814.072,768.897]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[917.437,784.004],[917.437,887.879],[814.072,777.577],[814.072,878.723]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,438.014],[1045.16,329.188],[902.352,441.572],[902.352,336.57]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,550.066],[1045.16,441.239],[902.352,549.686],[902.352,444.684]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,559.536],[1045.16,668.362],[902.352,558.823],[902.352,663.825]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,677.506],[1045.16,786.332],[902.352,672.648],[902.352,777.649]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,795.671],[1045.16,904.498],[902.352,786.66],[902.352,891.662]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1215.15,325.589],[1215.15,218.319],[959.734,338.479],[959.734,237.681]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,438.014],[1045.16,329.188],[1058.73,439.102],[1058.73,331.445]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,550.066],[1045.16,441.239],[1058.73,549.949],[1058.73,442.293]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,559.536],[1045.16,668.362],[1058.73,559.318],[1058.73,666.975]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,677.506],[1045.16,786.332],[1058.73,676.02],[1058.73,783.677]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1045.16,795.671],[1045.16,904.498],[1058.73,792.916],[1058.73,900.572]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1175.96,436.222],[1175.96,325.47],[1058.73,439.102],[1058.73,331.445]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1175.96,550.257],[1175.96,439.505],[1058.73,549.949],[1058.73,442.293]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1175.96,559.895],[1175.96,670.647],[1058.73,559.318],[1058.73,666.975]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1175.96,679.953],[1175.96,790.705],[1058.73,676.02],[1058.73,783.677]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1175.96,800.209],[1175.96,910.961],[1058.73,792.916],[1058.73,900.572]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1296.07,433.324],[1296.07,319.457],[1173.24,436.34],[1173.24,325.715]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1296.07,550.567],[1296.07,436.699],[1173.24,550.244],[1173.24,439.619]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1296.07,560.476],[1296.07,674.343],[1173.24,559.871],[1173.24,670.497]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1296.07,683.91],[1296.07,797.777],[1173.24,679.792],[1173.24,790.417]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1296.07,807.549],[1296.07,921.416],[1173.24,799.911],[1173.24,910.536]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1215.47,325.566],[1215.47,218.285],[1354.78,352.828],[1354.78,259.233]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,427.764],[1456.61,307.919],[1284.03,432.063],[1284.03,316.84]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,551.16],[1456.61,431.316],[1284.03,550.701],[1284.03,435.478]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,561.59],[1456.61,681.434],[1284.03,560.728],[1284.03,675.951]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,691.504],[1456.61,811.349],[1284.03,685.633],[1284.03,800.856]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,821.633],[1456.61,941.478],[1284.03,810.744],[1284.03,925.967]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1632.36,304.534],[1632.36,186.693],[1329.93,319.796],[1329.93,209.618]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,427.764],[1456.61,307.919],[1466.67,429.082],[1466.67,310.654]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,551.16],[1456.61,431.316],[1466.67,551.02],[1466.67,432.592]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,561.59],[1456.61,681.434],[1466.67,561.326],[1466.67,679.753]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,691.504],[1456.61,811.349],[1466.67,689.704],[1466.67,808.132]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1456.61,821.633],[1456.61,941.478],[1466.67,818.295],[1466.67,936.723]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1608.94,425.587],[1608.94,303.403],[1466.67,429.082],[1466.67,310.654]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1608.94,551.393],[1608.94,429.209],[1466.67,551.02],[1466.67,432.592]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1608.94,562.026],[1608.94,684.21],[1466.67,561.326],[1466.67,679.753]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1608.94,694.476],[1608.94,816.661],[1466.67,689.704],[1466.67,808.132]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1608.94,827.146],[1608.94,949.33],[1466.67,818.295],[1466.67,936.723]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1757.18,422.004],[1757.18,295.968],[1607.14,425.688],[1607.14,303.611]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1757.18,551.776],[1757.18,425.74],[1607.14,551.382],[1607.14,429.306]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1757.18,562.744],[1757.18,688.779],[1607.14,562.006],[1607.14,684.082]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1757.18,699.369],[1757.18,825.405],[1607.14,694.339],[1607.14,816.415]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1757.18,836.221],[1757.18,962.257],[1607.14,826.892],[1607.14,948.968]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1979.38,287.02],[1979.38,160.388],[1631.83,304.56],[1631.83,186.734]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1962.81,415.153],[1962.81,281.752],[1749.92,420.457],[1749.92,292.758]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1962.81,552.507],[1962.81,419.107],[1749.92,551.941],[1749.92,424.242]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1962.81,564.116],[1962.81,697.517],[1749.92,563.054],[1749.92,690.753]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1962.81,708.726],[1962.81,842.126],[1749.92,701.483],[1749.92,829.182]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:38,
                    verts:[[1962.81,853.574],[1962.81,986.975],[1749.92,840.141],[1749.92,967.84]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[185.483,458.268],[185.483,371.214],[108.092,459.806],[108.092,374.405]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[185.483,547.902],[185.483,460.848],[108.092,547.738],[108.092,462.337]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[185.483,555.478],[185.483,642.532],[108.092,555.17],[108.092,640.571]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[185.483,649.846],[185.483,736.9],[108.092,647.746],[108.092,733.147]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[185.483,744.371],[185.483,831.425],[108.092,740.476],[108.092,825.876]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.112,455.415],[273.112,365.294],[168.27,457.527],[168.27,369.676]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.112,548.207],[273.112,458.086],[168.27,547.982],[168.27,460.13]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.112,556.05],[273.112,646.17],[168.27,555.627],[168.27,643.478]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.112,653.742],[273.112,743.863],[168.27,650.859],[168.27,738.71]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.112,751.597],[273.112,841.718],[168.27,746.249],[168.27,834.1]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[420.698,362.863],[420.698,274.307],[236.143,370.415],[236.143,285.65]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.113,455.415],[273.113,365.294],[290.374,456.223],[290.374,366.97]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.113,548.207],[273.113,458.086],[290.374,548.121],[290.374,458.868]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.113,556.05],[273.113,646.17],[290.374,555.888],[290.374,645.141]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.113,653.742],[273.113,743.863],[290.374,652.64],[290.374,741.892]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[273.113,751.597],[273.113,841.718],[290.374,749.552],[290.374,838.805]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[373.964,454.562],[373.964,363.525],[290.374,456.223],[290.374,366.97]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[373.964,548.298],[373.964,457.261],[290.374,548.121],[290.374,458.868]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[373.964,556.221],[373.964,647.258],[290.374,555.888],[290.374,645.141]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[373.964,654.907],[373.964,745.945],[290.374,652.64],[290.374,741.892]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[373.964,753.757],[373.964,844.795],[290.374,749.552],[290.374,838.805]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[463.05,452.793],[463.05,359.853],[375.664,454.529],[375.664,363.455]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[463.05,548.487],[463.05,455.548],[375.664,548.302],[375.664,457.228]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[463.05,556.575],[463.05,649.515],[375.664,556.227],[375.664,647.301]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[463.05,657.324],[463.05,750.263],[375.664,654.953],[375.664,746.027]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[463.05,758.239],[463.05,851.178],[375.664,753.843],[375.664,844.916]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[622.366,354.61],[622.366,261.911],[420.923,362.854],[420.923,274.293]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,449.501],[566.759,353.024],[446.818,451.917],[446.818,358.036]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,548.839],[566.759,452.361],[446.818,548.581],[446.818,454.7]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,557.234],[566.759,653.712],[446.818,556.75],[446.818,650.632]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,661.818],[566.759,758.296],[446.818,658.52],[446.818,752.401]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,766.575],[566.759,863.053],[446.818,760.457],[446.818,854.339]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,449.501],[566.759,353.024],[581.678,450.395],[581.678,354.878]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,548.839],[566.759,452.361],[581.678,548.743],[581.678,453.226]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,557.234],[566.759,653.712],[581.678,557.055],[581.678,652.573]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,661.818],[566.759,758.296],[581.678,660.598],[581.678,756.115]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[566.759,766.575],[566.759,863.053],[581.678,764.312],[581.678,859.829]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.714,448.467],[678.714,350.877],[581.678,450.395],[581.678,354.878]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.714,548.949],[678.714,451.359],[581.678,548.743],[581.678,453.226]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.714,557.442],[678.714,655.032],[581.678,557.055],[581.678,652.573]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.714,663.231],[678.714,760.821],[581.678,660.598],[581.678,756.115]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.714,769.196],[678.714,866.786],[581.678,764.312],[581.678,859.829]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[622.604,354.595],[622.604,261.888],[790.77,376.12],[790.77,294.22]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.38,448.516],[678.38,350.98],[707.811,450.442],[707.811,354.975]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.38,548.944],[678.38,451.407],[707.811,548.738],[707.811,453.272]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.38,557.432],[678.38,654.968],[707.811,557.046],[707.811,652.513]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.38,663.163],[678.38,760.7],[707.811,660.534],[707.811,756]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[678.38,769.07],[678.38,866.607],[707.811,764.193],[707.811,859.66]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[942.983,443.26],[942.983,340.073],[834.569,445.414],[834.569,344.542]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[942.983,549.505],[942.983,446.319],[834.569,549.275],[834.569,448.403]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[942.983,558.485],[942.983,661.672],[834.569,558.054],[834.569,658.925]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[942.983,670.342],[942.983,773.528],[834.569,667.401],[834.569,768.273]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[942.983,782.384],[942.983,885.57],[834.569,776.929],[834.569,877.801]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,439.186],[1078.98,331.619],[930.345,442.179],[930.345,337.831]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,549.94],[1078.98,442.374],[930.345,549.621],[930.345,445.272]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,559.301],[1078.98,666.868],[930.345,558.702],[930.345,663.05]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,675.906],[1078.98,783.472],[930.345,671.818],[930.345,776.167]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,792.703],[1078.98,900.27],[930.345,785.121],[930.345,889.47]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1241.65,329.269],[1241.65,223.847],[978.536,340.036],[978.536,240.019]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,439.186],[1078.98,331.619],[1089.92,440.295],[1089.92,333.922]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,549.94],[1078.98,442.374],[1089.92,549.822],[1089.92,443.448]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,559.301],[1078.98,666.868],[1089.92,559.079],[1089.92,665.453]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,675.906],[1078.98,783.472],[1089.92,674.39],[1089.92,780.764]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1078.98,792.703],[1078.98,900.27],[1089.92,789.893],[1089.92,896.267]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1210.56,437.898],[1210.56,328.947],[1089.92,440.295],[1089.92,333.922]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1210.56,550.078],[1210.56,441.127],[1089.92,549.822],[1089.92,443.448]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1210.56,559.559],[1210.56,668.51],[1089.92,559.079],[1089.92,665.453]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1210.56,677.664],[1210.56,786.615],[1089.92,674.39],[1089.92,780.764]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1210.56,795.965],[1210.56,904.916],[1089.92,789.893],[1089.92,896.267]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1332.97,680.92],[1332.97,792.433],[1207.67,677.521],[1207.67,786.359]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1332.97,435.514],[1332.97,324.001],[1207.67,438.003],[1207.67,329.165]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1332.97,550.333],[1332.97,438.819],[1207.67,550.067],[1207.67,441.229]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1332.97,560.037],[1332.97,671.55],[1207.67,559.538],[1207.67,668.376]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1332.97,802.003],[1332.97,913.516],[1207.67,795.699],[1207.67,904.537]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1241.98,329.249],[1241.98,223.818],[1349.4,356.65],[1349.4,264.975]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,430.739],[1498.4,314.093],[1324.05,434.251],[1324.05,321.379]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,550.843],[1498.4,434.197],[1324.05,550.468],[1324.05,437.596]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,560.994],[1498.4,677.64],[1324.05,560.29],[1324.05,673.162]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,687.44],[1498.4,804.086],[1324.05,682.645],[1324.05,795.517]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,814.097],[1498.4,930.743],[1324.05,805.203],[1324.05,918.075]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1660.79,312.118],[1660.79,198.085],[1358.26,324.497],[1358.26,216.68]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,430.739],[1498.4,314.093],[1505.21,432.043],[1505.21,316.798]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,550.843],[1498.4,434.197],[1505.21,550.703],[1505.21,435.459]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,560.994],[1498.4,677.64],[1505.21,560.732],[1505.21,675.977]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,687.44],[1498.4,804.086],[1505.21,685.66],[1505.21,800.905]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1498.4,814.097],[1498.4,930.743],[1505.21,810.795],[1505.21,926.04]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1647.1,429.223],[1647.1,310.947],[1505.21,432.043],[1505.21,316.798]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1647.1,551.005],[1647.1,432.729],[1505.21,550.703],[1505.21,435.459]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1647.1,561.297],[1647.1,679.573],[1505.21,560.732],[1505.21,675.977]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1647.1,689.511],[1647.1,807.787],[1505.21,685.66],[1505.21,800.905]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1647.1,817.937],[1647.1,936.213],[1505.21,810.795],[1505.21,926.04]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1793.25,426.372],[1793.25,305.031],[1645.2,429.312],[1645.2,311.132]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1793.25,551.309],[1793.25,429.968],[1645.2,550.995],[1645.2,432.815]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1793.25,561.869],[1793.25,683.21],[1645.2,561.279],[1645.2,679.459]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1793.25,693.405],[1793.25,814.746],[1645.2,689.389],[1645.2,807.569]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1793.25,825.159],[1793.25,946.5],[1645.2,817.711],[1645.2,935.891]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1999.74,298.248],[1999.74,177.251],[1660.26,312.139],[1660.26,198.117]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1997.14,420.695],[1997.14,293.252],[1789.64,424.874],[1789.64,301.923]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1997.14,551.915],[1997.14,424.473],[1789.64,551.469],[1789.64,428.518]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1997.14,563.006],[1997.14,690.449],[1789.64,562.169],[1789.64,685.12]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1997.14,701.157],[1997.14,828.6],[1789.64,695.45],[1789.64,818.401]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:39,
                    verts:[[1997.14,839.536],[1789.64,828.952],[1997.14,966.979],[1789.64,951.903]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[162.892,456.497],[162.892,367.54],[78.0307,457.831],[78.0307,370.308]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[162.892,548.091],[162.892,459.134],[78.0307,547.949],[78.0307,460.425]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[162.892,555.833],[162.892,644.79],[78.0307,555.566],[78.0307,643.089]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[162.892,652.264],[162.892,741.222],[78.0307,650.443],[78.0307,737.966]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[162.892,748.856],[162.892,837.813],[78.0307,745.477],[78.0307,833.001]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,453.875],[260.962,362.098],[146.598,455.695],[146.598,365.876]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,548.372],[260.962,456.595],[146.598,548.177],[146.598,458.358]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,556.358],[260.962,648.135],[146.598,555.993],[146.598,645.813]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,655.846],[260.962,747.622],[146.598,653.36],[146.598,743.179]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,755.499],[260.962,847.275],[146.598,750.887],[146.598,840.707]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[410.287,360.527],[410.287,270.799],[210.869,366.993],[210.869,280.51]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,453.875],[260.962,362.098],[277.029,454.741],[277.029,363.896]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,548.372],[260.962,456.595],[277.029,548.279],[277.029,457.434]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,556.358],[260.962,648.135],[277.029,556.185],[277.029,647.03]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,655.846],[260.962,747.622],[277.029,654.663],[277.029,745.508]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[260.962,755.499],[260.962,847.275],[277.029,753.304],[277.029,844.149]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[367.415,453.321],[367.415,360.95],[277.029,454.741],[277.029,363.896]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[367.415,548.431],[367.415,456.059],[277.029,548.279],[277.029,457.434]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[367.415,556.469],[367.415,648.841],[277.029,556.185],[277.029,647.03]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[367.415,656.602],[367.415,748.974],[277.029,654.663],[277.029,745.508]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[367.415,756.901],[367.415,849.272],[277.029,753.304],[277.029,844.149]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[463.123,451.818],[463.123,357.83],[369.247,453.292],[369.247,360.89]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[463.123,548.591],[463.123,454.603],[369.247,548.434],[369.247,456.031]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[463.123,556.77],[463.123,650.758],[369.247,556.475],[369.247,648.877]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[463.123,658.655],[463.123,752.643],[369.247,656.641],[369.247,749.044]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[463.123,760.709],[463.123,854.697],[369.247,756.974],[369.247,849.376]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[625.08,353.563],[625.08,260.338],[410.529,360.52],[410.529,270.787]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.528,448.851],[576.528,351.674],[448.47,450.89],[448.47,355.905]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.528,548.908],[576.528,451.731],[448.47,548.69],[448.47,453.705]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.528,557.365],[576.528,654.541],[448.47,556.956],[448.47,651.942]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.528,662.706],[576.528,759.883],[448.47,659.922],[448.47,754.908]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.528,768.222],[576.528,865.399],[448.47,763.059],[448.47,858.044]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.527,448.851],[576.527,351.674],[589.68,449.789],[589.68,353.621]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.527,548.908],[576.527,451.731],[589.68,548.808],[589.68,452.64]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.527,557.365],[576.527,654.541],[589.68,557.177],[589.68,653.345]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.527,662.706],[576.527,759.883],[589.68,661.425],[589.68,757.594]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[576.527,768.222],[576.527,865.399],[589.68,765.846],[589.68,862.015]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[692.299,448.176],[692.299,350.274],[589.681,449.789],[589.681,353.621]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[692.299,548.98],[692.299,451.078],[589.681,548.808],[589.681,452.64]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[692.299,557.5],[692.299,655.402],[589.681,557.177],[589.681,653.345]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[692.299,663.628],[692.299,761.53],[589.681,661.425],[589.681,757.594]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[692.299,769.932],[692.299,867.834],[589.681,765.846],[589.681,862.015]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[625.336,353.549],[625.336,260.318],[772.53,375.978],[772.53,294.006]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[691.851,663.562],[691.851,761.412],[717.224,660.825],[717.224,756.52]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[691.851,448.225],[691.851,350.374],[717.224,450.229],[717.224,354.534]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[691.851,548.975],[691.851,451.125],[717.224,548.761],[717.224,453.065]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[691.851,557.49],[691.851,655.34],[717.224,557.089],[717.224,652.784]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[691.851,769.809],[691.851,867.66],[717.224,764.732],[717.224,860.428]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[967.974,443.886],[967.974,341.372],[855.492,445.653],[855.492,345.039]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[967.974,549.438],[967.974,446.924],[855.492,549.25],[855.492,448.635]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[967.974,558.36],[967.974,660.874],[855.492,558.005],[855.492,658.62]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[967.974,669.487],[967.974,772.001],[855.492,667.074],[855.492,767.688]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[967.974,780.799],[967.974,883.313],[855.492,776.323],[855.492,876.937]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,440.346],[1110.79,334.027],[957.825,442.781],[957.825,339.079]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,549.817],[1110.79,443.497],[957.825,549.556],[957.825,445.855]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,559.069],[1110.79,665.388],[957.825,558.581],[957.825,662.283]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,674.321],[1110.79,780.641],[957.825,670.996],[957.825,774.698]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,789.765],[1110.79,896.084],[957.825,783.597],[957.825,887.299]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1265.06,332.814],[1265.06,229.171],[996.692,341.515],[996.692,242.241]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,440.346],[1110.79,334.027],[1119.1,441.468],[1119.1,336.354]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,549.817],[1110.79,443.497],[1119.1,549.697],[1119.1,444.583]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,559.069],[1110.79,665.388],[1119.1,558.844],[1119.1,663.958]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,674.321],[1110.79,780.641],[1119.1,672.789],[1119.1,777.903]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1110.79,789.765],[1110.79,896.084],[1119.1,786.923],[1119.1,892.037]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1241.91,439.538],[1241.91,332.349],[1119.1,441.468],[1119.1,336.354]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1241.91,549.903],[1241.91,442.715],[1119.1,549.697],[1119.1,444.583]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1241.91,559.231],[1241.91,666.419],[1119.1,558.844],[1119.1,663.958]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1241.91,675.425],[1241.91,782.614],[1119.1,672.789],[1119.1,777.903]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1241.91,791.812],[1241.91,899.001],[1119.1,786.923],[1119.1,892.037]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1365.31,437.643],[1365.31,328.419],[1238.87,439.63],[1238.87,332.541]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1365.31,550.105],[1365.31,440.881],[1238.87,549.893],[1238.87,442.804]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1365.31,559.61],[1365.31,668.835],[1238.87,559.212],[1238.87,666.301]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1365.31,678.012],[1365.31,787.236],[1238.87,675.299],[1238.87,782.388]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1365.31,796.61],[1365.31,905.834],[1238.87,791.578],[1238.87,898.668]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1265.39,332.797],[1265.39,229.146],[1342.06,360.149],[1342.06,270.23]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,433.615],[1533.59,320.061],[1359.39,436.388],[1359.39,325.815]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,550.535],[1533.59,436.981],[1359.39,550.239],[1359.39,439.666]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,560.417],[1533.59,673.972],[1359.39,559.862],[1359.39,670.435]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,683.513],[1533.59,797.068],[1359.39,679.726],[1359.39,790.3]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,806.813],[1533.59,920.367],[1359.39,799.789],[1359.39,910.362]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1682.16,319.29],[1682.16,208.858],[1382.37,329.01],[1382.37,223.458]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,433.615],[1533.59,320.061],[1537.35,434.894],[1537.35,322.714]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,550.535],[1533.59,436.981],[1537.35,550.399],[1537.35,438.219]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,560.417],[1533.59,673.972],[1537.35,560.161],[1537.35,672.341]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,683.513],[1533.59,797.068],[1537.35,681.767],[1537.35,793.947]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1533.59,806.813],[1533.59,920.367],[1537.35,803.574],[1537.35,915.754]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1677.4,432.692],[1677.4,318.146],[1537.35,434.894],[1537.35,322.714]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1677.4,550.634],[1677.4,436.088],[1537.35,550.399],[1537.35,438.219]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1677.4,560.602],[1677.4,675.149],[1537.35,560.161],[1537.35,672.341]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1677.4,684.773],[1677.4,799.319],[1537.35,681.767],[1537.35,793.947]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1677.4,809.15],[1537.35,803.574],[1677.4,923.696],[1537.35,915.754]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1820.07,430.499],[1675.43,432.771],[1820.07,313.594],[1675.43,318.309]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1820.07,550.868],[1820.07,433.964],[1675.43,550.626],[1675.43,436.164]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1820.07,561.042],[1820.07,677.947],[1675.43,560.587],[1675.43,675.048]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1820.07,687.769],[1675.43,684.666],[1820.07,804.674],[1675.43,799.128]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1820.07,814.706],[1675.43,808.951],[1820.07,931.611],[1675.43,923.412]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[2010.45,308.646],[1681.65,319.307],[2010.45,192.87],[1681.65,208.883]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1819.76,429.06],[2020.04,425.871],[1819.76,310.608],[2020.04,303.992]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1819.76,551.022],[1819.76,432.57],[2020.04,551.363],[2020.04,429.483]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1819.76,561.33],[1819.76,679.782],[2020.04,561.969],[2020.04,683.848]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1819.76,689.734],[2020.04,694.089],[1819.76,808.186],[2020.04,815.968]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:40,
                    verts:[[1819.76,818.351],[2020.04,826.427],[1819.76,936.803],[2020.04,948.306]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[143.904,454.58],[143.904,363.562],[51.535,455.685],[51.535,365.854]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[143.904,548.296],[143.904,457.278],[51.535,548.178],[51.535,458.347]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[143.904,556.217],[143.904,647.235],[51.535,555.996],[51.535,645.827]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[143.904,654.883],[143.904,745.901],[51.535,653.374],[51.535,743.205]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[143.904,753.712],[143.904,844.73],[51.535,750.914],[51.535,840.745]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,452.219],[252.426,358.663],[128.673,453.717],[128.673,361.772]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,548.548],[252.426,454.992],[128.673,548.388],[128.673,456.443]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,556.69],[252.426,650.246],[128.673,556.39],[128.673,648.336]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,658.107],[252.426,751.663],[128.673,656.061],[128.673,748.007]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,759.691],[252.426,853.247],[128.673,755.897],[128.673,847.843]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[402.718,357.977],[402.718,266.968],[188.803,363.26],[188.803,274.903]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,452.219],[252.426,358.663],[267.148,453.144],[267.148,360.582]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,548.548],[252.426,454.992],[267.148,548.45],[267.148,455.887]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,556.69],[252.426,650.246],[267.148,556.505],[267.148,649.067]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,658.107],[252.426,751.663],[267.148,656.844],[267.148,749.406]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[252.426,759.691],[252.426,853.247],[267.148,757.35],[267.148,849.912]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[364.088,451.985],[364.088,358.178],[267.148,453.144],[267.148,360.582]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[364.088,548.573],[364.088,454.766],[267.148,548.45],[267.148,455.887]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[364.088,556.737],[364.088,650.544],[267.148,556.505],[267.148,649.067]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[364.088,658.426],[364.088,752.234],[267.148,656.844],[267.148,749.406]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[364.088,760.284],[364.088,854.092],[267.148,757.35],[267.148,849.912]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[466.041,450.767],[466.041,355.649],[366.046,451.962],[366.046,358.129]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[466.041,548.703],[466.041,453.586],[366.046,548.576],[366.046,454.743]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[466.041,556.981],[466.041,652.098],[366.046,556.742],[366.046,650.574]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[466.041,660.09],[466.041,755.208],[366.046,658.458],[366.046,752.291]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[466.041,763.37],[466.041,858.488],[366.046,760.344],[366.046,854.176]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[629.684,352.372],[629.684,258.549],[402.975,357.97],[402.975,266.958]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,448.15],[588.589,350.22],[453.103,449.79],[453.103,353.623]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,548.983],[588.589,451.053],[453.103,548.808],[453.103,452.641]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,557.505],[588.589,655.435],[453.103,557.177],[453.103,653.344]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,663.664],[588.589,761.594],[453.103,661.424],[453.103,757.591]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,769.998],[588.589,867.928],[453.103,765.844],[453.103,862.011]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,448.15],[588.589,350.22],[599.862,449.129],[599.862,352.25]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,548.983],[588.589,451.053],[599.862,548.878],[599.862,452]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,557.505],[588.589,655.435],[599.862,557.309],[599.862,654.188]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,663.664],[588.589,761.594],[599.862,662.328],[599.862,759.206]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[588.589,769.998],[588.589,867.928],[599.862,767.52],[599.862,864.398]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[707.405,447.843],[707.405,349.582],[599.862,449.129],[599.862,352.25]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[707.405,549.016],[707.405,450.755],[599.862,548.878],[599.862,452]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[707.405,557.567],[707.405,655.828],[599.862,557.309],[599.862,654.188]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[707.405,664.084],[707.405,762.344],[599.862,662.328],[599.862,759.206]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[707.405,770.777],[707.405,869.038],[599.862,767.52],[599.862,864.398]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[629.959,352.36],[629.959,258.53],[755.361,375.6],[755.361,293.439]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[706.844,447.889],[706.844,349.679],[727.98,449.962],[727.98,353.98]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[706.844,549.011],[706.844,450.8],[727.98,548.789],[727.98,452.807]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[706.844,557.557],[706.844,655.768],[727.98,557.142],[727.98,653.124]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[706.844,664.02],[706.844,762.23],[727.98,661.189],[727.98,757.171]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[706.844,770.659],[706.844,868.869],[727.98,765.408],[727.98,861.39]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[992.317,444.477],[992.317,342.598],[876.707,445.859],[876.707,345.465]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[992.317,549.375],[992.317,447.497],[876.707,549.228],[876.707,448.834]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[992.317,558.241],[992.317,660.12],[876.707,557.964],[876.707,658.358]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[992.317,668.68],[992.317,770.559],[876.707,666.793],[876.707,767.186]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[992.317,779.302],[992.317,881.18],[876.707,775.802],[876.707,876.195]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,441.469],[1140.56,336.357],[984.674,443.356],[984.674,340.272]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,549.697],[1140.56,444.584],[984.674,549.495],[984.674,446.411]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,558.844],[1140.56,663.956],[984.674,558.466],[984.674,661.55]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,672.788],[1140.56,777.9],[984.674,670.211],[984.674,773.295]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,786.92],[1140.56,892.033],[984.674,782.141],[984.674,885.225]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1285.56,336.174],[1285.56,234.219],[1014.17,342.877],[1014.17,244.286]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,441.469],[1140.56,336.357],[1146.29,442.595],[1146.29,338.693]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,549.697],[1140.56,444.584],[1146.29,549.576],[1146.29,445.675]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,558.844],[1140.56,663.956],[1146.29,558.618],[1146.29,662.52]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,672.788],[1140.56,777.9],[1146.29,671.25],[1146.29,775.152]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1140.56,786.92],[1140.56,892.033],[1146.29,784.068],[1146.29,887.97]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1270.12,441.114],[1270.12,335.621],[1146.29,442.595],[1146.29,338.693]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1270.12,549.734],[1270.12,444.241],[1146.29,549.576],[1146.29,445.675]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1270.12,558.915],[1270.12,664.408],[1146.29,558.618],[1146.29,662.52]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1270.12,673.272],[1270.12,778.765],[1146.29,671.25],[1146.29,775.151]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1270.12,787.818],[1270.12,893.311],[1146.29,784.068],[1146.29,887.97]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1393.37,439.684],[1393.37,332.653],[1266.97,441.194],[1266.97,335.787]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1393.37,549.887],[1393.37,442.856],[1266.97,549.726],[1266.97,444.319]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1393.37,559.201],[1393.37,666.233],[1266.97,558.899],[1266.97,664.306]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1393.37,675.226],[1393.37,782.257],[1266.97,673.163],[1266.97,778.57]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1393.37,791.442],[1393.37,898.473],[1266.97,787.616],[1266.97,893.023]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1285.91,336.16],[1285.91,234.198],[1333.03,363.312],[1333.03,274.981]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,436.358],[1562.75,325.753],[1390.33,438.446],[1390.33,330.083]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,550.242],[1562.75,439.637],[1390.33,550.02],[1390.33,441.657]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,559.868],[1562.75,670.474],[1390.33,559.45],[1390.33,667.812]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,679.767],[1562.75,790.373],[1390.33,676.917],[1390.33,785.279]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,799.865],[1390.33,794.578],[1562.75,910.47],[1390.33,902.94]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1697.34,326.005],[1402.59,333.284],[1697.34,218.945],[1402.59,229.878]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,436.358],[1562.75,325.753],[1563.67,437.605],[1563.67,328.338]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,550.242],[1562.75,439.637],[1563.67,550.109],[1563.67,440.843]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,559.868],[1562.75,670.474],[1563.67,559.618],[1563.67,668.884]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,679.767],[1562.75,790.373],[1563.67,678.065],[1563.67,787.331]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1562.75,799.865],[1562.75,910.47],[1563.67,796.708],[1563.67,905.974]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1700.72,435.966],[1563.67,437.605],[1700.72,324.938],[1563.67,328.338]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1700.72,550.284],[1563.67,550.109],[1700.72,439.257],[1563.67,440.843]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1700.72,559.946],[1563.67,559.618],[1700.72,670.974],[1563.67,668.884]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1700.72,680.303],[1563.67,678.065],[1700.72,791.331],[1563.67,787.331]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1700.72,800.859],[1563.67,796.708],[1700.72,911.886],[1563.67,905.974]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1696.84,326.018],[1696.84,218.963],[2013.14,318.206],[2013.14,207.23]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1698.71,436.035],[1838.87,434.359],[1698.71,325.081],[1838.87,321.605]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1698.71,550.277],[1698.71,439.323],[1838.87,550.456],[1838.87,437.701]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1698.71,559.933],[1698.71,670.887],[1838.87,560.268],[1838.87,673.023]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1698.71,680.209],[1838.87,682.497],[1698.71,791.163],[1838.87,795.251]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1698.71,800.685],[1838.87,804.928],[1698.71,911.639],[1838.87,917.682]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1841.5,432.984],[1841.5,318.752],[2033.33,430.662],[2033.33,313.933]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1841.5,550.603],[1841.5,436.37],[2033.33,550.851],[2033.33,434.122]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1841.5,560.544],[1841.5,674.777],[2033.33,561.009],[2033.33,677.738]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1841.5,684.375],[1841.5,798.607],[2033.33,687.546],[2033.33,804.275]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:41,
                    verts:[[1841.5,808.411],[1841.5,922.643],[2033.33,814.292],[2033.33,931.021]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[128.547,452.499],[128.547,359.244],[28.6493,453.346],[28.6493,361.001]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[128.547,548.518],[128.547,455.263],[28.6493,548.428],[28.6493,456.083]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[128.547,556.634],[128.547,649.889],[28.6493,556.464],[28.6493,648.809]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[128.547,657.725],[128.547,750.98],[28.6493,656.568],[28.6493,748.913]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[128.547,758.983],[128.547,852.238],[28.6493,756.838],[28.6493,849.183]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,450.434],[247.501,354.959],[114.53,451.575],[114.53,357.326]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,548.739],[247.501,453.264],[114.53,548.617],[114.53,454.368]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,557.048],[247.501,652.523],[114.53,556.819],[114.53,651.068]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,660.545],[247.501,756.02],[114.53,658.987],[114.53,753.236]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,764.213],[247.501,859.688],[114.53,761.324],[114.53,855.573]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[397.945,355.184],[397.945,262.772],[169.947,359.179],[169.947,268.773]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,450.434],[247.501,354.959],[260.724,451.416],[260.724,356.996]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,548.739],[247.501,453.264],[260.724,548.634],[260.724,454.214]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,557.048],[247.501,652.523],[260.724,556.851],[260.724,651.271]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,660.545],[247.501,756.02],[260.724,659.204],[260.724,753.624]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[247.501,764.213],[247.501,859.688],[260.724,761.727],[260.724,856.147]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[363.94,450.541],[363.94,355.181],[260.724,451.416],[260.724,356.996]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[363.94,548.728],[363.94,453.368],[260.724,548.634],[260.724,454.214]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[363.94,557.026],[363.94,652.386],[260.724,556.851],[260.724,651.271]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[363.94,660.398],[363.94,755.758],[260.724,659.204],[260.724,753.624]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[363.94,763.942],[363.94,859.302],[260.724,761.727],[260.724,856.147]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[471.729,449.628],[471.729,353.286],[366.018,450.524],[366.018,355.145]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[471.729,548.825],[471.729,452.483],[366.018,548.729],[366.018,453.35]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[471.729,557.209],[471.729,653.551],[366.018,557.03],[366.018,652.409]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[471.729,661.646],[471.729,757.987],[366.018,660.423],[366.018,755.801]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[471.729,766.255],[471.729,862.597],[366.018,763.987],[366.018,859.365]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[636.094,351.01],[636.094,256.504],[398.217,355.179],[398.217,262.765]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,447.386],[602.832,348.634],[460.64,448.606],[460.64,351.165]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,549.065],[602.832,450.313],[460.64,548.934],[460.64,451.494]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,557.658],[602.832,656.41],[460.64,557.414],[460.64,654.855]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,664.707],[602.832,763.459],[460.64,663.042],[460.64,760.482]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,771.934],[602.832,870.686],[460.64,768.844],[460.64,866.285]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,447.386],[602.832,348.634],[612.119,448.4],[612.119,350.739]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,549.065],[602.832,450.313],[612.119,548.956],[612.119,451.295]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,557.658],[602.832,656.41],[612.119,557.455],[612.119,655.117]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,664.707],[602.832,763.459],[612.119,663.322],[612.119,760.984]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[602.832,771.934],[602.832,870.686],[612.119,769.365],[612.119,867.026]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.914,447.453],[723.914,348.772],[612.119,448.4],[612.119,350.739]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.914,549.057],[723.914,450.377],[612.119,548.956],[612.119,451.295]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.914,557.645],[723.914,656.325],[612.119,557.455],[612.119,655.117]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.914,664.616],[723.914,763.296],[612.119,663.322],[612.119,760.984]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.914,771.765],[723.914,870.445],[612.119,769.365],[612.119,867.026]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[636.386,351],[636.386,256.488],[739.212,374.97],[739.212,292.493]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.245,447.497],[723.245,348.865],[739.987,449.629],[739.987,353.288]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.245,549.053],[723.245,450.421],[739.987,548.825],[739.987,452.484]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.245,557.636],[723.245,656.268],[739.987,557.209],[739.987,653.55]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.245,664.555],[723.245,763.187],[739.987,661.645],[739.987,757.985]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[723.245,771.651],[723.245,870.283],[739.987,766.253],[739.987,862.594]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1015.95,445.017],[1015.95,343.718],[898.119,446.015],[898.119,345.79]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1015.95,549.318],[1015.95,448.019],[898.119,549.211],[898.119,448.986]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1015.95,558.133],[1015.95,659.432],[898.119,557.933],[898.119,658.158]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1015.95,667.943],[1015.95,769.241],[898.119,666.579],[898.119,766.805]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1015.95,777.935],[1015.95,879.233],[898.119,775.406],[898.119,875.631]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,442.535],[1168.31,338.568],[1010.82,443.886],[1010.82,341.372]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,549.583],[1168.31,445.616],[1010.82,549.438],[1010.82,446.924]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,558.63],[1168.31,662.597],[1010.82,558.36],[1010.82,660.874]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,671.332],[1168.31,775.299],[1010.82,669.487],[1010.82,772.001]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,784.221],[1168.31,888.187],[1010.82,780.799],[1010.82,883.313]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1303.36,339.317],[1303.36,238.94],[1030.94,344.091],[1030.94,246.11]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,442.535],[1168.31,338.568],[1171.52,443.658],[1171.52,340.9]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,549.583],[1168.31,445.616],[1171.52,549.463],[1171.52,446.704]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,558.63],[1168.31,662.597],[1171.52,558.405],[1171.52,661.164]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,671.332],[1168.31,775.299],[1171.52,669.798],[1171.52,772.556]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1168.31,784.221],[1168.31,888.187],[1171.52,781.375],[1171.52,884.133]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1295.35,442.609],[1295.35,338.722],[1171.52,443.658],[1171.52,340.9]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1295.35,549.575],[1295.35,445.688],[1171.52,549.463],[1171.52,446.704]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1295.35,558.615],[1295.35,662.503],[1171.52,558.405],[1171.52,661.164]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1295.35,671.231],[1295.35,775.118],[1171.52,669.798],[1171.52,772.556]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1295.35,784.033],[1171.52,781.375],[1295.35,887.92],[1171.52,884.133]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.48,441.615],[1292.13,442.677],[1417.48,336.659],[1292.13,338.863]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.48,549.681],[1417.48,444.725],[1292.13,549.568],[1292.13,445.754]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.48,558.815],[1417.48,663.77],[1292.13,558.602],[1292.13,662.416]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.48,672.589],[1292.13,671.139],[1417.48,777.545],[1292.13,774.953]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.48,786.552],[1292.13,783.862],[1417.48,891.507],[1292.13,887.676]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1303.7,339.305],[1303.7,238.922],[1322.52,366.134],[1322.52,279.221]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.15,440.4],[1586.46,438.948],[1417.15,334.139],[1586.46,331.125]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.15,549.811],[1417.15,443.55],[1586.46,549.966],[1586.46,442.143]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.15,559.058],[1417.15,665.319],[1586.46,559.349],[1586.46,667.171]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.15,674.247],[1586.46,676.231],[1417.15,780.509],[1586.46,784.053]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1417.15,789.628],[1586.46,793.306],[1417.15,895.889],[1586.46,901.129]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1419.26,337.286],[1419.26,235.889],[1707.08,332.242],[1707.08,228.313]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1584.74,674.581],[1584.74,781.105],[1717.87,676.122],[1717.87,783.859]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1584.74,440.156],[1584.74,333.632],[1717.87,439.027],[1717.87,331.29]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1584.74,549.837],[1584.74,443.313],[1717.87,549.957],[1717.87,442.22]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1584.74,559.107],[1584.74,665.631],[1717.87,559.333],[1717.87,667.07]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1584.74,790.247],[1717.87,793.105],[1584.74,896.771],[1717.87,900.842]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1706.6,332.251],[1706.6,228.326],[2009.15,326.949],[2009.15,220.362]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1715.83,439.087],[1715.83,331.414],[1850.72,437.944],[1850.72,329.042]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1715.83,549.951],[1715.83,442.278],[1850.72,550.073],[1850.72,441.171]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1715.83,559.321],[1715.83,666.994],[1850.72,559.55],[1850.72,668.452]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1715.83,676.041],[1715.83,783.714],[1850.72,677.602],[1850.72,786.504]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1715.83,792.954],[1715.83,900.628],[1850.72,795.849],[1850.72,904.751]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1855.98,436.636],[1855.98,326.328],[2038.53,435.07],[2038.53,323.078]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1855.98,550.213],[1855.98,439.905],[2038.53,550.38],[2038.53,438.389]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1855.98,559.812],[1855.98,670.12],[2038.53,560.126],[2038.53,672.117]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1855.98,679.388],[1855.98,789.696],[2038.53,681.527],[2038.53,793.518]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:42,
                    verts:[[1855.98,799.163],[1855.98,909.47],[2038.53,803.129],[2038.53,915.12]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[116.897,450.236],[116.897,354.547],[9.47202,450.793],[9.47202,355.704]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[116.897,548.76],[116.897,453.072],[9.47202,548.701],[9.47202,453.611]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[116.897,557.087],[116.897,652.776],[9.47202,556.976],[9.47202,652.065]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[116.897,660.816],[116.897,756.504],[9.47202,660.055],[9.47202,755.144]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[116.897,764.716],[116.897,860.404],[9.47202,763.304],[9.47202,858.394]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,448.504],[246.228,350.954],[104.258,449.249],[104.258,352.5]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,548.945],[246.228,451.395],[104.258,548.866],[104.258,452.117]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,557.434],[246.228,654.984],[104.258,557.285],[104.258,654.034]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,663.181],[246.228,760.731],[104.258,662.163],[104.258,758.912]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,769.102],[246.228,866.652],[104.258,767.215],[104.258,863.964]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[395.959,352.12],[395.959,258.171],[154.345,354.712],[154.345,262.064]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,448.504],[246.228,350.954],[257.791,449.542],[257.791,353.108]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,548.945],[246.228,451.395],[257.791,548.834],[257.791,452.4]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,557.434],[246.228,654.984],[257.791,557.226],[257.791,653.66]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,663.181],[246.228,760.731],[257.791,661.763],[257.791,758.197]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[246.228,769.102],[246.228,866.652],[257.791,766.473],[257.791,862.907]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[366.973,448.976],[366.973,351.933],[257.791,449.542],[257.791,353.108]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[366.973,548.895],[366.973,451.852],[257.791,548.834],[257.791,452.4]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[366.973,557.34],[366.973,654.382],[257.791,557.226],[257.791,653.66]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[366.973,662.536],[366.973,759.579],[257.791,661.763],[257.791,758.197]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[366.973,767.907],[366.973,864.949],[257.791,766.473],[257.791,862.907]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[480.153,448.389],[480.153,350.716],[369.163,448.964],[369.163,351.91]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[480.153,548.957],[480.153,451.284],[369.163,548.896],[369.163,451.841]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[480.153,557.457],[480.153,655.131],[369.163,557.342],[369.163,654.397]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[480.153,663.338],[480.153,761.011],[369.163,662.552],[369.163,759.607]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[480.153,769.393],[480.153,867.066],[369.163,767.935],[369.163,864.99]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[644.255,349.456],[644.255,254.169],[396.245,352.117],[396.245,258.166]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,446.547],[619.18,346.893],[471.046,447.324],[471.046,348.506]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,549.154],[619.18,449.5],[471.046,549.071],[471.046,450.253]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,557.826],[619.18,657.48],[471.046,557.671],[471.046,656.489]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,665.854],[619.18,765.508],[471.046,664.792],[471.046,763.61]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,774.06],[619.18,873.714],[471.046,772.091],[471.046,870.909]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,446.547],[619.18,346.893],[626.381,447.593],[626.381,349.064]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,549.154],[619.18,449.5],[626.381,549.042],[626.381,450.513]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,557.826],[619.18,657.48],[626.381,557.617],[626.381,656.146]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,665.854],[619.18,765.508],[626.381,664.425],[626.381,762.954]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[619.18,774.06],[619.18,873.714],[626.381,771.409],[626.381,869.938]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[741.745,446.995],[741.745,347.822],[626.382,447.593],[626.382,349.064]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[741.745,549.106],[741.745,449.934],[626.382,549.042],[626.382,450.513]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[741.745,557.737],[741.745,656.909],[626.382,557.617],[626.382,656.146]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[741.745,665.242],[741.745,764.414],[626.382,664.425],[626.382,762.954]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[741.745,772.925],[741.745,872.097],[626.382,771.409],[626.382,869.938]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[644.563,349.447],[644.563,254.156],[724.034,374.071],[724.034,291.142]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[740.972,447.037],[740.972,347.911],[753.177,449.218],[753.177,352.435]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[740.972,549.102],[740.972,449.975],[753.177,548.869],[753.177,452.086]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[740.972,557.728],[740.972,656.855],[753.177,557.291],[753.177,654.074]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[740.972,665.183],[740.972,764.31],[753.177,662.206],[753.177,758.988]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[740.972,772.817],[740.972,871.943],[753.177,767.294],[753.177,864.076]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1038.86,445.492],[1038.86,344.705],[919.66,446.11],[919.66,345.987]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1038.86,549.267],[1038.86,448.479],[919.66,549.201],[919.66,449.078]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1038.86,558.038],[1038.86,658.825],[919.66,557.914],[919.66,658.037]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1038.86,667.293],[1038.86,768.081],[919.66,666.449],[919.66,766.572]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1038.86,776.73],[1038.86,877.517],[919.66,775.165],[919.66,875.288]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,443.529],[1194.11,340.632],[1036.22,444.358],[1036.22,342.351]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,549.477],[1194.11,446.579],[1036.22,549.388],[1036.22,447.381]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,558.431],[1194.11,661.329],[1036.22,558.265],[1036.22,660.272]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,669.974],[1194.11,772.872],[1036.22,668.843],[1036.22,770.849]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,781.702],[1036.22,779.603],[1194.11,884.6],[1036.22,881.61]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1318.62,342.22],[1047.02,345.134],[1318.62,243.3],[1047.02,247.678]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,443.529],[1194.11,340.632],[1194.84,444.644],[1194.84,342.946]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,549.477],[1194.11,446.579],[1194.84,549.357],[1194.84,447.659]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,558.431],[1194.11,661.329],[1194.84,558.208],[1194.84,659.906]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,669.974],[1194.11,772.872],[1194.84,668.451],[1194.84,770.15]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1194.11,781.702],[1194.11,884.6],[1194.84,778.877],[1194.84,880.576]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1317.77,444.007],[1194.84,444.644],[1317.77,341.623],[1194.84,342.946]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1317.77,549.425],[1194.84,549.357],[1317.77,447.041],[1194.84,447.659]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1317.77,558.335],[1194.84,558.208],[1317.77,660.719],[1194.84,659.906]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1317.77,669.322],[1194.84,668.451],[1317.77,771.706],[1194.84,770.15]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1317.77,780.492],[1194.84,778.877],[1317.77,882.877],[1194.84,880.576]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1314.5,780.35],[1437.92,781.971],[1314.5,882.674],[1437.92,884.982]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1314.5,444.063],[1437.92,443.423],[1314.5,341.739],[1437.92,340.412]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1314.5,549.419],[1314.5,447.096],[1437.92,549.488],[1437.92,446.476]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1314.5,558.324],[1314.5,660.648],[1437.92,558.452],[1437.92,661.464]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1314.5,669.245],[1437.92,670.119],[1314.5,771.569],[1437.92,773.13]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1432.67,340.997],[1432.67,241.462],[1712.06,337.999],[1712.06,236.96]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1440.15,442.238],[1440.15,337.952],[1605.21,441.372],[1605.21,336.155]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1440.15,549.615],[1440.15,445.329],[1605.21,549.707],[1605.21,444.49]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1440.15,558.69],[1440.15,662.975],[1605.21,558.863],[1605.21,664.08]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1440.15,671.738],[1440.15,776.023],[1605.21,672.921],[1605.21,778.138]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1440.15,784.973],[1440.15,889.259],[1605.21,787.167],[1605.21,892.384]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1601.06,558.63],[1601.06,662.593],[1729.55,558.763],[1729.55,663.443]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1601.06,671.329],[1601.06,775.292],[1729.55,672.239],[1729.55,776.919]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1601.06,442.537],[1601.06,338.574],[1729.55,441.871],[1729.55,337.191]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1601.06,549.582],[1601.06,445.619],[1729.55,549.654],[1729.55,444.974]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1601.06,784.214],[1601.06,888.178],[1729.55,785.902],[1729.55,890.582]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1711.59,338.004],[1711.59,236.967],[1999.55,334.914],[1999.55,232.326]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1727.5,441.922],[1727.5,337.296],[1856.54,441.253],[1856.54,335.908]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1727.5,549.648],[1727.5,445.023],[1856.54,549.72],[1856.54,444.375]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1727.5,558.753],[1727.5,663.379],[1856.54,558.887],[1856.54,664.232]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1727.5,672.169],[1727.5,776.795],[1856.54,673.083],[1856.54,778.428]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1727.5,785.773],[1727.5,890.399],[1856.54,787.468],[1856.54,892.813]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1864.13,440.013],[1864.13,333.335],[2036.88,439.106],[2036.88,331.454]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1864.13,549.852],[1864.13,443.175],[2036.88,549.949],[2036.88,442.297]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1864.13,559.136],[1864.13,665.813],[2036.88,559.317],[2036.88,666.969]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1864.13,674.776],[1864.13,781.454],[2036.88,676.015],[2036.88,783.667]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:43,
                    verts:[[1864.13,790.609],[1864.13,897.286],[2036.88,792.905],[2036.88,900.557]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[109.095,447.77],[109.095,349.431],[-5.82396,448.001],[-5.82396,349.91]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[109.095,549.024],[109.095,450.685],[-5.82396,548.999],[-5.82396,450.908]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[109.095,557.581],[109.095,655.92],[-5.82396,557.535],[-5.82396,655.626]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[109.095,664.183],[109.095,762.522],[-5.82396,663.868],[-5.82396,761.958]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[109.095,770.961],[109.095,869.3],[-5.82396,770.376],[-5.82396,868.467]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,446.414],[248.706,346.617],[98.0123,446.72],[98.0123,347.253]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,549.168],[248.706,449.372],[98.0123,549.136],[98.0123,449.668]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,557.853],[248.706,657.65],[98.0123,557.792],[98.0123,657.259]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,666.035],[248.706,765.832],[98.0123,665.617],[98.0123,765.084]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,774.396],[248.706,874.193],[98.0123,773.62],[98.0123,873.087]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[396.793,348.759],[396.793,253.122],[142.101,349.819],[142.101,254.714]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,446.414],[248.706,346.617],[258.438,447.507],[258.438,348.886]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,549.168],[248.706,449.372],[258.438,549.052],[258.438,450.43]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,557.853],[248.706,657.65],[258.438,557.634],[258.438,656.255]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,666.035],[248.706,765.832],[258.438,664.542],[258.438,763.163]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[248.706,774.396],[248.706,874.193],[258.438,771.626],[258.438,870.248]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[373.232,447.277],[373.232,348.407],[258.438,447.507],[258.438,348.886]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[373.232,549.076],[373.232,450.207],[258.438,549.052],[258.438,450.43]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[373.232,557.68],[373.232,656.549],[258.438,557.634],[258.438,656.255]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[373.232,664.857],[373.232,763.726],[258.438,664.542],[258.438,763.163]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[373.232,772.211],[373.232,871.08],[258.438,771.626],[258.438,870.248]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[491.318,447.039],[491.318,347.915],[375.525,447.272],[375.525,348.398]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[491.318,549.102],[491.318,449.977],[375.525,549.077],[375.525,450.203]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[491.318,557.728],[491.318,656.852],[375.525,557.681],[375.525,656.555]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[491.318,665.181],[491.318,764.305],[375.525,664.863],[375.525,763.737]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[491.318,772.812],[491.318,871.936],[375.525,772.222],[375.525,871.096]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[654.141,347.689],[654.141,251.515],[397.092,348.758],[397.092,253.121]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,445.623],[637.593,344.976],[484.326,445.935],[484.326,345.623]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,549.253],[637.593,448.606],[484.326,549.22],[484.326,448.908]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,558.012],[637.593,658.659],[484.326,557.949],[484.326,658.261]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,667.115],[637.593,767.762],[484.326,666.689],[484.326,767.001]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,776.399],[637.593,877.046],[484.326,775.61],[484.326,875.922]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,445.623],[637.593,344.976],[642.613,446.697],[642.613,347.206]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,549.253],[637.593,448.606],[642.613,549.138],[642.613,449.646]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,558.012],[637.593,658.659],[642.613,557.796],[642.613,657.288]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,667.115],[637.593,767.762],[642.613,665.648],[642.613,765.139]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[637.593,776.399],[637.593,877.046],[642.613,773.677],[642.613,873.169]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[760.843,446.46],[760.843,346.713],[642.613,446.697],[642.613,347.206]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[760.843,549.164],[760.843,449.416],[642.613,549.138],[642.613,449.646]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[760.843,557.844],[760.843,657.591],[642.613,557.796],[642.613,657.288]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[760.843,665.972],[760.843,765.719],[642.613,665.648],[642.613,765.139]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[760.843,774.279],[760.843,874.026],[642.613,773.677],[642.613,873.169]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[654.462,347.682],[654.462,251.505],[709.785,372.888],[709.785,289.365]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[759.969,446.5],[759.969,346.796],[767.51,448.721],[767.51,351.404]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[759.969,549.159],[759.969,449.455],[767.51,548.922],[767.51,451.605]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[759.969,557.836],[759.969,657.54],[767.51,557.391],[767.51,654.708]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[759.969,665.917],[759.969,765.621],[767.51,662.884],[767.51,760.201]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[759.969,774.177],[759.969,873.881],[767.51,768.552],[767.51,865.869]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1061.02,445.895],[941.283,446.135],[1061.02,345.54],[941.283,346.039]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1061.02,549.224],[1061.02,448.869],[941.283,549.198],[941.283,449.102]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1061.02,557.957],[1061.02,658.312],[941.283,557.909],[941.283,658.005]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1061.02,666.744],[941.283,666.415],[1061.02,767.099],[941.283,766.511]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1061.02,775.711],[941.283,775.101],[1061.02,876.065],[941.283,875.198]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1060.85,444.762],[1218,444.443],[1060.85,343.19],[1218,342.527]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1060.85,549.345],[1060.85,447.773],[1218,549.379],[1218,447.463]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1060.85,558.184],[1060.85,659.756],[1218,558.248],[1218,660.164]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1060.85,668.291],[1218,668.727],[1060.85,769.863],[1218,770.643]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1060.85,778.579],[1218,779.389],[1060.85,880.152],[1218,881.305]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1062.42,345.991],[1062.42,248.964],[1331.52,344.871],[1331.52,247.283]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1216.33,667.222],[1216.33,767.954],[1337.53,667.555],[1337.53,768.548]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1216.33,445.544],[1216.33,344.813],[1337.53,445.301],[1337.53,344.307]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1216.33,549.261],[1216.33,448.53],[1337.53,549.287],[1337.53,448.294]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1216.33,558.027],[1216.33,658.759],[1337.53,558.076],[1337.53,659.069]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1216.33,776.598],[1337.53,777.215],[1216.33,877.33],[1337.53,878.208]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1334.24,445.346],[1334.24,344.401],[1454.94,445.103],[1454.94,343.898]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1334.24,549.283],[1334.24,448.338],[1454.94,549.308],[1454.94,448.103]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1334.24,558.067],[1334.24,659.012],[1454.94,558.116],[1454.94,659.321]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1334.24,667.494],[1334.24,768.438],[1454.94,667.825],[1454.94,769.03]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1334.24,777.101],[1334.24,878.046],[1454.94,777.715],[1454.94,878.921]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1443.07,344.407],[1443.07,246.586],[1712.78,343.286],[1712.78,244.901]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1459.59,443.951],[1459.59,341.507],[1619.45,443.626],[1619.45,340.833]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1459.59,549.431],[1459.59,446.988],[1619.45,549.466],[1619.45,446.673]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1459.59,558.346],[1459.59,660.79],[1619.45,558.412],[1619.45,661.205]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1459.59,669.398],[1459.59,771.842],[1619.45,669.842],[1619.45,772.635]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1459.59,780.633],[1459.59,883.077],[1619.45,781.457],[1619.45,884.25]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1613.07,668.311],[1613.07,769.9],[1736.34,668.65],[1736.34,770.505]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1613.07,778.618],[1613.07,880.207],[1736.34,779.246],[1736.34,881.101]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1613.07,444.747],[1613.07,343.158],[1736.34,444.499],[1736.34,342.644]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1613.07,549.346],[1613.07,447.758],[1736.34,549.373],[1736.34,447.518]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1613.07,558.187],[1613.07,659.776],[1736.34,558.237],[1736.34,660.092]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1712.34,343.288],[1712.34,244.904],[1985.17,342.153],[1985.17,243.199]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1734.3,444.542],[1734.3,342.733],[1857.08,444.295],[1857.08,342.221]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1734.3,549.368],[1734.3,447.559],[1857.08,549.395],[1857.08,447.321]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1734.3,558.228],[1734.3,660.037],[1857.08,558.278],[1857.08,660.352]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1734.3,668.591],[1734.3,770.4],[1857.08,668.928],[1857.08,771.002]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1734.3,779.137],[1734.3,880.946],[1857.08,779.762],[1857.08,881.836]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1866.73,443.123],[1866.73,339.789],[2029.39,442.792],[2029.39,339.103]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1866.73,549.52],[1866.73,446.186],[2029.39,549.555],[2029.39,445.866]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1866.73,558.512],[1866.73,661.846],[2029.39,558.579],[2029.39,662.268]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1866.73,670.529],[1866.73,773.863],[2029.39,670.98],[2029.39,774.67]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:44,
                    verts:[[1866.73,782.73],[1866.73,886.064],[2029.39,783.568],[2029.39,887.258]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[105.375,445.082],[105.375,343.853],[-16.9639,444.944],[-16.9639,343.568]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[105.375,549.311],[105.375,448.082],[-16.9639,549.325],[-16.9639,447.949]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[105.375,558.12],[105.375,659.348],[-16.9639,558.148],[-16.9639,659.524]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[105.375,667.854],[105.375,769.082],[-16.9639,668.042],[-16.9639,769.418]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[105.375,777.77],[105.375,878.998],[-16.9639,778.118],[-16.9639,879.494]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[255.107,444.149],[255.107,341.918],[96.0415,443.968],[96.0415,341.542]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[255.107,549.41],[255.107,447.179],[96.0415,549.43],[96.0415,447.004]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[255.107,558.307],[255.107,660.538],[96.0415,558.343],[96.0415,660.769]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[255.107,669.128],[255.107,771.359],[96.0415,669.375],[96.0415,771.801]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[255.107,780.132],[255.107,882.363],[96.0415,780.59],[96.0415,883.016]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[400.532,345.076],[400.532,247.591],[133.396,344.455],[133.396,246.657]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[382.822,445.432],[382.822,344.58],[262.827,445.297],[262.827,344.301]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[382.822,549.273],[382.822,448.421],[262.827,549.288],[262.827,448.291]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[382.822,558.05],[382.822,658.902],[262.827,558.077],[262.827,659.074]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[382.822,667.375],[382.822,768.227],[262.827,667.56],[262.827,768.556]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[382.822,776.882],[382.822,877.734],[262.827,777.224],[262.827,878.22]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[505.275,445.57],[505.275,344.866],[385.209,445.435],[385.209,344.586]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[505.275,549.258],[505.275,448.555],[385.209,549.273],[385.209,448.424]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[505.275,558.022],[505.275,658.726],[385.209,558.049],[385.209,658.898]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[505.275,667.187],[505.275,767.891],[385.209,667.372],[385.209,768.221]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[505.275,776.533],[505.275,877.237],[385.209,776.875],[385.209,877.724]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[665.755,345.694],[665.755,248.518],[400.843,345.077],[400.843,247.592]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[658.066,444.608],[658.066,342.869],[500.532,444.428],[500.532,342.498]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[658.066,549.361],[658.066,447.623],[500.532,549.38],[500.532,447.45]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[658.066,558.215],[658.066,659.953],[500.532,558.251],[500.532,660.182]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[658.066,668.501],[658.066,770.24],[500.532,668.746],[500.532,770.677]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[658.066,778.971],[658.066,880.709],[500.532,779.425],[500.532,881.355]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[781.182,445.842],[781.182,345.431],[660.812,445.707],[660.812,345.15]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[781.182,549.23],[781.182,448.818],[660.812,549.244],[660.812,448.687]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[781.182,557.968],[781.182,658.379],[660.812,557.995],[660.812,658.552]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[781.182,666.816],[781.182,767.227],[660.812,667.001],[660.812,767.558]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[781.182,775.844],[660.812,776.187],[781.182,876.256],[660.812,876.744]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.951,446.113],[962.951,345.994],[961.193,448.506],[961.193,350.959]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.951,549.201],[962.951,449.081],[961.193,548.945],[961.193,451.398]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.951,557.913],[962.951,658.033],[961.193,557.434],[961.193,654.981]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.951,666.445],[962.951,766.565],[961.193,663.177],[961.193,760.725]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.951,775.157],[962.951,875.276],[961.193,769.096],[961.193,866.643]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.959,446.085],[962.959,345.934],[1082.42,446.219],[1082.42,346.213]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.959,549.204],[962.959,449.053],[1082.42,549.189],[1082.42,449.183]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.959,557.919],[962.959,658.07],[1082.42,557.892],[1082.42,657.898]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.959,666.485],[1082.42,666.301],[962.959,766.635],[1082.42,766.307]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[962.959,775.23],[1082.42,774.89],[962.959,875.38],[1082.42,874.896]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1077.66,346.647],[1077.66,249.95],[1053.43,372.127],[1053.43,288.222]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1077.13,346.651],[1077.13,249.956],[1342.18,347.268],[1342.18,250.882]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,445.093],[1084.69,343.877],[1082.42,446.219],[1082.42,346.213]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,549.31],[1084.69,448.093],[1082.42,549.189],[1082.42,449.183]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,558.118],[1084.69,659.334],[1082.42,557.892],[1082.42,657.898]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,667.838],[1084.69,769.055],[1082.42,666.301],[1082.42,766.307]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,777.741],[1084.69,878.957],[1082.42,774.89],[1082.42,874.896]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,445.093],[1084.69,343.877],[1240.03,445.27],[1240.03,344.244]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,549.31],[1084.69,448.093],[1240.03,549.291],[1240.03,448.264]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,558.118],[1084.69,659.334],[1240.03,558.082],[1240.03,659.109]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,667.838],[1084.69,769.055],[1240.03,667.597],[1240.03,768.623]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1084.69,777.741],[1084.69,878.957],[1240.03,777.293],[1240.03,878.319]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1236.04,666.117],[1236.04,765.979],[1354.76,665.935],[1354.76,765.653]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1236.04,446.354],[1236.04,346.492],[1354.76,446.487],[1354.76,346.769]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1236.04,549.175],[1236.04,449.313],[1354.76,549.161],[1354.76,449.443]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1236.04,557.865],[1236.04,657.727],[1354.76,557.838],[1354.76,657.556]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1236.04,774.548],[1236.04,874.41],[1354.76,774.21],[1354.76,873.928]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1351.46,446.521],[1351.46,346.84],[1468.76,446.653],[1468.76,347.114]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1351.46,549.157],[1351.46,449.476],[1468.76,549.143],[1468.76,449.603]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1351.46,557.832],[1351.46,657.513],[1468.76,557.805],[1468.76,657.344]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1351.46,665.888],[1351.46,765.569],[1468.76,665.708],[1468.76,765.247]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1351.46,774.124],[1351.46,873.805],[1468.76,773.79],[1468.76,873.329]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1451.19,347.516],[1451.19,251.256],[1377.84,372.782],[1377.84,289.205]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1450.66,347.52],[1450.66,251.262],[1709.68,348.123],[1709.68,252.167]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,445.538],[1475.68,344.8],[1468.76,446.653],[1468.76,347.114]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,549.262],[1475.68,448.524],[1468.76,549.143],[1468.76,449.603]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,558.029],[1475.68,658.767],[1468.76,557.805],[1468.76,657.344]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,667.231],[1475.68,767.969],[1468.76,665.708],[1468.76,765.247]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,776.614],[1475.68,877.352],[1468.76,773.79],[1468.76,873.329]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,445.538],[1475.68,344.8],[1629.55,445.713],[1629.55,345.163]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,549.262],[1475.68,448.524],[1629.55,549.243],[1629.55,448.693]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,558.029],[1475.68,658.767],[1629.55,557.993],[1629.55,658.543]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,667.231],[1475.68,767.969],[1629.55,666.992],[1629.55,767.542]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1475.68,776.614],[1475.68,877.352],[1629.55,776.17],[1629.55,876.72]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1621.12,665.526],[1621.12,764.922],[1738.72,665.345],[1738.72,764.599]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1621.12,446.787],[1621.12,347.391],[1738.72,446.919],[1738.72,347.665]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1621.12,549.129],[1621.12,449.733],[1738.72,549.114],[1738.72,449.861]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1621.12,557.778],[1621.12,657.174],[1738.72,557.752],[1738.72,657.005]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1621.12,773.451],[1621.12,872.847],[1738.72,773.116],[1738.72,872.37]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1709.26,348.122],[1709.26,252.166],[1966.65,348.721],[1966.65,253.066]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1736.7,446.954],[1736.7,347.739],[1852.92,447.085],[1852.92,348.01]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1736.7,549.111],[1736.7,449.895],[1852.92,549.097],[1852.92,450.022]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1736.7,557.745],[1736.7,656.96],[1852.92,557.719],[1852.92,656.794]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1736.7,665.297],[1736.7,764.512],[1852.92,665.118],[1852.92,764.193]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1736.7,773.027],[1736.7,872.242],[1852.92,772.696],[1852.92,871.771]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,445.98],[1864.4,345.718],[1852.92,447.085],[1852.92,348.01]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,549.215],[1864.4,448.952],[1852.92,549.097],[1852.92,450.022]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,557.94],[1864.4,658.203],[1852.92,557.719],[1852.92,656.794]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,666.627],[1864.4,766.889],[1852.92,665.118],[1852.92,764.193]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,775.494],[1864.4,875.756],[1852.92,772.696],[1852.92,871.771]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,445.98],[1864.4,345.718],[2016.83,446.154],[2016.83,346.078]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,549.215],[1864.4,448.952],[2016.83,549.196],[2016.83,449.12]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,557.94],[1864.4,658.203],[2016.83,557.905],[2016.83,657.981]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,666.627],[1864.4,766.889],[2016.83,666.39],[2016.83,766.466]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:45,
                    verts:[[1864.4,775.494],[1864.4,875.756],[2016.83,775.054],[2016.83,875.13]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[106.074,442.152],[106.074,337.773],[-23.5436,441.596],[-23.5436,336.621]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[106.074,549.624],[106.074,445.245],[-23.5436,549.683],[-23.5436,444.708]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[106.074,558.707],[106.074,663.085],[-23.5436,558.818],[-23.5436,663.794]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[106.074,671.855],[106.074,776.234],[-23.5436,672.614],[-23.5436,777.589]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[106.074,785.191],[106.074,889.569],[-23.5436,786.598],[-23.5436,891.573]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[265.69,441.698],[265.69,336.831],[98.7064,440.973],[98.7064,335.329]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[265.69,549.672],[265.69,444.806],[98.7064,549.75],[98.7064,444.105]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[265.69,558.798],[265.69,663.664],[98.7064,558.943],[98.7064,664.588]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[265.69,672.476],[265.69,777.342],[98.7064,673.464],[98.7064,779.109]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[265.69,786.341],[265.69,891.208],[98.7064,788.175],[98.7064,893.82]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[407.325,341.049],[407.325,241.542],[128.512,338.577],[128.512,237.829]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[395.915,443.433],[395.915,340.433],[271.203,442.899],[271.203,339.324]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[395.915,549.487],[395.915,446.486],[271.203,549.544],[271.203,445.969]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[395.915,558.45],[395.915,661.451],[271.203,558.557],[271.203,662.132]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[395.915,670.105],[395.915,773.105],[271.203,670.835],[271.203,774.409]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[395.915,781.945],[395.915,884.945],[271.203,783.298],[271.203,886.873]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[522.13,443.974],[522.13,341.555],[398.386,443.444],[398.386,340.455]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[522.13,549.429],[522.13,447.01],[398.386,549.486],[398.386,446.497]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[522.13,558.342],[522.13,660.761],[398.386,558.448],[398.386,661.437]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[522.13,669.367],[522.13,771.786],[398.386,670.091],[398.386,773.08]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[522.13,780.575],[522.13,882.994],[398.386,781.918],[398.386,884.907]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[679.137,343.459],[679.137,245.162],[407.647,341.052],[407.647,241.546]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[680.632,443.497],[680.632,340.565],[519.773,442.799],[519.773,339.117]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[680.632,549.48],[680.632,446.548],[519.773,549.555],[519.773,445.872]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[680.632,558.438],[680.632,661.37],[519.773,558.577],[519.773,662.259]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[680.632,670.018],[519.773,670.971],[680.632,772.951],[519.773,774.653]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[680.632,781.784],[519.773,783.551],[680.632,884.716],[519.773,887.233]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[681.013,444.616],[802.761,445.138],[681.013,342.886],[802.761,343.969]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[681.013,549.36],[802.761,549.305],[681.013,447.631],[802.761,448.136]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[681.013,558.213],[802.761,558.109],[681.013,659.943],[802.761,659.277]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[681.013,668.49],[802.761,667.778],[681.013,770.22],[802.761,768.946]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[681.013,778.95],[802.761,777.628],[681.013,880.679],[802.761,878.797]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.597,445.985],[984.597,345.726],[977.652,448.372],[977.652,350.68]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.597,549.214],[984.597,448.956],[977.652,548.959],[977.652,451.267]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.597,557.939],[984.597,658.197],[977.652,557.461],[977.652,655.153]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.597,666.621],[984.597,766.879],[977.652,663.361],[977.652,761.053]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.597,775.483],[984.597,875.741],[977.652,769.437],[977.652,867.129]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.667,445.956],[984.667,345.667],[1103.06,446.463],[1103.06,346.719]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.667,549.217],[984.667,448.928],[1103.06,549.163],[1103.06,449.419]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.667,557.945],[984.667,658.234],[1103.06,557.843],[1103.06,657.587]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.667,666.661],[984.667,766.95],[1103.06,665.968],[1103.06,765.712]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[984.667,775.556],[984.667,875.845],[1103.06,774.272],[1103.06,874.016]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1091.7,347.112],[1091.7,250.648],[1041.97,372.362],[1041.97,288.575]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1091.18,347.113],[1091.18,250.649],[1350.69,349.413],[1350.69,254.105]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,445.349],[1107.74,344.408],[1103.06,446.463],[1103.06,346.719]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,549.282],[1107.74,448.341],[1103.06,549.163],[1103.06,449.419]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,558.066],[1107.74,659.008],[1103.06,557.843],[1103.06,657.587]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,667.489],[1107.74,768.43],[1103.06,665.968],[1103.06,765.712]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,777.093],[1107.74,878.034],[1103.06,774.272],[1103.06,874.016]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,445.349],[1107.74,344.408],[1260.24,446.01],[1260.24,345.78]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,549.282],[1107.74,448.341],[1260.24,549.212],[1260.24,448.981]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,558.066],[1107.74,659.008],[1260.24,557.934],[1260.24,658.164]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,667.489],[1107.74,768.43],[1260.24,666.586],[1260.24,766.816]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1107.74,777.093],[1107.74,878.034],[1260.24,775.418],[1260.24,875.648]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1254.01,557.721],[1254.01,656.811],[1369.54,557.622],[1369.54,656.18]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1254.01,665.137],[1254.01,764.226],[1369.54,664.46],[1369.54,763.018]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1254.01,447.072],[1254.01,347.982],[1369.54,447.567],[1369.54,349.009]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1254.01,549.098],[1254.01,450.009],[1369.54,549.045],[1369.54,450.488]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1254.01,772.73],[1254.01,871.819],[1369.54,771.476],[1369.54,870.033]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1456.1,350.343],[1456.1,255.501],[1359.91,374.805],[1359.91,292.245]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1366.26,771.416],[1366.26,869.947],[1479.55,770.186],[1479.55,868.196]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1366.26,447.59],[1366.26,349.059],[1479.55,448.076],[1479.55,350.066]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1366.26,549.043],[1366.26,450.511],[1479.55,548.991],[1479.55,450.981]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1366.26,557.617],[1366.26,656.149],[1479.55,557.52],[1479.55,655.53]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1366.26,664.428],[1366.26,762.96],[1479.55,663.765],[1479.55,761.775]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1455.59,350.344],[1455.59,255.502],[1703.05,352.538],[1703.05,258.798]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,447.001],[1488.59,347.835],[1479.55,448.076],[1479.55,350.066]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,549.106],[1488.59,449.94],[1479.55,548.991],[1479.55,450.981]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,557.736],[1488.59,656.902],[1479.55,557.52],[1479.55,655.53]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,665.234],[1488.59,764.4],[1479.55,663.765],[1479.55,761.775]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,772.91],[1488.59,872.076],[1479.55,770.186],[1479.55,868.196]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,447.001],[1488.59,347.835],[1635.79,447.639],[1635.79,349.159]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,549.106],[1488.59,449.94],[1635.79,549.038],[1635.79,450.558]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,557.736],[1488.59,656.901],[1635.79,557.608],[1635.79,656.087]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,665.234],[1488.59,764.4],[1635.79,664.362],[1635.79,762.842]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1488.59,772.91],[1488.59,872.076],[1635.79,771.293],[1635.79,869.773]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1625.47,662.963],[1625.47,760.341],[1737.05,662.31],[1737.05,759.174]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1625.47,448.664],[1625.47,351.285],[1737.05,449.142],[1737.05,352.278]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1625.47,548.928],[1625.47,451.55],[1737.05,548.877],[1737.05,452.013]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1625.47,557.402],[1625.47,654.781],[1737.05,557.307],[1737.05,654.171]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1625.47,768.698],[1625.47,866.076],[1737.05,767.486],[1737.05,864.351]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1702.65,352.534],[1702.65,258.792],[1944.43,354.678],[1944.43,262.012]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1735.06,767.414],[1735.06,864.247],[1844.49,766.227],[1844.49,862.556]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1735.06,449.17],[1735.06,352.337],[1844.49,449.639],[1844.49,353.31]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1735.06,548.874],[1735.06,452.041],[1844.49,548.824],[1844.49,452.494]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1735.06,557.301],[1735.06,654.134],[1844.49,557.207],[1844.49,653.536]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1735.06,662.27],[1735.06,759.104],[1844.49,661.63],[1844.49,757.96]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,448.601],[1857.6,351.155],[1844.49,449.639],[1844.49,353.31]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,548.935],[1857.6,451.489],[1844.49,548.824],[1844.49,452.494]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,557.415],[1857.6,654.861],[1844.49,557.207],[1844.49,653.536]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,663.048],[1857.6,760.494],[1844.49,661.63],[1844.49,757.96]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,768.857],[1857.6,866.303],[1844.49,766.227],[1844.49,862.556]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,448.601],[1857.6,351.155],[1999.75,449.217],[1999.75,352.434]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,548.935],[1857.6,451.489],[1999.75,548.869],[1999.75,452.086]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,557.415],[1857.6,654.861],[1999.75,557.291],[1999.75,654.075]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,663.048],[1857.6,760.494],[1999.75,662.206],[1999.75,758.99]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:46,
                    verts:[[1857.6,768.857],[1857.6,866.303],[1999.75,767.295],[1999.75,864.079]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[111.661,438.961],[111.661,331.154],[-25.0037,437.931],[-25.0037,329.015]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[111.661,549.964],[111.661,442.157],[-25.0037,550.075],[-25.0037,441.159]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[111.661,559.346],[111.661,667.154],[-25.0037,559.553],[-25.0037,668.469]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[111.661,676.212],[111.661,784.02],[-25.0037,677.62],[-25.0037,786.536]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[111.661,793.271],[111.661,901.079],[-25.0037,795.883],[-25.0037,904.798]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[280.805,439.049],[280.805,331.336],[106.495,437.718],[106.495,328.575]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[280.805,549.955],[280.805,442.242],[106.495,550.097],[106.495,440.953]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[280.805,559.329],[280.805,667.042],[106.495,559.595],[106.495,668.739]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[280.805,676.092],[280.805,783.806],[106.495,677.91],[106.495,787.054]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[280.805,793.05],[280.805,900.763],[106.495,796.42],[106.495,905.564]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[417.388,336.662],[417.388,234.951],[127.847,332.146],[127.847,228.168]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[412.752,441.274],[412.752,335.952],[283.901,440.302],[283.901,333.936]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[412.752,549.717],[412.752,444.395],[283.901,549.821],[283.901,443.455]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[412.752,558.883],[412.752,664.205],[283.901,559.078],[283.901,665.444]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[412.752,673.054],[412.752,778.376],[283.901,674.381],[283.901,780.748]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[412.752,787.415],[283.901,789.876],[412.752,892.737],[283.901,896.242]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.033,442.248],[415.294,441.293],[542.033,337.974],[415.294,335.991]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.033,549.613],[542.033,445.339],[415.294,549.715],[415.294,444.414]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.033,558.688],[415.294,558.879],[542.033,662.962],[415.294,664.181]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.033,671.723],[415.294,673.028],[542.033,775.997],[415.294,778.33]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.033,784.946],[415.294,787.366],[542.033,889.22],[415.294,892.668]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[417.718,336.667],[694.353,340.981],[417.718,234.959],[694.353,241.44]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.202,441.045],[705.348,442.29],[542.202,335.476],[705.348,338.06]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.202,549.742],[542.202,444.173],[705.348,549.609],[705.348,445.379]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.202,558.929],[542.202,664.497],[705.348,558.679],[705.348,662.909]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.202,673.367],[705.348,671.667],[542.202,778.936],[705.348,775.896]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[542.202,787.995],[705.348,784.841],[542.202,893.564],[705.348,889.071]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[703.279,443.424],[703.279,340.414],[825.592,444.347],[825.592,342.328]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[703.279,670.118],[703.279,773.128],[825.592,668.858],[825.592,770.876]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[703.279,781.968],[825.592,779.631],[703.279,884.978],[825.592,881.65]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[703.279,549.488],[703.279,446.477],[825.592,549.389],[825.592,447.371]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[703.279,558.452],[703.279,661.462],[825.592,558.267],[825.592,660.286]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.25,445.779],[1006.25,345.299],[994.131,448.15],[994.131,350.219]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.25,549.236],[1006.25,448.757],[994.131,548.983],[994.131,451.052]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.25,557.98],[1006.25,658.46],[994.131,557.505],[994.131,655.436]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.25,666.902],[1006.25,767.382],[994.131,663.664],[994.131,761.595]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.25,776.005],[1006.25,876.484],[994.131,769.999],[994.131,867.93]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.39,445.75],[1006.39,345.239],[1122.92,446.628],[1122.92,347.063]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.39,549.239],[1006.39,448.729],[1122.92,549.146],[1122.92,449.58]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.39,557.986],[1006.39,658.497],[1122.92,557.81],[1122.92,657.376]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.39,666.942],[1006.39,767.452],[1122.92,665.742],[1122.92,765.308]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1006.39,776.078],[1006.39,876.588],[1122.92,773.852],[1122.92,873.418]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1105.06,347.382],[1105.06,251.053],[1030.12,372.317],[1030.12,288.508]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1104.55,347.379],[1104.55,251.049],[1357.11,351.318],[1357.11,256.966]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,445.531],[1129.96,344.786],[1122.92,446.628],[1122.92,347.063]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,549.263],[1129.96,448.517],[1122.92,549.146],[1122.92,449.58]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,558.03],[1129.96,658.775],[1122.92,557.81],[1122.92,657.376]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,667.24],[1129.96,767.985],[1122.92,665.742],[1122.92,765.308]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,776.631],[1129.96,877.376],[1122.92,773.852],[1122.92,873.418]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,445.531],[1129.96,344.786],[1278.63,446.666],[1278.63,347.141]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,549.263],[1129.96,448.517],[1278.63,549.141],[1278.63,449.616]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,558.03],[1129.96,658.775],[1278.63,557.802],[1278.63,657.328]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,667.24],[1129.96,767.985],[1278.63,665.69],[1278.63,765.216]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1129.96,776.631],[1129.96,877.376],[1278.63,773.756],[1278.63,873.282]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1270.25,557.595],[1270.25,656.008],[1381.93,557.426],[1381.93,654.934]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1270.25,664.277],[1270.25,762.69],[1381.93,663.127],[1381.93,760.634]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1270.25,447.701],[1270.25,349.288],[1381.93,448.543],[1381.93,351.036]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1270.25,549.031],[1270.25,450.618],[1381.93,548.941],[1381.93,451.434]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1270.25,771.136],[1270.25,869.549],[1381.93,769.002],[1381.93,866.509]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1458.45,352.893],[1458.45,259.332],[1340.62,376.505],[1340.62,294.798]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1378.7,448.557],[1378.7,351.064],[1487.41,449.377],[1487.41,352.765]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1378.7,548.94],[1378.7,451.447],[1487.41,548.852],[1487.41,452.24]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1378.7,557.424],[1378.7,654.917],[1487.41,557.259],[1487.41,653.871]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1378.7,663.108],[1378.7,760.601],[1487.41,661.989],[1487.41,758.6]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1378.7,768.967],[1378.7,866.46],[1487.41,766.891],[1487.41,863.503]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1457.96,352.891],[1457.96,259.328],[1693.1,356.558],[1693.1,264.837]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,448.344],[1498.43,350.623],[1487.41,449.377],[1487.41,352.765]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,548.962],[1498.43,451.241],[1487.41,548.852],[1487.41,452.24]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,557.466],[1498.43,655.188],[1487.41,557.259],[1487.41,653.871]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,663.399],[1498.43,761.12],[1487.41,661.989],[1487.41,758.6]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,769.507],[1498.43,867.228],[1487.41,766.891],[1487.41,863.503]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,448.344],[1498.43,350.623],[1638.36,449.412],[1638.36,352.839]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,548.962],[1498.43,451.241],[1638.36,548.848],[1638.36,452.275]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,557.466],[1498.43,655.188],[1638.36,557.252],[1638.36,653.826]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,663.399],[1498.43,761.12],[1638.36,661.94],[1638.36,758.513]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1498.43,769.507],[1498.43,867.228],[1638.36,766.801],[1638.36,863.374]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1626.32,660.609],[1626.32,756.135],[1731.58,659.525],[1731.58,754.197]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1626.32,450.387],[1626.32,354.861],[1731.58,451.181],[1731.58,356.509]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1626.32,548.744],[1626.32,453.218],[1731.58,548.659],[1731.58,453.987]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1626.32,557.057],[1626.32,652.583],[1731.58,556.898],[1731.58,651.57]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1626.32,764.333],[1626.32,859.858],[1731.58,762.321],[1731.58,856.994]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1692.73,356.552],[1692.73,264.828],[1918.81,360.078],[1918.81,270.124]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1729.63,451.203],[1729.63,356.555],[1832.12,451.976],[1832.12,358.158]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1729.63,548.657],[1729.63,454.008],[1832.12,548.574],[1832.12,454.757]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1729.63,556.894],[1729.63,651.542],[1832.12,556.739],[1832.12,650.556]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1729.63,659.494],[1729.63,754.143],[1832.12,658.439],[1832.12,752.257]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1729.63,762.265],[1729.63,856.914],[1832.12,760.308],[1832.12,854.125]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,451.003],[1846.66,356.138],[1832.12,451.976],[1832.12,358.158]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,548.678],[1846.66,453.814],[1832.12,548.574],[1832.12,454.757]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,556.934],[1846.66,651.798],[1832.12,556.739],[1832.12,650.556]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,659.768],[1846.66,754.632],[1832.12,658.439],[1832.12,752.257]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,762.773],[1846.66,857.637],[1832.12,760.308],[1832.12,854.126]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,451.003],[1846.66,356.139],[1978.57,452.01],[1978.57,358.228]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,548.678],[1846.66,453.814],[1978.57,548.571],[1978.57,454.789]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,556.934],[1846.66,651.798],[1978.57,556.732],[1978.57,650.514]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,659.768],[1846.66,754.632],[1978.57,658.393],[1978.57,752.175]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:47,
                    verts:[[1846.66,762.773],[1846.66,857.637],[1978.57,760.223],[1978.57,854.005]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[122.746,435.496],[122.746,323.963],[-20.5963,433.923],[-20.5963,320.699]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[122.746,550.335],[122.746,438.802],[-20.5963,550.503],[-20.5963,437.279]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[122.746,560.041],[122.746,671.573],[-20.5963,560.356],[-20.5963,673.579]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[122.746,680.945],[122.746,792.477],[-20.5963,683.093],[-20.5963,796.316]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[122.746,802.049],[122.746,913.582],[-20.5963,806.033],[-20.5963,919.257]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[300.903,436.198],[300.903,325.42],[120.047,434.189],[120.047,321.251]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[300.903,550.26],[300.903,439.481],[120.047,550.474],[120.047,437.536]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[300.903,559.9],[300.903,670.678],[120.047,560.302],[120.047,673.24]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[300.903,679.986],[120.047,682.73],[300.903,790.764],[120.047,795.668]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[300.903,800.271],[120.047,805.36],[300.903,911.049],[120.047,918.298]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[431.007,331.903],[131.938,325.124],[431.007,227.804],[131.938,217.621]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[301.358,437.5],[433.645,438.951],[301.358,328.121],[433.645,331.132]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[301.358,550.121],[433.645,549.966],[301.358,440.742],[433.645,442.147]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[301.358,559.639],[433.645,559.348],[301.358,669.018],[433.645,667.167]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[301.358,678.208],[433.645,676.227],[301.358,787.587],[433.645,784.046]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[301.358,796.974],[433.645,793.298],[301.358,906.352],[433.645,901.117]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[431.345,331.911],[431.345,227.816],[711.5,338.262],[711.5,237.355]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[436.243,438.979],[436.243,331.191],[565.185,440.394],[565.185,334.126]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[436.243,549.963],[436.243,442.174],[565.185,549.811],[565.185,443.543]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[436.243,559.343],[436.243,667.131],[565.185,559.059],[565.185,665.327]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[436.243,676.188],[565.185,674.256],[436.243,783.976],[565.185,780.524]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[436.243,793.226],[565.185,789.644],[436.243,901.014],[565.185,895.912]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,439.165],[568.021,331.577],[565.185,440.394],[565.185,334.126]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,549.943],[568.021,442.354],[565.185,549.811],[565.185,443.543]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,559.305],[568.021,666.894],[565.185,559.059],[565.185,665.327]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,675.934],[568.021,783.522],[565.185,674.256],[565.185,780.524]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,792.755],[568.021,900.343],[565.185,789.644],[565.185,895.912]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,439.165],[568.021,331.577],[732.299,440.99],[732.299,335.364]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,549.943],[568.021,442.354],[732.299,549.748],[732.299,444.121]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,559.305],[568.021,666.894],[732.299,558.94],[732.299,664.566]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,675.934],[568.021,783.522],[732.299,673.441],[732.299,779.068]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[568.021,792.755],[568.021,900.343],[732.299,788.133],[732.299,893.759]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[727.695,442.135],[727.695,337.738],[849.7,443.474],[849.7,340.516]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[727.695,549.625],[727.695,445.229],[849.7,549.482],[849.7,446.525]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[727.695,558.71],[727.695,663.107],[849.7,558.442],[849.7,661.4]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[727.695,671.879],[727.695,776.275],[849.7,670.05],[849.7,773.008]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[727.695,785.234],[727.695,889.631],[849.7,781.843],[849.7,884.8]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1027.89,445.5],[1027.89,344.721],[1010.62,447.844],[1010.62,349.584]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1027.89,549.266],[1027.89,448.487],[1010.62,549.016],[1010.62,450.756]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1027.89,558.036],[1027.89,658.815],[1010.62,557.567],[1010.62,655.826]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1027.89,667.283],[1027.89,768.062],[1010.62,664.082],[1010.62,762.341]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1027.89,776.711],[1027.89,877.49],[1010.62,770.774],[1010.62,869.033]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1117.72,347.465],[1117.72,251.179],[1017.86,371.996],[1017.86,288.026]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1028.09,445.471],[1028.09,344.662],[1141.97,446.721],[1141.97,347.254]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1028.09,549.269],[1028.09,448.459],[1141.97,549.136],[1141.97,449.669]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1028.09,558.042],[1028.09,658.852],[1141.97,557.792],[1141.97,657.259]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1028.09,667.322],[1028.09,768.132],[1141.97,665.616],[1141.97,765.083]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1028.09,776.783],[1028.09,877.593],[1141.97,773.619],[1141.97,873.086]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1117.21,347.459],[1117.21,251.17],[1361.43,352.996],[1361.43,259.486]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,445.645],[1151.32,345.022],[1141.97,446.721],[1141.97,347.254]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,549.251],[1151.32,448.628],[1141.97,549.136],[1141.97,449.669]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,558.007],[1151.32,658.63],[1141.97,557.792],[1141.97,657.259]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,667.084],[1151.32,767.707],[1141.97,665.616],[1141.97,765.083]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,776.343],[1151.32,876.965],[1141.97,773.619],[1141.97,873.086]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,445.645],[1151.32,345.022],[1295.19,447.243],[1295.19,348.338]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,549.251],[1151.32,448.628],[1295.19,549.08],[1295.19,450.175]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,558.007],[1151.32,658.63],[1295.19,557.687],[1295.19,656.592]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,667.084],[1151.32,767.707],[1295.19,664.902],[1295.19,763.807]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1151.32,776.343],[1151.32,876.965],[1295.19,772.295],[1295.19,871.2]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1284.73,663.531],[1284.73,761.356],[1391.95,661.924],[1391.95,758.485]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1284.73,448.247],[1284.73,350.422],[1391.95,449.424],[1391.95,352.863]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1284.73,548.973],[1284.73,451.147],[1391.95,548.847],[1391.95,452.286]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1284.73,557.486],[1284.73,655.311],[1391.95,557.25],[1391.95,653.811]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1284.73,769.751],[1284.73,867.577],[1391.95,766.771],[1391.95,863.332]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1458.28,355.186],[1458.28,262.776],[1319.91,377.899],[1319.91,296.891]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1388.77,449.428],[1388.77,352.871],[1492.4,450.564],[1492.4,355.23]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1388.77,548.846],[1388.77,452.29],[1492.4,548.725],[1492.4,453.39]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1388.77,557.249],[1388.77,653.806],[1492.4,557.021],[1492.4,652.356]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1388.77,661.919],[1388.77,758.476],[1492.4,660.367],[1492.4,755.702]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1388.77,766.762],[1388.77,863.319],[1492.4,763.883],[1492.4,859.218]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1457.8,355.18],[1457.8,262.767],[1679.97,360.217],[1679.97,270.332]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,449.577],[1505.26,353.181],[1492.4,450.564],[1492.4,355.23]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,548.831],[1505.26,452.434],[1492.4,548.725],[1492.4,453.39]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,557.219],[1505.26,653.616],[1492.4,557.021],[1492.4,652.356]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,661.715],[1505.26,758.111],[1492.4,660.367],[1492.4,755.702]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,766.384],[1505.26,862.78],[1492.4,763.883],[1492.4,859.218]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,449.577],[1505.26,353.181],[1637.39,451.045],[1637.39,356.226]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,548.831],[1505.26,452.434],[1637.39,548.674],[1637.39,453.855]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,557.219],[1505.26,653.616],[1637.39,556.925],[1637.39,651.744]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,661.715],[1505.26,758.111],[1637.39,659.711],[1637.39,754.529]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1505.26,766.384],[1505.26,862.78],[1637.39,762.666],[1637.39,857.485]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1623.78,556.74],[1623.78,650.566],[1722.46,556.523],[1722.46,649.185]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1623.78,658.45],[1623.78,752.276],[1722.46,656.971],[1722.46,749.633]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1623.78,451.968],[1623.78,358.142],[1722.46,453.051],[1722.46,360.389]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1623.78,548.575],[1623.78,454.749],[1722.46,548.46],[1722.46,455.798]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1623.78,760.328],[1623.78,854.154],[1722.46,757.585],[1722.46,850.247]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1679.61,360.209],[1679.61,270.32],[1889.96,364.977],[1889.96,277.483]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1720.56,453.067],[1720.56,360.423],[1816.01,454.114],[1816.01,362.595]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1720.56,548.458],[1720.56,455.813],[1816.01,548.346],[1816.01,456.827]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1720.56,556.52],[1720.56,649.165],[1816.01,556.31],[1816.01,647.829]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1720.56,656.949],[1720.56,749.593],[1816.01,655.519],[1816.01,747.038]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1720.56,757.544],[1720.56,850.188],[1816.01,754.892],[1816.01,846.411]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,453.205],[1831.81,360.708],[1816.01,454.114],[1816.01,362.595]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,548.443],[1831.81,455.946],[1816.01,548.346],[1816.01,456.827]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,556.492],[1831.81,648.989],[1816.01,556.31],[1816.01,647.829]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,656.761],[1831.81,749.258],[1816.01,655.519],[1816.01,747.038]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,757.196],[1831.81,849.692],[1816.01,754.892],[1816.01,846.411]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,453.205],[1831.81,360.708],[1953.54,454.557],[1953.54,363.514]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,548.443],[1831.81,455.946],[1953.54,548.299],[1953.54,457.256]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,556.492],[1831.81,648.989],[1953.54,556.222],[1953.54,647.265]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,656.761],[1831.81,749.258],[1953.54,654.914],[1953.54,745.957]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:48,
                    verts:[[1831.81,757.196],[1831.81,849.692],[1953.54,753.77],[1953.54,844.813]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.101,431.746],[-9.36104,429.554],[140.101,316.182],[-9.36104,311.633]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.101,550.735],[140.101,435.171],[-9.36104,550.969],[-9.36104,433.049]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.101,560.792],[-9.36104,561.231],[140.101,676.356],[-9.36104,679.151]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.101,686.066],[-9.36104,689.059],[140.101,801.63],[-9.36104,806.98]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.101,811.547],[-9.36104,817.099],[140.101,927.111],[-9.36104,935.02]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.159,430.377],[326.536,433.145],[140.159,313.341],[326.536,319.085]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.159,550.881],[140.159,433.845],[326.536,550.586],[326.536,436.525]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.159,561.066],[140.159,678.102],[326.536,560.512],[326.536,674.572]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.159,687.936],[326.536,684.155],[140.159,804.972],[326.536,798.216]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[140.159,815.016],[326.536,808.004],[140.159,932.052],[326.536,922.064]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[142.108,317.495],[142.108,206.162],[141.177,348.976],[141.177,253.448]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[141.477,317.483],[141.477,206.143],[448.542,326.774],[448.542,220.1]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[324.112,434.491],[324.112,321.878],[458.972,436.468],[458.972,325.98]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[324.112,550.442],[324.112,437.829],[458.972,550.231],[458.972,439.743]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[324.112,560.242],[324.112,672.855],[458.972,559.846],[458.972,670.333]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[324.112,682.317],[324.112,794.93],[458.972,679.617],[458.972,790.105]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[324.112,804.594],[458.972,799.586],[324.112,917.207],[458.972,910.074]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[448.885,326.785],[448.885,220.116],[730.692,335.312],[730.692,232.925]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[461.608,436.507],[461.608,326.061],[591.826,438.416],[591.826,330.022]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[461.608,550.227],[461.608,439.78],[591.826,550.023],[591.826,441.628]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[461.608,559.838],[461.608,670.284],[591.826,559.456],[591.826,667.85]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[461.608,679.564],[461.608,790.01],[591.826,676.957],[591.826,785.351]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[461.608,799.489],[461.608,909.935],[591.826,794.653],[591.826,903.048]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,437.169],[597.467,327.435],[591.826,438.416],[591.826,330.022]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,550.156],[597.467,440.421],[591.826,550.023],[591.826,441.628]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,559.705],[597.467,669.44],[591.826,559.456],[591.826,667.85]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,678.66],[597.467,788.394],[591.826,676.957],[591.826,785.351]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,797.811],[597.467,907.546],[591.826,794.653],[591.826,903.048]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,437.169],[597.467,327.435],[761.574,439.607],[761.574,332.492]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,550.156],[597.467,440.421],[761.574,549.896],[761.574,442.781]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,559.705],[597.467,669.44],[761.574,559.217],[761.574,666.331]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,678.66],[597.467,788.394],[761.574,675.331],[761.574,782.445]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[597.467,797.811],[597.467,907.546],[761.574,791.638],[761.574,898.752]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[754.361,440.755],[754.361,334.875],[875.105,442.526],[875.105,338.549]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[754.361,549.773],[754.361,443.893],[875.105,549.584],[875.105,445.607]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[754.361,558.987],[754.361,664.867],[875.105,558.632],[875.105,662.608]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[754.361,673.763],[754.361,779.643],[875.105,671.345],[875.105,775.321]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[754.361,788.729],[754.361,894.609],[875.105,784.244],[875.105,888.22]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1129.64,347.379],[1129.64,251.049],[1005.15,371.406],[1005.15,287.14]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.47,445.157],[1049.47,344.008],[1027.08,447.461],[1027.08,348.791]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.47,549.303],[1049.47,448.154],[1027.08,549.057],[1027.08,450.386]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.47,558.105],[1049.47,659.253],[1027.08,557.643],[1027.08,656.314]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.47,667.752],[1049.47,768.9],[1027.08,664.604],[1027.08,763.275]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.47,777.58],[1049.47,878.729],[1027.08,771.743],[1027.08,870.413]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.72,445.129],[1049.72,343.95],[1160.13,446.747],[1160.13,347.309]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.72,549.306],[1049.72,448.127],[1160.13,549.133],[1160.13,449.694]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.72,558.111],[1049.72,659.289],[1160.13,557.786],[1160.13,657.225]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.72,667.79],[1049.72,768.969],[1160.13,665.58],[1160.13,765.018]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1049.72,777.651],[1049.72,878.83],[1160.13,773.552],[1160.13,872.99]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1129.14,347.369],[1129.14,251.035],[1363.65,354.466],[1363.65,261.694]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,445.699],[1171.74,345.134],[1160.13,446.747],[1160.13,347.309]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,549.245],[1171.74,448.68],[1160.13,549.133],[1160.13,449.694]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,557.996],[1171.74,658.562],[1160.13,557.786],[1160.13,657.225]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,667.011],[1171.74,767.577],[1160.13,665.58],[1160.13,765.018]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,776.207],[1171.74,876.772],[1160.13,773.552],[1160.13,872.99]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,445.699],[1171.74,345.134],[1309.85,447.75],[1309.85,349.39]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,549.245],[1171.74,448.68],[1309.85,549.026],[1309.85,450.665]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,557.996],[1171.74,658.562],[1309.85,557.585],[1309.85,655.945]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,667.011],[1171.74,767.577],[1309.85,664.21],[1309.85,762.57]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1171.74,776.207],[1171.74,876.772],[1309.85,771.011],[1309.85,869.371]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1297.41,448.719],[1297.41,351.401],[1399.56,450.217],[1399.56,354.51]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1297.41,662.887],[1297.41,760.205],[1399.56,660.841],[1399.56,756.548]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1297.41,548.922],[1297.41,451.604],[1399.56,548.762],[1399.56,453.054]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1297.41,557.391],[1297.41,654.71],[1399.56,557.091],[1399.56,652.799]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1297.41,768.557],[1297.41,865.875],[1399.56,764.762],[1399.56,860.47]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1455.57,357.242],[1455.57,265.864],[1297.75,379.003],[1297.75,298.55]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1396.46,450.212],[1396.46,354.497],[1494.5,451.649],[1494.5,357.48]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1396.46,548.763],[1396.46,453.048],[1494.5,548.609],[1494.5,454.44]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1396.46,557.092],[1396.46,652.806],[1494.5,556.804],[1494.5,650.973]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1396.46,660.849],[1396.46,756.563],[1494.5,658.886],[1494.5,753.055]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1396.46,764.777],[1396.46,860.491],[1494.5,761.136],[1494.5,855.306]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1455.11,357.233],[1455.11,265.851],[1663.69,363.545],[1663.69,275.332]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,450.709],[1509.08,355.53],[1494.5,451.649],[1494.5,357.48]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,548.71],[1509.08,453.53],[1494.5,548.609],[1494.5,454.44]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,556.992],[1509.08,652.172],[1494.5,556.804],[1494.5,650.973]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,660.169],[1509.08,755.348],[1494.5,658.886],[1494.5,753.055]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,763.516],[1509.08,858.695],[1494.5,761.136],[1494.5,855.306]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,450.709],[1509.08,355.53],[1632.93,452.549],[1632.93,359.347]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,548.71],[1509.08,453.53],[1632.93,548.513],[1632.93,455.311]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,556.992],[1509.08,652.172],[1632.93,556.624],[1632.93,649.826]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,660.169],[1509.08,755.348],[1632.93,657.657],[1632.93,750.858]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1509.08,763.516],[1509.08,858.695],[1632.93,758.857],[1632.93,852.058]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1617.89,656.468],[1617.89,748.733],[1709.79,654.627],[1709.79,745.444]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1617.89,453.42],[1617.89,361.154],[1709.79,454.767],[1709.79,363.951]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1617.89,548.42],[1617.89,456.154],[1709.79,548.276],[1709.79,457.459]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1617.89,556.45],[1617.89,648.715],[1709.79,556.179],[1709.79,646.996]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1617.89,756.651],[1617.89,848.917],[1709.79,753.237],[1709.79,844.055]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1663.36,363.535],[1663.36,275.317],[1857.99,369.424],[1857.99,284.163]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1707.95,654.613],[1707.95,745.418],[1796.27,652.845],[1796.27,742.258]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1707.95,454.778],[1707.95,363.972],[1796.27,456.073],[1796.27,366.659]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1707.95,548.275],[1707.95,457.469],[1796.27,548.137],[1796.27,458.723]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1707.95,556.177],[1707.95,646.983],[1796.27,555.918],[1796.27,645.332]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1707.95,753.211],[1707.95,844.016],[1796.27,749.932],[1796.27,839.346]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,455.226],[1813.17,364.902],[1796.27,456.073],[1796.27,366.659]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,548.227],[1813.17,457.903],[1796.27,548.137],[1796.27,458.723]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,556.088],[1813.17,646.411],[1796.27,555.918],[1796.27,645.332]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,654.001],[1813.17,744.324],[1796.27,652.845],[1796.27,742.258]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,752.076],[1813.17,842.4],[1796.27,749.932],[1796.27,839.346]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,455.226],[1813.17,364.902],[1924.82,456.885],[1924.82,368.344]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,548.227],[1813.17,457.903],[1924.82,548.05],[1924.82,459.509]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,556.088],[1813.17,646.411],[1924.82,555.755],[1924.82,644.296]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,654.001],[1813.17,744.325],[1924.82,651.736],[1924.82,740.277]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:49,
                    verts:[[1813.17,752.076],[1813.17,842.4],[1924.82,747.875],[1924.82,836.416]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90161,424.811],[9.90161,301.793],[0.985233,436.173],[0.985233,325.368]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90161,551.476],[9.90161,428.457],[0.985233,550.262],[0.985233,439.457]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90161,562.181],[9.90161,685.2],[0.985233,559.905],[0.985233,670.71]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90161,695.536],[9.90161,818.554],[0.985233,680.02],[0.985233,790.825]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90161,829.111],[9.90161,952.13],[0.985233,800.334],[0.985233,911.139]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90143,424.811],[9.90143,301.793],[164.665,427.71],[164.665,307.807]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90143,551.476],[9.90143,428.457],[164.665,551.166],[164.665,431.264]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90143,562.181],[9.90143,685.2],[164.665,561.601],[164.665,681.503]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90143,695.536],[164.665,691.578],[9.90143,818.554],[164.665,811.48]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[9.90143,829.111],[164.665,821.77],[9.90143,952.13],[164.665,941.672]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[157.98,309.228],[157.98,193.744],[124.08,342.007],[124.08,242.98]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[157.322,309.209],[157.322,193.716],[470.418,321.288],[470.418,211.859]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,426.282],[167.796,304.845],[164.666,427.71],[164.666,307.807]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,551.319],[167.796,429.882],[164.666,551.166],[164.666,431.264]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,561.887],[167.796,683.324],[164.666,561.601],[164.666,681.503]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,693.527],[167.796,814.964],[164.666,691.578],[164.666,811.48]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,825.385],[167.796,946.822],[164.666,821.77],[164.666,941.672]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,426.282],[167.796,304.845],[358.347,429.899],[358.347,312.349]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,551.319],[167.796,429.882],[358.347,550.932],[358.347,433.383]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,561.887],[167.796,683.324],[358.347,561.162],[358.347,678.712]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,693.527],[167.796,814.964],[358.347,688.588],[358.347,806.138]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[167.796,825.385],[167.796,946.822],[358.347,816.226],[358.347,933.775]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[352.797,431.284],[352.797,315.223],[489.168,433.836],[489.168,320.52]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[352.797,550.784],[352.797,434.723],[489.168,550.512],[489.168,437.195]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[352.797,560.885],[352.797,676.946],[489.168,560.373],[489.168,673.69]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[352.797,686.697],[352.797,802.758],[489.168,683.211],[489.168,796.528]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[352.797,812.718],[352.797,928.779],[489.168,806.252],[489.168,919.569]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[470.764,321.301],[470.764,211.879],[752.059,332.153],[752.059,228.18]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[491.82,433.886],[491.82,320.623],[622.219,436.327],[622.219,325.688]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[491.82,550.507],[491.82,437.243],[622.219,550.246],[622.219,439.606]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[491.82,560.363],[491.82,673.627],[622.219,559.874],[622.219,670.513]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[491.82,683.143],[491.82,796.407],[622.219,679.81],[622.219,790.449]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[491.82,806.126],[491.82,919.39],[622.219,799.944],[622.219,910.583]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,435.069],[630.798,323.078],[622.219,436.327],[622.219,325.688]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,550.38],[630.798,438.389],[622.219,550.246],[622.219,439.606]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,560.126],[630.798,672.117],[622.219,559.874],[622.219,670.513]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,681.527],[630.798,793.518],[622.219,679.81],[622.219,790.449]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,803.129],[630.798,915.12],[622.219,799.944],[622.219,910.583]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,435.07],[630.798,323.078],[793.264,438.153],[793.264,329.476]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,550.38],[630.798,438.389],[793.264,550.051],[793.264,441.374]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,560.126],[630.798,672.117],[793.264,559.508],[793.264,668.185]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,681.527],[630.798,793.518],[793.264,677.316],[793.264,785.993]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[630.798,803.129],[630.798,915.12],[793.264,795.319],[793.264,903.996]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[783.376,439.298],[783.376,331.852],[901.819,441.516],[901.819,336.454]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[783.376,549.929],[783.376,442.482],[901.819,549.692],[901.819,444.63]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[783.376,559.279],[783.376,666.725],[901.819,558.834],[901.819,663.896]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[783.376,675.753],[783.376,783.199],[901.819,672.724],[901.819,777.785]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[783.376,792.42],[783.376,899.866],[901.819,786.801],[901.819,891.863]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1070.91,444.76],[1070.91,343.186],[1043.48,447.012],[1043.48,347.859]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1070.91,549.345],[1070.91,447.771],[1043.48,549.104],[1043.48,449.951]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1070.91,558.184],[1070.91,659.759],[1043.48,557.733],[1043.48,656.886]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1070.91,668.293],[1070.91,769.867],[1043.48,665.217],[1043.48,764.371]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1070.91,778.584],[1070.91,880.158],[1043.48,772.88],[1043.48,872.033]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1140.74,347.142],[1140.74,250.694],[991.973,370.556],[991.973,285.863]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1071.23,444.733],[1071.23,343.129],[1177.33,446.719],[1177.33,347.25]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1071.23,549.348],[1071.23,447.744],[1177.33,549.136],[1177.33,449.667]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1071.23,558.19],[1071.23,659.794],[1177.33,557.792],[1177.33,657.261]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1071.23,668.331],[1071.23,769.934],[1177.33,665.618],[1177.33,765.087]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1071.23,778.654],[1071.23,880.257],[1177.33,773.623],[1177.33,873.091]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1140.26,347.13],[1140.26,250.675],[1363.69,355.75],[1363.69,263.622]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,445.704],[1191.12,345.144],[1177.33,446.719],[1177.33,347.25]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,549.244],[1191.12,448.684],[1177.33,549.136],[1177.33,449.667]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,557.995],[1191.12,658.555],[1177.33,557.792],[1177.33,657.261]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,667.005],[1191.12,767.565],[1177.33,665.618],[1177.33,765.087]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,776.194],[1191.12,876.754],[1177.33,773.623],[1177.33,873.091]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,445.704],[1191.12,345.144],[1322.51,448.197],[1322.51,350.318]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,549.244],[1191.12,448.684],[1322.51,548.978],[1322.51,451.098]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,557.995],[1191.12,658.555],[1322.51,557.496],[1322.51,655.375]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,667.005],[1191.12,767.565],[1322.51,663.599],[1322.51,761.479]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1191.12,776.194],[1191.12,876.754],[1322.51,769.879],[1322.51,867.758]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1308.19,662.33],[1308.19,759.21],[1404.7,659.862],[1404.7,754.799]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1308.19,449.127],[1308.19,352.247],[1404.7,450.934],[1404.7,355.997]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1308.19,548.879],[1308.19,451.998],[1404.7,548.686],[1404.7,453.748]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1308.19,557.31],[1308.19,654.19],[1404.7,556.947],[1404.7,651.885]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1308.19,767.524],[1308.19,864.404],[1404.7,762.946],[1404.7,857.883]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1450.28,359.084],[1450.28,268.631],[1274.04,379.835],[1274.04,299.8]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1401.69,450.919],[1401.69,355.965],[1493.68,452.641],[1493.68,359.539]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1401.69,548.687],[1401.69,453.733],[1493.68,548.503],[1493.68,455.401]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1401.69,556.95],[1401.69,651.904],[1493.68,556.605],[1493.68,649.708]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1401.69,659.882],[1401.69,754.836],[1493.68,657.531],[1493.68,750.633]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1401.69,762.985],[1401.69,857.938],[1493.68,758.623],[1493.68,851.725]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1449.84,359.073],[1449.84,268.614],[1644.28,366.574],[1644.28,279.882]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,451.752],[1509.83,357.694],[1493.68,452.641],[1493.68,359.539]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,548.598],[1509.83,454.54],[1493.68,548.503],[1493.68,455.401]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,556.784],[1509.83,650.841],[1493.68,556.605],[1493.68,649.708]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,658.744],[1509.83,752.802],[1493.68,657.531],[1493.68,750.633]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,760.874],[1509.83,854.932],[1493.68,758.623],[1493.68,851.725]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,451.752],[1509.83,357.694],[1624.98,453.938],[1624.98,362.229]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,548.598],[1509.83,454.54],[1624.98,548.365],[1624.98,456.656]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,556.784],[1509.83,650.841],[1624.98,556.346],[1624.98,648.055]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,658.744],[1509.83,752.802],[1624.98,655.76],[1624.98,747.469]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1509.83,760.874],[1509.83,854.932],[1624.98,755.339],[1624.98,847.048]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1608.66,654.645],[1608.66,745.476],[1693.59,652.472],[1693.59,741.594]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1608.66,454.754],[1608.66,363.923],[1693.59,456.345],[1693.59,367.224]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1608.66,548.278],[1608.66,457.447],[1693.59,548.108],[1693.59,458.987]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1608.66,556.182],[1608.66,647.013],[1693.59,555.863],[1693.59,644.984]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1608.66,753.271],[1608.66,844.102],[1693.59,749.242],[1693.59,838.363]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1643.98,366.563],[1643.98,279.864],[1822.89,373.465],[1822.89,290.232]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1691.81,456.35],[1691.81,367.235],[1772.94,457.869],[1772.94,370.386]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1691.81,548.107],[1691.81,458.992],[1772.94,547.945],[1772.94,460.462]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1691.81,555.862],[1691.81,644.978],[1772.94,555.558],[1772.94,643.041]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1691.81,652.465],[1691.81,741.581],[1772.94,650.391],[1772.94,737.874]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1691.81,749.228],[1691.81,838.344],[1772.94,745.382],[1772.94,832.865]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,457.085],[1790.79,368.759],[1772.94,457.869],[1772.94,370.386]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,548.029],[1790.79,459.703],[1772.94,547.945],[1772.94,460.462]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,555.715],[1790.79,644.041],[1772.94,555.558],[1772.94,643.041]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,651.462],[1790.79,739.789],[1772.94,650.391],[1772.94,737.874]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,747.368],[1790.79,835.695],[1772.94,745.382],[1772.94,832.865]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,457.085],[1790.79,368.759],[1892.49,459.015],[1892.49,372.763]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,548.029],[1790.79,459.703],[1892.49,547.823],[1892.49,461.571]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,555.715],[1790.79,644.041],[1892.49,555.328],[1892.49,641.58]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,651.463],[1790.79,739.789],[1892.49,648.827],[1892.49,735.078]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1790.79,747.368],[1790.79,835.695],[1892.49,742.48],[1892.49,828.731]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1874.72,459.737],[1874.72,374.263],[1950.02,461.148],[1950.02,377.189]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1874.72,647.84],[1874.72,733.314],[1950.02,645.914],[1950.02,729.872]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1874.72,547.745],[1874.72,462.271],[1950.02,547.595],[1950.02,463.636]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1874.72,555.184],[1874.72,640.658],[1950.02,554.901],[1950.02,638.86]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:50,
                    verts:[[1874.72,740.649],[1874.72,826.124],[1950.02,737.078],[1950.02,821.036]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6414,419.697],[38.6414,291.18],[3.4709,431.601],[3.4709,315.882]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6414,552.022],[38.6414,423.506],[3.4709,550.751],[3.4709,435.031]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6414,563.206],[38.6414,691.722],[3.4709,560.821],[3.4709,676.54]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6414,702.521],[38.6414,831.037],[3.4709,686.263],[3.4709,801.983]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6414,842.066],[38.6414,970.582],[3.4709,811.914],[3.4709,927.633]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6412,419.697],[38.6412,291.18],[197.541,423.399],[197.541,298.863]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6412,552.022],[38.6412,423.506],[197.541,551.627],[197.541,427.09]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6412,563.206],[38.6412,691.722],[197.541,562.464],[197.541,687.001]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6412,702.521],[38.6412,831.037],[197.541,697.464],[197.541,822.001]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[38.6412,842.066],[38.6412,970.582],[197.541,832.688],[197.541,957.224]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[181.19,300.336],[181.19,180.388],[110.695,334.309],[110.695,231.418]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[180.51,300.311],[180.51,180.351],[497.119,315.475],[497.119,203.127]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,421.92],[204.079,295.794],[197.542,423.399],[197.542,298.863]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,551.785],[204.079,425.658],[197.542,551.627],[197.542,427.09]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,562.761],[204.079,688.887],[197.542,562.464],[197.542,687.001]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,699.484],[204.079,825.61],[197.542,697.464],[197.542,822.001]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,836.434],[204.079,962.56],[197.542,832.688],[197.542,957.224]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,421.92],[204.079,295.794],[397.055,426.48],[397.055,305.256]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,551.785],[204.079,425.658],[397.055,551.298],[397.055,430.073]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,562.761],[204.079,688.887],[397.055,561.847],[397.055,683.071]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,699.484],[204.079,825.61],[397.055,693.257],[397.055,814.481]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[204.079,836.434],[204.079,962.56],[397.055,824.884],[397.055,946.109]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[388.129,427.895],[388.129,308.191],[524.707,431.076],[524.707,314.791]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[388.129,551.146],[388.129,431.443],[524.707,550.807],[524.707,434.522]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[388.129,561.563],[388.129,681.267],[524.707,560.926],[524.707,677.211]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[388.129,691.325],[388.129,811.029],[524.707,686.981],[524.707,803.266]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[388.129,821.301],[388.129,941.005],[524.707,813.245],[524.707,929.529]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[497.465,315.491],[497.465,203.152],[775.731,328.818],[775.731,223.17]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[527.349,431.137],[527.349,314.919],[656.64,434.148],[656.64,321.167]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[527.349,550.8],[527.349,434.582],[656.64,550.479],[656.64,437.497]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[527.349,560.914],[527.349,677.132],[656.64,560.311],[656.64,673.292]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[527.349,686.897],[527.349,803.115],[656.64,682.785],[656.64,795.767]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[527.349,813.089],[527.349,929.307],[656.64,805.462],[656.64,918.444]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,432.889],[668.275,318.554],[656.64,434.148],[656.64,321.167]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,550.613],[668.275,436.278],[656.64,550.479],[656.64,437.497]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,560.563],[668.275,674.898],[656.64,560.311],[656.64,673.292]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,684.505],[668.275,798.84],[656.64,682.785],[656.64,795.767]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,808.652],[668.275,922.987],[656.64,805.462],[656.64,918.444]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,432.889],[668.275,318.554],[827.435,436.65],[827.435,326.358]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,550.613],[668.275,436.278],[827.435,550.211],[827.435,439.919]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,560.563],[668.275,674.898],[827.435,559.809],[827.435,670.102]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,684.505],[668.275,798.84],[827.435,679.369],[827.435,789.661]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[668.275,808.652],[668.275,922.987],[827.435,799.126],[827.435,909.418]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[814.828,437.783],[814.828,328.708],[929.827,440.462],[929.827,334.268]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[814.828,550.09],[814.828,441.016],[929.827,549.804],[929.827,443.61]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[814.828,559.582],[814.828,668.657],[929.827,559.046],[929.827,665.24]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[814.828,677.822],[814.828,786.897],[929.827,674.162],[929.827,780.357]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[814.828,796.257],[814.828,905.332],[929.827,789.47],[929.827,895.664]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1150.95,346.783],[1150.95,250.154],[978.301,369.458],[978.301,284.212]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.12,444.326],[1092.12,342.285],[1059.75,446.511],[1059.75,346.818]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.12,549.391],[1092.12,447.35],[1059.75,549.158],[1059.75,449.466]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.12,558.271],[1092.12,660.312],[1059.75,557.834],[1059.75,657.526]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.12,668.886],[1092.12,770.927],[1059.75,665.902],[1059.75,765.595]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.12,779.684],[1092.12,881.725],[1059.75,774.15],[1059.75,873.843]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.5,444.299],[1092.5,342.23],[1193.44,446.65],[1193.44,347.108]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.5,549.394],[1092.5,447.325],[1193.44,549.143],[1193.44,449.601]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.5,558.277],[1092.5,660.346],[1193.44,557.806],[1193.44,657.348]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.5,668.922],[1092.5,770.992],[1193.44,665.712],[1193.44,765.255]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1092.5,779.751],[1092.5,881.821],[1193.44,773.797],[1193.44,873.34]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1150.49,346.767],[1150.49,250.13],[1361.47,356.871],[1361.47,265.307]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,445.674],[1209.33,345.082],[1193.44,446.65],[1193.44,347.108]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,549.247],[1209.33,448.656],[1193.44,549.143],[1193.44,449.601]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,558.001],[1209.33,658.593],[1193.44,557.806],[1193.44,657.348]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,667.045],[1209.33,767.637],[1193.44,665.712],[1193.44,765.255]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,776.269],[1209.33,876.861],[1193.44,773.797],[1193.44,873.34]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,445.674],[1209.33,345.082],[1333.05,448.598],[1333.05,351.148]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,549.247],[1209.33,448.656],[1333.05,548.935],[1333.05,451.486]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,558.001],[1209.33,658.593],[1333.05,557.416],[1333.05,654.865]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,667.045],[1209.33,767.637],[1333.05,663.053],[1333.05,760.502]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1209.33,776.269],[1209.33,876.861],[1333.05,768.865],[1333.05,866.314]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1316.96,661.844],[1316.96,758.341],[1407.25,658.971],[1407.25,753.207]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1316.96,449.483],[1316.96,352.986],[1407.25,451.587],[1407.25,357.351]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1316.96,548.841],[1316.96,452.343],[1407.25,548.616],[1407.25,454.38]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1316.96,557.238],[1316.96,653.736],[1407.25,556.817],[1407.25,651.053]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1316.96,766.622],[1316.96,863.12],[1407.25,761.294],[1407.25,855.53]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1442.33,360.738],[1442.33,271.115],[1248.7,380.412],[1248.7,300.666]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1404.35,451.562],[1404.35,357.3],[1489.86,453.554],[1489.86,361.432]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1404.35,548.619],[1404.35,454.356],[1489.86,548.406],[1489.86,456.284]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1404.35,556.822],[1404.35,651.084],[1489.86,556.423],[1489.86,648.544]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1404.35,659.004],[1404.35,753.266],[1489.86,656.284],[1489.86,748.406]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1404.35,761.356],[1404.35,855.618],[1489.86,756.312],[1489.86,848.433]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1441.92,360.724],[1441.92,271.095],[1621.69,369.334],[1621.69,284.027]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,452.718],[1507.44,359.699],[1489.86,453.554],[1489.86,361.432]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,548.495],[1507.44,455.475],[1489.86,548.406],[1489.86,456.284]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,556.59],[1507.44,649.609],[1489.86,556.423],[1489.86,648.544]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,657.425],[1507.44,750.445],[1489.86,656.284],[1489.86,748.406]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,758.427],[1507.44,851.447],[1489.86,756.312],[1489.86,848.433]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,452.718],[1507.44,359.699],[1613.49,455.224],[1613.49,364.898]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,548.495],[1507.44,455.475],[1613.49,548.227],[1613.49,457.901]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,556.59],[1507.44,649.609],[1613.49,556.088],[1613.49,646.414]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,657.425],[1507.44,750.445],[1613.49,654.003],[1613.49,744.329]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1507.44,758.427],[1507.44,851.447],[1613.49,752.081],[1613.49,842.406]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1596.02,652.964],[1596.02,742.471],[1673.83,650.488],[1673.83,738.046]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1596.02,455.985],[1596.02,366.478],[1673.83,457.799],[1673.83,370.24]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1596.02,548.146],[1596.02,458.638],[1673.83,547.952],[1673.83,460.394]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1596.02,555.935],[1596.02,645.443],[1673.83,555.572],[1673.83,643.131]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1596.02,750.153],[1596.02,839.66],[1673.83,745.56],[1673.83,833.119]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1621.41,369.321],[1621.41,284.007],[1784.66,377.14],[1784.66,295.751]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1672.12,457.799],[1672.12,370.24],[1746.01,459.52],[1746.01,373.811]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1672.12,547.952],[1672.12,460.394],[1746.01,547.769],[1746.01,462.06]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1672.12,555.572],[1672.12,643.131],[1746.01,555.227],[1746.01,640.936]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1672.12,650.488],[1672.12,738.046],[1746.01,648.137],[1746.01,733.846]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1672.12,745.56],[1672.12,833.119],[1746.01,741.201],[1746.01,826.91]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,458.797],[1764.69,372.312],[1746.01,459.52],[1746.01,373.811]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,547.846],[1764.69,461.36],[1746.01,547.769],[1746.01,462.06]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,555.372],[1764.69,641.857],[1746.01,555.227],[1746.01,640.936]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,649.124],[1764.69,735.609],[1746.01,648.137],[1746.01,733.846]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,743.031],[1764.69,829.517],[1746.01,741.201],[1746.01,826.91]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,458.797],[1764.69,372.312],[1856.55,460.968],[1856.55,376.816]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,547.846],[1764.69,461.36],[1856.55,547.614],[1856.55,463.462]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,555.372],[1764.69,641.857],[1856.55,554.937],[1856.55,639.089]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,649.124],[1764.69,735.609],[1856.55,646.16],[1856.55,730.312]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1764.69,743.031],[1764.69,829.517],[1856.55,737.534],[1856.55,821.686]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1838.21,461.629],[1838.21,378.187],[1905.93,463.207],[1905.93,381.462]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1838.21,554.805],[1838.21,638.246],[1905.93,554.489],[1905.93,636.234]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1838.21,645.257],[1838.21,728.698],[1905.93,643.102],[1905.93,724.847]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1838.21,547.543],[1838.21,464.102],[1905.93,547.375],[1905.93,465.63]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:51,
                    verts:[[1838.21,735.859],[1838.21,819.3],[1905.93,731.862],[1905.93,813.608]]
                },
                ],
                [
                {
                    num:"508",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5383,414.23],[78.5383,279.837],[13.7429,426.622],[13.7429,305.55]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5383,552.606],[78.5383,418.213],[13.7429,551.282],[13.7429,430.21]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5383,564.301],[78.5383,698.694],[13.7429,561.819],[13.7429,682.891]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5383,709.986],[78.5383,844.378],[13.7429,693.063],[13.7429,814.135]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5383,855.912],[78.5383,990.304],[13.7429,824.525],[13.7429,945.597]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5381,414.23],[78.5381,279.837],[239.959,418.842],[239.959,289.407]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5381,552.606],[78.5381,418.213],[239.959,552.113],[239.959,422.678]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5381,564.301],[78.5381,698.694],[239.959,563.377],[239.959,692.812]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5381,709.986],[78.5381,844.378],[239.959,703.688],[239.959,833.123]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[78.5381,855.912],[78.5381,990.304],[239.959,844.23],[239.959,973.666]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[212.926,290.859],[212.926,166.153],[101.904,325.85],[101.904,218.712]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[212.229,290.827],[212.229,166.105],[529.159,309.386],[529.159,193.982]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,417.322],[250.247,286.254],[239.959,418.842],[239.959,289.407]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,552.276],[250.247,421.207],[239.959,552.113],[239.959,422.678]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,563.682],[250.247,694.75],[239.959,563.377],[239.959,692.812]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,705.763],[250.247,836.832],[239.959,703.688],[239.959,833.123]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,848.08],[250.247,979.148],[239.959,844.23],[239.959,973.666]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,417.322],[250.247,286.254],[443.406,422.924],[443.406,297.878]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,552.276],[250.247,421.207],[443.406,551.677],[443.406,426.631]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,563.682],[250.247,694.75],[443.406,562.559],[443.406,687.606]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,705.763],[250.247,836.832],[443.406,698.113],[443.406,823.159]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[250.247,848.08],[250.247,979.148],[443.406,833.891],[443.406,958.937]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[430.864,424.357],[430.864,300.85],[566.062,428.217],[566.062,308.86]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[430.864,551.524],[430.864,428.017],[566.062,551.112],[566.062,431.755]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[430.864,562.272],[430.864,685.779],[566.062,561.499],[566.062,680.856]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[430.864,696.157],[430.864,819.664],[566.062,690.885],[566.062,810.241]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[430.864,830.263],[430.864,953.77],[566.062,820.484],[566.062,939.841]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[529.501,309.406],[529.501,194.013],[801.822,325.354],[801.822,217.966]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[568.664,428.292],[568.664,309.014],[695.336,431.909],[695.336,316.52]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[568.664,551.104],[568.664,431.827],[695.336,550.718],[695.336,435.329]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[568.664,561.484],[568.664,680.761],[695.336,560.759],[695.336,676.148]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[568.664,690.783],[568.664,810.06],[695.336,685.843],[695.336,801.232]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[568.664,820.296],[568.664,939.573],[695.336,811.134],[695.336,926.523]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,430.66],[710.122,313.928],[695.336,431.909],[695.336,316.52]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,550.851],[710.122,434.12],[695.336,550.718],[695.336,435.329]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,561.01],[710.122,677.741],[695.336,560.759],[695.336,676.148]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,687.549],[710.122,804.281],[695.336,685.843],[695.336,801.232]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,814.298],[710.122,931.03],[695.336,811.134],[695.336,926.523]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,430.66],[710.122,313.928],[864.108,435.126],[864.108,323.195]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,550.851],[710.122,434.12],[864.108,550.374],[864.108,438.443]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,561.01],[710.122,677.741],[864.108,560.115],[864.108,672.046]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,687.549],[710.122,804.281],[864.108,681.45],[864.108,793.381]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[710.122,814.298],[710.122,931.03],[864.108,802.987],[864.108,914.918]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[848.761,436.236],[848.761,325.499],[959.074,439.388],[959.074,332.038]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[848.761,550.255],[848.761,439.518],[959.074,549.919],[959.074,442.569]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[848.761,559.892],[848.761,670.63],[959.074,559.261],[959.074,666.61]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[848.761,679.934],[848.761,790.672],[959.074,675.63],[959.074,782.979]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[848.761,800.175],[848.761,910.912],[959.074,792.192],[959.074,899.541]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1112.97,443.873],[1112.97,341.345],[1075.79,445.973],[1075.79,345.703]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1112.97,549.44],[1112.97,446.912],[1075.79,549.215],[1075.79,448.945]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1112.97,558.362],[1112.97,660.89],[1075.79,557.941],[1075.79,658.211]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1112.97,669.505],[1112.97,772.033],[1075.79,666.636],[1075.79,766.907]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1112.97,780.832],[1112.97,883.36],[1075.79,775.511],[1075.79,875.781]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1160.15,346.331],[1160.15,249.475],[964.12,368.124],[964.12,282.21]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1113.41,443.847],[1113.41,341.292],[1208.29,446.557],[1208.29,346.914]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1113.41,549.443],[1113.41,446.887],[1208.29,549.153],[1208.29,449.51]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1113.41,558.367],[1113.41,660.923],[1208.29,557.824],[1208.29,657.467]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1113.41,669.54],[1113.41,772.096],[1208.29,665.84],[1208.29,765.483]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1113.41,780.897],[1113.41,883.452],[1208.29,774.034],[1208.29,873.677]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1159.7,346.312],[1159.7,249.446],[1356.85,357.857],[1356.85,266.787]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,445.627],[1226.19,344.984],[1208.29,446.557],[1208.29,346.914]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,549.252],[1226.19,448.61],[1208.29,549.153],[1208.29,449.51]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,558.011],[1226.19,658.654],[1208.29,557.824],[1208.29,657.467]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,667.11],[1226.19,767.752],[1208.29,665.84],[1208.29,765.483]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,776.389],[1226.19,877.032],[1208.29,774.034],[1208.29,873.677]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,445.627],[1226.19,344.984],[1341.3,448.965],[1341.3,351.912]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,549.252],[1226.19,448.61],[1341.3,548.896],[1341.3,451.842]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,558.011],[1226.19,658.654],[1341.3,557.342],[1341.3,654.396]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,667.11],[1226.19,767.752],[1341.3,662.55],[1341.3,759.604]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1226.19,776.389],[1226.19,877.032],[1341.3,767.933],[1341.3,864.987]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1323.56,449.801],[1323.56,353.646],[1407.07,452.187],[1407.07,358.597]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1323.56,548.807],[1323.56,452.651],[1407.07,548.552],[1407.07,454.961]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1323.56,557.174],[1323.56,653.33],[1407.07,556.696],[1407.07,650.287]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1323.56,661.409],[1323.56,757.564],[1407.07,658.151],[1407.07,751.741]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1323.56,765.816],[1323.56,861.971],[1407.07,759.773],[1407.07,853.363]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1431.61,362.229],[1431.61,273.354],[1221.64,380.75],[1221.64,301.175]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1404.31,452.154],[1404.31,358.528],[1482.91,454.399],[1482.91,363.185]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1404.31,548.555],[1404.31,454.929],[1482.91,548.316],[1482.91,457.102]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1404.31,556.703],[1404.31,650.329],[1482.91,556.253],[1482.91,647.467]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1404.31,658.196],[1404.31,751.822],[1482.91,655.131],[1482.91,746.344]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1404.31,759.857],[1404.31,853.483],[1482.91,754.172],[1482.91,845.385]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1431.22,362.212],[1431.22,273.329],[1595.84,371.852],[1595.84,287.809]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,453.62],[1501.79,361.569],[1482.91,454.399],[1482.91,363.185]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,548.399],[1501.79,456.348],[1482.91,548.316],[1482.91,457.102]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,556.409],[1501.79,648.46],[1482.91,556.253],[1482.91,647.467]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,656.194],[1501.79,748.245],[1482.91,655.131],[1482.91,746.344]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,756.144],[1501.79,848.195],[1482.91,754.172],[1482.91,845.385]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,453.62],[1501.79,361.569],[1598.39,456.421],[1598.39,367.382]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,548.399],[1501.79,456.348],[1598.39,548.1],[1598.39,459.06]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,556.409],[1501.79,648.46],[1598.39,555.848],[1598.39,644.887]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,656.194],[1501.79,748.245],[1598.39,652.368],[1598.39,741.408]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1501.79,756.144],[1501.79,848.195],[1598.39,749.049],[1598.39,838.088]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1579.91,555.707],[1579.91,643.989],[1650.46,555.303],[1650.46,641.419]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1579.91,651.407],[1579.91,739.689],[1650.46,648.654],[1650.46,734.77]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1595.59,371.837],[1595.59,287.787],[1743.23,380.483],[1743.23,300.774]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1579.91,457.125],[1579.91,368.843],[1650.46,459.141],[1650.46,373.026]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1579.91,548.024],[1579.91,459.742],[1650.46,547.809],[1650.46,461.694]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1579.91,747.265],[1579.91,835.547],[1650.46,742.16],[1650.46,828.275]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1648.82,648.661],[1648.82,734.781],[1715.46,646.062],[1715.46,730.137]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1648.82,459.136],[1648.82,373.016],[1715.46,461.039],[1715.46,376.964]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1648.82,547.81],[1648.82,461.689],[1715.46,547.606],[1715.46,463.531]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1648.82,555.304],[1648.82,641.425],[1715.46,554.923],[1715.46,638.998]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1648.82,742.172],[1648.82,828.292],[1715.46,737.352],[1715.46,821.427]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,460.378],[1734.82,375.593],[1715.46,461.039],[1715.46,376.964]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,547.677],[1734.82,462.891],[1715.46,547.606],[1715.46,463.531]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,555.055],[1734.82,639.841],[1715.46,554.923],[1715.46,638.998]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,646.965],[1734.82,731.75],[1715.46,646.062],[1715.46,730.137]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,739.026],[1734.82,823.812],[1715.46,737.352],[1715.46,821.427]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,460.378],[1734.82,375.593],[1816.98,462.761],[1816.98,380.537]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,547.677],[1734.82,462.891],[1816.98,547.422],[1816.98,465.198]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,555.055],[1734.82,639.841],[1816.98,554.578],[1816.98,636.802]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,646.965],[1734.82,731.75],[1816.98,643.711],[1816.98,725.935]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1734.82,739.026],[1734.82,823.812],[1816.98,732.991],[1816.98,815.215]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1798.19,463.362],[1798.19,381.784],[1858.55,465.086],[1858.55,385.362]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1798.19,642.89],[1798.19,724.468],[1858.55,640.535],[1858.55,720.26]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1798.19,547.358],[1798.19,465.78],[1858.55,547.174],[1858.55,467.449]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1798.19,554.457],[1798.19,636.036],[1858.55,554.112],[1858.55,633.837]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:52,
                    verts:[[1798.19,731.469],[1798.19,813.047],[1858.55,727.102],[1858.55,806.826]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[7.65306,424.613],[7.65306,301.382],[-68.5412,434.554],[-68.5412,322.008]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[7.65306,551.497],[7.65306,428.266],[-68.5412,550.435],[-68.5412,437.89]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[7.65306,562.221],[7.65306,685.452],[-68.5412,560.229],[-68.5412,672.775]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[7.65306,695.807],[7.65306,819.038],[-68.5412,682.231],[-68.5412,794.777]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[7.65306,829.613],[7.65306,952.845],[-68.5412,804.435],[-68.5412,916.981]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,408.46],[131.464,267.865],[33.4819,421.243],[33.4819,294.389]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,553.222],[131.464,412.627],[33.4819,551.857],[33.4819,425.003]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,565.457],[131.464,706.053],[33.4819,562.896],[33.4819,689.75]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,717.866],[131.464,858.461],[33.4819,700.409],[33.4819,827.262]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,870.527],[131.464,1011.12],[33.4819,838.148],[33.4819,965.002]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[254.504,280.878],[254.504,151.161],[98.8237,316.615],[98.8237,204.84]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,408.46],[131.464,267.865],[293.23,414.09],[293.23,279.547]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,553.222],[131.464,412.627],[293.23,552.621],[293.23,418.078]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,565.457],[131.464,706.053],[293.23,564.329],[293.23,698.873]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,717.866],[131.464,858.461],[293.23,710.177],[293.23,844.721]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[131.464,870.527],[131.464,1011.12],[293.23,856.267],[293.23,990.81]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[253.797,280.837],[253.797,151.1],[567.051,303.102],[567.051,184.544]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,412.545],[307.601,276.341],[293.23,414.09],[293.23,279.547]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,552.786],[307.601,416.582],[293.23,552.621],[293.23,418.078]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,564.639],[307.601,700.843],[293.23,564.329],[293.23,698.873]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,712.287],[307.601,848.491],[293.23,710.177],[293.23,844.721]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,860.18],[307.601,996.384],[293.23,856.267],[293.23,990.81]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,412.545],[307.601,276.341],[498.124,419.285],[498.124,290.326]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,552.786],[307.601,416.582],[498.124,552.066],[498.124,423.107]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,564.639],[307.601,700.843],[498.124,563.289],[498.124,692.248]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,712.287],[307.601,848.491],[498.124,703.083],[498.124,832.042]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[307.601,860.18],[307.601,996.384],[498.124,843.109],[498.124,972.068]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[481.756,420.719],[481.756,293.301],[613.667,425.307],[613.667,302.822]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[481.756,551.913],[481.756,424.495],[613.667,551.423],[613.667,428.938]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[481.756,563.001],[481.756,690.419],[613.667,562.082],[613.667,684.567]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[481.756,701.125],[481.756,828.542],[613.667,694.859],[613.667,817.344]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[481.756,839.477],[481.756,966.894],[613.667,827.855],[613.667,950.34]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[567.385,303.126],[567.385,184.579],[830.411,321.821],[830.411,212.661]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[616.192,425.395],[616.192,303.004],[738.502,429.65],[738.502,311.832]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[616.192,551.413],[616.192,429.023],[738.502,550.959],[738.502,433.142]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[616.192,562.064],[616.192,684.455],[738.502,561.212],[738.502,679.029]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[616.192,694.739],[616.192,817.129],[738.502,688.929],[738.502,806.746]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[616.192,827.633],[616.192,950.023],[738.502,816.857],[738.502,934.674]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,428.424],[756.493,309.29],[738.502,429.65],[738.502,311.832]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,551.09],[756.493,431.956],[738.502,550.959],[738.502,433.142]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,561.457],[756.493,680.592],[738.502,561.212],[738.502,679.029]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,690.602],[756.493,809.736],[738.502,688.929],[738.502,806.746]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,819.96],[756.493,939.094],[738.502,816.857],[738.502,934.674]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,428.424],[756.493,309.29],[903.233,433.615],[903.233,320.061]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,551.09],[756.493,431.956],[903.233,550.535],[903.233,436.981]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,561.457],[756.493,680.592],[903.233,560.417],[903.233,673.972]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,690.602],[756.493,809.736],[903.233,683.513],[903.233,797.067]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[756.493,819.96],[756.493,939.094],[903.233,806.812],[903.233,920.367]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[885.16,434.691],[885.16,322.294],[989.446,438.321],[989.446,329.825]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[885.16,550.421],[885.16,438.023],[989.446,550.033],[989.446,441.537]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[885.16,560.202],[885.16,672.6],[989.446,559.475],[989.446,667.971]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[885.16,682.043],[885.16,794.441],[989.446,677.087],[989.446,785.583]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[885.16,804.087],[885.16,916.485],[989.446,794.894],[989.446,903.39]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1168.2,345.823],[1168.2,248.713],[949.432,366.574],[949.432,279.881]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.26,443.422],[1133.26,340.41],[1091.47,445.42],[1091.47,344.556]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.26,549.488],[1133.26,446.476],[1091.47,549.275],[1091.47,448.41]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.26,558.452],[1133.26,661.465],[1091.47,558.052],[1091.47,658.917]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.26,670.12],[1133.26,773.132],[1091.47,667.391],[1091.47,768.256]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.26,781.973],[1133.26,884.985],[1091.47,776.912],[1091.47,877.776]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.76,443.398],[1133.76,340.359],[1221.71,446.457],[1221.71,346.708]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.76,549.491],[1133.76,446.452],[1221.71,549.164],[1221.71,449.414]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.76,558.457],[1133.76,661.496],[1221.71,557.844],[1221.71,657.594]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.76,670.153],[1133.76,773.192],[1221.71,665.975],[1221.71,765.725]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1133.76,782.034],[1133.76,885.073],[1221.71,774.285],[1221.71,874.035]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1167.78,345.801],[1167.78,248.679],[1349.72,358.733],[1349.72,268.103]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,445.581],[1241.48,344.889],[1221.71,446.457],[1221.71,346.708]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,549.257],[1241.48,448.565],[1221.71,549.164],[1221.71,449.414]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,558.02],[1241.48,658.712],[1221.71,557.844],[1221.71,657.594]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,667.173],[1241.48,767.865],[1221.71,665.975],[1221.71,765.725]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,776.506],[1241.48,877.198],[1221.71,774.285],[1221.71,874.035]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,445.581],[1241.48,344.889],[1347.07,449.316],[1347.07,352.639]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,549.257],[1241.48,448.565],[1347.07,548.858],[1347.07,452.181]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,558.02],[1241.48,658.712],[1347.07,557.272],[1347.07,653.949]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,667.173],[1241.48,767.865],[1347.07,662.072],[1347.07,758.749]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1241.48,776.506],[1241.48,877.198],[1347.07,767.045],[1347.07,863.722]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1327.81,450.097],[1327.81,354.26],[1404.02,452.749],[1404.02,359.763]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1327.81,548.775],[1327.81,452.938],[1404.02,548.492],[1404.02,455.506]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1327.81,557.115],[1327.81,652.953],[1404.02,556.584],[1404.02,649.57]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1327.81,661.005],[1327.81,756.842],[1404.02,657.383],[1404.02,750.369]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1327.81,765.067],[1327.81,860.904],[1404.02,758.349],[1404.02,851.335]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1418.01,363.58],[1418.01,275.384],[1192.77,380.866],[1192.77,301.349]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1401.4,758.455],[1401.4,851.486],[1472.7,752.172],[1472.7,842.537]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1401.4,452.708],[1401.4,359.677],[1472.7,455.188],[1472.7,364.823]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1401.4,548.496],[1401.4,455.465],[1472.7,548.231],[1472.7,457.866]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1401.4,556.592],[1401.4,649.623],[1472.7,556.095],[1472.7,646.46]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1401.4,657.44],[1401.4,750.471],[1472.7,654.053],[1472.7,744.418]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1417.65,363.561],[1417.65,275.356],[1566.67,374.153],[1566.67,291.266]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,454.469],[1492.75,363.332],[1472.7,455.188],[1472.7,364.823]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,548.308],[1492.75,457.17],[1472.7,548.231],[1472.7,457.866]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,556.239],[1492.75,647.377],[1472.7,556.095],[1472.7,646.46]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,655.034],[1492.75,746.172],[1472.7,654.053],[1472.7,744.418]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,753.993],[1492.75,845.131],[1472.7,752.172],[1472.7,842.537]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,454.469],[1492.75,363.332],[1579.58,457.541],[1579.58,369.705]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,548.308],[1492.75,457.17],[1579.58,547.98],[1579.58,460.144]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,556.239],[1492.75,647.377],[1579.58,555.624],[1579.58,643.459]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,655.034],[1492.75,746.172],[1579.58,650.84],[1579.58,738.675]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1492.75,753.993],[1492.75,845.131],[1579.58,746.213],[1579.58,834.049]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1566.44,374.137],[1566.44,291.241],[1698.54,383.526],[1698.54,305.344]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1560.22,649.958],[1560.22,737.1],[1623.4,646.956],[1623.4,731.734]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1560.22,458.186],[1560.22,371.044],[1623.4,460.385],[1623.4,375.607]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1560.22,547.911],[1560.22,460.769],[1623.4,547.676],[1623.4,462.898]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1560.22,555.494],[1560.22,642.637],[1623.4,555.054],[1623.4,639.832]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1560.22,744.579],[1560.22,831.721],[1623.4,739.01],[1623.4,823.788]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1621.85,460.376],[1621.85,375.587],[1681.23,462.441],[1681.23,379.873]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1621.85,547.677],[1621.85,462.889],[1681.23,547.457],[1681.23,464.889]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1621.85,555.056],[1621.85,639.844],[1681.23,554.642],[1681.23,637.21]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1621.85,646.968],[1621.85,731.756],[1681.23,644.147],[1681.23,726.715]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1621.85,739.033],[1621.85,823.821],[1681.23,733.801],[1681.23,816.369]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,461.842],[1701.15,378.629],[1681.23,462.441],[1681.23,379.873]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,547.521],[1701.15,464.308],[1681.23,547.457],[1681.23,464.889]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,554.762],[1701.15,637.975],[1681.23,554.642],[1681.23,637.21]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,644.966],[1701.15,728.179],[1681.23,644.147],[1681.23,726.715]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,735.32],[1701.15,818.533],[1681.23,733.801],[1681.23,816.369]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,461.842],[1701.15,378.629],[1773.77,464.41],[1773.77,383.959]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,547.521],[1701.15,464.308],[1773.77,547.246],[1773.77,466.795]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,554.762],[1701.15,637.975],[1773.77,554.247],[1773.77,634.699]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,644.966],[1701.15,728.179],[1773.77,641.458],[1773.77,721.91]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1701.15,735.32],[1701.15,818.533],[1773.77,728.814],[1773.77,809.265]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1754.63,464.952],[1754.63,385.083],[1807.82,466.803],[1807.82,388.924]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1754.63,547.188],[1754.63,467.319],[1807.82,546.991],[1807.82,469.112]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1754.63,554.139],[1754.63,634.008],[1807.82,553.768],[1807.82,631.647]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1754.63,640.719],[1754.63,720.588],[1807.82,638.19],[1807.82,716.069]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:53,
                    verts:[[1754.63,727.442],[1754.63,807.311],[1807.82,722.753],[1807.82,800.632]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[28.9892,418.943],[28.9892,289.617],[-76.4532,429.138],[-76.4532,310.772]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[28.9892,552.103],[28.9892,422.777],[-76.4532,551.014],[-76.4532,432.647]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[28.9892,563.357],[28.9892,692.683],[-76.4532,561.314],[-76.4532,679.681]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[28.9892,703.549],[28.9892,832.875],[-76.4532,689.627],[-76.4532,807.993]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[28.9892,843.973],[28.9892,973.299],[-76.4532,818.151],[-76.4532,936.518]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.361,402.471],[199.361,255.437],[64.63,415.497],[64.63,282.467]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.361,553.862],[199.361,406.829],[64.63,552.471],[64.63,419.44]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.361,566.657],[199.361,713.691],[64.63,564.047],[64.63,697.078]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.361,726.045],[199.361,873.078],[64.63,708.255],[64.63,841.285]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.361,885.696],[199.361,1032.73],[64.63,852.702],[64.63,985.732]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[307.288,270.528],[307.288,135.616],[102.813,306.616],[102.813,189.821]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.36,402.471],[199.36,255.437],[358.633,409.223],[358.633,269.449]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.36,553.862],[199.36,406.829],[358.633,553.141],[358.633,413.366]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.36,566.657],[199.36,713.691],[358.633,565.304],[358.633,705.079]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.36,726.045],[199.36,873.078],[358.633,716.823],[358.633,856.598]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[199.36,885.696],[199.36,1032.73],[358.633,868.593],[358.633,1008.37]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[306.581,270.478],[306.581,135.541],[611.254,296.733],[611.254,174.977]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.379,407.675],[377.379,266.235],[358.633,409.223],[358.633,269.449]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.379,553.306],[377.379,411.867],[358.633,553.141],[358.633,413.366]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.379,565.615],[377.379,707.054],[358.633,565.304],[358.633,705.079]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.379,718.938],[377.379,860.377],[358.633,716.823],[358.633,856.598]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.379,872.515],[377.379,1013.95],[358.633,868.593],[358.633,1008.37]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.378,407.675],[377.378,266.235],[561.813,415.636],[561.813,282.755]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.378,553.306],[377.378,411.867],[561.813,552.456],[561.813,419.574]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.378,565.615],[377.378,707.054],[561.813,564.02],[561.813,696.901]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.378,718.938],[377.378,860.377],[561.813,708.066],[561.813,840.947]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[377.378,872.515],[377.378,1013.95],[561.813,852.351],[561.813,985.232]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[541.462,417.052],[541.462,285.692],[667.848,422.407],[667.848,296.804]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[541.462,552.305],[541.462,420.945],[667.848,551.733],[667.848,426.13]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[541.462,563.736],[541.462,695.095],[667.848,562.663],[667.848,688.266]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[541.462,706.133],[541.462,837.492],[667.848,698.82],[667.848,824.423]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[541.462,848.765],[541.462,980.125],[667.848,835.202],[667.848,960.805]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[611.575,296.761],[611.575,175.018],[861.518,318.299],[861.518,207.37]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[670.254,422.509],[670.254,297.015],[786.222,427.422],[786.222,307.211]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[670.254,551.722],[670.254,426.228],[786.222,551.197],[786.222,430.985]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[670.254,562.643],[670.254,688.136],[786.222,561.658],[786.222,681.87]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[670.254,698.68],[670.254,824.174],[786.222,691.97],[786.222,812.182]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[670.254,834.943],[670.254,960.437],[786.222,822.498],[786.222,942.71]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,426.238],[807.42,304.753],[786.222,427.422],[786.222,307.211]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,551.323],[807.42,429.839],[786.222,551.197],[786.222,430.985]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,561.896],[807.42,683.38],[786.222,561.658],[786.222,681.87]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,693.588],[807.42,815.072],[786.222,691.97],[786.222,812.182]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,825.498],[807.42,946.982],[786.222,822.498],[786.222,942.71]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,426.238],[807.42,304.753],[944.657,432.162],[944.657,317.045]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,551.323],[807.42,429.839],[944.657,550.691],[944.657,435.574]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,561.896],[807.42,683.38],[944.657,560.709],[944.657,675.825]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,693.588],[807.42,815.072],[944.657,685.498],[944.657,800.614]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[807.42,825.498],[807.42,946.982],[944.657,810.493],[944.657,925.61]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[923.92,433.19],[923.92,319.178],[1020.76,437.296],[1020.76,327.698]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[923.92,550.581],[923.92,436.569],[1020.76,550.142],[1020.76,440.544]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[923.92,560.503],[923.92,674.514],[1020.76,559.68],[1020.76,669.278]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[923.92,684.094],[923.92,798.105],[1020.76,678.487],[1020.76,788.085]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[923.92,807.889],[923.92,921.901],[1020.76,797.49],[1020.76,907.089]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1174.93,345.3],[1174.93,247.926],[934.26,364.829],[934.26,277.259]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1152.78,443],[1152.78,339.533],[1106.63,444.875],[1106.63,343.424]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1152.78,549.533],[1152.78,446.066],[1106.63,549.333],[1106.63,447.882]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1152.78,558.537],[1152.78,662.004],[1106.63,558.161],[1106.63,659.612]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1152.78,670.698],[1152.78,774.164],[1106.63,668.136],[1106.63,769.587]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1152.78,783.044],[1152.78,886.51],[1106.63,778.293],[1106.63,879.744]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1153.32,442.977],[1153.32,339.485],[1233.46,446.372],[1233.46,346.53]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1153.32,549.536],[1153.32,446.044],[1233.46,549.173],[1233.46,449.331]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1153.32,558.542],[1153.32,662.033],[1233.46,557.861],[1233.46,657.703]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1153.32,670.729],[1153.32,774.22],[1233.46,666.092],[1233.46,765.934]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1153.32,783.102],[1153.32,886.593],[1233.46,774.502],[1233.46,874.343]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1174.54,345.274],[1174.54,247.887],[1339.93,359.526],[1339.93,269.295]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,445.556],[1254.96,344.838],[1233.46,446.372],[1233.46,346.53]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,549.26],[1254.96,448.542],[1233.46,549.173],[1233.46,449.331]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,558.025],[1254.96,658.743],[1233.46,557.861],[1233.46,657.703]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,667.206],[1254.96,767.924],[1233.46,666.092],[1233.46,765.934]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,776.567],[1254.96,877.286],[1233.46,774.502],[1233.46,874.343]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,445.557],[1254.96,344.838],[1350.14,449.665],[1350.14,353.363]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,549.26],[1254.96,448.542],[1350.14,548.821],[1350.14,452.519]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,558.025],[1254.96,658.743],[1350.14,557.202],[1350.14,653.503]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,667.206],[1254.96,767.924],[1350.14,661.595],[1350.14,757.897]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1254.96,776.567],[1254.96,877.286],[1350.14,766.161],[1350.14,862.463]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1401.41,364.817],[1401.41,277.242],[1162.02,380.775],[1162.02,301.212]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1329.5,450.386],[1329.5,354.859],[1397.92,453.286],[1397.92,360.877]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1329.5,660.611],[1329.5,756.138],[1397.92,656.65],[1397.92,749.059]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1329.5,548.744],[1329.5,453.217],[1397.92,548.434],[1397.92,456.025]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1329.5,557.057],[1329.5,652.584],[1397.92,556.476],[1397.92,648.885]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1329.5,764.336],[1329.5,859.863],[1397.92,756.989],[1397.92,849.398]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1395.46,453.236],[1395.46,360.773],[1459.12,455.934],[1459.12,366.37]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1395.46,548.44],[1395.46,455.977],[1459.12,548.152],[1459.12,458.588]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1395.46,556.486],[1395.46,648.949],[1459.12,555.946],[1459.12,645.509]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1395.46,656.718],[1395.46,749.181],[1459.12,653.034],[1459.12,742.598]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1395.46,757.116],[1395.46,849.579],[1459.12,750.284],[1459.12,839.847]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1401.08,364.796],[1401.08,277.211],[1534.1,376.259],[1534.1,294.428]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,455.278],[1480.17,365.01],[1459.12,455.934],[1459.12,366.37]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,548.222],[1480.17,457.953],[1459.12,548.152],[1459.12,458.588]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,556.077],[1480.17,646.345],[1459.12,555.946],[1459.12,645.509]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,653.93],[1480.17,744.198],[1459.12,653.034],[1459.12,742.598]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,751.945],[1480.17,842.213],[1459.12,750.284],[1459.12,839.847]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,455.278],[1480.17,365.01],[1556.97,458.593],[1556.97,371.889]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,548.222],[1480.17,457.953],[1556.97,547.868],[1556.97,461.163]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,556.077],[1480.17,646.345],[1556.97,555.413],[1556.97,642.117]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,653.93],[1480.17,744.198],[1556.97,649.402],[1556.97,736.107]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1480.17,751.945],[1480.17,842.213],[1556.97,743.548],[1556.97,830.252]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1533.9,376.241],[1533.9,294.402],[1650.54,386.293],[1650.54,309.5]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1536.88,459.178],[1536.88,373.102],[1592.6,461.54],[1592.6,378.004]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1536.88,648.604],[1536.88,734.68],[1592.6,645.378],[1592.6,728.914]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1536.88,547.805],[1536.88,461.729],[1592.6,547.553],[1592.6,464.016]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1536.88,555.296],[1536.88,641.372],[1592.6,554.822],[1592.6,638.359]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1536.88,742.067],[1536.88,828.143],[1592.6,736.083],[1592.6,819.619]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1591.13,461.527],[1591.13,377.976],[1643.27,463.736],[1643.27,382.56]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1591.13,547.554],[1591.13,464.003],[1643.27,547.318],[1643.27,466.142]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1591.13,554.825],[1591.13,638.376],[1643.27,554.382],[1643.27,635.559]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1591.13,645.396],[1591.13,728.947],[1643.27,642.379],[1643.27,723.555]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1591.13,736.117],[1591.13,819.668],[1643.27,730.522],[1643.27,811.698]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,463.198],[1663.65,381.443],[1643.27,463.736],[1643.27,382.56]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,547.376],[1663.65,465.621],[1643.27,547.318],[1643.27,466.142]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,554.49],[1663.65,636.245],[1643.27,554.382],[1643.27,635.559]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,643.114],[1663.65,724.869],[1643.27,642.379],[1643.27,723.555]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,731.885],[1663.65,813.64],[1643.27,730.522],[1643.27,811.698]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,463.198],[1663.65,381.443],[1726.88,465.928],[1726.88,387.107]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,547.376],[1663.65,465.621],[1726.88,547.084],[1726.88,468.264]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,554.49],[1663.65,636.245],[1726.88,553.943],[1726.88,632.764]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,643.114],[1663.65,724.869],[1726.88,639.387],[1726.88,718.207]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1663.65,731.885],[1663.65,813.64],[1726.88,724.971],[1726.88,803.792]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1707.48,466.411],[1707.48,388.11],[1753.72,468.371],[1753.72,392.178]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1707.48,553.847],[1707.48,632.147],[1753.72,553.454],[1753.72,629.647]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1707.48,547.033],[1707.48,468.732],[1753.72,546.823],[1753.72,470.63]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1707.48,638.726],[1707.48,717.027],[1753.72,636.049],[1753.72,712.243]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:54,
                    verts:[[1707.48,723.747],[1707.48,802.047],[1753.72,718.782],[1753.72,794.975]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[62.8557,412.923],[62.8557,277.124],[-75.2403,423.242],[-75.2403,298.536]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[62.8557,552.746],[62.8557,416.948],[-75.2403,551.643],[-75.2403,426.938]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[62.8557,564.563],[62.8557,700.361],[-75.2403,562.496],[-75.2403,687.201]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[62.8557,711.771],[62.8557,847.57],[-75.2403,697.679],[-75.2403,822.385]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[62.8557,859.223],[62.8557,995.021],[-75.2403,833.087],[-75.2403,957.793]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.055,396.394],[284.055,242.828],[109.326,409.45],[109.326,269.919]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.055,554.511],[284.055,400.945],[109.326,553.117],[109.326,413.586]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.055,567.875],[284.055,721.441],[109.326,565.259],[109.326,704.79]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.055,734.344],[284.055,887.909],[109.326,716.513],[109.326,856.044]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.055,901.088],[284.055,1054.65],[109.326,868.018],[109.326,1007.55]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[372.564,260.016],[372.564,119.825],[115.469,295.905],[115.469,173.732]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.054,396.394],[284.054,242.828],[437.263,404.358],[437.263,259.353]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.054,554.511],[284.054,400.945],[437.263,553.66],[437.263,408.655]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.054,567.875],[284.054,721.441],[437.263,566.279],[437.263,711.284]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.054,734.344],[284.054,887.909],[437.263,723.468],[437.263,868.473]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[284.054,901.088],[284.054,1054.65],[437.263,880.917],[437.263,1025.92]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[371.87,259.956],[371.87,119.735],[662.105,290.425],[662.105,165.501]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,402.834],[460.593,256.19],[437.263,404.358],[437.263,259.353]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,553.823],[460.593,407.18],[437.263,553.66],[437.263,408.655]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,566.585],[460.593,713.228],[437.263,566.279],[437.263,711.284]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,725.549],[460.593,872.192],[437.263,723.468],[437.263,868.473]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,884.777],[460.593,1031.42],[437.263,880.917],[437.263,1025.92]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,402.834],[460.593,256.19],[634.844,412.077],[634.844,275.37]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,553.823],[460.593,407.18],[634.844,552.836],[634.844,416.129]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,566.585],[460.593,713.228],[634.844,564.733],[634.844,701.44]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,725.549],[460.593,872.192],[634.844,712.926],[634.844,849.634]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[460.593,884.777],[460.593,1031.42],[634.844,861.365],[634.844,998.073]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[610.438,413.449],[610.438,278.216],[728.74,419.594],[728.74,290.967]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[610.438,552.689],[610.438,417.457],[728.74,552.033],[728.74,423.406]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[610.438,564.458],[610.438,699.691],[728.74,563.227],[728.74,691.854]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[610.438,711.053],[610.438,846.286],[728.74,702.661],[728.74,831.288]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[610.438,857.891],[610.438,993.124],[728.74,842.326],[728.74,970.953]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[662.407,290.456],[662.407,165.549],[895.076,314.882],[895.076,202.237]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[730.98,419.71],[730.98,291.208],[838.421,425.291],[838.421,302.788]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[730.98,552.021],[730.98,423.519],[838.421,551.425],[838.421,428.922]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[730.98,563.203],[730.98,691.705],[838.421,562.085],[838.421,684.588]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[730.98,702.502],[730.98,831.004],[838.421,694.881],[838.421,817.383]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[730.98,842.032],[730.98,970.534],[838.421,827.896],[838.421,950.399]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,424.166],[862.757,300.455],[838.421,425.291],[838.421,302.788]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,551.545],[862.757,427.833],[838.421,551.425],[838.421,428.922]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,562.31],[862.757,686.022],[838.421,562.085],[838.421,684.588]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,696.416],[862.757,820.128],[838.421,694.881],[838.421,817.383]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,830.744],[862.757,954.456],[838.421,827.896],[838.421,950.399]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,424.167],[862.757,300.455],[988.099,430.815],[988.099,314.251]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,551.545],[862.757,427.833],[988.099,550.834],[988.099,434.27]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,562.31],[862.757,686.022],[988.099,560.978],[988.099,677.543]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,696.416],[862.757,820.128],[988.099,687.337],[988.099,803.901]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[862.757,830.744],[862.757,954.456],[988.099,813.904],[988.099,930.469]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[964.816,431.78],[964.816,316.254],[1052.74,436.351],[1052.74,325.737]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[964.816,550.731],[964.816,435.205],[1052.74,550.243],[1052.74,439.629]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[964.816,560.785],[964.816,676.312],[1052.74,559.869],[1052.74,670.483]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[964.816,686.019],[964.816,801.545],[1052.74,679.777],[1052.74,790.391]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[964.816,811.46],[964.816,926.986],[1052.74,799.884],[1052.74,910.498]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.24,442.631],[1171.24,338.768],[1121.07,444.363],[1121.07,342.362]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.24,549.572],[1171.24,445.709],[1121.07,549.388],[1121.07,447.386]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.24,558.611],[1171.24,662.474],[1121.07,558.264],[1121.07,660.265]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.24,671.201],[1171.24,775.064],[1121.07,668.836],[1121.07,770.837]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.24,783.977],[1171.24,887.84],[1121.07,779.591],[1121.07,881.592]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1180.17,344.803],[1180.17,247.179],[918.655,362.913],[918.655,274.382]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.83,442.61],[1171.83,338.724],[1243.29,446.322],[1243.29,346.426]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.83,549.575],[1171.83,445.689],[1243.29,549.178],[1243.29,449.282]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.83,558.615],[1171.83,662.501],[1243.29,557.872],[1243.29,657.767]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.83,671.23],[1171.83,775.116],[1243.29,666.161],[1243.29,766.057]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1171.83,784.031],[1171.83,887.917],[1243.29,774.629],[1243.29,874.525]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1179.81,344.773],[1179.81,247.136],[1327.36,360.263],[1327.36,270.402]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,445.575],[1266.35,344.877],[1243.29,446.322],[1243.29,346.426]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,549.258],[1266.35,448.56],[1243.29,549.178],[1243.29,449.282]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,558.021],[1266.35,658.719],[1243.29,557.872],[1243.29,657.767]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,667.18],[1266.35,767.878],[1243.29,666.161],[1243.29,766.057]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,776.52],[1266.35,877.218],[1243.29,774.629],[1243.29,874.525]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,445.575],[1266.35,344.877],[1350.3,450.028],[1350.3,354.117]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,549.258],[1266.35,448.56],[1350.3,548.782],[1350.3,452.871]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,558.021],[1266.35,658.719],[1350.3,557.129],[1350.3,653.04]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,667.18],[1266.35,767.878],[1350.3,661.099],[1350.3,757.01]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1266.35,776.52],[1266.35,877.218],[1350.3,765.241],[1350.3,861.152]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1381.71,365.961],[1381.71,278.961],[1129.37,380.492],[1129.37,300.786]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1328.45,450.683],[1328.45,355.475],[1388.62,453.81],[1388.62,361.964]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1328.45,548.712],[1328.45,453.505],[1388.62,548.378],[1388.62,456.532]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1328.45,556.998],[1328.45,652.206],[1388.62,556.371],[1388.62,648.217]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1328.45,660.205],[1328.45,755.413],[1388.62,655.934],[1388.62,747.78]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1328.45,763.583],[1328.45,858.791],[1388.62,755.662],[1388.62,847.508]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1381.42,365.938],[1381.42,278.926],[1498.09,378.187],[1498.09,297.324]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1386.34,453.752],[1386.34,361.844],[1442.04,456.646],[1442.04,367.848]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1386.34,548.385],[1386.34,456.476],[1442.04,548.076],[1442.04,459.278]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1386.34,556.383],[1386.34,648.291],[1442.04,555.803],[1442.04,644.601]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1386.34,656.013],[1386.34,747.922],[1442.04,652.062],[1442.04,740.86]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1386.34,755.809],[1386.34,847.717],[1442.04,748.48],[1442.04,837.278]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,456.056],[1463.94,366.625],[1442.04,456.646],[1442.04,367.848]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,548.138],[1463.94,458.707],[1442.04,548.076],[1442.04,459.278]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,555.921],[1463.94,645.352],[1442.04,555.803],[1442.04,644.601]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,652.867],[1463.94,742.298],[1442.04,652.062],[1442.04,740.86]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,749.973],[1463.94,839.404],[1442.04,748.48],[1442.04,837.278]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,456.056],[1463.94,366.625],[1530.51,459.588],[1530.51,373.952]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,548.138],[1463.94,458.707],[1530.51,547.761],[1530.51,462.126]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,555.921],[1463.94,645.352],[1530.51,555.214],[1530.51,640.849]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,652.867],[1463.94,742.298],[1530.51,648.044],[1530.51,733.68]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1463.94,749.973],[1463.94,839.404],[1530.51,741.029],[1530.51,826.665]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1497.92,378.168],[1497.92,297.296],[1599.21,388.802],[1599.21,313.269]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1509.81,460.11],[1509.81,375.035],[1558.03,462.616],[1558.03,380.236]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1509.81,547.706],[1509.81,462.631],[1558.03,547.438],[1558.03,465.058]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1509.81,555.109],[1509.81,640.183],[1558.03,554.607],[1558.03,636.987]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1509.81,647.331],[1509.81,732.406],[1558.03,643.908],[1558.03,726.288]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1509.81,739.707],[1509.81,824.781],[1558.03,733.358],[1558.03,815.738]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1556.65,462.599],[1556.65,380.2],[1601.58,464.932],[1601.58,385.042]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1556.65,547.44],[1556.65,465.041],[1601.58,547.19],[1601.58,467.3]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1556.65,554.61],[1556.65,637.009],[1601.58,554.143],[1601.58,634.033]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1556.65,643.932],[1556.65,726.331],[1601.58,640.745],[1601.58,720.635]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1556.65,733.402],[1556.65,815.801],[1601.58,727.491],[1601.58,807.381]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,464.456],[1622.29,384.053],[1601.58,464.932],[1601.58,385.042]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,547.241],[1622.29,466.839],[1601.58,547.19],[1601.58,467.3]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,554.238],[1622.29,634.641],[1601.58,554.143],[1601.58,634.033]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,641.396],[1622.29,721.799],[1601.58,640.745],[1601.58,720.635]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,728.699],[1622.29,809.101],[1601.58,727.491],[1601.58,807.381]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,464.456],[1622.29,384.053],[1676.32,467.322],[1676.32,390.001]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,547.241],[1622.29,466.839],[1676.32,546.935],[1676.32,469.614]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,554.238],[1622.29,634.641],[1676.32,553.664],[1676.32,630.985]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,641.396],[1622.29,721.799],[1676.32,637.482],[1676.32,714.803]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1622.29,728.699],[1622.29,809.101],[1676.32,721.438],[1676.32,798.76]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1656.76,467.748],[1656.76,390.885],[1696.24,469.8],[1696.24,395.143]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1656.76,546.89],[1656.76,470.026],[1696.24,546.67],[1696.24,472.013]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1656.76,553.579],[1656.76,630.442],[1696.24,553.167],[1696.24,627.825]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1656.76,636.9],[1656.76,713.763],[1696.24,634.097],[1696.24,708.755]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:55,
                    verts:[[1656.76,720.36],[1656.76,797.223],[1696.24,715.161],[1696.24,789.819]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[111.553,406.64],[111.553,264.088],[-62.5105,416.894],[-62.5105,285.365]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[111.553,553.417],[111.553,410.865],[-62.5105,552.321],[-62.5105,420.792]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[111.553,565.822],[111.553,708.374],[-62.5105,563.768],[-62.5105,695.297]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[111.553,720.352],[111.553,862.904],[-62.5105,706.348],[-62.5105,837.877]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[111.553,875.137],[111.553,1017.69],[-62.5105,849.165],[-62.5105,980.694]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[451.362,249.623],[451.362,104.216],[138.589,284.588],[138.589,156.734]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.964,390.415],[386.964,230.422],[169.757,403.211],[169.757,256.973]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.964,555.15],[386.964,395.157],[169.757,553.783],[169.757,407.545]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.964,569.073],[386.964,729.066],[169.757,566.509],[169.757,712.747]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.964,742.509],[386.964,902.502],[169.757,725.034],[169.757,871.272]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.964,916.232],[386.964,1076.22],[169.757,883.822],[169.757,1030.06]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.963,390.415],[386.963,230.422],[529.81,399.646],[529.81,249.577]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.963,555.15],[386.963,395.157],[529.81,554.164],[529.81,404.094]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.963,569.073],[386.963,729.066],[529.81,567.223],[529.81,717.293]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.963,742.509],[386.963,902.502],[529.81,729.902],[529.81,879.971]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[386.963,916.232],[386.963,1076.22],[529.81,892.85],[529.81,1042.92]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[450.697,249.552],[450.697,104.109],[719.73,284.358],[719.73,156.388]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,398.182],[557.8,246.539],[529.81,399.646],[529.81,249.577]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,554.32],[557.8,402.677],[529.81,554.164],[529.81,404.094]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,567.517],[557.8,719.16],[529.81,567.223],[529.81,717.293]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,731.901],[557.8,883.544],[529.81,729.902],[529.81,879.971]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,896.557],[557.8,1048.2],[529.81,892.85],[529.81,1042.92]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,398.182],[557.8,246.539],[717.204,408.729],[717.204,268.423]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,554.32],[557.8,402.677],[717.204,553.194],[717.204,412.887]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,567.517],[557.8,719.16],[717.204,565.404],[717.204,705.71]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,731.901],[557.8,883.544],[717.204,717.498],[717.204,857.805]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[557.8,896.558],[557.8,1048.2],[717.204,869.845],[717.204,1010.15]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[688.795,410.027],[688.795,271.116],[796.198,416.962],[796.198,285.507]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[688.795,553.055],[688.795,414.144],[796.198,552.314],[796.198,420.859]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[688.795,565.143],[688.795,704.054],[796.198,563.754],[796.198,695.209]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[688.795,715.726],[688.795,854.637],[796.198,706.255],[796.198,837.71]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[688.795,866.557],[688.795,1005.47],[796.198,848.991],[796.198,980.447]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[720.006,284.393],[720.006,156.442],[930.901,311.677],[930.901,197.423]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[798.221,417.093],[798.221,285.778],[894.805,423.33],[894.805,298.719]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[798.221,552.3],[798.221,420.985],[894.805,551.634],[894.805,427.023]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[798.221,563.728],[798.221,695.043],[894.805,562.478],[894.805,687.089]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[798.221,706.076],[798.221,837.391],[894.805,697.559],[894.805,822.17]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[798.221,848.66],[798.221,979.976],[894.805,832.864],[894.805,957.474]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,422.286],[922.117,296.554],[894.805,423.33],[894.805,298.719]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,551.745],[922.117,426.013],[894.805,551.634],[894.805,427.023]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,562.687],[922.117,688.42],[894.805,562.478],[894.805,687.089]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,698.984],[922.117,824.716],[894.805,697.559],[894.805,822.17]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,835.507],[922.117,961.239],[894.805,832.864],[894.805,957.475]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,422.286],[922.117,296.554],[1033.12,429.63],[1033.12,311.793]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,551.745],[922.117,426.013],[1033.12,550.961],[1033.12,433.123]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,562.687],[922.117,688.42],[1033.12,561.216],[1033.12,679.054]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,698.984],[922.117,824.716],[1033.12,688.955],[1033.12,806.793]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[922.117,835.507],[922.117,961.239],[1033.12,816.905],[1033.12,934.743]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1007.48,430.517],[1007.48,313.631],[1085.01,435.527],[1085.01,324.028]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1007.48,550.866],[1007.48,433.981],[1085.01,550.331],[1085.01,438.832]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1007.48,561.038],[1007.48,677.924],[1085.01,560.034],[1085.01,671.533]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1007.48,687.745],[1007.48,804.63],[1085.01,680.902],[1085.01,792.401]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1007.48,814.661],[1007.48,931.546],[1085.01,801.969],[1085.01,913.468]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.33,442.344],[1188.33,338.173],[1134.54,443.911],[1134.54,341.423]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.33,549.603],[1188.33,445.432],[1134.54,549.436],[1134.54,446.948]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.33,558.668],[1188.33,662.84],[1134.54,558.355],[1134.54,660.842]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.33,671.592],[1188.33,775.764],[1134.54,669.453],[1134.54,771.941]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.33,784.703],[1188.33,888.875],[1134.54,780.736],[1134.54,883.223]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1183.73,344.376],[1183.73,246.538],[902.696,360.856],[902.696,271.293]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1183.41,344.344],[1183.41,246.49],[1311.9,360.967],[1311.9,271.46]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.97,442.325],[1188.97,338.133],[1250.94,446.327],[1250.94,346.437]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.97,549.605],[1188.97,445.413],[1250.94,549.178],[1250.94,449.288]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.97,558.672],[1188.97,662.864],[1250.94,557.871],[1250.94,657.76]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.97,671.619],[1188.97,775.811],[1250.94,666.153],[1250.94,766.043]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1188.97,784.752],[1188.97,888.944],[1250.94,774.615],[1250.94,874.505]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,445.658],[1275.36,345.048],[1250.94,446.327],[1250.94,346.437]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,549.249],[1275.36,448.64],[1250.94,549.178],[1250.94,449.288]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,558.005],[1275.36,658.614],[1250.94,557.87],[1250.94,657.76]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,667.067],[1275.36,767.677],[1250.94,666.153],[1250.94,766.043]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,776.311],[1275.36,876.92],[1250.94,774.615],[1250.94,874.505]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,445.658],[1275.36,345.048],[1347.34,450.42],[1347.34,354.93]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,549.249],[1275.36,448.64],[1347.34,548.74],[1347.34,453.25]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,558.005],[1275.36,658.614],[1347.34,557.05],[1347.34,652.541]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,667.067],[1275.36,767.677],[1347.34,660.564],[1347.34,756.054]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1275.36,776.311],[1275.36,876.92],[1347.34,764.249],[1347.34,859.739]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1358.85,367.032],[1358.85,280.569],[1094.8,380.031],[1094.8,300.094]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1324.47,451.003],[1324.47,356.139],[1375.99,454.332],[1375.99,363.048]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1324.47,556.934],[1324.47,651.798],[1375.99,556.267],[1375.99,647.551]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1324.47,548.678],[1324.47,453.814],[1375.99,548.323],[1375.99,457.038]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1324.47,659.768],[1324.47,754.632],[1375.99,655.221],[1375.99,746.506]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1324.47,762.773],[1324.47,857.637],[1375.99,754.34],[1375.99,845.625]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1358.59,367.007],[1358.59,280.532],[1458.64,379.951],[1458.64,299.974]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1373.9,454.267],[1373.9,362.912],[1421.39,457.333],[1421.39,369.274]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1373.9,548.33],[1373.9,456.975],[1421.39,548.002],[1421.39,459.943]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1373.9,556.28],[1373.9,647.634],[1421.39,555.665],[1421.39,643.724]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1373.9,655.31],[1373.9,746.665],[1421.39,651.123],[1421.39,739.182]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1373.9,754.505],[1373.9,845.86],[1421.39,746.739],[1421.39,834.798]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,456.814],[1443.98,368.196],[1421.39,457.333],[1421.39,369.274]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,548.058],[1443.98,459.44],[1421.39,548.002],[1421.39,459.943]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,555.769],[1443.98,644.387],[1421.39,555.665],[1421.39,643.724]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,651.833],[1443.98,740.45],[1421.39,651.123],[1421.39,739.182]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,748.055],[1443.98,836.673],[1421.39,746.739],[1421.39,834.798]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,456.814],[1443.98,368.196],[1500.16,460.531],[1500.16,375.909]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,548.058],[1443.98,459.44],[1500.16,547.661],[1500.16,463.039]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,555.769],[1443.98,644.387],[1500.16,555.025],[1500.16,639.646]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,651.833],[1443.98,740.45],[1500.16,646.757],[1500.16,731.378]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1443.98,748.055],[1443.98,836.673],[1500.16,738.64],[1500.16,823.262]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1458.49,379.931],[1458.49,299.944],[1544.57,391.068],[1544.57,316.673]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1478.99,460.989],[1478.99,376.859],[1519.68,463.619],[1519.68,382.316]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1478.99,554.933],[1478.99,639.062],[1519.68,554.406],[1519.68,635.708]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1478.99,547.612],[1478.99,463.482],[1519.68,547.331],[1519.68,466.028]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1478.99,646.131],[1478.99,730.261],[1519.68,642.54],[1519.68,723.842]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1478.99,737.48],[1478.99,821.61],[1519.68,730.819],[1519.68,812.122]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1518.39,463.597],[1518.39,382.272],[1556.17,466.037],[1556.17,387.334]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1518.39,547.333],[1518.39,466.008],[1556.17,547.073],[1556.17,468.37]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1518.39,554.41],[1518.39,635.736],[1556.17,553.922],[1556.17,632.624]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1518.39,642.569],[1518.39,723.894],[1556.17,639.237],[1556.17,717.94]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1518.39,730.873],[1518.39,812.199],[1556.17,724.694],[1556.17,803.397]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,465.622],[1577.11,386.473],[1556.17,466.037],[1556.17,387.334]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,547.117],[1577.11,467.968],[1556.17,547.073],[1556.17,468.37]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,554.005],[1577.11,633.154],[1556.17,553.922],[1556.17,632.624]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,639.804],[1577.11,718.953],[1556.17,639.237],[1556.17,717.94]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,725.745],[1577.11,804.894],[1556.17,724.694],[1556.17,803.397]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,465.622],[1577.11,386.473],[1622.15,468.602],[1622.15,392.655]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,547.117],[1577.11,467.968],[1622.15,546.799],[1622.15,470.853]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,554.005],[1577.11,633.154],[1622.15,553.408],[1622.15,629.354]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,639.804],[1577.11,718.953],[1622.15,635.735],[1622.15,711.681]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1577.11,725.745],[1577.11,804.894],[1622.15,718.198],[1622.15,794.144]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1602.49,468.971],[1602.49,393.421],[1635.42,471.099],[1635.42,397.837]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1602.49,546.759],[1602.49,471.21],[1635.42,546.532],[1635.42,473.27]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1602.49,553.334],[1602.49,628.883],[1635.42,552.907],[1635.42,626.169]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1602.49,635.231],[1602.49,710.78],[1635.42,632.325],[1635.42,705.586]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:56,
                    verts:[[1602.49,717.263],[1602.49,792.813],[1635.42,711.873],[1635.42,785.135]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[177.339,400.234],[177.339,250.796],[-35.5468,410.165],[-35.5468,271.403]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[177.339,554.101],[177.339,404.663],[-35.5468,553.04],[-35.5468,414.278]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[177.339,567.105],[177.339,716.543],[-35.5468,565.116],[-35.5468,703.878]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[177.339,729.099],[177.339,878.537],[-35.5468,715.537],[-35.5468,854.299]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[177.339,891.361],[177.339,1040.8],[-35.5468,866.207],[-35.5468,1004.97]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[544.214,239.717],[544.214,89.3354],[174.076,272.843],[174.076,139.093]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,384.775],[508.716,218.72],[247.924,396.941],[247.924,243.964]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,555.752],[508.716,389.697],[247.924,554.453],[247.924,401.475]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,570.203],[508.716,736.258],[247.924,567.765],[247.924,720.742]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,750.21],[508.716,916.265],[247.924,733.596],[247.924,886.573]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,930.516],[508.716,1096.57],[247.924,899.701],[247.924,1052.68]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,384.775],[508.716,218.72],[636.301,395.28],[636.301,240.517]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,555.752],[508.716,389.697],[636.301,554.63],[636.301,399.867]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,570.203],[508.716,736.258],[636.301,568.098],[636.301,722.861]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,750.21],[508.716,916.265],[636.301,735.865],[636.301,890.627]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[508.716,930.516],[508.716,1096.57],[636.301,903.909],[636.301,1058.67]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[543.597,239.635],[543.597,89.2123],[783.953,278.746],[783.953,147.959]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,393.918],[668.834,237.691],[636.301,395.28],[636.301,240.517]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,554.776],[668.834,398.548],[636.301,554.63],[636.301,399.867]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,568.371],[668.834,724.598],[636.301,568.098],[636.301,722.861]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,737.724],[668.834,893.951],[636.301,735.865],[636.301,890.627]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,907.358],[636.301,903.909],[668.834,1063.59],[636.301,1058.67]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,393.918],[668.834,237.691],[808.354,405.734],[808.354,262.209]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,554.776],[668.834,398.548],[808.354,553.513],[808.354,409.988]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,568.371],[668.834,724.598],[808.354,566.004],[808.354,709.529]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,737.724],[668.834,893.951],[808.354,721.588],[808.354,865.113]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[668.834,907.358],[668.834,1063.59],[808.354,877.43],[808.354,1020.96]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[784.197,278.786],[784.197,148.019],[968.672,308.804],[968.672,193.107]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[776.152,406.925],[776.152,264.679],[869.699,414.62],[869.699,280.646]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[776.152,553.386],[776.152,411.141],[869.699,552.564],[869.699,418.59]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[776.152,565.765],[776.152,708.01],[869.699,564.223],[869.699,698.197]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[776.152,719.962],[776.152,862.207],[869.699,709.454],[869.699,843.428]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[776.152,874.415],[776.152,1016.66],[869.699,854.925],[869.699,988.899]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[871.453,414.764],[871.453,280.945],[954.809,421.62],[954.809,295.172]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[871.453,552.549],[871.453,418.73],[954.809,551.817],[954.809,425.368]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[871.453,564.194],[871.453,698.013],[954.809,562.821],[954.809,689.269]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[871.453,709.257],[871.453,843.076],[954.809,699.893],[954.809,826.342]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[871.453,854.56],[871.453,988.378],[954.809,837.193],[954.809,963.642]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,420.68],[984.834,293.221],[954.809,421.62],[954.809,295.172]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,551.917],[984.834,424.458],[954.809,551.817],[954.809,425.368]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,563.009],[984.834,690.468],[954.809,562.821],[954.809,689.269]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,701.177],[984.834,828.636],[954.809,699.893],[954.809,826.342]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,839.574],[954.809,837.193],[984.834,967.033],[954.809,963.642]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,420.68],[984.834,293.222],[1079.11,428.665],[1079.11,309.789]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,551.917],[984.834,424.458],[1079.11,551.064],[1079.11,432.188]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,563.009],[984.834,690.468],[1079.11,561.409],[1079.11,680.285]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,701.177],[984.834,828.636],[1079.11,690.273],[1079.11,809.149]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[984.834,839.574],[984.834,967.033],[1079.11,819.351],[1079.11,938.226]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1051.37,429.455],[1051.37,311.429],[1117.12,434.869],[1117.12,322.662]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1051.37,550.98],[1051.37,432.954],[1117.12,550.402],[1117.12,438.194]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1051.37,561.251],[1051.37,679.277],[1117.12,560.166],[1117.12,672.373]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1051.37,689.194],[1051.37,807.22],[1117.12,681.801],[1117.12,794.008]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1051.37,817.349],[1051.37,935.375],[1117.12,803.637],[1117.12,915.845]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1185.43,344.063],[1185.43,246.068],[886.505,358.693],[886.505,268.043]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1203.71,442.166],[1203.71,337.804],[1146.78,443.546],[1146.78,340.667]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1203.71,549.622],[1203.71,445.26],[1146.78,549.475],[1146.78,446.595]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1203.71,558.704],[1203.71,663.067],[1146.78,558.428],[1146.78,661.307]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1203.71,671.835],[1203.71,776.198],[1146.78,669.951],[1146.78,772.831]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1203.71,785.154],[1203.71,889.516],[1146.78,781.66],[1146.78,884.539]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1185.14,344.028],[1185.14,246.016],[1293.5,361.661],[1293.5,272.501]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1204.38,442.149],[1204.38,337.769],[1256.16,446.408],[1256.16,346.605]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1204.38,549.624],[1204.38,445.243],[1256.16,549.169],[1256.16,449.366]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1204.38,558.708],[1204.38,663.088],[1256.16,557.854],[1256.16,657.657]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1204.38,671.859],[1204.38,776.239],[1256.16,666.043],[1256.16,765.846]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1204.38,785.197],[1204.38,889.578],[1256.16,774.41],[1256.16,874.213]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,445.823],[1281.71,345.392],[1256.16,446.408],[1256.16,346.605]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,549.232],[1281.71,448.8],[1256.16,549.169],[1256.16,449.366]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,557.971],[1281.71,658.403],[1256.16,557.854],[1256.16,657.657]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,666.841],[1281.71,767.272],[1256.16,666.043],[1256.16,765.846]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,775.891],[1256.16,774.41],[1281.71,876.322],[1256.16,874.213]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,445.824],[1281.71,345.392],[1341.1,450.853],[1341.1,355.828]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,549.232],[1281.71,448.8],[1341.1,548.694],[1341.1,453.669]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,557.971],[1281.71,658.403],[1341.1,556.964],[1341.1,651.989]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,666.841],[1281.71,767.272],[1341.1,659.973],[1341.1,754.998]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1281.71,775.891],[1281.71,876.322],[1341.1,763.153],[1341.1,858.178]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1332.81,368.046],[1332.81,282.092],[1058.4,379.406],[1058.4,299.156]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1332.58,368.019],[1332.58,282.052],[1415.8,381.561],[1415.8,302.392]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1317.39,451.358],[1317.39,356.877],[1359.94,454.862],[1359.94,364.147]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1317.39,556.862],[1317.39,651.344],[1359.94,556.16],[1359.94,646.876]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1317.39,548.64],[1317.39,454.159],[1359.94,548.266],[1359.94,457.551]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1317.39,659.282],[1317.39,753.764],[1359.94,654.498],[1359.94,745.213]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1317.39,761.872],[1317.39,856.353],[1359.94,752.998],[1359.94,843.714]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1358.06,454.79],[1358.06,363.997],[1397.12,458.003],[1397.12,370.664]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1358.06,548.274],[1358.06,457.481],[1397.12,547.931],[1397.12,460.592]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1358.06,556.175],[1358.06,646.968],[1397.12,555.531],[1397.12,642.87]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1358.06,654.596],[1358.06,745.389],[1397.12,650.208],[1397.12,737.547]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1358.06,753.181],[1358.06,843.973],[1397.12,745.042],[1397.12,832.381]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,457.556],[1420.24,369.736],[1397.12,458.003],[1397.12,370.664]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,547.978],[1420.24,460.159],[1397.12,547.931],[1397.12,460.592]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,555.621],[1420.24,643.44],[1397.12,555.531],[1397.12,642.87]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,650.819],[1420.24,738.639],[1397.12,650.208],[1397.12,737.547]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,746.175],[1397.12,745.042],[1420.24,833.995],[1397.12,832.381]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1415.67,381.54],[1415.67,302.361],[1486.71,393.1],[1486.71,319.724]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,457.556],[1420.24,369.736],[1465.96,461.427],[1465.96,377.77]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,547.978],[1420.24,460.159],[1465.96,547.565],[1465.96,463.907]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,555.621],[1420.24,643.44],[1465.96,554.845],[1465.96,638.503]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,650.819],[1420.24,738.639],[1465.96,645.532],[1465.96,729.19]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1420.24,746.175],[1420.24,833.995],[1465.96,736.369],[1465.96,820.027]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1444.44,554.766],[1444.44,638.003],[1477.63,554.219],[1477.63,634.518]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1444.44,461.82],[1444.44,378.583],[1477.63,464.552],[1477.63,384.252]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1444.44,547.523],[1444.44,464.287],[1477.63,547.231],[1477.63,466.932]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1444.44,644.996],[1444.44,728.232],[1477.63,641.265],[1477.63,721.565]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1444.44,735.376],[1444.44,818.612],[1477.63,728.456],[1477.63,808.755]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1476.43,464.527],[1476.43,384.201],[1507.14,467.053],[1507.14,389.442]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1476.43,547.234],[1476.43,466.908],[1507.14,546.964],[1507.14,469.353]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1476.43,554.224],[1476.43,634.55],[1507.14,553.718],[1507.14,631.329]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1476.43,641.299],[1476.43,721.625],[1507.14,637.85],[1507.14,715.46]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1476.43,728.519],[1476.43,808.845],[1507.14,722.121],[1507.14,799.731]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,466.7],[1528.22,388.71],[1507.14,467.053],[1507.14,389.442]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,547.002],[1528.22,469.012],[1507.14,546.964],[1507.14,469.353]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,553.789],[1528.22,631.779],[1507.14,553.718],[1507.14,631.329]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,638.332],[1528.22,716.322],[1507.14,637.85],[1507.14,715.46]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,723.015],[1507.14,722.121],[1528.22,801.005],[1507.14,799.731]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,466.7],[1528.22,388.71],[1564.46,469.77],[1564.46,395.079]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,547.002],[1528.22,469.012],[1564.46,546.674],[1564.46,471.983]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,553.789],[1528.22,631.779],[1564.46,553.174],[1564.46,627.864]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,638.332],[1528.22,716.322],[1564.46,634.14],[1564.46,708.83]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1528.22,723.015],[1528.22,801.005],[1564.46,715.24],[1564.46,789.93]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1544.8,470.082],[1544.8,395.728],[1571.38,472.271],[1571.38,400.269]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1544.8,546.64],[1544.8,472.286],[1571.38,546.407],[1571.38,474.405]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1544.8,553.111],[1544.8,627.465],[1571.38,552.672],[1571.38,624.674]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1544.8,633.712],[1544.8,708.066],[1571.38,630.724],[1571.38,702.726]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:57,
                    verts:[[1544.8,714.447],[1544.8,788.801],[1571.38,708.905],[1571.38,780.906]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[262.117,393.904],[262.117,237.662],[8.53598,403.177],[8.53598,256.903]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[262.117,554.777],[262.117,398.535],[8.53598,553.787],[8.53598,407.513]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[262.117,568.374],[262.117,724.616],[8.53598,566.516],[8.53598,712.79]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[262.117,737.744],[262.117,893.986],[8.53598,725.08],[8.53598,871.354]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[262.117,907.394],[262.117,1063.64],[8.53598,883.907],[8.53598,1030.18]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[650.882,230.735],[650.882,75.8441],[223.776,260.934],[223.776,121.204]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,379.767],[648.71,208.328],[345.284,390.863],[345.284,231.351]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,556.287],[648.71,384.848],[345.284,555.102],[345.284,395.59]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,571.206],[648.71,742.645],[345.284,568.983],[345.284,728.495]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,757.05],[648.71,928.489],[345.284,741.897],[345.284,901.408]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,943.201],[648.71,1114.64],[345.284,915.097],[345.284,1074.61]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,379.767],[648.71,208.328],[755.818,391.479],[755.818,232.629]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,556.287],[648.71,384.848],[755.818,555.036],[755.818,396.187]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,571.206],[648.71,742.645],[755.818,568.86],[755.818,727.709]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,757.05],[648.71,928.489],[755.818,741.056],[755.818,899.905]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[648.71,943.201],[648.71,1114.64],[755.818,913.537],[755.818,1072.39]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[650.332,230.642],[650.332,75.7045],[854.201,273.827],[854.201,140.57]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,390.264],[792.531,230.11],[755.818,391.479],[755.818,232.629]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,555.166],[792.531,395.011],[755.818,555.036],[755.818,396.187]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,569.103],[792.531,729.257],[755.818,568.86],[755.818,727.709]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,742.714],[792.531,902.868],[755.818,741.056],[755.818,899.905]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,916.612],[755.818,913.537],[792.531,1076.77],[755.818,1072.39]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,390.264],[792.531,230.11],[907.086,403.246],[907.086,257.047]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,555.166],[792.531,395.011],[907.086,553.779],[907.086,407.58]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,569.103],[792.531,729.257],[907.086,566.502],[907.086,712.701]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,742.714],[792.531,902.868],[907.086,724.985],[907.086,871.185]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[792.531,916.612],[792.531,1076.77],[907.086,883.731],[907.086,1029.93]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[854.406,273.87],[854.406,140.636],[1007.91,306.387],[1007.91,189.477]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[871.49,404.294],[871.49,259.221],[948.27,412.68],[948.27,276.621]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[871.49,553.667],[871.49,408.594],[948.27,552.772],[948.27,416.712]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[871.49,566.292],[871.49,711.365],[948.27,564.612],[948.27,700.671]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[871.49,723.554],[871.49,868.627],[948.27,712.103],[948.27,848.162]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[871.49,881.077],[871.49,1026.15],[948.27,859.838],[948.27,995.898]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[949.704,412.836],[949.704,276.945],[1017.56,420.247],[1017.56,292.323]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[949.704,552.755],[949.704,416.864],[1017.56,551.963],[1017.56,424.039]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[949.704,564.581],[949.704,700.471],[1017.56,563.096],[1017.56,691.02]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[949.704,711.889],[949.704,847.78],[1017.56,701.769],[1017.56,829.693]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[949.704,859.442],[949.704,995.333],[1017.56,840.671],[1017.56,968.595]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,419.433],[1049.92,290.634],[1017.56,420.247],[1017.56,292.323]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,552.05],[1049.92,423.251],[1017.56,551.963],[1017.56,424.039]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,563.259],[1049.92,692.058],[1017.56,563.096],[1017.56,691.02]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,702.88],[1049.92,831.68],[1017.56,701.769],[1017.56,829.693]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,842.733],[1017.56,840.671],[1049.92,971.533],[1017.56,968.595]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,419.433],[1049.92,290.634],[1125.3,427.975],[1125.3,308.358]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,552.05],[1049.92,423.251],[1125.3,551.138],[1125.3,431.521]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,563.259],[1049.92,692.058],[1125.3,561.547],[1125.3,681.165]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,702.88],[1049.92,831.68],[1125.3,691.215],[1125.3,810.832]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1049.92,842.733],[1049.92,971.533],[1125.3,821.098],[1125.3,940.715]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1095.79,428.654],[1095.79,309.766],[1148.49,434.416],[1148.49,321.722]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1095.79,551.065],[1095.79,432.178],[1148.49,550.45],[1148.49,437.756]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1095.79,561.411],[1095.79,680.299],[1148.49,560.257],[1148.49,672.951]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1095.79,690.288],[1095.79,809.176],[1148.49,682.419],[1148.49,795.113]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1095.79,819.378],[1095.79,938.266],[1148.49,804.784],[1148.49,917.478]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.02,442.122],[1217.02,337.712],[1157.52,443.295],[1157.52,340.145]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.02,549.627],[1217.02,445.217],[1157.52,549.502],[1157.52,446.352]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.02,558.713],[1217.02,663.123],[1157.52,558.478],[1157.52,661.628]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.02,671.896],[1217.02,776.305],[1157.52,670.294],[1157.52,773.444]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.02,785.266],[1217.02,889.675],[1157.52,782.296],[1157.52,885.446]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1185.09,343.903],[1185.09,245.829],[870.241,356.462],[870.241,264.692]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1184.85,343.866],[1184.85,245.773],[1272.15,362.36],[1272.15,273.552]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.73,442.108],[1217.73,337.682],[1258.7,446.582],[1258.7,346.966]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.73,549.628],[1217.73,445.203],[1258.7,549.151],[1258.7,449.535]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.73,558.716],[1217.73,663.141],[1258.7,557.819],[1258.7,657.435]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.73,671.915],[1217.73,776.341],[1258.7,665.805],[1258.7,765.421]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1217.73,785.302],[1217.73,889.728],[1258.7,773.97],[1258.7,873.586]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,446.089],[1285.14,345.943],[1258.7,446.582],[1258.7,346.966]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,549.203],[1285.14,449.057],[1258.7,549.151],[1258.7,449.535]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,557.918],[1285.14,658.064],[1258.7,557.819],[1258.7,657.435]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,666.478],[1285.14,766.624],[1258.7,665.805],[1258.7,765.421]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,775.219],[1258.7,773.97],[1285.14,875.364],[1258.7,873.586]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1303.63,369.014],[1303.63,283.547],[1020.27,378.631],[1020.27,297.991]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,446.089],[1285.14,345.943],[1331.44,451.336],[1331.44,356.831]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,549.203],[1285.14,449.057],[1331.44,548.643],[1331.44,454.138]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,557.918],[1285.14,658.064],[1331.44,556.867],[1331.44,651.372]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,666.478],[1285.14,766.624],[1331.44,659.313],[1331.44,753.818]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1285.14,775.219],[1285.14,875.364],[1331.44,761.928],[1331.44,856.433]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1303.43,368.986],[1303.43,283.504],[1369.69,383.022],[1369.69,304.586]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1307.11,451.761],[1307.11,357.711],[1340.45,455.406],[1340.45,365.276]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1307.11,548.597],[1307.11,454.548],[1340.45,548.208],[1340.45,458.078]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1307.11,556.782],[1307.11,650.831],[1340.45,556.051],[1340.45,646.182]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1307.11,658.733],[1307.11,752.782],[1340.45,653.755],[1340.45,743.885]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1307.11,760.853],[1307.11,854.902],[1340.45,751.62],[1340.45,841.75]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1338.78,455.328],[1338.78,365.114],[1369.29,458.66],[1369.29,372.027]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1338.78,548.216],[1338.78,458.002],[1369.29,547.86],[1369.29,461.228]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1338.78,556.067],[1338.78,646.281],[1369.29,555.4],[1369.29,642.032]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1338.78,653.861],[1338.78,744.076],[1369.29,649.311],[1369.29,735.944]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1338.78,751.818],[1338.78,842.032],[1369.29,743.378],[1369.29,830.011]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,458.288],[1392.78,371.254],[1369.29,458.66],[1369.29,372.027]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,547.9],[1392.78,460.867],[1369.29,547.86],[1369.29,461.228]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,555.474],[1392.78,642.507],[1369.29,555.4],[1369.29,642.032]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,649.82],[1392.78,736.853],[1369.29,649.311],[1369.29,735.944]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,744.322],[1369.29,743.378],[1392.78,831.355],[1369.29,830.011]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1369.59,383.001],[1369.59,304.555],[1425.78,394.902],[1425.78,322.43]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,458.288],[1392.78,371.254],[1428.01,462.28],[1428.01,379.539]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,547.9],[1392.78,460.867],[1428.01,547.474],[1428.01,464.733]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,555.474],[1392.78,642.507],[1428.01,554.674],[1428.01,637.415]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,649.82],[1392.78,736.853],[1428.01,644.367],[1428.01,727.109]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1392.78,744.322],[1392.78,831.355],[1428.01,734.209],[1428.01,816.95]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1406.29,554.609],[1406.29,637],[1432,554.046],[1432,633.414]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1406.29,462.605],[1406.29,380.214],[1432,465.418],[1432,386.049]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1406.29,547.439],[1406.29,465.048],[1432,547.139],[1432,467.77]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1406.29,643.923],[1406.29,726.315],[1432,640.083],[1432,719.451]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1406.29,733.385],[1406.29,815.777],[1432,726.262],[1432,805.63]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1430.91,465.39],[1430.91,385.991],[1454.65,467.983],[1454.65,391.372]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1430.91,547.142],[1430.91,467.743],[1454.65,546.865],[1454.65,470.254]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1430.91,554.051],[1430.91,633.45],[1454.65,553.532],[1454.65,630.143]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1430.91,640.121],[1430.91,719.52],[1454.65,636.58],[1454.65,713.191]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1430.91,726.333],[1430.91,805.732],[1454.65,719.765],[1454.65,796.376]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,467.692],[1475.77,390.768],[1454.65,467.983],[1454.65,391.372]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,546.896],[1475.77,469.972],[1454.65,546.865],[1454.65,470.254]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,553.59],[1475.77,630.514],[1454.65,553.532],[1454.65,630.143]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,636.977],[1475.77,713.901],[1454.65,636.58],[1454.65,713.191]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,720.503],[1454.65,719.765],[1475.77,797.427],[1454.65,796.376]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,467.692],[1475.77,390.768],[1503.45,470.829],[1503.45,397.277]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,546.896],[1475.77,469.972],[1503.45,546.561],[1503.45,473.009]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,553.59],[1475.77,630.514],[1503.45,552.961],[1503.45,626.513]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,636.977],[1475.77,713.901],[1503.45,632.693],[1503.45,706.245]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1475.77,720.503],[1475.77,797.427],[1503.45,712.557],[1503.45,786.109]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1483.84,471.086],[1483.84,397.81],[1504.27,473.319],[1504.27,402.445]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:58,
                    verts:[[1483.84,552.91],[1483.84,626.185],[1504.27,552.462],[1504.27,623.337]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[367.019,387.907],[367.019,225.218],[72.5132,396.114],[72.5132,242.248]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[367.019,555.418],[367.019,392.729],[72.5132,554.541],[72.5132,400.675]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[367.019,569.575],[367.019,732.264],[72.5132,567.931],[72.5132,721.797]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[367.019,745.934],[367.019,908.623],[72.5132,734.725],[72.5132,888.592]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[367.019,922.584],[367.019,1085.27],[72.5132,901.796],[72.5132,1055.66]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[770.09,223.164],[770.09,64.4717],[289.24,249.218],[289.24,103.606]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.71,375.709],[804.71,199.907],[462.315,385.251],[462.315,219.707]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.71,556.72],[804.71,380.919],[462.315,555.701],[462.315,390.157]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.71,572.019],[804.71,747.82],[462.315,570.108],[462.315,735.651]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.71,762.592],[804.71,938.393],[462.315,749.561],[462.315,915.105]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.71,953.48],[804.71,1129.28],[462.315,929.311],[462.315,1094.85]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[769.628,223.061],[769.628,64.3169],[929.442,269.846],[929.442,134.591]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.709,375.709],[804.709,199.907],[886.281,388.475],[886.281,226.396]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.709,556.72],[804.709,380.919],[886.281,555.357],[886.281,393.278]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.709,572.019],[804.709,747.821],[886.281,569.462],[886.281,731.54]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.709,762.592],[804.709,938.393],[886.281,745.158],[886.281,907.237]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[804.709,953.48],[804.709,1129.28],[886.281,921.146],[886.281,1083.22]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,387.455],[926.529,224.28],[886.281,388.475],[886.281,226.396]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,555.466],[926.529,392.291],[886.281,555.357],[886.281,393.278]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,569.666],[926.529,732.841],[886.281,569.462],[886.281,731.54]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,746.551],[886.281,745.158],[926.529,909.726],[886.281,907.237]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,923.729],[886.281,921.146],[926.529,1086.9],[886.281,1083.22]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,387.455],[926.529,224.28],[1011.46,401.419],[1011.46,253.255]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,555.466],[926.529,392.291],[1011.46,553.974],[1011.46,405.81]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,569.666],[926.529,732.841],[1011.46,566.868],[1011.46,715.032]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,746.551],[926.529,909.726],[1011.46,727.481],[1011.46,875.645]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[926.529,923.729],[926.529,1086.9],[1011.46,888.36],[1011.46,1036.52]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[929.601,269.892],[929.601,134.66],[1047.98,304.546],[1047.98,186.712]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[973.067,402.29],[973.067,255.062],[1030.45,411.255],[1030.45,273.664]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[973.067,553.881],[973.067,406.654],[1030.45,552.924],[1030.45,415.333]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[973.067,566.694],[973.067,713.921],[1030.45,564.897],[1030.45,702.488]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[973.067,726.292],[973.067,873.519],[1030.45,714.049],[1030.45,851.64]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[973.067,886.154],[973.067,1033.38],[1030.45,863.447],[1030.45,1001.04]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1031.52,411.422],[1031.52,274.01],[1081.89,419.291],[1081.89,290.339]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1031.52,552.906],[1031.52,415.494],[1081.89,552.065],[1081.89,423.113]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1031.52,564.864],[1031.52,702.276],[1081.89,563.287],[1081.89,692.239]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1031.52,713.821],[1031.52,851.233],[1081.89,703.074],[1081.89,832.026]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1031.52,863.025],[1031.52,1000.44],[1081.89,843.092],[1081.89,972.044]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,418.624],[1116.09,288.954],[1081.89,419.291],[1081.89,290.339]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,552.137],[1116.09,422.467],[1081.89,552.065],[1081.89,423.113]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,563.421],[1116.09,693.091],[1081.89,563.287],[1081.89,692.239]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,703.986],[1081.89,703.074],[1116.09,833.655],[1081.89,832.026]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,844.783],[1081.89,843.092],[1116.09,974.453],[1081.89,972.044]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,418.624],[1116.09,288.954],[1170.75,427.612],[1170.75,307.604]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,552.137],[1116.09,422.467],[1170.75,551.177],[1170.75,431.169]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,563.421],[1116.09,693.091],[1170.75,561.62],[1170.75,681.628]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,703.986],[1116.09,833.655],[1170.75,691.711],[1170.75,811.719]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1116.09,844.783],[1116.09,974.453],[1170.75,822.018],[1170.75,942.026]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1139.89,428.165],[1139.89,308.751],[1178.49,434.206],[1178.49,321.286]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1139.89,551.118],[1139.89,431.704],[1178.49,550.472],[1178.49,437.553]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1139.89,561.509],[1139.89,680.923],[1178.49,560.299],[1178.49,673.219]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1139.89,690.957],[1139.89,810.37],[1178.49,682.706],[1178.49,795.626]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1139.89,820.618],[1139.89,940.032],[1178.49,805.316],[1178.49,918.236]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1182.59,343.933],[1182.59,245.874],[854.103,354.205],[854.103,261.302]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1227.92,442.233],[1227.92,337.942],[1166.48,443.18],[1166.48,339.908]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1227.92,549.615],[1227.92,445.324],[1166.48,549.514],[1166.48,446.241]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1227.92,558.691],[1227.92,662.982],[1166.48,558.501],[1166.48,661.774]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1227.92,671.745],[1227.92,776.036],[1166.48,670.451],[1166.48,773.723]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1227.92,784.986],[1227.92,889.277],[1166.48,782.586],[1166.48,885.858]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1182.39,343.894],[1182.39,245.815],[1247.92,363.079],[1247.92,274.632]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1228.65,442.221],[1228.65,337.917],[1258.36,446.862],[1258.36,347.548]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1228.65,549.616],[1228.65,445.313],[1258.36,549.12],[1258.36,449.806]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1228.65,558.693],[1228.65,662.997],[1258.36,557.763],[1258.36,657.078]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1228.65,671.761],[1228.65,776.064],[1258.36,665.422],[1258.36,764.737]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1228.65,785.016],[1228.65,889.319],[1258.36,773.259],[1258.36,872.574]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1271.43,369.946],[1271.43,284.946],[980.611,377.718],[980.611,296.62]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,446.467],[1285.42,346.728],[1258.36,446.863],[1258.36,347.548]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,549.163],[1285.42,449.423],[1258.36,549.12],[1258.36,449.806]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,557.842],[1285.42,657.582],[1258.36,557.763],[1258.36,657.078]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,665.962],[1258.36,665.422],[1285.42,765.702],[1258.36,764.736]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,774.261],[1258.36,773.259],[1285.42,874.001],[1258.36,872.574]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1271.27,369.916],[1271.27,284.901],[1320.53,384.336],[1320.53,306.56]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,446.467],[1285.42,346.728],[1318.33,451.878],[1318.33,357.955]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,549.163],[1285.42,449.423],[1318.33,548.585],[1318.33,454.662]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,557.842],[1285.42,657.582],[1318.33,556.758],[1318.33,650.681]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,665.962],[1285.42,765.702],[1318.33,658.573],[1318.33,752.496]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1285.42,774.261],[1285.42,874.001],[1318.33,760.556],[1318.33,854.479]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1316.12,455.886],[1316.12,366.271],[1338.01,459.306],[1338.01,373.369]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1316.12,548.157],[1316.12,458.542],[1338.01,547.791],[1338.01,461.854]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1316.12,555.955],[1316.12,645.57],[1338.01,555.27],[1338.01,641.208]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1316.12,653.099],[1316.12,742.714],[1338.01,648.429],[1338.01,734.366]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1316.12,750.404],[1316.12,840.019],[1338.01,741.741],[1338.01,827.679]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1320.46,384.314],[1320.46,306.528],[1361.99,396.474],[1361.99,324.793]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,459.01],[1361.71,372.754],[1338.01,459.306],[1338.01,373.369]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,547.823],[1361.71,461.567],[1338.01,547.791],[1338.01,461.854]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,555.329],[1361.71,641.585],[1338.01,555.27],[1338.01,641.208]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,648.833],[1338.01,648.429],[1361.71,735.089],[1338.01,734.366]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,742.491],[1338.01,741.741],[1361.71,828.747],[1338.01,827.679]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,459.01],[1361.71,372.754],[1386.51,463.089],[1386.51,381.218]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,547.823],[1361.71,461.567],[1386.51,547.387],[1386.51,465.516]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,555.329],[1361.71,641.585],[1386.51,554.512],[1386.51,636.383]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,648.833],[1361.71,735.089],[1386.51,643.262],[1386.51,725.134]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1361.71,742.491],[1361.71,828.747],[1386.51,732.16],[1386.51,814.031]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1364.7,554.46],[1364.7,636.055],[1383.04,553.885],[1383.04,632.395]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1364.7,463.347],[1364.7,381.753],[1383.04,466.217],[1383.04,387.708]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1382.04,466.186],[1382.04,387.643],[1398.94,468.827],[1398.94,393.123]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1382.04,547.057],[1382.04,468.514],[1398.94,546.774],[1398.94,471.07]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1382.04,553.892],[1382.04,632.434],[1398.94,553.363],[1398.94,629.067]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1382.04,639.034],[1382.04,717.576],[1398.94,635.427],[1398.94,711.131]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1382.04,724.317],[1382.04,802.859],[1398.94,717.628],[1398.94,793.332]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,468.597],[1420.01,392.646],[1398.94,468.827],[1398.94,393.123]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,546.799],[1420.01,470.848],[1398.94,546.774],[1398.94,471.07]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,553.409],[1420.01,629.359],[1398.94,553.363],[1398.94,629.067]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,635.741],[1398.94,635.427],[1420.01,711.692],[1398.94,711.131]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,718.21],[1398.94,717.628],[1420.01,794.16],[1398.94,793.332]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,468.597],[1420.01,392.646],[1439.36,471.779],[1439.36,399.248]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,546.799],[1420.01,470.848],[1439.36,546.459],[1439.36,473.929]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,553.409],[1420.01,629.359],[1439.36,552.771],[1439.36,625.302]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,635.741],[1420.01,711.692],[1439.36,631.396],[1439.36,703.926]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:59,
                    verts:[[1420.01,718.21],[1420.01,794.16],[1439.36,710.151],[1439.36,782.681]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[491.925,382.548],[491.925,214.099],[158.623,389.229],[158.623,227.962]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[491.925,555.99],[491.925,387.541],[158.623,555.276],[158.623,394.009]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[491.925,570.649],[491.925,739.098],[158.623,569.31],[158.623,730.578]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[491.925,753.252],[491.925,921.701],[158.623,744.128],[158.623,905.395]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[491.925,936.157],[491.925,1104.61],[158.623,919.234],[158.623,1080.5]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[899.356,217.49],[899.356,55.9494],[371.403,238.144],[371.403,86.9728]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,372.912],[972.623,194.105],[598.052,380.421],[598.052,209.685]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,557.019],[972.623,378.212],[598.052,556.217],[598.052,385.481]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,572.58],[972.623,751.387],[598.052,571.075],[598.052,741.811]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,766.411],[972.623,945.218],[598.052,756.157],[598.052,926.893]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,960.563],[972.623,1139.37],[598.052,941.545],[598.052,1112.28]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[899.002,217.378],[899.002,55.7817],[1008.16,267.033],[1008.16,130.365]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,372.912],[972.623,194.105],[1024.36,386.486],[1024.36,222.27]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,557.019],[972.623,378.212],[1024.36,555.569],[1024.36,391.353]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,572.58],[972.623,751.387],[1024.36,569.86],[1024.36,734.076]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,766.411],[972.623,945.218],[1024.36,747.874],[1024.36,912.089]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[972.623,960.563],[972.623,1139.37],[1024.36,926.182],[1024.36,1090.4]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,385.702],[1024.36,386.486],[1067.22,220.643],[1024.36,222.27]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,555.653],[1067.22,390.594],[1024.36,555.569],[1024.36,391.353]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,570.017],[1067.22,735.076],[1024.36,569.86],[1024.36,734.076]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,748.944],[1024.36,747.874],[1067.22,914.003],[1024.36,912.089]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,928.168],[1024.36,926.182],[1067.22,1093.23],[1024.36,1090.4]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,385.702],[1067.22,220.643],[1118.8,400.386],[1118.8,251.112]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,555.653],[1067.22,390.594],[1118.8,554.085],[1118.8,404.811]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,570.017],[1067.22,735.076],[1118.8,567.075],[1118.8,716.349]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,748.944],[1067.22,914.003],[1118.8,728.891],[1118.8,878.165]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1067.22,928.168],[1067.22,1093.23],[1118.8,890.975],[1118.8,1040.25]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1114.98,410.618],[1114.98,272.342],[1146.33,418.821],[1146.33,289.364]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1114.98,552.992],[1114.98,414.716],[1146.33,552.116],[1146.33,422.658]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1114.98,565.025],[1114.98,703.301],[1146.33,563.381],[1146.33,692.839]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1114.98,714.919],[1114.98,853.194],[1146.33,703.716],[1146.33,833.174]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1114.98,865.061],[1114.98,1003.34],[1146.33,844.283],[1146.33,973.741]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,418.317],[1146.33,418.821],[1181.79,288.318],[1146.33,289.364]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,552.169],[1181.79,422.17],[1146.33,552.116],[1146.33,422.658]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,563.482],[1181.79,693.482],[1146.33,563.381],[1146.33,692.839]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,704.404],[1146.33,703.716],[1181.79,834.404],[1146.33,833.174]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,845.56],[1146.33,844.283],[1181.79,975.559],[1146.33,973.741]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,418.317],[1181.79,288.318],[1214.45,427.615],[1214.45,307.61]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,552.169],[1181.79,422.17],[1214.45,551.176],[1214.45,431.171]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,563.482],[1181.79,693.482],[1214.45,561.62],[1214.45,681.625]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,704.404],[1181.79,834.404],[1214.45,691.708],[1214.45,811.712]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1181.79,845.56],[1181.79,975.559],[1214.45,822.011],[1214.45,942.016]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.1,442.513],[1236.1,338.523],[1173.41,443.221],[1173.41,339.993]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.1,549.585],[1236.1,445.595],[1173.41,549.509],[1173.41,446.281]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.1,558.635],[1236.1,662.625],[1173.41,558.493],[1173.41,661.721]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.1,671.362],[1236.1,775.352],[1173.41,670.395],[1173.41,773.623]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.1,784.276],[1173.41,782.482],[1236.1,888.266],[1173.41,885.711]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.84,442.504],[1236.84,338.504],[1255.01,447.259],[1255.01,348.37]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.84,549.586],[1236.84,445.586],[1255.01,549.078],[1255.01,450.19]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.84,558.636],[1236.84,662.636],[1255.01,557.684],[1255.01,656.572]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.84,671.374],[1236.84,775.374],[1255.01,664.881],[1255.01,763.77]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1236.84,784.299],[1236.84,888.299],[1255.01,772.256],[1255.01,871.144]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,446.965],[1255.01,447.259],[1282.42,347.76],[1255.01,348.37]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,549.11],[1282.42,449.905],[1255.01,549.078],[1255.01,450.19]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,557.743],[1282.42,656.947],[1255.01,557.684],[1255.01,656.572]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,665.282],[1255.01,664.881],[1282.42,764.487],[1255.01,763.77]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,773],[1255.01,772.256],[1282.42,872.204],[1255.01,871.144]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,446.965],[1282.42,347.761],[1301.79,452.48],[1301.79,359.204]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,549.11],[1282.42,449.905],[1301.79,548.52],[1301.79,455.244]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,557.743],[1282.42,656.947],[1301.79,556.638],[1301.79,649.914]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,665.282],[1282.42,764.487],[1301.79,657.751],[1301.79,751.027]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1282.42,773],[1282.42,872.204],[1301.79,759.032],[1301.79,852.308]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1290.2,456.465],[1290.2,367.473],[1303.49,459.942],[1303.49,374.687]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1290.2,555.839],[1290.2,644.831],[1303.49,555.143],[1303.49,640.397]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1290.2,548.095],[1290.2,459.103],[1303.49,547.724],[1303.49,462.469]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1290.2,652.309],[1290.2,741.301],[1303.49,647.561],[1303.49,732.816]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1290.2,748.938],[1290.2,837.93],[1303.49,740.132],[1303.49,825.386]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,459.724],[1303.49,459.942],[1327.24,374.234],[1303.49,374.687]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,547.747],[1327.24,462.257],[1303.49,547.724],[1303.49,462.469]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,555.186],[1327.24,640.676],[1303.49,555.143],[1303.49,640.397]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,647.859],[1303.49,647.561],[1327.24,733.348],[1303.49,732.816]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,740.685],[1303.49,740.132],[1327.24,826.174],[1303.49,825.387]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,459.724],[1327.24,374.234],[1341.74,463.853],[1341.74,382.803]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,547.747],[1327.24,462.257],[1341.74,547.306],[1341.74,466.255]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,555.186],[1327.24,640.676],[1341.74,554.359],[1341.74,635.409]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,647.859],[1327.24,733.348],[1341.74,642.219],[1341.74,723.27]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1327.24,740.685],[1327.24,826.174],[1341.74,730.225],[1341.74,811.276]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1330.13,553.746],[1330.13,631.506],[1340.33,553.211],[1340.33,628.103]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1330.13,722.473],[1330.13,800.234],[1340.33,715.714],[1340.33,790.606]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1330.13,466.914],[1330.13,389.153],[1340.33,469.582],[1340.33,394.691]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,469.414],[1340.33,469.582],[1361.28,394.341],[1340.33,394.691]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,546.712],[1361.28,471.639],[1340.33,546.694],[1340.33,471.802]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,553.245],[1361.28,628.317],[1340.33,553.211],[1340.33,628.103]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,634.625],[1340.33,634.395],[1361.28,709.698],[1340.33,709.287]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,716.14],[1340.33,715.714],[1361.28,791.213],[1340.33,790.606]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,469.414],[1361.28,394.341],[1372.54,472.619],[1372.54,400.991]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,546.712],[1361.28,471.639],[1372.54,546.369],[1372.54,474.742]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,553.245],[1361.28,628.317],[1372.54,552.603],[1372.54,624.23]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,634.625],[1361.28,709.698],[1372.54,630.249],[1372.54,701.877]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:60,
                    verts:[[1361.28,716.14],[1361.28,791.213],[1372.54,708.023],[1372.54,779.651]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[635.027,378.159],[635.027,204.992],[268.026,382.84],[268.026,214.704]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[635.027,556.459],[635.027,383.292],[268.026,555.959],[268.026,387.823]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[635.027,571.528],[635.027,744.696],[268.026,570.591],[268.026,738.726]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[635.027,759.245],[635.027,932.413],[268.026,752.853],[268.026,920.989]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[635.027,947.273],[635.027,1120.44],[268.026,935.418],[268.026,1103.55]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1034.99,214.142],[1034.99,50.9203],[470.246,228.232],[470.246,72.0844]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,371.634],[1146.6,191.453],[749.739,376.696],[749.739,201.956]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,557.156],[1146.6,376.975],[749.739,556.615],[749.739,381.875]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,572.836],[1146.6,753.016],[749.739,571.822],[749.739,746.561]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,768.156],[1146.6,948.337],[749.739,761.243],[749.739,935.983]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,963.799],[1146.6,1143.98],[749.739,950.979],[749.739,1125.72]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1034.76,214.024],[1034.76,50.7431],[1088.42,265.58],[1088.42,128.183]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1088.47,265.63],[1088.47,128.259],[1127.36,303.001],[1127.36,184.391]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,371.634],[1146.6,191.453],[1165.61,385.688],[1165.61,220.615]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,557.156],[1146.6,376.975],[1165.61,555.655],[1165.61,390.581]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,572.836],[1146.6,753.017],[1165.61,570.02],[1165.61,735.093]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,768.156],[1146.6,948.337],[1165.61,748.963],[1165.61,914.037]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1146.6,963.799],[1146.6,1143.98],[1165.61,928.203],[1165.61,1093.28]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,385.171],[1165.61,385.688],[1209.92,219.542],[1165.61,220.615]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,555.71],[1165.61,555.655],[1209.92,390.081],[1165.61,390.581]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,570.123],[1165.61,570.02],[1209.92,735.753],[1165.61,735.093]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,749.669],[1165.61,748.963],[1209.92,915.298],[1165.61,914.037]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,929.512],[1165.61,928.203],[1209.92,1095.14],[1165.61,1093.28]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,385.171],[1209.92,219.542],[1225.9,400.248],[1225.9,250.824]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,555.71],[1209.92,390.081],[1225.9,554.099],[1225.9,404.676]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,570.123],[1209.92,735.753],[1225.9,567.103],[1225.9,716.526]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,749.669],[1209.92,915.298],[1225.9,729.081],[1225.9,878.504]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1209.92,929.512],[1209.92,1095.14],[1225.9,891.327],[1225.9,1040.75]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,418.557],[1209.25,418.886],[1245.3,288.816],[1209.25,289.498]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,552.144],[1209.25,552.109],[1245.3,422.402],[1209.25,422.721]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,563.434],[1209.25,563.369],[1245.3,693.176],[1209.25,692.757]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,704.077],[1209.25,703.628],[1245.3,833.818],[1209.25,833.016]]
                },{
                    num:"107",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,844.952],[1209.25,844.12],[1245.3,974.694],[1209.25,973.508]]
                },{
                    num:"507",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,418.557],[1245.3,288.816],[1255.32,428.008],[1255.32,308.426]]
                },{
                    num:"407",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,552.144],[1245.3,422.402],[1255.32,551.134],[1255.32,431.552]]
                },{
                    num:"307",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,563.434],[1245.3,693.176],[1255.32,561.541],[1255.32,681.123]]
                },{
                    num:"207",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1245.3,704.077],[1245.3,833.818],[1255.32,691.17],[1255.32,810.752]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1276.07,447.585],[1248.61,447.774],[1276.07,349.046],[1248.61,349.44]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1276.07,549.043],[1248.61,549.023],[1276.07,450.505],[1248.61,450.689]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1276.07,557.619],[1248.61,557.581],[1276.07,656.157],[1248.61,655.915]]
                },{
                    num:"206",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1276.07,664.436],[1248.61,664.177],[1276.07,762.974],[1248.61,762.511]]
                },{
                    num:"406",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1276.07,549.043],[1276.07,450.505],[1281.96,548.45],[1281.96,455.884]]
                },{
                    num:"306",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1276.07,557.619],[1276.07,656.157],[1281.96,556.505],[1281.96,649.071]]
                },{
                    num:"506",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1276.07,447.585],[1276.07,349.046],[1281.96,453.141],[1281.96,360.575]]
                },{
                    num:"106",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1276.07,771.431],[1276.07,869.969],[1281.96,757.357],[1281.96,849.923]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,460.424],[1266.03,460.564],[1289.68,375.687],[1266.03,375.979]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,547.672],[1266.03,547.657],[1289.68,462.935],[1266.03,463.071]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,555.046],[1266.03,555.018],[1289.68,639.783],[1266.03,639.604]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,738.911],[1266.03,738.555],[1289.68,823.647],[1266.03,823.141]]
                },{
                    num:"405",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,547.672],[1289.68,462.935],[1294.07,547.229],[1294.07,466.947]]
                },{
                    num:"305",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,555.046],[1289.68,639.783],[1294.07,554.216],[1294.07,634.498]]
                },{
                    num:"105",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,738.911],[1289.68,823.647],[1294.07,728.415],[1294.07,808.697]]
                },{
                    num:"505",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,460.424],[1289.68,375.687],[1294.07,464.568],[1294.07,384.286]]
                },{
                    num:"205",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1289.68,646.902],[1289.68,731.639],[1294.07,641.243],[1294.07,721.525]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,470.14],[1279.22,470.248],[1299.98,395.847],[1279.22,396.071]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,546.634],[1279.22,546.623],[1299.98,472.342],[1279.22,472.446]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,553.1],[1279.22,553.078],[1299.98,627.392],[1279.22,627.255]]
                },{
                    num:"204",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,633.634],[1279.22,633.487],[1299.98,707.927],[1279.22,707.664]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,714.303],[1279.22,714.029],[1299.98,788.595],[1279.22,788.206]]
                },{
                    num:"404",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,546.634],[1299.98,472.342],[1303.38,546.292],[1303.38,475.446]]
                },{
                    num:"304",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,553.1],[1299.98,627.392],[1303.38,552.457],[1303.38,623.303]]
                },{
                    num:"104",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,714.303],[1299.98,788.595],[1303.38,706.182],[1303.38,777.028]]
                },{
                    num:"504",
                    tipo:"TorreF",
                    frame:61,
                    verts:[[1299.98,470.14],[1299.98,395.847],[1303.38,473.346],[1303.38,402.5]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[792.588,375.053],[792.588,198.547],[400.226,377.304],[400.226,203.218]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[792.588,556.79],[792.588,380.284],[400.226,556.55],[400.226,382.464]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[792.588,572.151],[792.588,748.657],[400.226,571.7],[400.226,745.786]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[792.588,763.487],[792.588,939.994],[400.226,760.413],[400.226,934.499]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[792.588,955.141],[792.588,1131.65],[400.226,949.439],[400.226,1123.53]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1172.34,213.42],[1172.34,49.8367],[584.491,220.025],[584.491,59.758]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1319.58,372.029],[912.734,374.363],[1319.58,192.273],[912.734,197.116]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1319.58,557.114],[912.734,556.864],[1319.58,377.357],[912.734,379.617]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1319.58,572.756],[912.734,572.289],[1319.58,752.513],[912.734,749.536]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1319.58,767.616],[912.734,764.429],[1319.58,947.373],[912.734,941.676]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1319.58,962.799],[912.734,956.887],[1319.58,1142.56],[912.734,1134.13]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1304.85,386.181],[1349.32,385.947],[1304.85,221.637],[1349.32,221.152]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1304.85,569.921],[1349.32,569.968],[1304.85,734.465],[1349.32,734.763]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1304.85,748.29],[1349.32,748.609],[1304.85,912.834],[1349.32,913.405]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1304.85,926.955],[1349.32,927.547],[1304.85,1091.5],[1349.32,1092.34]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:62,
                    verts:[[1304.85,555.602],[1349.32,555.627],[1304.85,391.058],[1349.32,390.832]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[583.633,390.862],[539.73,390.815],[583.633,227.221],[539.73,227.121]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[583.633,559.354],[583.633,395.713],[539.73,559.361],[539.73,395.667]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[583.633,573.595],[539.73,573.606],[583.633,737.237],[539.73,737.3]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[583.633,750.986],[539.73,751.054],[583.633,914.628],[539.73,914.749]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[583.633,928.672],[539.73,928.796],[583.633,1092.31],[539.73,1092.49]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[959.05,373.477],[959.05,195.277],[552.622,372.983],[552.622,194.252]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[959.05,556.959],[959.05,378.759],[552.622,557.012],[552.622,378.281]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[959.05,572.466],[959.05,750.667],[552.622,572.565],[552.622,751.296]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[959.05,765.639],[959.05,943.839],[552.622,766.314],[552.622,945.045]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[959.05,959.132],[552.622,960.383],[959.05,1137.33],[552.622,1139.11]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[711.439,214.03],[1306.24,215.446],[711.439,50.753],[1306.24,52.8789]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1080.81,373.625],[1080.81,195.584],[1484.11,374.115],[1484.11,196.601]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1080.81,556.943],[1080.81,378.902],[1484.11,556.891],[1484.11,379.376]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1080.81,572.437],[1080.81,750.478],[1484.11,572.339],[1484.11,749.853]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1080.81,765.437],[1080.81,943.478],[1484.11,764.768],[1484.11,942.282]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1080.81,958.757],[1080.81,1136.8],[1484.11,957.516],[1484.11,1135.03]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1436.78,387.97],[1480.11,388.018],[1436.78,225.348],[1480.11,225.448]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1436.78,569.563],[1436.78,732.184],[1480.11,569.553],[1480.11,732.122]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1436.78,745.848],[1480.11,745.782],[1436.78,908.469],[1480.11,908.351]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:63,
                    verts:[[1436.78,922.425],[1480.11,922.303],[1436.78,1085.05],[1480.11,1084.87]]
                },
                ],
                [
                {
                    num:"509",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[673.242,388.167],[718.051,388.498],[673.242,221.552],[718.051,222.25]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[673.242,559.72],[718.051,559.675],[673.242,393.105],[718.051,393.426]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[673.242,574.219],[718.051,574.142],[673.242,740.833],[718.051,740.391]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[673.242,754.833],[718.051,754.36],[673.242,921.447],[718.051,920.608]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[673.242,935.746],[718.051,934.875],[673.242,1102.36],[718.051,1101.12]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,374.454],[720.402,192.718],[718.051,388.498],[718.051,222.25]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,561.577],[720.402,379.841],[718.051,559.675],[718.051,393.426]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,577.393],[720.402,759.129],[718.051,574.142],[718.051,740.391]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,774.399],[720.402,956.135],[718.051,754.36],[718.051,920.608]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,971.731],[720.402,1153.47],[718.051,934.875],[718.051,1101.12]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,370.187],[720.402,188.451],[1127.58,373.567],[1127.58,195.465]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,557.31],[720.402,375.574],[1127.58,556.949],[1127.58,378.846]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,573.125],[720.402,754.862],[1127.58,572.448],[1127.58,750.551]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,770.132],[720.402,951.868],[1127.58,765.516],[1127.58,943.619]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[720.402,967.464],[720.402,1149.2],[1127.58,958.903],[1127.58,1137.01]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[847.048,210.681],[847.048,45.722],[822.238,263.532],[822.238,125.107]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[847.067,210.641],[847.067,45.6614],[1431.69,220.132],[1431.69,59.9182]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[1246.87,374.558],[1246.87,197.519],[1633.47,377.767],[1633.47,204.178]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[1246.87,556.843],[1246.87,379.805],[1633.47,556.501],[1633.47,382.912]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[1246.87,572.25],[1246.87,749.288],[1633.47,571.607],[1633.47,745.196]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[1246.87,764.163],[1246.87,941.202],[1633.47,759.781],[1633.47,933.37]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:64,
                    verts:[[1246.87,956.395],[1246.87,1133.43],[1633.47,948.267],[1633.47,1121.86]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,469.409],[619.111,394.331],[611.728,472.66],[611.728,401.077]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,546.712],[619.111,471.634],[611.728,546.365],[611.728,474.782]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,553.246],[619.111,628.324],[611.728,552.595],[611.728,624.178]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,634.632],[619.111,709.71],[611.728,630.192],[611.728,701.776]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,716.153],[619.111,791.232],[611.728,707.919],[611.728,779.502]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,469.409],[640.042,469.541],[619.111,394.331],[640.042,394.604]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,546.712],[619.111,471.634],[640.042,546.698],[640.042,471.762]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,553.246],[640.042,553.22],[619.111,628.324],[640.042,628.156]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,634.632],[640.042,634.452],[619.111,709.71],[640.042,709.389]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[619.111,716.153],[640.042,715.82],[619.111,791.232],[640.042,790.756]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,462.221],[641.562,376.542],[632.007,466.286],[632.007,385.129]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,550.438],[641.562,464.76],[632.007,549.848],[632.007,468.691]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,557.895],[641.562,643.573],[632.007,556.911],[632.007,638.068]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,650.772],[641.562,736.45],[632.007,644.886],[632.007,726.043]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,743.803],[641.562,829.482],[632.007,733.008],[632.007,814.165]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,462.221],[665.393,462.386],[641.562,376.542],[665.393,376.892]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,550.438],[641.562,464.76],[665.393,550.414],[665.393,464.92]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,557.895],[665.393,557.854],[641.562,643.573],[665.393,643.349]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,650.772],[665.393,650.532],[641.562,736.45],[665.393,736.026]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[641.562,743.803],[665.393,743.363],[641.562,829.482],[665.393,828.857]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,449.614],[671.193,349.913],[658.365,455.071],[658.365,361.441]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,552.269],[671.193,452.569],[658.365,551.477],[658.365,457.847]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,560.946],[671.193,660.646],[658.365,559.625],[658.365,653.255]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,669.023],[671.193,768.724],[658.365,661.122],[658.365,754.752]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,777.28],[671.193,876.98],[658.365,762.787],[658.365,856.417]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,449.614],[698.84,449.838],[671.193,349.913],[698.84,350.387]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,552.269],[671.193,452.569],[698.84,552.237],[698.84,452.786]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,560.946],[698.84,560.891],[671.193,660.646],[698.84,660.342]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,669.023],[698.84,668.698],[671.193,768.724],[698.84,768.149]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[671.193,777.28],[698.84,776.684],[671.193,876.98],[698.84,876.135]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[711.429,445.115],[711.429,340.411],[698.84,449.838],[698.84,350.387]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[711.429,552.922],[711.429,448.219],[698.84,552.237],[698.84,452.786]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[711.429,562.034],[711.429,666.738],[698.84,560.891],[698.84,660.342]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[711.429,675.535],[711.429,780.239],[698.84,668.698],[698.84,768.149]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[711.429,789.225],[711.429,893.929],[698.84,776.684],[698.84,876.135]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[712.18,445.122],[712.18,340.426],[835.118,446.174],[835.118,342.648]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[712.18,552.921],[712.18,448.225],[835.118,552.769],[835.118,449.243]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[712.18,562.033],[712.18,666.729],[835.118,561.778],[835.118,665.304]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[712.18,675.525],[712.18,780.221],[835.118,674.002],[835.118,777.528]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[712.18,789.206],[712.18,893.902],[835.118,786.413],[835.118,889.939]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,420.884],[738.718,289.23],[716.778,430.219],[716.778,308.947]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,556.441],[738.718,424.787],[716.778,555.086],[716.778,433.814]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,567.898],[738.718,699.553],[716.778,565.639],[716.778,686.911]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,710.615],[738.718,842.269],[716.778,697.101],[716.778,818.373]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,853.568],[738.718,985.222],[716.778,828.78],[716.778,950.052]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,420.884],[774.973,421.275],[738.718,289.23],[774.973,290.056]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,556.441],[738.718,424.787],[774.973,556.384],[774.973,425.165]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,567.898],[774.973,567.804],[738.718,699.553],[774.973,699.023]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,710.615],[774.973,710.049],[738.718,842.269],[774.973,841.268]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[738.718,853.568],[774.973,852.529],[738.718,985.222],[774.973,983.749]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[797.056,412.991],[797.056,272.557],[774.973,421.275],[774.973,290.056]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[797.056,557.587],[797.056,417.153],[774.973,556.384],[774.973,425.165]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[797.056,569.808],[797.056,710.242],[774.973,567.804],[774.973,699.023]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[797.056,722.042],[797.056,862.476],[774.973,710.049],[774.973,841.268]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[797.056,874.528],[797.056,1014.96],[774.973,852.529],[774.973,983.749]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,386.801],[815.666,218.68],[780.664,401.825],[780.664,250.273]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,559.905],[815.666,391.784],[780.664,557.869],[780.664,406.317]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,574.535],[815.666,742.656],[780.664,571.058],[780.664,722.61]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,756.782],[815.666,924.903],[780.664,735.344],[780.664,886.896]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,939.331],[815.666,1107.45],[780.664,899.902],[780.664,1051.45]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[822.218,570.937],[822.218,721.913],[796.732,568.705],[796.732,709.043]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,386.801],[860.036,387.421],[815.666,218.68],[860.036,219.985]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,559.905],[815.666,391.784],[860.036,559.821],[860.036,392.384]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,574.535],[860.036,574.392],[815.666,742.656],[860.036,741.828]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,756.782],[860.036,755.896],[815.666,924.903],[860.036,923.333]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[815.666,939.331],[860.036,937.702],[815.666,1107.45],[860.036,1105.14]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,373.415],[896.893,190.533],[860.036,387.421],[860.036,219.985]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,561.718],[896.893,378.836],[860.036,559.821],[860.036,392.384]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,577.633],[896.893,760.516],[860.036,574.392],[860.036,741.828]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,775.882],[896.893,958.764],[860.036,755.896],[860.036,923.333]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,974.458],[896.893,1157.34],[860.036,937.702],[860.036,1105.14]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,369.121],[896.893,186.239],[1290.95,375.32],[1290.95,199.101]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,557.424],[896.893,374.542],[1290.95,556.762],[1290.95,380.543]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,573.339],[896.893,756.221],[1290.95,572.097],[1290.95,748.316]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,771.588],[896.893,954.47],[1290.95,763.123],[1290.95,939.342]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[896.893,970.164],[896.893,1153.05],[1290.95,954.464],[1290.95,1130.68]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[986.322,210.112],[986.322,44.8678],[902.758,262.42],[902.758,123.437]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[986.386,210.072],[986.386,44.8079],[1544.41,227.198],[1544.41,70.5312]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[1403.91,377.097],[1403.91,202.788],[1762.51,382.737],[1762.51,214.492]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[1403.91,556.572],[1403.91,382.263],[1762.51,555.97],[1762.51,387.724]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[1403.91,571.741],[1403.91,746.05],[1762.51,570.611],[1762.51,738.856]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[1403.91,760.696],[1403.91,935.005],[1762.51,752.993],[1762.51,921.238]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:65,
                    verts:[[1403.91,949.964],[1403.91,1124.27],[1762.51,935.677],[1762.51,1103.92]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,468.401],[555.382,392.24],[539.898,471.663],[539.898,399.008]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,546.82],[555.382,470.659],[539.898,546.472],[539.898,473.816]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,553.448],[555.382,629.609],[539.898,552.794],[539.898,625.449]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,636.008],[555.382,712.17],[539.898,631.554],[539.898,704.209]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,718.706],[555.382,794.867],[539.898,710.444],[539.898,783.099]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,468.401],[576.535,468.597],[555.382,392.24],[576.535,392.646]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,546.82],[555.382,470.659],[576.535,546.799],[576.535,470.848]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,553.448],[555.382,629.609],[576.535,553.409],[576.535,629.359]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,636.008],[576.535,635.741],[555.382,712.17],[576.535,711.691]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[555.382,718.706],[576.535,718.209],[555.382,794.867],[576.535,794.16]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[589.807,465.974],[589.807,387.204],[576.535,468.597],[576.535,392.646]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[589.807,547.079],[589.807,468.309],[576.535,546.799],[576.535,470.848]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[589.807,553.934],[589.807,632.704],[576.535,553.409],[576.535,629.359]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[589.807,639.323],[589.807,718.093],[576.535,635.741],[576.535,711.691]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[589.807,724.853],[589.807,803.623],[576.535,718.209],[576.535,794.16]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,461.237],[602.302,374.464],[582.329,465.303],[582.329,383.052]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,550.581],[602.302,463.809],[582.329,549.991],[582.329,467.741]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,558.133],[602.302,644.905],[582.329,557.149],[582.329,639.399]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,652.196],[602.302,738.969],[582.329,646.31],[582.329,728.56]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,746.415],[602.302,833.188],[582.329,735.619],[582.329,817.869]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[604.313,465.516],[604.313,383.503],[589.385,468.373],[589.385,389.538]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[604.313,557.097],[604.313,639.11],[589.385,556.406],[589.385,635.241]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[604.313,646.001],[604.313,728.014],[589.385,641.865],[589.385,720.7]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,461.237],[626.245,461.483],[602.302,374.464],[626.245,374.983]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,550.581],[602.302,463.809],[626.245,550.546],[626.245,464.046]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,558.133],[602.302,644.905],[626.245,558.073],[626.245,644.572]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,652.196],[626.245,651.84],[602.302,738.969],[626.245,738.34]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[602.302,746.415],[626.245,745.763],[602.302,833.188],[626.245,832.262]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[644.161,458.061],[644.161,367.756],[626.245,461.483],[626.245,374.983]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[644.161,551.043],[644.161,460.738],[626.245,550.546],[626.245,464.046]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[644.161,558.901],[644.161,649.206],[626.245,558.073],[626.245,644.572]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[644.161,656.794],[644.161,747.099],[626.245,651.84],[626.245,738.34]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[644.161,754.849],[644.161,845.154],[626.245,745.763],[626.245,832.262]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,448.665],[664.065,347.908],[637.359,454.101],[637.359,359.391]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,552.407],[664.065,451.651],[637.359,551.618],[637.359,456.908]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,561.175],[664.065,661.931],[637.359,559.86],[637.359,654.569]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,670.397],[664.065,771.153],[637.359,662.527],[637.359,757.237]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,779.8],[664.065,880.556],[637.359,765.365],[637.359,860.074]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,448.665],[691.627,448.996],[664.065,347.908],[691.627,348.608]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,552.407],[664.065,451.651],[691.627,552.359],[691.627,451.971]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,561.175],[664.065,661.931],[691.627,561.095],[691.627,661.483]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,670.397],[691.627,669.918],[664.065,771.153],[691.627,770.306]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[664.065,779.8],[691.627,778.921],[664.065,880.556],[691.627,879.308]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[691.576,368.552],[691.576,282.852],[650.408,383.424],[650.408,305.19]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[691.605,368.541],[691.605,282.836],[988.593,375.289],[988.593,292.972]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.157,444.311],[716.157,338.712],[691.627,448.996],[691.627,348.608]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.157,553.039],[716.157,447.441],[691.627,552.359],[691.627,451.971]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.157,562.229],[716.157,667.827],[691.627,561.095],[691.627,661.483]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.157,676.7],[716.157,782.299],[691.627,669.918],[691.627,770.306]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.157,791.361],[716.157,896.959],[691.627,778.921],[691.627,879.308]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[766.61,341.446],[766.61,242.138],[711.312,361.422],[711.312,272.143]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.901,444.321],[716.901,338.734],[838.322,445.86],[838.322,341.985]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.901,553.038],[716.901,447.45],[838.322,552.814],[838.322,448.939]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.901,562.226],[716.901,667.814],[838.322,561.854],[838.322,665.729]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.901,676.685],[716.901,782.273],[838.322,674.457],[838.322,778.332]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[716.901,791.334],[716.901,896.921],[838.322,787.246],[838.322,891.122]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,420.216],[803.824,287.817],[758.563,429.429],[758.563,307.278]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[790.413,429.898],[790.413,308.27],[758.184,436.067],[758.184,321.299]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,556.538],[803.824,424.14],[758.563,555.2],[758.563,433.049]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[790.413,565.717],[790.413,687.345],[758.184,564.224],[758.184,678.992]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,568.06],[803.824,700.459],[758.563,565.83],[758.563,687.982]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,711.583],[803.824,843.982],[758.563,698.245],[758.563,820.396]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,855.344],[803.824,987.742],[758.563,830.879],[758.563,953.03]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,420.216],[839.329,420.787],[803.824,287.817],[839.329,289.023]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,556.538],[803.824,424.14],[839.329,556.455],[839.329,424.692]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,568.06],[803.824,700.459],[839.329,567.922],[839.329,699.685]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,711.583],[839.329,710.756],[803.824,843.982],[839.329,842.52]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[803.824,855.344],[839.329,853.827],[803.824,987.742],[839.329,985.59]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[881.881,412.66],[881.881,271.857],[839.329,420.787],[839.329,289.023]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[881.881,557.635],[881.881,416.833],[839.329,556.455],[839.329,424.692]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[881.881,569.889],[881.881,710.691],[839.329,567.922],[839.329,699.685]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[881.881,722.521],[881.881,863.324],[839.329,710.756],[839.329,842.52]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[881.881,875.407],[881.881,1016.21],[839.329,853.827],[839.329,985.59]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[930.305,402.225],[930.305,251.115],[881.345,411.658],[881.345,270.949]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[930.305,557.815],[930.305,406.704],[881.345,556.537],[881.345,415.828]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[930.305,570.965],[930.305,722.076],[881.345,568.782],[881.345,709.491]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[930.305,734.773],[930.305,885.884],[881.345,721.314],[881.345,862.023]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[930.305,898.852],[930.305,1049.96],[881.345,874.098],[881.345,1014.81]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,386.788],[961.547,218.654],[890.061,401.467],[890.061,249.52]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,559.906],[961.547,391.772],[890.061,557.918],[890.061,405.971]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,574.538],[961.547,742.672],[890.061,571.141],[890.061,723.088]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,756.799],[961.547,924.934],[890.061,735.854],[890.061,887.801]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,939.362],[961.547,1107.5],[890.061,900.841],[890.061,1052.79]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,386.789],[1004.12,387.685],[961.547,218.654],[1004.12,220.539]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,559.906],[961.547,391.772],[1004.12,559.785],[1004.12,392.639]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,574.538],[961.547,742.672],[1004.12,574.331],[1004.12,741.477]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,756.799],[1004.12,755.52],[961.547,924.934],[1004.12,922.667]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[961.547,939.362],[1004.12,937.011],[961.547,1107.5],[1004.12,1104.16]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,374.119],[1074.39,192.013],[1004.12,387.685],[1004.12,220.539]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,561.623],[1074.39,379.517],[1004.12,559.785],[1004.12,392.639]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,577.47],[1074.39,759.576],[1004.12,574.331],[1004.12,741.477]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,774.877],[1074.39,956.983],[1004.12,755.521],[1004.12,922.667]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,972.611],[1074.39,1154.72],[1004.12,937.011],[1004.12,1104.16]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1123.93,212.365],[1123.93,48.2522],[984.051,262.896],[984.051,124.152]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,369.843],[1074.39,187.737],[1442.57,378.591],[1442.57,205.888]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,557.347],[1074.39,375.241],[1442.57,556.413],[1442.57,383.71]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,573.194],[1074.39,755.3],[1442.57,571.442],[1442.57,744.144]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,770.601],[1074.39,952.707],[1442.57,758.655],[1442.57,931.358]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1074.39,968.335],[1074.39,1150.44],[1442.57,946.179],[1442.57,1118.88]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1124.04,212.327],[1124.04,48.1948],[1641.34,236.212],[1641.34,84.0711]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1545.98,381.048],[1545.98,210.986],[1868.17,388.703],[1868.17,226.87]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1545.98,556.15],[1545.98,386.089],[1868.17,555.333],[1868.17,393.5]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1545.98,570.95],[1545.98,741.011],[1868.17,569.416],[1868.17,731.249]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1545.98,755.3],[1545.98,925.362],[1868.17,744.846],[1868.17,906.679]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:66,
                    verts:[[1545.98,939.956],[1545.98,1110.02],[1868.17,920.567],[1868.17,1082.4]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,467.286],[493.505,389.926],[469.591,470.535],[469.591,396.667]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,546.939],[493.505,469.579],[469.591,546.592],[469.591,472.724]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,553.671],[493.505,631.031],[469.591,553.02],[469.591,626.888]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,637.531],[493.505,714.891],[469.591,633.094],[469.591,706.962]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,721.53],[493.505,798.89],[469.591,713.301],[469.591,787.169]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,467.286],[493.505,389.926],[514.812,467.548],[514.812,390.47]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,546.939],[493.505,469.579],[514.812,546.911],[514.812,469.833]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,553.671],[493.505,631.031],[514.812,553.619],[514.812,630.697]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,637.531],[493.505,714.891],[514.812,637.173],[514.812,714.252]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[493.505,721.53],[514.812,720.866],[493.505,798.89],[514.812,797.944]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[534.82,464.945],[534.82,385.068],[514.812,467.548],[514.812,390.47]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[534.82,547.189],[534.82,467.312],[514.812,546.911],[514.812,469.833]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[534.82,554.14],[534.82,634.017],[514.812,553.619],[514.812,630.697]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[534.82,640.729],[534.82,720.606],[514.812,637.173],[514.812,714.252]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[534.82,727.461],[534.82,807.338],[514.812,720.866],[514.812,797.944]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,460.233],[565.668,372.344],[534.987,464.261],[534.987,380.852]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[557.016,464.545],[557.016,381.452],[534.534,467.376],[534.534,387.432]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,550.727],[565.668,462.838],[534.987,550.142],[534.987,466.733]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[557.016,557.332],[557.016,640.425],[534.534,556.647],[534.534,636.591]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,558.376],[565.668,646.265],[534.987,557.401],[534.987,640.81]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,653.649],[565.668,741.539],[534.987,647.818],[534.987,731.227]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,749.081],[565.668,836.97],[534.987,738.385],[534.987,821.794]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[595.619,381.653],[595.619,302.531],[546.127,393.998],[546.127,321.073]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,460.233],[565.668,372.344],[589.565,460.56],[589.565,373.034]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,550.727],[565.668,462.838],[589.565,550.68],[589.565,463.154]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,558.376],[565.668,646.265],[589.565,558.297],[589.565,645.822]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,653.649],[589.565,653.176],[565.668,741.539],[589.565,740.702]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[565.668,749.081],[589.565,748.214],[565.668,836.97],[589.565,835.739]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[616.407,457.184],[616.407,365.904],[589.565,460.56],[589.565,373.034]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[616.407,551.17],[616.407,459.89],[589.565,550.68],[589.565,463.154]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[616.407,559.113],[616.407,650.394],[589.565,558.297],[589.565,645.822]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[616.407,658.063],[616.407,749.343],[589.565,653.176],[589.565,740.702]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[616.407,757.177],[616.407,848.457],[589.565,748.214],[589.565,835.739]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[654.411,366.989],[654.411,280.505],[595.708,381.631],[595.708,302.498]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[644.24,453.561],[644.24,358.251],[614.825,457.265],[614.825,366.075]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[644.24,551.696],[644.24,456.386],[614.825,551.158],[614.825,459.968]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[644.24,559.99],[644.24,655.3],[614.825,559.094],[614.825,650.284]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[644.24,663.309],[644.24,758.619],[614.825,657.946],[614.825,749.136]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[644.24,766.798],[644.24,862.108],[614.825,756.962],[614.825,848.152]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,447.839],[660.074,346.164],[619.339,453.187],[619.339,357.46]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,552.527],[660.074,450.852],[619.339,551.75],[619.339,456.024]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,561.375],[660.074,663.05],[619.339,560.081],[619.339,655.807]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,671.592],[660.074,773.267],[619.339,663.85],[619.339,759.577]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,781.992],[660.074,883.667],[619.339,767.792],[619.339,863.518]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[654.452,366.979],[654.452,280.489],[945.439,375.785],[945.439,293.717]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,447.839],[660.074,346.164],[687.25,448.276],[687.25,347.087]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,552.527],[660.074,450.852],[687.25,552.464],[687.25,451.275]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,561.375],[660.074,663.05],[687.25,561.269],[687.25,662.458]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,671.592],[687.25,670.96],[660.074,773.267],[687.25,772.149]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[660.074,781.992],[687.25,780.832],[660.074,883.667],[687.25,882.021]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[760.703,340.477],[760.703,240.682],[682.455,359.994],[682.455,269.998]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[723.706,443.691],[723.706,337.404],[687.25,448.276],[687.25,347.087]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[723.706,553.129],[723.706,446.842],[687.25,552.464],[687.25,451.275]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[723.706,562.379],[723.706,668.666],[687.25,561.269],[687.25,662.458]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[723.706,677.597],[723.706,783.884],[687.25,670.96],[687.25,772.149]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[723.706,793.005],[723.706,899.293],[687.25,780.832],[687.25,882.021]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[724.434,443.704],[724.434,337.431],[842.875,445.717],[842.875,341.683]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[724.434,553.127],[724.434,446.854],[842.875,552.835],[842.875,448.801]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[724.434,562.376],[724.434,668.649],[842.875,561.888],[842.875,665.923]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[724.434,677.578],[724.434,783.851],[842.875,674.664],[842.875,778.698]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[724.434,792.971],[724.434,899.244],[842.875,787.626],[842.875,891.66]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[760.757,340.463],[760.757,240.662],[1087.69,352.098],[1087.69,258.137]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[833.992,429.665],[833.992,307.777],[786.457,435.651],[786.457,320.421]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[833.992,555.166],[833.992,433.278],[786.457,554.297],[786.457,439.067]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[833.992,565.773],[833.992,687.661],[786.457,564.325],[786.457,679.554]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[833.992,697.902],[833.992,819.79],[786.457,689.236],[786.457,804.466]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[833.992,830.25],[833.992,952.138],[786.457,814.355],[786.457,929.585]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,420.13],[871.136,287.635],[803.169,429.053],[803.169,306.483]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,556.551],[871.136,424.057],[803.169,555.255],[803.169,432.686]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,568.081],[871.136,700.575],[803.169,565.921],[803.169,688.491]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,711.707],[871.136,844.202],[803.169,698.789],[803.169,821.359]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,855.572],[871.136,988.066],[803.169,831.878],[803.169,954.447]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,420.13],[871.136,287.635],[905.186,420.87],[905.186,289.2]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,556.551],[871.136,424.057],[905.186,556.443],[905.186,424.773]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,568.081],[871.136,700.575],[905.186,567.902],[905.186,699.572]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,711.707],[905.186,710.635],[871.136,844.202],[905.186,842.305]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[871.136,855.572],[905.186,853.605],[871.136,988.066],[905.186,985.275]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[967.277,413.063],[967.277,272.708],[905.186,420.87],[905.186,289.2]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[967.277,557.577],[967.277,417.223],[905.186,556.443],[905.186,424.773]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[967.277,569.791],[967.277,710.146],[905.186,567.902],[905.186,699.572]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[967.277,721.939],[967.277,862.293],[905.186,710.635],[905.186,842.305]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[967.277,874.338],[967.277,1014.69],[905.186,853.605],[905.186,985.275]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1063.69,264.905],[1063.69,127.169],[921.721,300.315],[921.721,180.357]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1037.61,403.045],[1037.61,252.838],[966.542,412.06],[966.542,271.794]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1037.61,557.704],[1037.61,407.497],[966.542,556.483],[966.542,416.217]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1037.61,570.776],[1037.61,720.982],[966.542,568.689],[966.542,708.955]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1037.61,733.603],[1037.61,883.81],[966.542,720.74],[966.542,861.006]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1037.61,896.7],[1037.61,1046.91],[966.542,873.043],[966.542,1013.31]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,388.097],[1105.21,221.406],[999.68,402.072],[999.68,250.792]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,559.729],[1105.21,393.038],[999.68,557.836],[999.68,406.556]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,574.235],[1105.21,740.926],[999.68,571.001],[999.68,722.281]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,754.932],[1105.21,921.623],[999.68,734.992],[999.68,886.272]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,935.928],[1105.21,1102.62],[999.68,899.254],[999.68,1050.53]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1254.82,217.23],[1254.82,55.5592],[1063.73,264.895],[1063.73,127.154]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,388.097],[1105.21,221.407],[1144.76,389.238],[1144.76,223.805]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,559.729],[1105.21,393.038],[1144.76,559.574],[1144.76,394.142]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,574.235],[1105.21,740.926],[1144.76,573.971],[1144.76,739.404]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,754.932],[1144.76,753.304],[1105.21,921.623],[1144.76,918.737]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1105.21,935.928],[1144.76,932.934],[1105.21,1102.62],[1144.76,1098.37]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,376.473],[1245.26,196.962],[1144.76,389.238],[1144.76,223.805]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,561.304],[1245.26,381.793],[1144.76,559.574],[1144.76,394.142]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,576.926],[1245.26,756.436],[1144.76,573.971],[1144.76,739.404]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,771.519],[1245.26,951.03],[1144.76,753.304],[1144.76,918.737]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,966.435],[1245.26,1145.95],[1144.76,932.934],[1144.76,1098.37]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,372.258],[1245.26,192.747],[1577.31,383.127],[1577.31,215.301]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,557.089],[1245.26,377.578],[1577.31,555.928],[1577.31,388.102]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,572.711],[1245.26,752.221],[1577.31,570.533],[1577.31,738.36]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,767.304],[1245.26,946.815],[1577.31,752.461],[1577.31,920.287]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1245.26,962.22],[1245.26,1141.73],[1577.31,934.69],[1577.31,1102.52]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1254.97,217.194],[1254.97,55.5053],[1720.86,246.662],[1720.86,99.7677]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1668.88,386.125],[1668.88,221.52],[1949.58,395.314],[1949.58,240.587]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1668.88,555.608],[1668.88,391.004],[1949.58,554.626],[1949.58,399.9]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1668.88,569.932],[1668.88,734.537],[1949.58,568.091],[1949.58,722.818]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1668.88,748.367],[1668.88,912.972],[1949.58,735.819],[1949.58,890.546]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:67,
                    verts:[[1668.88,927.098],[1668.88,1091.7],[1949.58,903.824],[1949.58,1058.55]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[421.239,469.569],[421.239,394.662],[397.239,471.853],[397.239,399.401]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[421.239,546.695],[421.239,471.789],[397.239,546.451],[397.239,474]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[421.239,553.214],[421.239,628.12],[397.239,552.756],[397.239,625.208]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[421.239,634.414],[421.239,709.321],[397.239,631.295],[397.239,703.746]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[421.239,715.749],[421.239,790.655],[397.239,709.964],[397.239,782.415]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,466.067],[434.032,387.396],[401.349,469.277],[401.349,394.058]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,547.069],[434.032,468.399],[401.349,546.726],[401.349,471.507]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,553.916],[434.032,632.586],[401.349,553.272],[401.349,628.492]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,639.196],[434.032,717.867],[401.349,634.812],[401.349,710.031]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,724.619],[434.032,803.289],[401.349,716.486],[401.349,791.706]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,466.067],[434.032,387.396],[455.415,466.396],[455.415,388.08]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,547.069],[434.032,468.399],[455.415,547.034],[455.415,468.718]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,553.916],[434.032,632.586],[455.415,553.849],[455.415,632.166]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,639.196],[434.032,717.867],[455.415,638.746],[455.415,717.063]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[434.032,724.619],[455.415,723.784],[434.032,803.289],[455.415,802.1]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[482.368,463.834],[482.368,382.763],[455.415,466.396],[455.415,388.08]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[482.368,547.308],[482.368,466.237],[455.415,547.034],[455.415,468.718]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[482.368,554.363],[482.368,635.434],[455.415,553.849],[455.415,632.166]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[482.368,642.245],[482.368,723.316],[455.415,638.746],[455.415,717.063]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[482.368,730.273],[482.368,811.344],[455.415,723.784],[455.415,802.1]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[543.155,379.693],[543.155,299.586],[478.342,391.801],[478.342,317.773]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[512.45,463.522],[512.45,379.291],[482.224,466.302],[482.224,385.162]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[512.45,550.25],[512.45,466.018],[482.224,549.846],[482.224,468.707]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[512.45,557.58],[512.45,641.811],[482.224,556.907],[482.224,638.046]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[512.45,648.888],[512.45,733.119],[482.224,644.864],[482.224,726.003]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[512.45,740.348],[512.45,824.579],[482.224,732.966],[482.224,814.106]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,459.215],[532.113,370.194],[490.501,463.166],[490.501,378.539]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,550.875],[532.113,461.854],[490.501,550.301],[490.501,465.674]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,558.622],[532.113,647.643],[490.501,557.666],[490.501,642.293]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,655.123],[532.113,744.144],[490.501,649.404],[490.501,734.031]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,751.783],[532.113,840.804],[490.501,741.293],[490.501,825.92]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,459.215],[532.113,370.194],[555.795,459.623],[555.795,371.055]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,550.875],[532.113,461.854],[555.795,550.816],[555.795,462.248]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,558.622],[532.113,647.643],[555.795,558.523],[555.795,647.091]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,655.123],[532.113,744.144],[555.795,654.532],[555.795,743.1]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[532.113,751.783],[555.795,750.701],[532.113,840.804],[555.795,839.268]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[619.705,365.393],[619.705,278.107],[543.273,379.671],[543.273,299.554]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[591.646,456.329],[591.646,364.098],[555.795,459.623],[555.795,371.055]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[591.646,551.294],[591.646,459.063],[555.795,550.816],[555.795,462.248]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[591.646,559.32],[591.646,651.551],[555.795,558.523],[555.795,647.091]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[591.646,659.301],[591.646,751.532],[555.795,654.532],[555.795,743.1]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[591.646,759.447],[591.646,851.677],[555.795,750.701],[555.795,839.268]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[629.014,452.801],[629.014,356.646],[589.829,456.405],[589.829,364.258]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[629.014,551.806],[629.014,455.651],[589.829,551.283],[589.829,459.136]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[629.014,560.174],[629.014,656.329],[589.829,559.302],[589.829,651.449]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[629.014,664.408],[629.014,760.564],[589.829,659.191],[589.829,751.338]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[629.014,768.815],[629.014,864.971],[589.829,759.246],[589.829,851.392]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,447.144],[659.271,344.696],[604.568,452.337],[604.568,355.665]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,552.628],[659.271,450.18],[604.568,551.874],[604.568,455.202]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,561.543],[659.271,663.991],[604.568,560.286],[604.568,656.958]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,672.599],[659.271,775.047],[604.568,665.081],[604.568,761.752]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,783.838],[659.271,886.286],[604.568,770.048],[604.568,866.72]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[619.758,365.383],[619.758,278.092],[903.039,376.18],[903.039,294.31]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[756.889,339.765],[756.889,239.613],[656.05,358.603],[656.05,267.908]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,447.144],[659.271,344.696],[685.76,447.683],[685.76,345.835]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,552.628],[659.271,450.18],[685.76,552.55],[685.76,450.702]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,561.543],[659.271,663.991],[685.76,561.413],[685.76,663.26]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,672.599],[659.271,775.047],[685.76,671.818],[685.76,773.666]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[659.271,783.838],[685.76,782.406],[659.271,886.286],[685.76,884.253]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[733.908,443.26],[733.908,336.492],[685.76,447.683],[685.76,345.835]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[733.908,553.192],[733.908,446.424],[685.76,552.55],[685.76,450.702]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[733.908,562.483],[733.908,669.251],[685.76,561.413],[685.76,663.26]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[733.908,678.222],[733.908,784.989],[685.76,671.818],[685.76,773.666]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[733.908,794.152],[733.908,900.919],[685.76,782.406],[685.76,884.253]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[734.611,443.276],[734.611,336.526],[848.662,445.737],[848.662,341.725]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[734.611,553.19],[734.611,446.44],[848.662,552.832],[848.662,448.82]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[734.611,562.479],[734.611,669.229],[848.662,561.884],[848.662,665.896]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[734.611,678.199],[734.611,784.949],[848.662,674.635],[848.662,778.647]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[734.611,794.11],[734.611,900.86],[848.662,787.573],[848.662,891.585]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[756.959,339.752],[756.959,239.593],[1069.36,353.838],[1069.36,260.751]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[878.794,429.829],[878.794,308.122],[816.704,435.539],[816.704,320.184]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[878.794,555.142],[878.794,433.436],[816.704,554.313],[816.704,438.958]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[878.794,565.734],[878.794,687.44],[816.704,564.352],[816.704,679.707]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[878.794,697.666],[878.794,819.372],[816.704,689.399],[816.704,804.754]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[878.794,829.817],[878.794,951.523],[816.704,814.653],[816.704,930.008]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,420.604],[938.824,288.639],[849.507,429.084],[849.507,306.549]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,556.482],[938.824,424.516],[849.507,555.25],[849.507,432.716]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,567.966],[938.824,699.932],[849.507,565.914],[849.507,688.449]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,711.02],[938.824,842.986],[849.507,698.744],[849.507,821.279]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,854.311],[938.824,986.277],[849.507,831.795],[849.507,954.33]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,420.604],[938.824,288.638],[970.781,421.498],[970.781,290.526]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,556.482],[938.824,424.516],[970.781,556.352],[970.781,425.38]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,567.966],[938.824,699.932],[970.781,567.75],[970.781,698.722]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,711.02],[938.824,842.986],[970.781,709.726],[970.781,840.698]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[938.824,854.311],[970.781,851.938],[938.824,986.277],[970.781,982.91]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1139.58,268.274],[1139.58,132.229],[961.786,301.488],[961.786,182.119]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1050.76,414.15],[1050.76,275.005],[970.781,421.498],[970.781,290.526]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1050.76,557.419],[1050.76,418.274],[970.781,556.352],[970.781,425.38]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1050.76,569.528],[1050.76,708.673],[970.781,567.75],[970.781,698.721]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1050.76,720.364],[1050.76,859.509],[970.781,709.726],[970.781,840.698]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1050.76,871.45],[1050.76,1010.59],[970.781,851.938],[970.781,982.91]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1140.76,404.727],[1140.76,256.376],[1049.85,413.151],[1049.85,274.089]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1140.76,557.476],[1140.76,409.125],[1049.85,556.335],[1049.85,417.273]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1140.76,570.386],[1140.76,718.738],[1049.85,568.437],[1049.85,707.499]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1140.76,731.203],[1140.76,879.554],[1049.85,719.183],[1049.85,858.245]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1140.76,892.286],[1140.76,1040.64],[1049.85,870.179],[1049.85,1009.24]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,390.597],[1241.46,226.662],[1105.98,403.57],[1105.98,253.941]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,559.39],[1241.46,395.456],[1105.98,557.633],[1105.98,408.005]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,573.657],[1241.46,737.591],[1105.98,570.654],[1105.98,720.282]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,751.365],[1241.46,915.3],[1105.98,732.855],[1105.98,882.483]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,929.368],[1241.46,1093.3],[1105.98,895.324],[1105.98,1044.95]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1374.85,224.324],[1374.85,66.2143],[1139.63,268.264],[1139.63,132.215]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,390.597],[1241.46,226.662],[1277.02,391.938],[1277.02,229.483]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,559.39],[1241.46,395.456],[1277.02,559.209],[1277.02,396.754]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,573.657],[1241.46,737.591],[1277.02,573.346],[1277.02,735.801]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,751.365],[1241.46,915.3],[1277.02,749.451],[1277.02,911.906]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1241.46,929.368],[1277.02,925.848],[1241.46,1093.3],[1277.02,1088.3]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,380.253],[1402.98,204.911],[1277.02,391.938],[1277.02,229.483]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,560.792],[1402.98,385.45],[1277.02,559.209],[1277.02,396.754]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,576.051],[1402.98,751.393],[1277.02,573.346],[1277.02,735.801]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,766.125],[1402.98,941.467],[1277.02,749.451],[1277.02,911.906]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,956.514],[1402.98,1131.86],[1277.02,925.848],[1277.02,1088.3]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1375.02,224.291],[1375.02,66.1652],[1782.67,258.022],[1782.67,116.831]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,376.136],[1402.98,200.794],[1691.95,388.61],[1691.95,226.678]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,556.675],[1402.98,381.333],[1691.95,555.342],[1691.95,393.41]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,571.934],[1402.98,747.276],[1691.95,569.434],[1691.95,731.367]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,762.008],[1402.98,937.35],[1691.95,744.973],[1691.95,906.905]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1402.98,952.397],[1402.98,1127.74],[1691.95,920.802],[1691.95,1082.73]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1770.4,391.997],[1770.4,233.706],[2007.67,402.24],[2007.67,254.959]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1770.4,554.981],[1770.4,396.689],[2007.67,553.887],[2007.67,406.605]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1770.4,568.756],[1770.4,727.047],[2007.67,566.704],[2007.67,713.985]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1770.4,740.347],[1770.4,898.639],[2007.67,726.36],[2007.67,873.641]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:68,
                    verts:[[1770.4,912.223],[1770.4,1070.51],[2007.67,886.28],[2007.67,1033.56]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[355.649,468.244],[355.649,391.915],[325.096,470.485],[325.096,396.565]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[355.649,546.837],[355.649,470.507],[325.096,546.597],[325.096,472.676]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[355.649,553.479],[355.649,629.809],[325.096,553.03],[325.096,626.951]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[355.649,636.222],[355.649,712.552],[325.096,633.162],[325.096,707.083]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[355.649,719.103],[355.649,795.433],[325.096,713.427],[325.096,787.348]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,464.745],[377.462,384.654],[335.666,467.891],[335.666,391.181]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,547.211],[377.462,467.119],[335.666,546.874],[335.666,470.165]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,554.18],[377.462,634.272],[335.666,553.55],[335.666,630.26]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,641.001],[377.462,721.092],[335.666,636.705],[335.666,713.415]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,727.966],[377.462,808.057],[335.666,719.998],[335.666,796.707]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,464.745],[377.462,384.654],[398.83,465.144],[398.83,385.481]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,547.211],[377.462,467.119],[398.83,547.168],[398.83,467.505]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,554.18],[377.462,634.272],[398.83,554.1],[398.83,633.763]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,641.001],[377.462,721.092],[398.83,640.457],[398.83,720.12]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[377.462,727.966],[377.462,808.057],[398.83,726.956],[398.83,806.619]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[432.923,462.645],[432.923,380.297],[398.83,465.144],[398.83,385.481]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[432.923,547.435],[432.923,465.086],[398.83,547.168],[398.83,467.505]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[432.923,554.601],[432.923,636.95],[398.83,554.1],[398.83,633.763]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[432.923,643.869],[432.923,726.217],[398.83,640.457],[398.83,720.12]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[432.923,733.284],[432.923,815.633],[398.83,726.956],[398.83,806.619]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[493.4,377.569],[493.4,296.396],[412.886,389.341],[412.886,314.078]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[471.054,462.449],[471.054,377.026],[432.929,465.152],[432.929,382.734]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[471.054,550.405],[471.054,464.981],[432.929,550.013],[432.929,467.595]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[471.054,557.839],[471.054,643.263],[432.929,557.185],[432.929,639.603]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[471.054,650.441],[471.054,735.865],[432.929,646.528],[432.929,728.946]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[471.054,743.195],[471.054,828.619],[432.929,736.019],[432.929,818.437]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,458.189],[502.013,368.026],[449.321,462.022],[449.321,376.122]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,551.024],[502.013,460.861],[449.321,550.467],[449.321,464.568]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,558.87],[502.013,649.033],[449.321,557.943],[449.321,643.843]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,656.609],[502.013,746.772],[449.321,651.06],[449.321,736.96]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,754.509],[502.013,844.672],[449.321,744.332],[449.321,830.232]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[587.808,363.766],[587.808,275.663],[493.545,377.548],[493.545,296.364]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,458.189],[502.013,368.026],[525.302,458.677],[525.302,369.056]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,551.024],[502.013,460.861],[525.302,550.953],[525.302,461.333]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,558.87],[502.013,649.033],[525.302,558.752],[525.302,648.372]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,656.609],[502.013,746.772],[525.302,655.902],[525.302,745.523]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[502.013,754.509],[525.302,753.214],[502.013,844.672],[525.302,842.834]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[570.157,455.5],[570.157,362.346],[525.302,458.677],[525.302,369.056]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[570.157,551.414],[570.157,458.261],[525.302,550.953],[525.302,461.333]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[570.157,559.521],[570.157,652.674],[525.302,558.752],[525.302,648.372]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[570.157,660.501],[570.157,753.655],[525.302,655.902],[525.302,745.523]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[570.157,761.649],[570.157,854.803],[525.302,753.214],[525.302,842.834]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[616.968,452.106],[616.968,355.178],[568.114,455.569],[568.114,362.493]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[616.968,551.907],[616.968,454.979],[568.114,551.404],[568.114,458.328]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[616.968,560.342],[616.968,657.27],[568.114,559.504],[568.114,652.58]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[616.968,665.414],[616.968,762.342],[568.114,660.401],[568.114,753.477]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[616.968,770.66],[616.968,867.588],[568.114,761.465],[568.114,854.541]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[587.873,363.756],[587.873,275.648],[861.776,376.46],[861.776,294.731]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,446.58],[661.613,343.504],[593.212,451.555],[593.212,354.014]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,552.71],[661.613,449.635],[593.212,551.987],[593.212,454.446]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,561.68],[661.613,664.755],[593.212,560.476],[593.212,658.017]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,673.416],[661.613,776.491],[593.212,666.213],[593.212,763.754]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,785.336],[661.613,888.411],[593.212,772.125],[593.212,869.666]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[755.164,339.296],[755.164,238.909],[632.374,357.25],[632.374,265.875]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,446.58],[661.613,343.504],[687.118,447.217],[687.118,344.85]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,552.71],[661.613,449.635],[687.118,552.617],[687.118,450.251]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,561.68],[661.613,664.755],[687.118,561.526],[687.118,663.892]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,673.416],[661.613,776.491],[687.118,672.493],[687.118,774.86]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[661.613,785.336],[687.118,783.645],[661.613,888.411],[687.118,886.011]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[746.516,443.01],[746.516,335.964],[687.118,447.217],[687.118,344.85]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[746.516,553.228],[746.516,446.183],[687.118,552.617],[687.118,450.251]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[746.516,562.544],[746.516,669.589],[687.118,561.526],[687.118,663.892]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[746.516,678.583],[746.516,785.629],[687.118,672.493],[687.118,774.86]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[746.516,794.815],[746.516,901.86],[687.118,783.645],[687.118,886.011]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[747.186,443.028],[747.186,336.004],[855.539,445.905],[855.539,342.08]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[747.186,553.226],[747.186,446.201],[855.539,552.808],[855.539,448.982]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[747.186,562.539],[747.186,669.564],[855.539,561.843],[855.539,665.668]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[747.186,678.557],[747.186,785.581],[855.539,674.392],[855.539,778.217]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[747.186,794.766],[747.186,901.791],[855.539,787.127],[855.539,890.953]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[755.249,339.284],[755.249,238.89],[1050.56,355.613],[1050.56,263.418]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[923.781,430.358],[923.781,309.24],[848.248,435.712],[848.248,320.549]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[923.781,555.065],[923.781,433.948],[848.248,554.288],[848.248,439.125]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[923.781,565.606],[923.781,686.723],[848.248,564.31],[848.248,679.472]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[923.781,696.9],[923.781,818.017],[848.248,689.149],[848.248,804.311]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[923.781,828.411],[923.781,949.529],[848.248,814.194],[848.248,929.357]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,421.59],[1005.17,290.719],[896.479,429.496],[896.479,307.419]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,556.339],[1005.17,425.468],[896.479,555.191],[896.479,433.114]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,567.728],[1005.17,698.598],[896.479,565.814],[896.479,687.891]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,709.594],[1005.17,840.464],[896.479,698.148],[896.479,820.225]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,851.695],[1005.17,982.565],[896.479,830.701],[896.479,952.778]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1209.98,272.798],[1209.98,139.026],[1000.84,303.376],[1000.84,184.954]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,421.59],[1005.17,290.719],[1034.5,422.615],[1034.5,292.884]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,556.339],[1005.17,425.468],[1034.5,556.19],[1034.5,426.46]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,567.728],[1005.17,698.598],[1034.5,567.479],[1034.5,697.21]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,709.594],[1005.17,840.464],[1034.5,708.11],[1034.5,837.84]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1005.17,851.695],[1034.5,848.973],[1005.17,982.565],[1034.5,978.703]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1130.18,415.839],[1130.18,278.572],[1034.5,422.615],[1034.5,292.884]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1130.18,557.174],[1130.18,419.907],[1034.5,556.19],[1034.5,426.46]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1130.18,569.119],[1130.18,706.386],[1034.5,567.479],[1034.5,697.21]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1130.18,717.92],[1130.18,855.186],[1034.5,708.11],[1034.5,837.84]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1130.18,866.966],[1130.18,1004.23],[1034.5,848.973],[1034.5,978.703]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1236.93,407.146],[1236.93,261.461],[1129.11,414.848],[1129.11,277.656]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1236.93,557.149],[1236.93,411.464],[1129.11,556.105],[1129.11,418.914]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1236.93,569.827],[1236.93,715.512],[1129.11,568.044],[1129.11,705.235]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1236.93,727.752],[1236.93,873.437],[1129.11,716.763],[1129.11,853.954]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1236.93,885.94],[1236.93,1031.62],[1129.11,865.727],[1129.11,1002.92]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,394.085],[1366.19,233.996],[1205.96,405.84],[1205.96,258.716]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,558.918],[1366.19,398.83],[1205.96,557.326],[1205.96,410.201]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,572.849],[1366.19,732.938],[1205.96,570.129],[1205.96,717.253]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,746.388],[1366.19,906.477],[1205.96,729.615],[1205.96,876.739]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,920.215],[1366.19,1080.3],[1205.96,889.365],[1205.96,1036.49]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1481.1,233.158],[1481.1,79.4841],[1210.04,272.79],[1210.04,139.013]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,394.085],[1366.19,233.997],[1397.08,395.577],[1397.08,237.134]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,558.918],[1366.19,398.83],[1397.08,558.716],[1397.08,400.273]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,572.849],[1366.19,732.938],[1397.08,572.504],[1397.08,730.947]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,746.388],[1366.19,906.477],[1397.08,744.26],[1397.08,902.703]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1366.19,920.215],[1397.08,916.3],[1366.19,1080.3],[1397.08,1074.74]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,385.152],[1542.87,215.214],[1397.08,395.577],[1397.08,237.134]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,560.128],[1542.87,390.189],[1397.08,558.716],[1397.08,400.273]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,574.917],[1542.87,744.855],[1397.08,572.504],[1397.08,730.947]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,759.134],[1542.87,929.073],[1397.08,744.26],[1397.08,902.703]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,943.656],[1542.87,1113.59],[1397.08,916.3],[1397.08,1074.74]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1481.29,233.129],[1481.29,79.4403],[1827.6,269.807],[1827.6,134.533]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,381.162],[1542.87,211.224],[1785.26,394.709],[1785.26,239.332]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,556.138],[1542.87,386.199],[1785.26,554.691],[1785.26,399.314]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,570.927],[1542.87,740.865],[1785.26,568.213],[1785.26,723.59]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,755.144],[1542.87,925.082],[1785.26,736.645],[1785.26,892.022]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1542.87,939.666],[1542.87,1109.6],[1785.26,905.356],[1785.26,1060.73]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1850.24,398.34],[1850.24,246.867],[2044.62,409.204],[2044.62,269.408]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1850.24,554.303],[1850.24,402.83],[2044.62,553.143],[2044.62,413.347]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1850.24,567.485],[1850.24,718.959],[2044.62,565.308],[2044.62,705.104]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1850.24,731.686],[1850.24,883.159],[2044.62,716.85],[2044.62,856.646]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:69,
                    verts:[[1850.24,896.158],[1850.24,1047.63],[2044.62,868.643],[2044.62,1008.44]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[292.983,466.793],[292.983,388.904],[255.59,468.973],[255.59,393.425]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[292.983,546.992],[292.983,469.102],[255.59,546.759],[255.59,471.212]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[292.983,553.77],[292.983,631.66],[255.59,553.333],[255.59,628.88]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[292.983,638.204],[292.983,716.094],[255.59,635.228],[255.59,710.775]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[292.983,722.778],[292.983,800.668],[255.59,717.258],[255.59,792.806]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,463.323],[324.223,381.704],[272.979,466.376],[272.979,388.038]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,547.362],[324.223,465.743],[272.979,547.036],[272.979,468.698]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,554.465],[324.223,636.085],[272.979,553.854],[272.979,632.192]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,642.943],[324.223,724.562],[272.979,638.774],[272.979,717.112]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,731.567],[324.223,813.186],[272.979,723.835],[272.979,802.173]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,463.323],[324.223,381.704],[345.474,463.792],[345.474,382.676]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,547.362],[324.223,465.743],[345.474,547.312],[345.474,466.196]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,554.465],[324.223,636.085],[345.474,554.371],[345.474,635.487]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,642.943],[324.223,724.562],[345.474,642.303],[345.474,723.419]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[324.223,731.567],[324.223,813.186],[345.474,730.38],[345.474,811.496]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[386.882,461.381],[386.882,377.673],[345.474,463.792],[345.474,382.676]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[386.882,547.57],[386.882,463.862],[345.474,547.312],[345.474,466.196]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[386.882,554.854],[386.882,638.562],[345.474,554.371],[345.474,635.487]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[386.882,645.596],[386.882,729.304],[345.474,642.303],[345.474,723.419]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[386.882,736.487],[386.882,820.195],[345.474,730.38],[345.474,811.496]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[446.724,375.283],[446.724,292.963],[350.156,386.617],[350.156,309.987]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[433.186,461.331],[433.186,374.662],[387.043,463.929],[387.043,380.151]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[433.186,550.568],[433.186,463.899],[387.043,550.19],[387.043,466.412]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[433.186,558.11],[433.186,644.778],[387.043,557.481],[387.043,641.259]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[433.186,652.06],[433.186,738.729],[387.043,648.298],[387.043,732.076]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[433.186,746.167],[433.186,832.835],[387.043,739.266],[387.043,823.044]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,457.156],[475.647,365.844],[411.812,460.831],[411.812,373.607]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,551.174],[475.647,459.862],[411.812,550.64],[411.812,463.416]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,559.12],[475.647,650.432],[411.812,558.231],[411.812,645.455]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,658.104],[475.647,749.416],[411.812,652.784],[411.812,740.008]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,757.252],[475.647,848.563],[411.812,747.493],[411.812,834.717]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[558.986,362.107],[558.986,273.172],[446.897,375.263],[446.897,292.932]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,457.156],[475.647,365.844],[498.36,457.722],[498.36,367.041]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,551.174],[475.647,459.862],[498.36,551.092],[498.36,460.41]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,559.12],[475.647,650.432],[498.36,558.983],[498.36,649.665]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,658.104],[475.647,749.416],[498.36,657.284],[498.36,747.966]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[475.647,757.252],[475.647,848.563],[498.36,755.748],[498.36,846.429]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[552.127,454.696],[552.127,360.649],[498.36,457.722],[498.36,367.041]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[552.127,551.531],[552.127,457.484],[498.36,551.092],[498.36,460.41]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[552.127,559.715],[552.127,653.763],[498.36,558.983],[498.36,649.665]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[552.127,661.665],[552.127,755.712],[498.36,657.284],[498.36,747.966]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[552.127,763.783],[552.127,857.83],[498.36,755.748],[498.36,846.429]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[608.175,451.475],[608.175,353.844],[549.868,454.759],[549.868,360.781]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[608.175,551.999],[608.175,454.369],[549.868,551.522],[549.868,457.544]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[608.175,560.495],[608.175,658.126],[549.868,559.7],[549.868,653.678]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[608.175,666.329],[608.175,763.959],[549.868,661.574],[549.868,755.552]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[608.175,772.337],[608.175,869.968],[549.868,763.617],[549.868,857.595]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[559.064,362.098],[559.064,273.158],[821.967,376.613],[821.967,294.96]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,446.141],[666.966,342.579],[585.343,450.841],[585.343,352.505]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,552.773],[666.966,449.211],[585.343,552.091],[585.343,453.755]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,561.786],[666.966,665.349],[585.343,560.649],[585.343,658.985]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,674.05],[666.966,777.613],[585.343,667.247],[585.343,765.583]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,786.5],[666.966,890.063],[585.343,774.022],[585.343,872.358]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[755.465,339.047],[755.465,238.534],[611.621,355.93],[611.621,263.893]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,446.141],[666.966,342.579],[691.206,446.869],[691.206,344.116]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,552.773],[666.966,449.211],[691.206,552.668],[691.206,449.915]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,561.786],[666.966,665.349],[691.206,561.61],[691.206,664.363]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,674.05],[666.966,777.613],[691.206,672.996],[691.206,775.749]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[666.966,786.5],[666.966,890.063],[691.206,784.567],[691.206,887.32]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.226,442.929],[761.226,335.793],[691.207,446.869],[691.207,344.116]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.226,553.24],[761.226,446.104],[691.207,552.668],[691.207,449.915]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.226,562.563],[761.226,669.699],[691.207,561.61],[691.207,664.363]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.226,678.701],[761.226,785.837],[691.207,672.996],[691.207,775.749]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.226,795.031],[761.226,902.167],[691.207,784.567],[691.207,887.32]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[755.564,339.035],[755.564,238.516],[1031.55,357.38],[1031.55,266.071]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.854,442.949],[761.854,335.837],[863.338,446.201],[863.338,342.704]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.854,553.237],[761.854,446.124],[863.338,552.765],[863.338,449.268]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.854,562.558],[761.854,669.671],[863.338,561.771],[863.338,665.268]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.854,678.671],[761.854,785.784],[863.338,673.964],[863.338,777.46]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[761.854,794.976],[761.854,902.089],[863.338,786.342],[863.338,889.839]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[968.01,431.208],[968.01,311.036],[880.426,436.141],[880.426,321.456]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[968.01,554.942],[968.01,434.77],[880.426,554.226],[880.426,439.54]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[968.01,565.4],[968.01,685.572],[880.426,564.206],[880.426,678.891]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[968.01,695.669],[968.01,815.841],[880.426,688.527],[880.426,803.213]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[968.01,826.153],[968.01,946.325],[880.426,813.055],[880.426,927.74]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,423.013],[1068.7,293.725],[943.065,430.246],[943.065,309.003]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,556.132],[1068.7,426.845],[943.065,555.082],[943.065,433.839]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,567.383],[1068.7,696.671],[943.065,565.633],[943.065,686.875]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,707.534],[1068.7,836.821],[943.065,697.062],[943.065,818.305]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,847.916],[1068.7,977.204],[943.065,828.71],[943.065,949.952]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1273.64,278.23],[1273.64,147.183],[1038.18,305.865],[1038.18,188.693]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,423.013],[1068.7,293.725],[1094.99,424.145],[1094.99,296.117]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,556.132],[1068.7,426.845],[1094.99,555.968],[1094.99,427.939]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,567.383],[1068.7,696.671],[1094.99,567.109],[1094.99,695.137]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,707.534],[1068.7,836.821],[1094.99,705.894],[1094.99,833.923]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1068.7,847.916],[1068.7,977.204],[1094.99,844.91],[1094.99,972.938]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1203.83,418.02],[1203.83,283.179],[1094.99,424.145],[1094.99,296.117]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1203.83,556.857],[1203.83,422.016],[1094.99,555.968],[1094.99,427.94]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1203.83,568.591],[1203.83,703.432],[1094.99,567.109],[1094.99,695.137]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1203.83,714.762],[1203.83,849.603],[1094.99,705.894],[1094.99,833.923]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1203.83,861.174],[1203.83,996.015],[1094.99,844.91],[1094.99,972.938]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1324.1,410.145],[1324.1,267.768],[1202.64,417.04],[1202.64,282.266]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1324.1,556.742],[1324.1,414.365],[1202.64,555.808],[1202.64,421.035]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1324.1,569.132],[1324.1,711.51],[1202.64,567.537],[1202.64,702.31]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1324.1,723.472],[1324.1,865.849],[1202.64,713.634],[1202.64,848.408]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1324.1,878.068],[1324.1,1020.44],[1202.64,859.974],[1202.64,994.747]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1572.01,243.21],[1572.01,94.5823],[1273.71,278.222],[1273.71,147.172]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,398.32],[1476.62,242.903],[1297.34,408.731],[1297.34,264.795]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,558.344],[1476.62,402.927],[1297.34,556.934],[1297.34,412.998]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,571.869],[1476.62,727.286],[1297.34,569.46],[1297.34,713.396]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,740.345],[1476.62,895.762],[1297.34,725.49],[1297.34,869.426]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,909.1],[1476.62,1064.52],[1297.34,881.778],[1297.34,1025.71]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,398.32],[1476.62,242.903],[1502.5,399.912],[1502.5,246.25]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,558.344],[1476.62,402.927],[1502.5,558.129],[1502.5,404.466]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,571.869],[1476.62,727.286],[1502.5,571.501],[1502.5,725.163]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,740.345],[1476.62,895.762],[1502.5,738.074],[1502.5,891.736]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1476.62,909.1],[1476.62,1064.52],[1502.5,904.923],[1502.5,1058.59]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,390.833],[1662.32,227.158],[1502.5,399.912],[1502.5,246.25]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,559.359],[1662.32,395.684],[1502.5,558.129],[1502.5,404.466]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,573.602],[1662.32,737.277],[1502.5,571.501],[1502.5,725.163]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,751.029],[1662.32,914.704],[1502.5,738.074],[1502.5,891.736]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,928.75],[1662.32,1092.42],[1502.5,904.923],[1502.5,1058.59]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1572.23,243.185],[1572.23,94.5441],[1857.2,281.612],[1857.2,152.264]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,386.99],[1662.32,223.315],[1857.65,401.115],[1857.65,252.625]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,555.516],[1662.32,391.841],[1857.65,554.007],[1857.65,405.517]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,569.759],[1662.32,733.434],[1857.65,566.929],[1857.65,715.419]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,747.186],[1662.32,910.861],[1857.65,727.896],[1857.65,876.386]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1662.32,924.907],[1662.32,1088.58],[1857.65,889.129],[1857.65,1037.62]]
                },{
                    num:"508",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1909.5,404.865],[1909.5,260.405],[2063.33,415.99],[2063.33,283.489]]
                },{
                    num:"408",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1909.5,553.606],[1909.5,409.147],[2063.33,552.418],[2063.33,419.917]]
                },{
                    num:"308",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1909.5,566.178],[1909.5,710.637],[2063.33,563.949],[2063.33,696.449]]
                },{
                    num:"208",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1909.5,722.775],[1909.5,867.235],[2063.33,707.582],[2063.33,840.083]]
                },{
                    num:"108",
                    tipo:"TorreF",
                    frame:70,
                    verts:[[1909.5,879.632],[1909.5,1024.09],[2063.33,851.454],[2063.33,983.955]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[233.595,465.214],[233.595,385.626],[189.07,467.311],[189.07,389.978]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[233.595,547.16],[233.595,467.573],[189.07,546.936],[189.07,469.603]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[233.595,554.086],[233.595,633.674],[189.07,553.666],[189.07,630.999]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[233.595,640.361],[233.595,719.949],[189.07,637.497],[189.07,714.83]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[233.595,726.779],[233.595,806.366],[189.07,721.466],[189.07,798.799]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,461.802],[274.667,378.546],[213.654,464.731],[213.654,384.625]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,547.525],[274.667,464.269],[213.654,547.212],[213.654,467.106]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,554.77],[274.667,638.026],[213.654,554.183],[213.654,634.289]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,645.021],[274.667,728.277],[213.654,641.02],[213.654,721.126]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,735.422],[274.667,818.677],[213.654,728.001],[213.654,808.107]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,461.802],[274.667,378.546],[295.689,462.341],[295.689,379.665]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,547.525],[274.667,464.269],[295.689,547.467],[295.689,464.791]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,554.77],[274.667,638.026],[295.689,554.662],[295.689,637.338]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,645.021],[274.667,728.277],[295.689,644.285],[295.689,726.961]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[274.667,735.422],[274.667,818.677],[295.689,734.056],[295.689,816.731]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[403.417,372.834],[403.417,289.285],[290.475,383.626],[290.475,305.495]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[344.557,460.04],[344.557,374.892],[295.689,462.341],[295.689,379.665]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[344.557,547.713],[344.557,462.564],[295.689,547.467],[295.689,464.791]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[344.557,555.123],[344.557,640.272],[295.689,554.662],[295.689,637.338]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[344.557,647.426],[344.557,732.575],[295.689,644.285],[295.689,726.961]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[344.557,739.882],[344.557,825.031],[295.689,734.056],[295.689,816.731]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[399.114,460.165],[399.114,372.201],[344.882,462.634],[344.882,377.416]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[399.114,550.737],[399.114,462.773],[344.882,550.378],[344.882,465.16]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[399.114,558.392],[399.114,646.356],[344.882,557.794],[344.882,643.013]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[399.114,653.747],[399.114,741.712],[344.882,650.173],[344.882,735.392]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[399.114,749.261],[399.114,837.225],[344.882,742.705],[344.882,827.924]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,456.117],[453.203,363.65],[378.251,459.595],[378.251,370.997]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,551.325],[453.203,458.858],[378.251,550.82],[378.251,462.221]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,559.372],[453.203,651.839],[378.251,558.53],[378.251,647.128]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,659.608],[453.203,752.076],[378.251,654.573],[378.251,743.171]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,760.011],[453.203,852.478],[378.251,750.774],[378.251,839.373]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[533.423,360.412],[533.423,270.625],[403.619,372.815],[403.619,289.256]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,456.117],[453.203,363.65],[475.154,456.759],[475.154,365.007]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,551.325],[453.203,458.858],[475.154,551.232],[475.154,459.479]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,559.372],[453.203,651.839],[475.154,559.216],[475.154,650.969]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,659.608],[453.203,752.076],[475.154,658.678],[475.154,750.431]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[453.203,760.011],[453.203,852.478],[475.154,758.305],[475.154,850.057]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[537.652,453.916],[537.652,359.001],[475.154,456.759],[475.154,365.007]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[537.652,551.644],[537.652,456.729],[475.154,551.232],[475.154,459.479]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[537.652,559.904],[537.652,654.819],[475.154,559.216],[475.154,650.969]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[537.652,662.794],[537.652,757.709],[475.154,658.678],[475.154,750.431]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[537.652,765.855],[537.652,860.769],[475.154,758.305],[475.154,850.057]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[533.513,360.403],[533.513,270.612],[783.848,376.624],[783.848,294.977]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[602.626,450.901],[602.626,352.632],[535.191,453.971],[535.191,359.116]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[602.626,552.082],[602.626,453.814],[535.191,551.637],[535.191,456.782]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[602.626,560.634],[602.626,658.903],[535.191,559.891],[535.191,654.745]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[602.626,667.159],[602.626,765.428],[535.191,662.715],[535.191,757.57]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[602.626,773.861],[602.626,872.13],[535.191,765.71],[535.191,860.564]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,445.818],[675.124,341.896],[580.94,450.189],[580.94,351.128]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,552.82],[675.124,448.898],[580.94,552.186],[580.94,453.125]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,561.864],[675.124,665.786],[580.94,560.806],[580.94,659.867]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,674.518],[675.124,778.44],[580.94,668.19],[580.94,767.251]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,787.359],[675.124,891.281],[580.94,775.752],[580.94,874.813]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[757.68,338.983],[757.68,238.438],[593.906,354.632],[593.906,261.944]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,445.818],[675.124,341.896],[697.845,446.629],[697.845,343.608]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,552.82],[675.124,448.898],[697.845,552.703],[697.845,449.682]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,561.864],[675.124,665.786],[697.845,561.668],[697.845,664.688]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,674.518],[675.124,778.44],[697.845,673.344],[697.845,776.365]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[675.124,787.359],[675.124,891.281],[697.845,785.206],[697.845,888.226]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[777.701,442.996],[777.701,335.935],[697.845,446.629],[697.845,343.608]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[777.701,553.23],[777.701,446.169],[697.845,552.703],[697.845,449.682]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[777.701,562.547],[777.701,669.608],[697.845,561.668],[697.845,664.688]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[777.701,678.604],[777.701,785.665],[697.845,673.344],[697.845,776.365]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[777.701,794.852],[777.701,901.913],[697.845,785.206],[697.845,888.226]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[757.792,338.973],[757.792,238.422],[1012.58,359.095],[1012.58,268.648]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[778.28,443.019],[778.28,335.983],[871.887,446.6],[871.887,343.548]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[778.28,553.227],[778.28,446.191],[871.887,552.707],[871.887,449.655]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[778.28,562.542],[778.28,669.577],[871.887,561.675],[871.887,664.727]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[778.28,678.57],[778.28,785.606],[871.887,673.386],[871.887,776.438]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[778.28,794.791],[778.28,901.827],[871.887,785.282],[871.887,888.334]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1010.69,432.325],[1010.69,313.395],[912.629,436.789],[912.629,322.824]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1010.69,554.78],[1010.69,435.85],[912.629,554.132],[912.629,440.167]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1010.69,565.13],[1010.69,684.059],[912.629,564.049],[912.629,678.014]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1010.69,694.052],[1010.69,812.982],[912.629,687.59],[912.629,801.555]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1010.69,823.188],[1010.69,942.118],[912.629,811.335],[912.629,925.3]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,424.789],[1128.26,297.477],[988.383,431.28],[988.383,311.189]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,555.874],[1128.26,428.562],[988.383,554.932],[988.383,434.84]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,566.953],[1128.26,694.265],[988.383,565.382],[988.383,685.474]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,704.962],[1128.26,832.274],[988.383,695.564],[988.383,815.656]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,843.2],[1128.26,970.511],[988.383,825.962],[988.383,946.054]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1329.87,284.309],[1329.87,156.315],[1073.25,308.83],[1073.25,193.146]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,424.789],[1128.26,297.477],[1151.23,426.003],[1151.23,300.042]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,555.874],[1128.26,428.562],[1151.23,555.698],[1151.23,429.737]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,566.953],[1128.26,694.265],[1151.23,566.659],[1151.23,692.621]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,704.962],[1128.26,832.274],[1151.23,703.204],[1151.23,829.165]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1128.26,843.2],[1128.26,970.511],[1151.23,839.975],[1151.23,965.936]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1270.55,420.575],[1270.55,288.576],[1151.23,426.003],[1151.23,300.042]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1270.55,556.486],[1270.55,424.487],[1151.23,555.698],[1151.23,429.737]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1270.55,567.973],[1270.55,699.972],[1151.23,566.659],[1151.23,692.621]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1270.55,711.063],[1270.55,843.061],[1151.23,703.204],[1151.23,829.165]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1270.55,854.389],[1270.55,986.388],[1151.23,839.975],[1151.23,965.936]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1401.05,413.563],[1401.05,274.955],[1269.27,419.61],[1269.27,287.67]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1401.05,556.279],[1401.05,417.672],[1269.27,555.46],[1269.27,423.52]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1401.05,568.341],[1401.05,706.949],[1269.27,566.942],[1269.27,698.882]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1401.05,718.595],[1401.05,857.203],[1269.27,709.968],[1269.27,841.908]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1401.05,869.098],[1401.05,1007.71],[1269.27,853.23],[1269.27,985.17]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1647.25,253.982],[1647.25,110.762],[1329.94,284.302],[1329.94,156.305]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,403.058],[1571.39,252.866],[1378.69,412.078],[1378.69,271.833]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,557.702],[1571.39,407.51],[1378.69,556.48],[1378.69,416.235]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,570.773],[1571.39,720.965],[1378.69,568.685],[1378.69,708.93]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,733.584],[1571.39,883.776],[1378.69,720.714],[1378.69,860.959]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,896.665],[1571.39,1046.86],[1378.69,872.994],[1378.69,1013.24]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,403.059],[1571.39,252.866],[1592.18,404.702],[1592.18,256.323]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,557.702],[1571.39,407.51],[1592.18,557.48],[1592.18,409.1]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,570.773],[1571.39,720.965],[1592.18,570.392],[1592.18,718.771]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,733.584],[1571.39,883.776],[1592.18,731.238],[1592.18,879.617]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1571.39,896.665],[1571.39,1046.86],[1592.18,892.351],[1592.18,1040.73]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,396.969],[1760.61,240.062],[1592.18,404.702],[1592.18,256.323]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,558.527],[1760.61,401.62],[1592.18,557.48],[1592.18,409.1]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,572.182],[1760.61,729.089],[1592.18,570.392],[1592.18,718.771]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,742.273],[1760.61,899.18],[1592.18,731.238],[1592.18,879.618]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,912.646],[1760.61,1069.55],[1592.18,892.351],[1592.18,1040.73]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1647.48,253.96],[1647.48,110.729],[1873.44,293.121],[1873.44,169.551]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,393.285],[1760.61,236.378],[1910.69,407.575],[1910.69,266.029]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,554.843],[1760.61,397.936],[1910.69,553.317],[1910.69,411.771]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,568.498],[1760.61,725.405],[1910.69,565.635],[1910.69,707.181]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,738.589],[1760.61,895.496],[1910.69,719.074],[1910.69,860.62]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:71,
                    verts:[[1760.61,908.962],[1760.61,1065.87],[1910.69,872.767],[1910.69,1014.31]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[177.769,463.503],[177.769,382.076],[125.818,465.497],[125.818,386.213]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[177.769,547.343],[177.769,465.916],[125.818,547.13],[125.818,467.847]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[177.769,554.429],[177.769,635.856],[125.818,554.03],[125.818,633.313]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[177.769,642.698],[177.769,724.125],[125.818,639.975],[125.818,719.258]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[177.769,731.112],[177.769,812.539],[125.818,726.062],[125.818,805.346]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,460.178],[229.069,375.176],[157.984,462.954],[157.984,380.936]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,547.698],[229.069,462.697],[157.984,547.402],[157.984,465.384]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,555.095],[229.069,640.097],[157.984,554.539],[157.984,636.557]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,647.239],[229.069,732.24],[157.984,643.448],[157.984,725.465]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,739.535],[229.069,824.536],[157.984,732.504],[157.984,814.521]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,460.178],[229.069,375.176],[249.738,460.788],[249.738,376.443]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,547.698],[229.069,462.697],[249.738,547.633],[249.738,463.288]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,555.095],[229.069,640.097],[249.738,554.973],[249.738,639.318]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,647.239],[229.069,732.24],[249.738,646.405],[249.738,730.75]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[229.069,739.535],[229.069,824.536],[249.738,737.988],[249.738,822.333]]
                },{
                    num:"603",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[363.688,370.217],[363.688,285.354],[234.095,380.361],[234.095,300.59]]
                },{
                    num:"503",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[306.183,458.623],[306.183,371.951],[249.738,460.788],[249.738,376.443]]
                },{
                    num:"403",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[306.183,547.864],[306.183,461.192],[249.738,547.633],[249.738,463.288]]
                },{
                    num:"303",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[306.183,555.407],[306.183,642.079],[249.738,554.973],[249.738,639.318]]
                },{
                    num:"203",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[306.183,649.362],[306.183,736.034],[249.738,646.405],[249.738,730.75]]
                },{
                    num:"103",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[306.183,743.472],[306.183,830.145],[249.738,737.988],[249.738,822.333]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[369.021,458.952],[369.021,369.638],[306.675,461.265],[306.675,374.523]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[369.021,550.913],[369.021,461.599],[306.675,550.577],[306.675,463.836]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[369.021,558.685],[369.021,647.999],[306.675,558.126],[306.675,644.867]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[369.021,655.504],[369.021,744.818],[306.675,652.156],[306.675,738.897]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[369.021,752.482],[369.021,841.796],[306.675,746.341],[306.675,833.083]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,455.069],[434.779,361.437],[348.827,458.313],[348.827,368.288]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,551.477],[434.779,457.844],[348.827,551.006],[348.827,460.981]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,559.625],[434.779,653.258],[348.827,558.84],[348.827,648.865]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,661.125],[434.779,754.758],[348.827,656.429],[348.827,746.454]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,762.793],[434.779,856.426],[348.827,754.179],[348.827,844.204]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[511.22,358.669],[511.22,268.008],[363.919,370.199],[363.919,285.327]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,455.069],[434.779,361.436],[455.78,455.785],[455.78,362.948]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,551.477],[434.779,457.844],[455.78,551.373],[455.78,458.536]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,559.625],[434.779,653.258],[455.78,559.452],[455.78,652.289]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,661.125],[434.779,754.758],[455.78,660.089],[455.78,752.926]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[434.779,762.793],[434.779,856.426],[455.78,760.893],[455.78,853.73]]
                },{
                    num:"502",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[526.745,453.154],[526.745,357.391],[455.78,455.785],[455.78,362.948]]
                },{
                    num:"402",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[526.745,551.755],[526.745,455.992],[455.78,551.373],[455.78,458.536]]
                },{
                    num:"302",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[526.745,560.089],[526.745,655.852],[455.78,559.452],[455.78,652.289]]
                },{
                    num:"202",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[526.745,663.898],[526.745,759.661],[455.78,660.089],[455.78,752.926]]
                },{
                    num:"102",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[526.745,767.879],[526.745,863.641],[455.78,760.893],[455.78,853.73]]
                },{
                    num:"602",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[511.321,358.662],[511.321,267.996],[747.585,376.48],[747.585,294.76]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[600.238,450.376],[600.238,351.523],[524.098,453.2],[524.098,357.488]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[600.238,552.159],[600.238,453.306],[524.098,551.748],[524.098,456.037]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[600.238,560.761],[600.238,659.614],[524.098,560.078],[524.098,655.789]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[600.238,667.92],[600.238,766.773],[524.098,663.831],[524.098,759.543]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[600.238,775.256],[600.238,874.109],[524.098,767.756],[524.098,863.468]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[761.664,339.066],[761.664,238.563],[579.266,353.343],[579.266,260.008]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,445.594],[685.836,341.423],[579.907,449.592],[579.907,349.868]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,552.853],[685.836,448.682],[579.907,552.272],[579.907,452.548]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,561.918],[685.836,666.089],[579.907,560.951],[579.907,660.675]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,674.842],[685.836,779.013],[579.907,669.054],[579.907,768.779]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,787.953],[685.836,892.123],[579.907,777.337],[579.907,877.061]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,445.594],[685.836,341.423],[706.807,446.479],[706.807,343.292]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,552.853],[685.836,448.682],[706.807,552.724],[706.807,449.537]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,561.918],[685.836,666.089],[706.807,561.704],[706.807,664.891]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,674.842],[685.836,779.013],[706.807,673.561],[706.807,776.748]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[685.836,787.953],[685.836,892.123],[706.807,785.603],[706.807,888.79]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[795.596,443.188],[795.596,336.34],[706.807,446.479],[706.807,343.292]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[795.596,553.202],[795.596,446.355],[706.807,552.724],[706.807,449.537]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[795.596,562.501],[795.596,669.348],[706.807,561.704],[706.807,664.891]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[795.596,678.326],[795.596,785.174],[706.807,673.561],[706.807,776.748]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[795.596,794.343],[795.596,901.191],[706.807,785.603],[706.807,888.79]]
                },{
                    num:"601",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[761.788,339.057],[761.788,238.549],[993.82,360.722],[993.82,271.091]]
                },{
                    num:"501",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[796.121,443.212],[796.121,336.392],[881.018,447.077],[881.018,344.555]]
                },{
                    num:"401",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[796.121,553.199],[796.121,446.379],[881.018,552.638],[881.018,450.116]]
                },{
                    num:"301",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[796.121,562.495],[796.121,669.315],[881.018,561.559],[881.018,664.081]]
                },{
                    num:"201",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[796.121,678.29],[796.121,785.11],[881.018,672.695],[881.018,775.217]]
                },{
                    num:"101",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[796.121,794.277],[796.121,901.098],[881.018,784.015],[881.018,886.537]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1051.19,433.649],[1051.19,316.191],[944.333,437.612],[944.333,324.564]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1051.19,554.588],[1051.19,437.13],[944.333,554.012],[944.333,440.963]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1051.19,564.809],[1051.19,682.267],[944.333,563.85],[944.333,676.899]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1051.19,692.135],[1051.19,809.593],[944.333,686.397],[944.333,799.446]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1051.19,819.673],[1051.19,937.13],[944.333,809.148],[944.333,922.197]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,426.829],[1183.06,301.787],[1031.73,432.541],[1031.73,313.85]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,555.578],[1183.06,430.535],[1031.73,554.748],[1031.73,436.058]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,566.46],[1183.06,691.502],[1031.73,565.077],[1031.73,683.767]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,702.008],[1183.06,827.051],[1031.73,693.74],[1031.73,812.43]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,837.782],[1183.06,962.824],[1031.73,822.616],[1031.73,941.306]]
                },{
                    num:"605",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1378.41,290.791],[1378.41,166.052],[1105.67,312.14],[1105.67,198.118]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,426.829],[1183.06,301.787],[1202.56,428.102],[1202.56,304.474]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,555.578],[1183.06,430.535],[1202.56,555.393],[1202.56,431.766]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,566.46],[1183.06,691.502],[1202.56,566.152],[1202.56,689.779]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,702.008],[1183.06,827.051],[1202.56,700.166],[1202.56,823.794]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1183.06,837.782],[1183.06,962.824],[1202.56,834.403],[1202.56,958.03]]
                },{
                    num:"510",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1329.73,423.387],[1329.73,294.516],[1202.56,428.102],[1202.56,304.474]]
                },{
                    num:"410",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1329.73,556.078],[1329.73,427.207],[1202.56,555.393],[1202.56,431.766]]
                },{
                    num:"310",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1329.73,567.292],[1329.73,696.163],[1202.56,566.152],[1202.56,689.779]]
                },{
                    num:"210",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1329.73,706.991],[1329.73,835.862],[1202.56,700.166],[1202.56,823.794]]
                },{
                    num:"110",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1329.73,846.921],[1329.73,975.792],[1202.56,834.403],[1202.56,958.03]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1467.3,417.244],[1467.3,282.696],[1328.38,422.438],[1328.38,293.617]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1467.3,555.781],[1467.3,421.232],[1328.38,555.077],[1328.38,426.256]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1467.3,567.49],[1467.3,702.038],[1328.38,566.287],[1328.38,695.108]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1467.3,713.343],[1467.3,847.891],[1328.38,705.932],[1328.38,834.752]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1467.3,859.438],[1467.3,993.987],[1328.38,845.808],[1328.38,974.628]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1707.38,265.041],[1707.38,127.374],[1378.48,290.786],[1378.48,166.043]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,408.074],[1650.3,263.412],[1449.36,415.723],[1449.36,279.496]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,557.023],[1650.3,412.362],[1449.36,555.987],[1449.36,419.76]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,569.612],[1650.3,714.273],[1449.36,567.842],[1449.36,704.068]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,726.428],[1650.3,871.089],[1449.36,715.514],[1449.36,851.74]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,883.504],[1650.3,1028.17],[1449.36,863.431],[1449.36,999.658]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,408.074],[1650.3,263.413],[1666.15,409.731],[1666.15,266.896]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,557.023],[1650.3,412.362],[1666.15,556.798],[1666.15,413.964]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,569.612],[1650.3,714.273],[1666.15,569.228],[1666.15,712.063]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,726.428],[1650.3,871.089],[1666.15,724.064],[1666.15,866.898]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1650.3,883.504],[1650.3,1028.17],[1666.15,879.156],[1666.15,1021.99]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,403.283],[1838.5,253.338],[1666.15,409.731],[1666.15,266.896]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,557.672],[1838.5,407.727],[1666.15,556.798],[1666.15,413.964]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,570.721],[1838.5,720.666],[1666.15,569.228],[1666.15,712.063]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,733.264],[1838.5,883.209],[1666.15,724.064],[1666.15,866.898]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,896.077],[1838.5,1046.02],[1666.15,879.156],[1666.15,1021.99]]
                },{
                    num:"604",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1707.61,265.023],[1707.61,127.347],[1878.41,304.111],[1878.41,186.058]]
                },{
                    num:"509",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,399.762],[1838.5,249.817],[1946.63,413.893],[1946.63,279.138]]
                },{
                    num:"409",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,554.151],[1838.5,404.206],[1946.63,552.642],[1946.63,417.887]]
                },{
                    num:"309",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,567.2],[1838.5,717.145],[1946.63,564.369],[1946.63,699.124]]
                },{
                    num:"209",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,729.744],[1838.5,879.689],[1946.63,710.446],[1946.63,845.202]]
                },{
                    num:"109",
                    tipo:"TorreF",
                    frame:72,
                    verts:[[1838.5,892.557],[1838.5,1042.5],[1946.63,856.766],[1946.63,991.521]]
                },
                ],
                [
                
                ]
        ]
    }
}